const Data = [
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE/SOSOKI",
		"PU-Code": "23-01-01-002",
		"PU-Name": "ONIYEYE OPEN SPACE",
		Accredited_Voters: 220,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/01/pu/002/002-1677389827.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE/SOSOKI",
		"PU-Code": "23-01-01-003",
		"PU-Name": "LAODU 1 OPEN SPACE",
		Accredited_Voters: 235,
		Registered_Voters: 786,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/01/pu/003/003-1677387846.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE/SOSOKI",
		"PU-Code": "23-01-01-004",
		"PU-Name": "IDI-OSE L.G.E.A SCH",
		Accredited_Voters: 250,
		Registered_Voters: 876,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/01/pu/004/004-1677389332.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-001",
		"PU-Name": "OJA-IYA L.G.E.A SCH",
		Accredited_Voters: 215,
		Registered_Voters: 647,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/001/001-1677375218.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-002",
		"PU-Name": "AGBONA L.G.E.A SCH",
		Accredited_Voters: 215,
		Registered_Voters: 600,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/002/002-1677378358.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-003",
		"PU-Name": "MEGIDA EDUNJO OPEN SPACE I",
		Accredited_Voters: 185,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/003/003-1677377586.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-004",
		"PU-Name": "MEGIDA EDUNJO OPEN SPACE II",
		Accredited_Voters: 153,
		Registered_Voters: 407,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/004/004-1677380330.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-006",
		"PU-Name": "IGBOROKO L.G.E.A SCH",
		Accredited_Voters: 189,
		Registered_Voters: 633,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/006/006-1677392296.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-007",
		"PU-Name": "BUDO TUNTUN OPEN SPACE",
		Accredited_Voters: 171,
		Registered_Voters: 824,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/007/007-1677386065.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-001",
		"PU-Name": "ALAPA L.G.E.A SCH",
		Accredited_Voters: 264,
		Registered_Voters: 751,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/001/001-1677412839.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-002",
		"PU-Name": "KONDORO L.G.E.A SCH",
		Accredited_Voters: 300,
		Registered_Voters: 678,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/002/002-1677400541.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-003",
		"PU-Name": "ODE-GIWA MARKET",
		Accredited_Voters: 237,
		Registered_Voters: 749,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/003/003-1677397741.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-004",
		"PU-Name": "ONIKEKE L.G.E.A SCH",
		Accredited_Voters: 318,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23094/pu/75408/75408-1677778554.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-005",
		"PU-Name": "ONIRE ALHAJI OPEN SPACE",
		Accredited_Voters: 166,
		Registered_Voters: 686,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/005/005-1677394153.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-006",
		"PU-Name": "LABITAN L.G.E.A SCH",
		Accredited_Voters: 134,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/006/006-1677403590.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-007",
		"PU-Name": "ALAPA KORO OPEN SPACE",
		Accredited_Voters: 215,
		Registered_Voters: 860,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/007/007-1677405098.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-001",
		"PU-Name": "ALAPETE DISPENSARY",
		Accredited_Voters: 225,
		Registered_Voters: 612,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/001/001-1677379380.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-002",
		"PU-Name": "BAKASE L.G.E.A SCH",
		Accredited_Voters: 378,
		Registered_Voters: 941,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/002/002-1677384623.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-003",
		"PU-Name": "OLUPO-IJANA L.G.E.A SCH",
		Accredited_Voters: 133,
		Registered_Voters: 467,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/003/003-1677385258.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-004",
		"PU-Name": "ABIOWA L.G.E.A SCH",
		Accredited_Voters: 276,
		Registered_Voters: 607,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/004/004-1677383778.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-005",
		"PU-Name": "ABEMI L.G.E.A SCH",
		Accredited_Voters: 205,
		Registered_Voters: 571,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/005/005-1677382803.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "GAMBARI/AIYEKALE",
		"PU-Code": "23-01-06-001",
		"PU-Name": "DONGARI ETILE L.G.E.A SCH",
		Accredited_Voters: 432,
		Registered_Voters: 963,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/06/pu/001/001-1677389871.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "GAMBARI/AIYEKALE",
		"PU-Code": "23-01-06-002",
		"PU-Name": "SOKOTO L.G.E.A SCH",
		Accredited_Voters: 216,
		Registered_Voters: 743,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/06/pu/002/002-1677390808.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "EFUE/BERIKODO",
		"PU-Code": "23-01-07-001",
		"PU-Name": "EFUE L.G.E.A SCH",
		Accredited_Voters: 289,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/07/pu/001/001-1677373525.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "EFUE/BERIKODO",
		"PU-Code": "23-01-07-002",
		"PU-Name": "BERIKODO L.G.E.A SCH",
		Accredited_Voters: 295,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/07/pu/002/002-1677378623.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "EFUE/BERIKODO",
		"PU-Code": "23-01-07-003",
		"PU-Name": "GBENAGBENA L.G.E.A SCH",
		Accredited_Voters: 202,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/07/pu/003/003-1677378493.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OWODE/GBOGUN",
		"PU-Code": "23-01-08-001",
		"PU-Name": "OWODE L.G.E.A.SCH",
		Accredited_Voters: 0,
		Registered_Voters: 768,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/08/pu/001/001-1677382117.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OWODE/GBOGUN",
		"PU-Code": "23-01-08-002",
		"PU-Name": "AJUWON  L.G.E.A.SCH",
		Accredited_Voters: 52,
		Registered_Voters: 183,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/08/pu/002/002-1677381320.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OWODE/GBOGUN",
		"PU-Code": "23-01-08-003",
		"PU-Name": "GBOGUN  L.G.E.A.SCH",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/08/pu/003/003-1677382625.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OWODE/GBOGUN",
		"PU-Code": "23-01-08-004",
		"PU-Name": "ELERE/TAFATAFA  L.G.E.A.SCH",
		Accredited_Voters: 339,
		Registered_Voters: 900,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23098/pu/75425/75425-1677759087.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-001",
		"PU-Name": "OTTE  L.G.E.A.SCH",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/001/001-1677393189.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-002",
		"PU-Name": "BUDO ARE  L.G.E.A.SCH",
		Accredited_Voters: 249,
		Registered_Voters: 722,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/002/002-1677388589.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-003",
		"PU-Name": "BALLAH  L.G.E.A.SCH",
		Accredited_Voters: 284,
		Registered_Voters: 851,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/003/003-1677387764.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-005",
		"PU-Name": "EYENKORIN  L.G.E.A.SCH",
		Accredited_Voters: 303,
		Registered_Voters: 1272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/005/005-1677385923.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-006",
		"PU-Name": "OTTE MARKET",
		Accredited_Voters: 282,
		Registered_Voters: 919,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/006/006-1677386966.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-007",
		"PU-Name": "OTTE MATERNITY",
		Accredited_Voters: 284,
		Registered_Voters: 751,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/007/007-1677394229.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-008",
		"PU-Name": "AREA COURT BALLAH",
		Accredited_Voters: 201,
		Registered_Voters: 502,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/008/008-1677374714.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-010",
		"PU-Name": "ILE ABE OTTE OPEN SPACE",
		Accredited_Voters: 196,
		Registered_Voters: 637,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/010/010-1677377924.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-001",
		"PU-Name": "REKE  L.G.E.A.SCH",
		Accredited_Voters: 140,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/001/001-1677407945.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-002",
		"PU-Name": "OGBONDOROKO DISPENSARY",
		Accredited_Voters: 185,
		Registered_Voters: 770,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/002/002-1677410420.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-003",
		"PU-Name": "OGBONDOROKO  L.G.E.A.SCH",
		Accredited_Voters: 209,
		Registered_Voters: 875,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/003/003-1677410548.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-004",
		"PU-Name": "OGBONDOROKO A.I.S.S",
		Accredited_Voters: 254,
		Registered_Voters: 877,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/004/004-1677410992.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-001",
		"PU-Name": "LADUBA  L.G.E.A.SCH",
		Accredited_Voters: 193,
		Registered_Voters: 806,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/001/001-1677390777.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-002",
		"PU-Name": "LADUBA  AREA COURT I",
		Accredited_Voters: 118,
		Registered_Voters: 586,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/002/002-1677394897.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-003",
		"PU-Name": "LADUBA  AREA COURT II",
		Accredited_Voters: 103,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/003/003-1677387984.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-004",
		"PU-Name": "ABAYAWO  L.G.E.A.SCH",
		Accredited_Voters: 119,
		Registered_Voters: 586,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/004/004-1677397638.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-005",
		"PU-Name": "SAPATI-ILE  L.G.E.A.SCH",
		Accredited_Voters: 221,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/005/005-1677396255.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-006",
		"PU-Name": "AGO-OJA DISPENSARY",
		Accredited_Voters: 149,
		Registered_Voters: 693,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/006/006-1677386222.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-007",
		"PU-Name": "BUDO AGUN OPEN SPACE",
		Accredited_Voters: 180,
		Registered_Voters: 746,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/007/007-1677402073.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-008",
		"PU-Name": "TERU OPEN SPACE",
		Accredited_Voters: 116,
		Registered_Voters: 338,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/008/008-1677393278.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AFON",
		"PU-Code": "23-01-12-002",
		"PU-Name": "AFON AREA COURT",
		Accredited_Voters: 284,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/12/pu/002/002-1677375048.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AFON",
		"PU-Code": "23-01-12-003",
		"PU-Name": "AFON C.D OFFICE",
		Accredited_Voters: 274,
		Registered_Voters: 767,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/12/pu/003/003-1677375881.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-001",
		"PU-Name": "ILA OJA  L.G.E.A.SCH",
		Accredited_Voters: 115,
		Registered_Voters: 408,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/001/001-1677383733.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-005",
		"PU-Name": "OGUNTOYINBO  L.G.E.A.SCH",
		Accredited_Voters: 209,
		Registered_Voters: 1038,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/005/005-1677376560.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-006",
		"PU-Name": "ONIGUGURU  L.G.E.A.SCH",
		Accredited_Voters: 209,
		Registered_Voters: 932,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/006/006-1677376163.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-007",
		"PU-Name": "OLORO  L.G.E.A.SCH",
		Accredited_Voters: 108,
		Registered_Voters: 517,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/007/007-1677377967.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-008",
		"PU-Name": "SAPATI OKO  L.G.E.A.SCH",
		Accredited_Voters: 172,
		Registered_Voters: 698,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/008/008-1677380832.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-009",
		"PU-Name": "ONIYERE  L.G.E.A.SCH",
		Accredited_Voters: 209,
		Registered_Voters: 641,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/009/009-1677384551.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-002",
		"PU-Name": "OGELE DISPENSARY",
		Accredited_Voters: 154,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/14/pu/002/002-1677423766.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-003",
		"PU-Name": "PAMPO  L.G.E.A.SCH",
		Accredited_Voters: 232,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/14/pu/003/003-1677424207.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-004",
		"PU-Name": "ALADERE MOGAJI  L.G.E.A.SCH",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/14/pu/004/004-1677425447.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-001",
		"PU-Name": "ST KELVIN  L.G.E.A.SCH I",
		Accredited_Voters: 338,
		Registered_Voters: 942,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/001/001-1677366250.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-002",
		"PU-Name": "ST KELVIN  L.G.E.A.SCH II",
		Accredited_Voters: 221,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/002/002-1677383023.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-003",
		"PU-Name": "ADABATA  L.G.E.A.SCH",
		Accredited_Voters: 353,
		Registered_Voters: 913,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/003/003-1677364710.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-004",
		"PU-Name": "KOROKE  L.G.E.A.SCH",
		Accredited_Voters: 307,
		Registered_Voters: 749,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/004/004-1677367027.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-005",
		"PU-Name": "ONIGBO  L.G.E.A.SCH",
		Accredited_Voters: 183,
		Registered_Voters: 532,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/005/005-1677365345.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-006",
		"PU-Name": "ELEMI-NLA  L.G.E.A.SCH",
		Accredited_Voters: 234,
		Registered_Voters: 603,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/006/006-1677378471.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OKESHO",
		"PU-Code": "23-01-16-001",
		"PU-Name": "OKESHO  L.G.E.A.SCH",
		Accredited_Voters: 282,
		Registered_Voters: 945,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23106/pu/75474/75474-1677769110.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OKESHO",
		"PU-Code": "23-01-16-002",
		"PU-Name": "AFEYIN  L.G.E.A.SCH I",
		Accredited_Voters: 224,
		Registered_Voters: 784,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23106/pu/75475/75475-1677769929.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OKESHO",
		"PU-Code": "23-01-17-001",
		"PU-Name": "AFEYIN  L.G.E.A.SCH I",
		Accredited_Voters: 224,
		Registered_Voters: 784,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23106/pu/75475/75475-1677769929.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-002",
		"PU-Name": "ABOTO  L.G.E.A.SCH II",
		Accredited_Voters: 176,
		Registered_Voters: 755,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23107/pu/75477/75477-1677599020.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-003",
		"PU-Name": "BUDO-ARO  L.G.E.A.SCH",
		Accredited_Voters: 203,
		Registered_Voters: 749,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/17/pu/003/003-1677397192.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-004",
		"PU-Name": "ODO-ODE  L.G.E.A.SCH",
		Accredited_Voters: 268,
		Registered_Voters: 917,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23107/pu/75479/75479-1677600861.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-005",
		"PU-Name": "OMOLE  L.G.E.A.SCH",
		Accredited_Voters: 213,
		Registered_Voters: 594,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/17/pu/005/005-1677392247.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-006",
		"PU-Name": "OWODE ALAGBON  L.G.E.A.SCH",
		Accredited_Voters: 87,
		Registered_Voters: 300,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/17/pu/006/006-1677394508.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-001",
		"PU-Name": "BORIYA  L.G.E.A.SCH",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/001/001-1677412738.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-003",
		"PU-Name": "DANKORU OPEN SPACE I",
		Accredited_Voters: 224,
		Registered_Voters: 950,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/003/003-1677414765.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-004",
		"PU-Name": "DANKORU OPEN SPACE II",
		Accredited_Voters: 160,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/004/004-1677411031.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-005",
		"PU-Name": "OGAMUE  L.G.E.A.SCH",
		Accredited_Voters: 20,
		Registered_Voters: 798,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/005/005-1677426348.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-008",
		"PU-Name": "SHIYA  L.G.E.A.SCH",
		Accredited_Voters: 311,
		Registered_Voters: 930,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23108/pu/75489/75489-1677708311.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-009",
		"PU-Name": "GBIRIBU/GBAYINA",
		Accredited_Voters: 161,
		Registered_Voters: 579,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/009/009-1677415755.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-011",
		"PU-Name": "SHIYA OLD MARKET",
		Accredited_Voters: 276,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/011/011-1677416652.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-012",
		"PU-Name": "SHIYA NEW MARKET",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/012/012-1677427071.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-013",
		"PU-Name": "TUNDUN WADA OPEN SPACE SHIYA",
		Accredited_Voters: 244,
		Registered_Voters: 771,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/013/013-1677425234.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-001",
		"PU-Name": "MONRE  L.G.E.A.SCH",
		Accredited_Voters: 142,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75495/75495-1677491362.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-002",
		"PU-Name": "MOSHI  L.G.E.A.SCH",
		Accredited_Voters: 108,
		Registered_Voters: 885,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75496/75496-1677493063.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-003",
		"PU-Name": "BWEREGURU  L.G.E.A.SCH",
		Accredited_Voters: 208,
		Registered_Voters: 816,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75497/75497-1677492224.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-004",
		"PU-Name": "KURABARU  L.G.E.A.SCH",
		Accredited_Voters: 94,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75498/75498-1677493830.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-005",
		"PU-Name": "TUGA  L.G.E.A.SCH",
		Accredited_Voters: 159,
		Registered_Voters: 770,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75499/75499-1677494898.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-006",
		"PU-Name": "GWASORO  L.G.E.A.SCH",
		Accredited_Voters: 305,
		Registered_Voters: 838,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75500/75500-1677495368.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-007",
		"PU-Name": "GWANE  L.G.E.A.SCH",
		Accredited_Voters: 181,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75501/75501-1677495752.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-008",
		"PU-Name": "SABO SARE",
		Accredited_Voters: 182,
		Registered_Voters: 885,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75502/75502-1677496014.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-009",
		"PU-Name": "YANRI  L.G.E.A.SCH",
		Accredited_Voters: 263,
		Registered_Voters: 1062,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75503/75503-1677496343.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-010",
		"PU-Name": "AJEGUNLE/GURE NEW MRKET",
		Accredited_Voters: 158,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75504/75504-1677496704.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-011",
		"PU-Name": "BANIKANI/GURE OPEN SPACE",
		Accredited_Voters: 199,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75505/75505-1677497261.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-012",
		"PU-Name": "GURE OLD MARKET",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75506/75506-1677497672.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-014",
		"PU-Name": "SINAGURU  L.G.E.A.SCH",
		Accredited_Voters: 121,
		Registered_Voters: 688,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75508/75508-1677498289.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-015",
		"PU-Name": "KOSUBOSU AREA COURT",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75509/75509-1677498629.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-016",
		"PU-Name": "KOSUBOSU  L.G.E.A.SCH",
		Accredited_Voters: 217,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/75510/75510-1677499175.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWEDEBERERU/BABANE",
		"PU-Code": "23-02-03-001",
		"PU-Name": "GUKONBU MARKET",
		Accredited_Voters: 91,
		Registered_Voters: 893,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/03/pu/001/001-1677372750.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWEDEBERERU/BABANE",
		"PU-Code": "23-02-03-002",
		"PU-Name": "WAGURU MARKET",
		Accredited_Voters: 174,
		Registered_Voters: 792,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/03/pu/002/002-1677371535.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWEDEBERERU/BABANE",
		"PU-Code": "23-02-03-003",
		"PU-Name": "BABANE  L.G.E.A.SCH",
		Accredited_Voters: 76,
		Registered_Voters: 963,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/03/pu/003/003-1677370324.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-001",
		"PU-Name": "GOBBO  L.G.E.A.SCH",
		Accredited_Voters: 138,
		Registered_Voters: 585,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/001/001-1677371975.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-002",
		"PU-Name": "DOKONU GOBBO OPEN SPACE",
		Accredited_Voters: 228,
		Registered_Voters: 885,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/002/002-1677373685.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-003",
		"PU-Name": "MARESUNOKPARU  L.G.E.A.SCH",
		Accredited_Voters: 171,
		Registered_Voters: 950,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/003/003-1677384269.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-004",
		"PU-Name": "MAMUNEKPERU  L.G.E.A.SCH",
		Accredited_Voters: 111,
		Registered_Voters: 797,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/004/004-1677372736.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-005",
		"PU-Name": "KIYAYERU  L.G.E.A.SCH",
		Accredited_Voters: 159,
		Registered_Voters: 870,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/005/005-1677372569.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-006",
		"PU-Name": "MUNKO  L.G.E.A.SCH",
		Accredited_Voters: 194,
		Registered_Voters: 450,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/006/006-1677373872.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-007",
		"PU-Name": "KUBURE  L.G.E.A.SCH",
		Accredited_Voters: 178,
		Registered_Voters: 838,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/007/007-1677376419.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-008",
		"PU-Name": "GBIRINU/NINGURUME  L.G.E.A.SCH",
		Accredited_Voters: 100,
		Registered_Voters: 486,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/008/008-1677374524.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-009",
		"PU-Name": "NINGURUME OLD MARKET",
		Accredited_Voters: 182,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/009/009-1677391361.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-010",
		"PU-Name": "NINGURUME  L.G.E.A.SCH",
		Accredited_Voters: 142,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/010/010-1677374785.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-011",
		"PU-Name": "GINAWARA NEW MARKET",
		Accredited_Voters: 264,
		Registered_Voters: 679,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/011/011-1677371740.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-012",
		"PU-Name": "GWANARA  L.G.E.A.SCH I",
		Accredited_Voters: 329,
		Registered_Voters: 862,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/012/012-1677375435.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-013",
		"PU-Name": "GWANARA CENTRAL OFFICE I",
		Accredited_Voters: 188,
		Registered_Voters: 440,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/013/013-1677374271.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-015",
		"PU-Name": "GWANARA  L.G.E.A.SCH II",
		Accredited_Voters: 220,
		Registered_Voters: 537,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/015/015-1677372222.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-001",
		"PU-Name": "KPAKOTORU  L.G.E.A.SCH",
		Accredited_Voters: 94,
		Registered_Voters: 669,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/001/001-1677366048.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-002",
		"PU-Name": "YAKIBURARU MARKET",
		Accredited_Voters: 112,
		Registered_Voters: 697,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/002/002-1677370855.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-003",
		"PU-Name": "KOSOMONO  L.G.E.A.SCH",
		Accredited_Voters: 110,
		Registered_Voters: 743,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/003/003-1677374130.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-004",
		"PU-Name": "NANORU  L.G.E.A.SCH",
		Accredited_Voters: 105,
		Registered_Voters: 813,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/004/004-1677364974.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-005",
		"PU-Name": "ILESHA AREA COURT",
		Accredited_Voters: 241,
		Registered_Voters: 892,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/005/005-1677367398.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-006",
		"PU-Name": "ILESHA SABO AREA I",
		Accredited_Voters: 243,
		Registered_Voters: 987,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/006/006-1677372589.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-007",
		"PU-Name": "ILESHA SABO AREA II",
		Accredited_Voters: 205,
		Registered_Voters: 803,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/007/007-1677374796.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-008",
		"PU-Name": "ILESHA T.V CENTRE I",
		Accredited_Voters: 169,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/008/008-1677373594.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-009",
		"PU-Name": "ILESHA T.V CENTRE II",
		Accredited_Voters: 152,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/009/009-1677380834.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-010",
		"PU-Name": "ILESHA  L.G.E.A.SCH",
		Accredited_Voters: 200,
		Registered_Voters: 753,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/010/010-1677374911.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-011",
		"PU-Name": "ILESHA  DISPENSARY",
		Accredited_Voters: 181,
		Registered_Voters: 919,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/011/011-1677376151.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-001",
		"PU-Name": "GBONGBORU  L.G.E.A.SCH",
		Accredited_Voters: 124,
		Registered_Voters: 854,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75552/75552-1677707800.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-002",
		"PU-Name": "DOGERE  L.G.E.A.SCH",
		Accredited_Voters: 119,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75553/75553-1677656047.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-003",
		"PU-Name": "KONTUBARU  L.G.E.A.SCH I",
		Accredited_Voters: 383,
		Registered_Voters: 689,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75554/75554-1677657398.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-004",
		"PU-Name": "KONTUBARU  L.G.E.A.SCH II",
		Accredited_Voters: 330,
		Registered_Voters: 891,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75555/75555-1677657895.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-005",
		"PU-Name": "MUNDURO  L.G.E.A.SCH",
		Accredited_Voters: 195,
		Registered_Voters: 871,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75556/75556-1677658873.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-006",
		"PU-Name": "AYOO  L.G.E.A.SCH",
		Accredited_Voters: 253,
		Registered_Voters: 753,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75557/75557-1677759202.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-007",
		"PU-Name": "WONKORU  L.G.E.A.SCH",
		Accredited_Voters: 235,
		Registered_Voters: 669,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75558/75558-1677659721.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-008",
		"PU-Name": "KERO  L.G.E.A.SCH",
		Accredited_Voters: 321,
		Registered_Voters: 812,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75559/75559-1677660277.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-009",
		"PU-Name": "BEKIA KERO",
		Accredited_Voters: 174,
		Registered_Voters: 542,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75560/75560-1677660748.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-010",
		"PU-Name": "YAKIRU MARKET",
		Accredited_Voters: 224,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75561/75561-1677710956.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-011",
		"PU-Name": "YAKIRU  L.G.E.A.SCH",
		Accredited_Voters: 198,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/75562/75562-1677710057.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-001",
		"PU-Name": "BIOGBERU  L.G.E.A.SCH I",
		Accredited_Voters: 120,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75563/75563-1677472765.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-002",
		"PU-Name": "BIOGBERU  L.G.E.A.SCH II",
		Accredited_Voters: 131,
		Registered_Voters: 963,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75564/75564-1677471875.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-003",
		"PU-Name": "DAWIRU  L.G.E.A.SCH",
		Accredited_Voters: 32,
		Registered_Voters: 346,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75565/75565-1677472312.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-004",
		"PU-Name": "BUDO AIKI  L.G.E.A.SCH",
		Accredited_Voters: 101,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75566/75566-1677471391.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-005",
		"PU-Name": "KIYORU  L.G.E.A.SCH",
		Accredited_Voters: 85,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75567/75567-1677454851.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-007",
		"PU-Name": "BWEN  L.G.E.A.SCH",
		Accredited_Voters: 153,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75569/75569-1677473735.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-008",
		"PU-Name": "BUKURO  L.G.E.A.SCH",
		Accredited_Voters: 99,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75570/75570-1677474116.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-010",
		"PU-Name": "GBABE  L.G.E.A.SCH",
		Accredited_Voters: 203,
		Registered_Voters: 1130,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75572/75572-1677454430.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-011",
		"PU-Name": "DAMERA  L.G.E.A.SCH",
		Accredited_Voters: 218,
		Registered_Voters: 791,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75573/75573-1677470408.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-013",
		"PU-Name": "KOBIARO MARKET",
		Accredited_Voters: 162,
		Registered_Voters: 684,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/75575/75575-1677469913.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-001",
		"PU-Name": "TENGE  L.G.E.A.SCH",
		Accredited_Voters: 77,
		Registered_Voters: 716,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74879/result_68454_1677751107_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-003",
		"PU-Name": "TEMIDIRE/AROGURU  L.G.E.A.SCH",
		Accredited_Voters: 50,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74881/result_68456_1677710129_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-004",
		"PU-Name": "TEU  L.G.E.A.SCH",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74882/result_68457_1677710327_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-005",
		"PU-Name": "FONFON  L.G.E.A.SCH",
		Accredited_Voters: 130,
		Registered_Voters: 886,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74883/result_68458_1677752002_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-006",
		"PU-Name": "BANKUBU  L.G.E.A.SCH",
		Accredited_Voters: 125,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74884/result_68459_1677752143_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-007",
		"PU-Name": "TENBONU L.G.E.A SCH",
		Accredited_Voters: 100,
		Registered_Voters: 701,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74885/result_68460_1677752351_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-008",
		"PU-Name": "KABODONORU L.G.E.A SCH",
		Accredited_Voters: 227,
		Registered_Voters: 897,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74886/result_68461_1677752444_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-009",
		"PU-Name": "GBANA GURU L.G.E.A SCH",
		Accredited_Voters: 62,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74887/result_68462_1677752528_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-011",
		"PU-Name": "OKUTA GOROBANI  MARKET",
		Accredited_Voters: 276,
		Registered_Voters: 676,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74889/result_68464_1677752696_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-012",
		"PU-Name": "OKUTA BARIKE PEOPLES' BANK",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74890/result_68465_1677752784_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-013",
		"PU-Name": "OKUTA BAPTIST L.G.E.A SCH",
		Accredited_Voters: 244,
		Registered_Voters: 977,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74891/result_68466_1677752878_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-015",
		"PU-Name": "OKUTA CENTRAL L.G.E.A SCH",
		Accredited_Voters: 209,
		Registered_Voters: 877,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74893/result_68468_1677753083_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-016",
		"PU-Name": "OKUTA NASARAWA NEW MARKET",
		Accredited_Voters: 302,
		Registered_Voters: 984,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74894/result_68469_1677753180_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-001",
		"PU-Name": "TEBETABERU MARKET",
		Accredited_Voters: 121,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/001/001-1677367397.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-002",
		"PU-Name": "TUNBUYAN L.G.E.A SCH",
		Accredited_Voters: 161,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/002/002-1677369934.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-003",
		"PU-Name": "BUKARU L.G.E.A SCH",
		Accredited_Voters: 312,
		Registered_Voters: 1291,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/003/003-1677382317.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-004",
		"PU-Name": "SUBAYO L.G.E.A SCH",
		Accredited_Voters: 219,
		Registered_Voters: 768,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/004/004-1677384371.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-005",
		"PU-Name": "SHINAWU OLD MARKET I",
		Accredited_Voters: 245,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/005/005-1677369998.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-006",
		"PU-Name": "SHINAWU OLD MARKET II",
		Accredited_Voters: 232,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/006/006-1677368697.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-001",
		"PU-Name": "DOGARI MARKET",
		Accredited_Voters: 99,
		Registered_Voters: 646,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/001/001-1677373979.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-002",
		"PU-Name": "WODORA L.G.E.A SCH",
		Accredited_Voters: 96,
		Registered_Voters: 623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/002/002-1677384859.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-003",
		"PU-Name": "KARONJI L.G.E.A SCH",
		Accredited_Voters: 106,
		Registered_Voters: 641,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/003/003-1677388023.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-004",
		"PU-Name": "GWETTE L.G.E.A SCH",
		Accredited_Voters: 113,
		Registered_Voters: 657,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/004/004-1677389286.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-005",
		"PU-Name": "BWERU/GANDO L.G.E.A SCH",
		Accredited_Voters: 93,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/005/005-1677390592.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-006",
		"PU-Name": "SHINATOKO L.G.E.A SCH",
		Accredited_Voters: 170,
		Registered_Voters: 894,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/006/006-1677395424.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-007",
		"PU-Name": "KUBURUFU L.G.E.A SCH",
		Accredited_Voters: 192,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/007/007-1677397461.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-008",
		"PU-Name": "KENUGBE MARKET",
		Accredited_Voters: 10,
		Registered_Voters: 446,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/11/pu/008/008-1677400980.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-009",
		"PU-Name": "SEKUGBE MARKET",
		Accredited_Voters: 11,
		Registered_Voters: 493,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75607/75607-1677680890.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-010",
		"PU-Name": "YASHIKIRA OLD MARKET",
		Accredited_Voters: 158,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75608/75608-1677680249.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-011",
		"PU-Name": "YASHIKIRA  L.G.E.A SCH",
		Accredited_Voters: 219,
		Registered_Voters: 859,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75609/75609-1677709583.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-012",
		"PU-Name": "CHIKANDA OLD MARKET",
		Accredited_Voters: 147,
		Registered_Voters: 724,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75610/75610-1677710630.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-013",
		"PU-Name": "CHIKANDA L.G.E.A SCH",
		Accredited_Voters: 101,
		Registered_Voters: 980,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75611/75611-1677711404.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-015",
		"PU-Name": "GWETTE SAAMU OPEN SPACE",
		Accredited_Voters: 58,
		Registered_Voters: 504,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/75613/75613-1677757988.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-001",
		"PU-Name": "L.G.E.A SCH SOMASUN I",
		Accredited_Voters: 194,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75614/75614-1677674020.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-003",
		"PU-Name": "L.G.E.A SCH SOMASUN III",
		Accredited_Voters: 261,
		Registered_Voters: 844,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75616/75616-1677674835.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-004",
		"PU-Name": "L.G.E.A SCH TAKO-GABI I",
		Accredited_Voters: 269,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75617/75617-1677675013.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-005",
		"PU-Name": "L.G.E.A SCH TAKO-GABI II",
		Accredited_Voters: 233,
		Registered_Voters: 741,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75618/75618-1677677342.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-006",
		"PU-Name": "OPEN SPACE EGBAN MAKUN AREA",
		Accredited_Voters: 275,
		Registered_Voters: 947,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75619/75619-1677657097.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-009",
		"PU-Name": "OPEN SPACE LAFIGYAMI  AREA",
		Accredited_Voters: 251,
		Registered_Voters: 810,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75622/75622-1677478863.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-010",
		"PU-Name": "OPEN SPACE EGBAN LIORAN SWASUN",
		Accredited_Voters: 203,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75623/75623-1677480390.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-011",
		"PU-Name": "MAGISTRATE COURT LAFIAGI",
		Accredited_Voters: 207,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/75624/75624-1677479284.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-001",
		"PU-Name": "L.G.E.A SCH ABAGYAMA I",
		Accredited_Voters: 196,
		Registered_Voters: 795,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74928/result_68537_1677609273_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-002",
		"PU-Name": "L.G.E.A SCH ABAGYAMA II",
		Accredited_Voters: 250,
		Registered_Voters: 934,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74929/result_68538_1677610003_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-003",
		"PU-Name": "LOCAL GOVT DISPENSARY",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74930/result_68539_1677610148_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-004",
		"PU-Name": "AREA COURT LAFIAGI",
		Accredited_Voters: 254,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74931/result_68540_1677610257_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-005",
		"PU-Name": "L.G.E.A SCH CENTRAL I",
		Accredited_Voters: 203,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74932/result_68541_1677610343_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-006",
		"PU-Name": "L.G.E.A SCH CENTRAL II",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74933/result_68542_1677610436_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-008",
		"PU-Name": "OPEN SPACE EGBAN NDAMARAKI",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74935/result_68544_1677610636_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-009",
		"PU-Name": "L.G.E.A SCH KOKODO",
		Accredited_Voters: 237,
		Registered_Voters: 855,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74936/result_68545_1677610728_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-010",
		"PU-Name": "CO-OPERATIVE STORE",
		Accredited_Voters: 138,
		Registered_Voters: 768,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74937/result_68546_1677610854_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-011",
		"PU-Name": "OPEN SPACE EGBAN NDEJI AREA",
		Accredited_Voters: 205,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74938/result_68547_1677610945_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-001",
		"PU-Name": "L.G.E.A SCH ZAMBUFU",
		Accredited_Voters: 229,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74939/result_68559_1677571320_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-002",
		"PU-Name": "L.G.E.A SCH GUYEDADI",
		Accredited_Voters: 328,
		Registered_Voters: 1100,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74940/result_68560_1677571421_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-003",
		"PU-Name": "L.G.E.A SCH GUYE DOKO",
		Accredited_Voters: 299,
		Registered_Voters: 861,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74941/result_68561_1677571527_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-004",
		"PU-Name": "L.G.E.A SCH GBALE",
		Accredited_Voters: 348,
		Registered_Voters: 1153,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74942/result_68562_1677571660_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-005",
		"PU-Name": "L.G.E.A SCH GANAGAGI",
		Accredited_Voters: 396,
		Registered_Voters: 1010,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74943/result_68563_1677571763_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-006",
		"PU-Name": "L.G.E.A SCH KPOTUNKO",
		Accredited_Voters: 220,
		Registered_Voters: 473,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74944/result_68564_1677571839_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-007",
		"PU-Name": "L.G.E.A SCH YAWU",
		Accredited_Voters: 227,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74945/result_68565_1677571929_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-008",
		"PU-Name": "L.G.E.A SCH GBUGBU",
		Accredited_Voters: 251,
		Registered_Voters: 886,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74946/result_68566_1677572016_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-009",
		"PU-Name": "VET OFFICE GAGARA",
		Accredited_Voters: 221,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74947/result_68567_1677572141_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-010",
		"PU-Name": "L.G.E.A SCH SABAGINA",
		Accredited_Voters: 295,
		Registered_Voters: 874,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74948/result_68568_1677572253_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-011",
		"PU-Name": "L.G.E.A SCH CHEKO SHAABAN",
		Accredited_Voters: 319,
		Registered_Voters: 854,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74949/result_68569_1677572310_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-012",
		"PU-Name": "L.G.E.A SCH NDEJI",
		Accredited_Voters: 219,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74950/result_68570_1677572416_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-001",
		"PU-Name": "OPEN SPACE LUMABA VILLAGE",
		Accredited_Voters: 159,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74951/result_68578_1677572550_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-002",
		"PU-Name": "L.G.E.A SCH KPASHA",
		Accredited_Voters: 172,
		Registered_Voters: 446,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74952/result_68579_1677662411_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-003",
		"PU-Name": "L.G.E.A SCH LIPATA",
		Accredited_Voters: 457,
		Registered_Voters: 897,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74953/result_68580_1677662725_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-006",
		"PU-Name": "L.G.E.A SCH EDOGI-DOKUN I",
		Accredited_Voters: 326,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74956/result_68583_1677663004_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-007",
		"PU-Name": "L.G.E.A SCH EDOGI-DOKUN II",
		Accredited_Voters: 432,
		Registered_Voters: 1040,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74957/result_68584_1677663078_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-008",
		"PU-Name": "L.G.E.A SCH DZARA",
		Accredited_Voters: 148,
		Registered_Voters: 441,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74958/result_68585_1677663286_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-010",
		"PU-Name": "L.G.E.A SCH EKKO",
		Accredited_Voters: 371,
		Registered_Voters: 962,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74960/result_68587_1677663473_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-013",
		"PU-Name": "L.G.E.A SCH KPANKPARAGI",
		Accredited_Voters: 141,
		Registered_Voters: 551,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74963/result_68590_1677664167_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-001",
		"PU-Name": "L.G.E.A SCH KANGE",
		Accredited_Voters: 288,
		Registered_Voters: 842,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74964/result_68595_1677576958_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-003",
		"PU-Name": "L.G.E.A SCH DADA",
		Accredited_Voters: 287,
		Registered_Voters: 813,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74966/result_68597_1677577147_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-004",
		"PU-Name": "L.G.E.A SCH ESANZHI",
		Accredited_Voters: 247,
		Registered_Voters: 916,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74967/result_68598_1677577398_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-005",
		"PU-Name": "L.G.E.A SCH  KPANDARAGI",
		Accredited_Voters: 220,
		Registered_Voters: 841,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74968/result_68599_1677585455_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-006",
		"PU-Name": "L.G.E.A SCH BATAKPAN",
		Accredited_Voters: 224,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74969/result_68600_1677577500_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-007",
		"PU-Name": "L.G.E.A SCH JIYADE",
		Accredited_Voters: 155,
		Registered_Voters: 982,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74970/result_68601_1677586035_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-008",
		"PU-Name": "L.G.E.A SCH GBAGUTA",
		Accredited_Voters: 217,
		Registered_Voters: 519,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74971/result_68602_1677577739_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-009",
		"PU-Name": "L.G.E.A SCH NINGUBA",
		Accredited_Voters: 243,
		Registered_Voters: 928,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74972/result_68603_1677577826_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-010",
		"PU-Name": "OPEN SPACE MAWOKPAN VILLAGE",
		Accredited_Voters: 121,
		Registered_Voters: 580,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74973/result_68604_1677586835.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-001",
		"PU-Name": "LOCAL GOVT DISPENSARY BACITA I",
		Accredited_Voters: 141,
		Registered_Voters: 661,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23124/pu/75671/75671-1677756599.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-002",
		"PU-Name": "LOCAL GOVT DISPENSARY BACITA II",
		Accredited_Voters: 167,
		Registered_Voters: 773,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23124/pu/75672/75672-1677757067.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-003",
		"PU-Name": "OPEN SPACE PATI-TUNKU AREA",
		Accredited_Voters: 119,
		Registered_Voters: 713,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74976/result_68613_1677573990_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-004",
		"PU-Name": "UMCA PRIMARY SCH BACITA",
		Accredited_Voters: 191,
		Registered_Voters: 853,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74977/result_68614_1677574614_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-005",
		"PU-Name": "LOCAL GOVT SUB OFFICE BACITA",
		Accredited_Voters: 173,
		Registered_Voters: 685,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74978/result_68615_1677574240_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-006",
		"PU-Name": "LOCAL GOVT DISPENSARY  BACITA VILLAGE",
		Accredited_Voters: 266,
		Registered_Voters: 856,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74979/result_68616_1677575647_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-007",
		"PU-Name": "L.G.E.A SCH MANFU",
		Accredited_Voters: 208,
		Registered_Voters: 853,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74980/result_68617_1677576811_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-009",
		"PU-Name": "L.G.E.A SCH FANAGU",
		Accredited_Voters: 210,
		Registered_Voters: 894,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74982/result_68619_1677586699_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-012",
		"PU-Name": "L.G.E.A SCH EGBANGI",
		Accredited_Voters: 147,
		Registered_Voters: 727,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74984/result_68621_1677577050_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-001",
		"PU-Name": "DISTRICT OFFICE TSARAGI I",
		Accredited_Voters: 163,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74986/result_68631_1677571196_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-002",
		"PU-Name": "DISTRICT OFFICE TSARAGI II",
		Accredited_Voters: 184,
		Registered_Voters: 691,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74987/result_68632_1677572137_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-003",
		"PU-Name": "L.G.E.A SCH  TSARAGI",
		Accredited_Voters: 219,
		Registered_Voters: 771,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74988/result_68633_1677572634_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-004",
		"PU-Name": "LOCAL GOVT DISPENSARY TSARAGI",
		Accredited_Voters: 206,
		Registered_Voters: 577,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74989/result_68634_1677580379_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-005",
		"PU-Name": "L.G.E.A SCH BOKUNGI",
		Accredited_Voters: 314,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74990/result_68635_1677588162.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-006",
		"PU-Name": "L.G.E.A SCH PATIDZURU",
		Accredited_Voters: 484,
		Registered_Voters: 1161,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74991/result_68636_1677597072_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-008",
		"PU-Name": "OPEN SPACE OLD GARAGE TSARAGI",
		Accredited_Voters: 143,
		Registered_Voters: 751,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74993/result_68638_1677600735_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-009",
		"PU-Name": "L.G.E.A SCH DUBANGI",
		Accredited_Voters: 242,
		Registered_Voters: 921,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74994/result_68639_1677581873_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-010",
		"PU-Name": "L.G.E.A SCH TSAKPATA",
		Accredited_Voters: 262,
		Registered_Voters: 891,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74995/result_68640_1677589154_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-011",
		"PU-Name": "OPEN SPACE MAYARA AREA TSARAGI",
		Accredited_Voters: 150,
		Registered_Voters: 865,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74996/result_68641_1677588853_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-012",
		"PU-Name": "OPEN SPACE KPATAYARU AREA",
		Accredited_Voters: 181,
		Registered_Voters: 816,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74997/result_68642_1677585321_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-013",
		"PU-Name": "OPEN SPACE TSWAATAFU  AREA",
		Accredited_Voters: 224,
		Registered_Voters: 686,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74998/result_68643_1677597591_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-001",
		"PU-Name": "DISTRICT OFFICE TSONGA",
		Accredited_Voters: 171,
		Registered_Voters: 882,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/74999/result_68651_1677573971_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-002",
		"PU-Name": "LOCAL GOVT DISPENSARY TSONGA",
		Accredited_Voters: 139,
		Registered_Voters: 838,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75000/result_68652_1677574138_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-003",
		"PU-Name": "L.G.E.A SCH KUCHITA",
		Accredited_Voters: 240,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75001/result_68653_1677574355_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-005",
		"PU-Name": "L.G.E.A SCH EMI-NDEJI II",
		Accredited_Voters: 192,
		Registered_Voters: 698,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75003/result_68655_1677574728_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-006",
		"PU-Name": "L.G.E.A SCH BONZO I",
		Accredited_Voters: 278,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75004/result_68656_1677574848_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-007",
		"PU-Name": "L.G.E.A SCH BONZO II",
		Accredited_Voters: 185,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75005/result_68657_1677574999_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-008",
		"PU-Name": "OPEN SPACE YIMAGI VILLAGE",
		Accredited_Voters: 104,
		Registered_Voters: 641,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75006/result_68658_1677575144_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-001",
		"PU-Name": "L.G.E.A SCH DUMAGI I",
		Accredited_Voters: 296,
		Registered_Voters: 764,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75009/result_68667_1677569510_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-004",
		"PU-Name": "L.G.E.A SCH TSPATA",
		Accredited_Voters: 196,
		Registered_Voters: 511,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75012/result_68670_1677571012_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-005",
		"PU-Name": "L.G.E.A SCH PATI OKUN",
		Accredited_Voters: 213,
		Registered_Voters: 690,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75013/result_68671_1677571257_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-006",
		"PU-Name": "L.G.E.A SCH KANKO",
		Accredited_Voters: 328,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75014/result_68672_1677571459_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-007",
		"PU-Name": "L.G.E.A SCH SINASUN",
		Accredited_Voters: 245,
		Registered_Voters: 806,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75015/result_68673_1677571675_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-008",
		"PU-Name": "L.G.E.A SCH MANUGA",
		Accredited_Voters: 200,
		Registered_Voters: 401,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75016/result_68674_1677572042_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-009",
		"PU-Name": "L.G.E.A SCH TSUFENE",
		Accredited_Voters: 200,
		Registered_Voters: 696,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75017/result_68675_1677572302_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-001",
		"PU-Name": "L.G.E.A SCH MAYAKI",
		Accredited_Voters: 221,
		Registered_Voters: 1007,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75018/result_68679_1677669183_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-002",
		"PU-Name": "L.G.E.A SCH FAIGI",
		Accredited_Voters: 381,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75019/result_68680_1677669007_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-003",
		"PU-Name": "MARKET SQ FAIGI",
		Accredited_Voters: 294,
		Registered_Voters: 592,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75020/result_68681_1677668871_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-004",
		"PU-Name": "L.G.E.A SCH BIDUGI",
		Accredited_Voters: 315,
		Registered_Voters: 754,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75021/result_68682_1677669256_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-005",
		"PU-Name": "L.G.E.A SCH SANCHITAGI I",
		Accredited_Voters: 323,
		Registered_Voters: 1049,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75022/result_68683_1677669339_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-006",
		"PU-Name": "L.G.E.A SCH SANCHITAGI II",
		Accredited_Voters: 195,
		Registered_Voters: 726,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75023/result_68684_1677669423_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-007",
		"PU-Name": "L.G.E.A SCH OGUDU I",
		Accredited_Voters: 182,
		Registered_Voters: 543,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75024/result_68685_1677669490_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-008",
		"PU-Name": "L.G.E.A SCH OGUDU II",
		Accredited_Voters: 135,
		Registered_Voters: 481,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75025/result_68686_1677669094_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-009",
		"PU-Name": "L.G.E.A SCH TADA",
		Accredited_Voters: 271,
		Registered_Voters: 889,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75026/result_68687_1677669554_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-010",
		"PU-Name": "L.G.E.A SCH NDAKANSA",
		Accredited_Voters: 336,
		Registered_Voters: 709,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75027/result_68688_1677669621_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ERUKU",
		"PU-Code": "23-04-01-001",
		"PU-Name": "ST CYPRIAN SCH. ERUKU I",
		Accredited_Voters: 104,
		Registered_Voters: 442,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75028/result_68692_1677565928_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ERUKU",
		"PU-Code": "23-04-01-002",
		"PU-Name": "ST CYPRIAN SCH. ERUKU II",
		Accredited_Voters: 94,
		Registered_Voters: 482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75029/result_68693_1677570169_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ERUKU",
		"PU-Code": "23-04-01-004",
		"PU-Name": "OPEN SPACE OKE-OGI, ERUKU",
		Accredited_Voters: 133,
		Registered_Voters: 504,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75031/result_68695_1677570347_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ERUKU",
		"PU-Code": "23-04-01-006",
		"PU-Name": "CO-OPERATIVE L.G.E.A SCH ERUKU I",
		Accredited_Voters: 236,
		Registered_Voters: 899,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75033/result_68697_1677570533_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ERUKU",
		"PU-Code": "23-04-01-007",
		"PU-Name": "CO-OPERATIVE L.G.E.A SCH ERUKU II",
		Accredited_Voters: 147,
		Registered_Voters: 597,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75034/result_68698_1677570611_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-001",
		"PU-Name": "OPEN SPACE ODO-AGO ISAPA",
		Accredited_Voters: 173,
		Registered_Voters: 835,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75035/result_68699_1677574920_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-003",
		"PU-Name": "OPEN SPACE IBERIKEDO ISAPA",
		Accredited_Voters: 143,
		Registered_Voters: 742,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75037/result_68701_1677578743_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-004",
		"PU-Name": "OPEN SPACE ODO-ITAN ISAPA",
		Accredited_Voters: 106,
		Registered_Voters: 703,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75038/result_68702_1677578916_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-005",
		"PU-Name": "OPEN SPACE OKE-IPO  ISAPA",
		Accredited_Voters: 100,
		Registered_Voters: 679,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75039/result_68703_1677577428_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-006",
		"PU-Name": "OPEN SPACE OKESA/MISSION",
		Accredited_Voters: 169,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75040/result_68704_1677578060_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "KORO",
		"PU-Code": "23-04-03-001",
		"PU-Name": "COMM SCH KORO",
		Accredited_Voters: 216,
		Registered_Voters: 1008,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75041/result_68707_1677626746_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "KORO",
		"PU-Code": "23-04-03-002",
		"PU-Name": "HEALTH CENTRE KORO",
		Accredited_Voters: 217,
		Registered_Voters: 819,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75042/result_68708_1677626822_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "KORO",
		"PU-Code": "23-04-03-003",
		"PU-Name": "MARKET CENTRE KORO",
		Accredited_Voters: 178,
		Registered_Voters: 624,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75043/result_68709_1677626904_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 1",
		"PU-Code": "23-04-04-001",
		"PU-Name": "OPEN SPACE EKELA",
		Accredited_Voters: 133,
		Registered_Voters: 500,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75044/result_68712_1677553654_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 1",
		"PU-Code": "23-04-04-002",
		"PU-Name": "OPEN SPACE ILEMESIN",
		Accredited_Voters: 230,
		Registered_Voters: 792,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75045/result_68713_1677553318_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 1",
		"PU-Code": "23-04-04-003",
		"PU-Name": "OPEN SPACE AJIU",
		Accredited_Voters: 79,
		Registered_Voters: 280,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75046/result_68714_1677552939_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-001",
		"PU-Name": "OPEN SPACE ILEMO OBBO-AIYEGUNLE I",
		Accredited_Voters: 157,
		Registered_Voters: 778,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/75746/75746-1677581019.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-002",
		"PU-Name": "OPEN SPACE IPETU  OBBO-AIYEGUNLE II",
		Accredited_Voters: 59,
		Registered_Voters: 560,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/75747/75747-1677581906.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-003",
		"PU-Name": "OPEN SPACE ILAWE 1   OBBO-AIYEGUNLE",
		Accredited_Voters: 83,
		Registered_Voters: 464,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/75748/75748-1677582574.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-004",
		"PU-Name": "OPEN SPACE ILAWE 11  OBBO-AIYEGUNLE",
		Accredited_Voters: 126,
		Registered_Voters: 536,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/75749/75749-1677584233.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-005",
		"PU-Name": "OPEN SPACE IWODI OBBO-AIYEGUNLE",
		Accredited_Voters: 124,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/75750/75750-1677588093.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-001",
		"PU-Name": "TOWN HALL,OBBO-ILE",
		Accredited_Voters: 157,
		Registered_Voters: 668,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75054/result_68724_1677681154_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-002",
		"PU-Name": "MARKET CENTRE, OBBO-ILE",
		Accredited_Voters: 152,
		Registered_Voters: 623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75055/result_68725_1677669965_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-003",
		"PU-Name": "OPEN SPACE ILAWE OBBO-ILE",
		Accredited_Voters: 225,
		Registered_Voters: 853,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75056/result_68726_1677670216_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-004",
		"PU-Name": "ST LUKE'S LGEA OBBO-ILE",
		Accredited_Voters: 170,
		Registered_Voters: 791,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75057/result_68727_1677670363_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-005",
		"PU-Name": "OPEN SPACE ORA OBBO-ILE",
		Accredited_Voters: 196,
		Registered_Voters: 1071,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75058/result_68728_1677680999_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-001",
		"PU-Name": "S.D.A SCH, OSI",
		Accredited_Voters: 263,
		Registered_Voters: 983,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75059/result_68731_1677625082_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-002",
		"PU-Name": "EKITI LOCAL GOVT VOCATIONAL CENTRE, OSI",
		Accredited_Voters: 162,
		Registered_Voters: 777,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75060/result_68732_1677625233_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-003",
		"PU-Name": "NEW SHOPPING COMPLEX, OSI",
		Accredited_Voters: 128,
		Registered_Voters: 544,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75061/result_68733_1677625334_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-004",
		"PU-Name": "OPEN SAPACE ILE OHUN, OSI",
		Accredited_Voters: 173,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75062/result_68734_1677625526_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-005",
		"PU-Name": "MAGISTRATE COURT, OSI",
		Accredited_Voters: 90,
		Registered_Voters: 403,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75063/result_68735_1677625628_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-006",
		"PU-Name": "NEW POST OFFICE, OSI",
		Accredited_Voters: 250,
		Registered_Voters: 754,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75064/result_68736_1677625994_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-007",
		"PU-Name": "AGBARA MARKET, OSI",
		Accredited_Voters: 145,
		Registered_Voters: 572,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75065/result_68737_1677626105_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-008",
		"PU-Name": "TOWN HALL, OSI",
		Accredited_Voters: 81,
		Registered_Voters: 359,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75066/result_68738_1677626193_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-001",
		"PU-Name": "ST BRIDGET'S SCH, OSI",
		Accredited_Voters: 129,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75067/result_68740_1677588730_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-002",
		"PU-Name": "AREA COURT, OSI",
		Accredited_Voters: 128,
		Registered_Voters: 526,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75068/result_68741_1677584966_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-003",
		"PU-Name": "OPEN SPACE ODORE-OKE, OSI",
		Accredited_Voters: 155,
		Registered_Voters: 618,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75069/result_68742_1677596196_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-004",
		"PU-Name": "OLD POSTAL AGENCY",
		Accredited_Voters: 140,
		Registered_Voters: 536,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75070/result_68743_1677596764.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-005",
		"PU-Name": "COMM LGEA SCH OSI",
		Accredited_Voters: 184,
		Registered_Voters: 745,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75071/result_68744_1677596917_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-001",
		"PU-Name": "L.G.E.A SCH, IKERIN I",
		Accredited_Voters: 252,
		Registered_Voters: 692,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75073/result_68747_1677582809_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-002",
		"PU-Name": "L.G.E.A SCH, IKERIN II",
		Accredited_Voters: 184,
		Registered_Voters: 457,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75074/result_68748_1677579521_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-003",
		"PU-Name": "L.G.E.A SCH, ISOLO-OPIN I",
		Accredited_Voters: 152,
		Registered_Voters: 714,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75075/result_68749_1677579276_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-004",
		"PU-Name": "L.G.E.A SCH, ISOLO-OPEN II",
		Accredited_Voters: 183,
		Registered_Voters: 754,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75076/result_68750_1677579781_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-006",
		"PU-Name": "L.G.E.A SCH, EPE-OPIN II",
		Accredited_Voters: 221,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75078/result_68752_1677578642_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-007",
		"PU-Name": "L.G.E.A SCH, ISARE I",
		Accredited_Voters: 169,
		Registered_Voters: 546,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75079/result_68753_1677581069_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-008",
		"PU-Name": "L.G.E.A SCH, ISARE II",
		Accredited_Voters: 146,
		Registered_Voters: 526,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75080/result_68754_1677580926_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-009",
		"PU-Name": "L.G.E.A SCH AJUBA",
		Accredited_Voters: 141,
		Registered_Voters: 496,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75081/result_68755_1677582021_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-011",
		"PU-Name": "L.G.E.A SCH, IDERA",
		Accredited_Voters: 57,
		Registered_Voters: 264,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23137/pu/75780/75780-1677845937.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-012",
		"PU-Name": "L.G.E.A SCH, ARAROMI OPIN",
		Accredited_Voters: 64,
		Registered_Voters: 447,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75084/result_68758_1677582652_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OPIN",
		"PU-Code": "23-04-09-013",
		"PU-Name": "OPEN SPACE AARE",
		Accredited_Voters: 102,
		Registered_Voters: 403,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75085/result_68759_1677584010_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-001",
		"PU-Name": "CENTRAL L.G.E.A SCH, OKE-OPIN",
		Accredited_Voters: 174,
		Registered_Voters: 570,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75086/result_68760_1677561376_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-002",
		"PU-Name": "TOWN HALL, OKE-OPIN",
		Accredited_Voters: 138,
		Registered_Voters: 533,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75087/result_68761_1677561551_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-003",
		"PU-Name": "OPEN SPACE OLOWI'S COMPD, OKE-OPIN",
		Accredited_Voters: 139,
		Registered_Voters: 542,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75088/result_68762_1677561674_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-004",
		"PU-Name": "OPEN SPACE ADETIFA, OKE-OPIN",
		Accredited_Voters: 90,
		Registered_Voters: 324,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75089/result_68763_1677561745_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-005",
		"PU-Name": "HEALTH CENTRE, OKE-OPIN",
		Accredited_Voters: 130,
		Registered_Voters: 593,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75090/result_68764_1677561819_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-006",
		"PU-Name": "ST PATRICK L.G.E.A SCH ETAN",
		Accredited_Voters: 285,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75091/result_68765_1677561886_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-007",
		"PU-Name": "MARKET CENTRE, ETAN",
		Accredited_Voters: 178,
		Registered_Voters: 624,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75092/result_68766_1677562062_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OKE-OPIN/ETAN",
		"PU-Code": "23-04-10-008",
		"PU-Name": "OPEN SPACE HEALTH CENTRE, ETAN",
		Accredited_Voters: 210,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75093/result_68767_1677562148_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-002",
		"PU-Name": "ARABIC SCH OKE-ODE",
		Accredited_Voters: 74,
		Registered_Voters: 317,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75095/result_68769_1677737149_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-004",
		"PU-Name": "TOWN HALL OKE-ODE",
		Accredited_Voters: 137,
		Registered_Voters: 639,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75097/result_68771_1677737262_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-006",
		"PU-Name": "MATERNITY OKE-ODE",
		Accredited_Voters: 108,
		Registered_Voters: 414,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75099/result_68773_1677737363_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-008",
		"PU-Name": "ILE ELEMOSHO OKE-ODE",
		Accredited_Voters: 147,
		Registered_Voters: 683,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75101/result_68775_1677737456_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-009",
		"PU-Name": "ECWA SCH OKE-ODE",
		Accredited_Voters: 59,
		Registered_Voters: 274,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75102/result_68776_1677737513_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 1",
		"PU-Code": "23-05-01-010",
		"PU-Name": "LOCAL GOVT DISPENSARY",
		Accredited_Voters: 101,
		Registered_Voters: 478,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75103/result_68777_1677737583_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-001",
		"PU-Name": "ECWA SCH SHAGBE I",
		Accredited_Voters: 176,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/001/001-1677363979.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-002",
		"PU-Name": "ECWA SCH SHAGBE II",
		Accredited_Voters: 216,
		Registered_Voters: 742,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/002/002-1677366413.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-003",
		"PU-Name": "ECWA SCH AGBEE I",
		Accredited_Voters: 42,
		Registered_Voters: 186,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/003/003-1677359051.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-004",
		"PU-Name": "ECWA SCH AGBEE II",
		Accredited_Voters: 109,
		Registered_Voters: 358,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/004/004-1677359825.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-005",
		"PU-Name": "COMM SCH AJEGUNLE",
		Accredited_Voters: 148,
		Registered_Voters: 352,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/005/005-1677360085.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-006",
		"PU-Name": "COMM SCH BANKOLE",
		Accredited_Voters: 117,
		Registered_Voters: 484,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/006/006-1677358660.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-007",
		"PU-Name": "COMM SCH  OLOGORUN",
		Accredited_Voters: 214,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/007/007-1677358926.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-008",
		"PU-Name": "MARKET SQUARE ALAWON ALASORO",
		Accredited_Voters: 108,
		Registered_Voters: 269,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/008/008-1677359481.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-009",
		"PU-Name": "COMM SCH FAMOLE",
		Accredited_Voters: 75,
		Registered_Voters: 354,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/009/009-1677358681.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-010",
		"PU-Name": "COMM SCH   ALABE-OJA",
		Accredited_Voters: 116,
		Registered_Voters: 291,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/010/010-1677358635.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 11",
		"PU-Code": "23-05-02-011",
		"PU-Name": "COMM SCH   OLOGOMO",
		Accredited_Voters: 133,
		Registered_Voters: 326,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/02/pu/011/011-1677358805.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-001",
		"PU-Name": "COMM SCH ALADE",
		Accredited_Voters: 119,
		Registered_Voters: 457,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75116/result_68790_1677736739_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-003",
		"PU-Name": "COMM SCH  ASUNGBALE",
		Accredited_Voters: 121,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23141/pu/75815/75815-1677602950.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-004",
		"PU-Name": "COMM SCH  DABU OROKI",
		Accredited_Voters: 119,
		Registered_Voters: 281,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75119/result_68793_1677736849_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-005",
		"PU-Name": "COMM SCH  ELEIYELE",
		Accredited_Voters: 83,
		Registered_Voters: 382,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/03/pu/005/005-1677364275.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-006",
		"PU-Name": "ECWA SCH LABAKA-OJA I",
		Accredited_Voters: 125,
		Registered_Voters: 462,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75121/result_68795_1677736941_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-008",
		"PU-Name": "COMM SCH OMI-ARO",
		Accredited_Voters: 192,
		Registered_Voters: 690,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23141/pu/75820/75820-1677530296.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OKE-ODE 111",
		"PU-Code": "23-05-03-009",
		"PU-Name": "COMM SCH  GBEDE",
		Accredited_Voters: 63,
		Registered_Voters: 232,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23141/pu/75821/75821-1677788765.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-004",
		"PU-Name": "MARKET SQUARE ORA",
		Accredited_Voters: 128,
		Registered_Voters: 767,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/004/004-1677367188.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-006",
		"PU-Name": "COMM SCH ADIGUN",
		Accredited_Voters: 45,
		Registered_Voters: 224,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/006/006-1677366465.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-007",
		"PU-Name": "OPEN SPACE BALOGUN VILLAGE",
		Accredited_Voters: 93,
		Registered_Voters: 454,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/007/007-1677366730.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-008",
		"PU-Name": "COMM SCH DESENI",
		Accredited_Voters: 69,
		Registered_Voters: 272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/008/008-1677365477.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-009",
		"PU-Name": "COMM SCH  AIREKE",
		Accredited_Voters: 94,
		Registered_Voters: 407,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75133/result_68807_1677736318_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-010",
		"PU-Name": "COMM SCH  MAGBON",
		Accredited_Voters: 31,
		Registered_Voters: 229,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/010/010-1677364869.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-001",
		"PU-Name": "COMM SCH BABANLA",
		Accredited_Voters: 177,
		Registered_Voters: 1083,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/001/001-1677384176.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-002",
		"PU-Name": "COUNCIL HALL BABANLA",
		Accredited_Voters: 152,
		Registered_Voters: 823,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75136/result_68811_1677737690_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-003",
		"PU-Name": "OPEN SPACE ILENDEJI BABANLA I",
		Accredited_Voters: 90,
		Registered_Voters: 721,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75137/result_68812_1677737740_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-005",
		"PU-Name": "LOCAL GOVT DISPENSARY OKE-OYAN",
		Accredited_Voters: 94,
		Registered_Voters: 833,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/005/005-1677384053.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-006",
		"PU-Name": "ECWA SCH  ALABE I",
		Accredited_Voters: 119,
		Registered_Voters: 703,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75140/result_68815_1677737814_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-007",
		"PU-Name": "ECWA SCH ALABE II",
		Accredited_Voters: 100,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/007/007-1677384103.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-008",
		"PU-Name": "ECWA SCH IDERA I",
		Accredited_Voters: 77,
		Registered_Voters: 518,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75142/result_68817_1677737895_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-010",
		"PU-Name": "COMM SCH IKOSIN",
		Accredited_Voters: 102,
		Registered_Voters: 658,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/010/010-1677383502.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-011",
		"PU-Name": "COMM SCH OWODE I",
		Accredited_Voters: 63,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75145/result_68820_1677738002_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-012",
		"PU-Name": "COMM SCH OWODE II",
		Accredited_Voters: 93,
		Registered_Voters: 658,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/012/012-1677383351.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-013",
		"PU-Name": "TOWN HALL KAJOLA",
		Accredited_Voters: 228,
		Registered_Voters: 1008,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75147/result_68822_1677738075_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-014",
		"PU-Name": "COMM SCH OWA ONIRE",
		Accredited_Voters: 120,
		Registered_Voters: 566,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/014/014-1677386164.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-015",
		"PU-Name": "COMM SCH  OREKE",
		Accredited_Voters: 154,
		Registered_Voters: 954,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/015/015-1677385052.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-016",
		"PU-Name": "COMM SCH  GANMU",
		Accredited_Voters: 115,
		Registered_Voters: 628,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/016/016-1677382432.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-017",
		"PU-Name": "COMM SCH  BUDOIDOWU",
		Accredited_Voters: 76,
		Registered_Voters: 479,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/017/017-1677381836.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-018",
		"PU-Name": "MARKET SQUARE IDOBA/OBIN",
		Accredited_Voters: 89,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75152/result_68827_1677738490_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-019",
		"PU-Name": "COMM SCH AFIN",
		Accredited_Voters: 93,
		Registered_Voters: 544,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/019/019-1677383948.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-001",
		"PU-Name": "COMM SCH AGUNJIN",
		Accredited_Voters: 121,
		Registered_Voters: 614,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/06/pu/001/001-1677364381.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-002",
		"PU-Name": "COUNCIL HALL AGUNJIN",
		Accredited_Voters: 112,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/06/pu/002/002-1677370215.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-003",
		"PU-Name": "ECWA SCH OLAYINKA",
		Accredited_Voters: 133,
		Registered_Voters: 607,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/06/pu/003/003-1677364425.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-004",
		"PU-Name": "COMM. SCH.,  OREE",
		Accredited_Voters: 88,
		Registered_Voters: 468,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75157/result_68835_1677750623_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-005",
		"PU-Name": "ECWA SCH AGBEKU",
		Accredited_Voters: 141,
		Registered_Voters: 482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75158/result_68836_1677750710_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-006",
		"PU-Name": "MARKET SQUARE AGBEKU",
		Accredited_Voters: 104,
		Registered_Voters: 514,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75159/result_68837_1677750819_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-007",
		"PU-Name": "COMM SCH AMORI WANDE",
		Accredited_Voters: 192,
		Registered_Voters: 751,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/06/pu/007/007-1677365342.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "AGUNJIN",
		"PU-Code": "23-05-06-008",
		"PU-Name": "ECWA SCH PATAKO",
		Accredited_Voters: 171,
		Registered_Voters: 629,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/06/pu/008/008-1677367818.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-001",
		"PU-Name": "ECWA SCH ORO-AGO",
		Accredited_Voters: 155,
		Registered_Voters: 908,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/001/001-1677375060.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-002",
		"PU-Name": "COMM SCH ORO-AGO",
		Accredited_Voters: 135,
		Registered_Voters: 856,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/002/002-1677375738.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-003",
		"PU-Name": "COMM SCH OKE-AYIN",
		Accredited_Voters: 193,
		Registered_Voters: 971,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/003/003-1677376183.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-004",
		"PU-Name": "ECWA SCH OYATE",
		Accredited_Voters: 98,
		Registered_Voters: 661,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/004/004-1677376547.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-005",
		"PU-Name": "OPEN SPACE AHUN VILLAGE",
		Accredited_Voters: 115,
		Registered_Voters: 848,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/005/005-1677377677.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-006",
		"PU-Name": "ECWA SCH OKEDABA I",
		Accredited_Voters: 78,
		Registered_Voters: 393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/006/006-1677380449.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-007",
		"PU-Name": "ECWA SCH OKEDABA II",
		Accredited_Voters: 111,
		Registered_Voters: 638,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/007/007-1677380678.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-008",
		"PU-Name": "COMM SCH OMUGO",
		Accredited_Voters: 145,
		Registered_Voters: 908,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/008/008-1677381132.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-009",
		"PU-Name": "COMM SCH IRABON",
		Accredited_Voters: 114,
		Registered_Voters: 651,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/009/009-1677381883.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-010",
		"PU-Name": "COMM SCH  OKEDIO",
		Accredited_Voters: 146,
		Registered_Voters: 760,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/010/010-1677381872.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-011",
		"PU-Name": "COMM SCH AJEGUNLE",
		Accredited_Voters: 127,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/011/011-1677382570.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-012",
		"PU-Name": "COMM SCH AJEGUNLE/OWA",
		Accredited_Voters: 100,
		Registered_Voters: 532,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/012/012-1677383771.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-013",
		"PU-Name": "COMM SCH OKE-OWA",
		Accredited_Voters: 67,
		Registered_Voters: 562,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/013/013-1677383666.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-014",
		"PU-Name": "OPEN SPACE AIYETORO",
		Accredited_Voters: 176,
		Registered_Voters: 833,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/014/014-1677384107.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-015",
		"PU-Name": "ADULT SCH OYATE",
		Accredited_Voters: 146,
		Registered_Voters: 619,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/015/015-1677384158.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-001",
		"PU-Name": "COMM SCH OMUPO",
		Accredited_Voters: 145,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75177/result_68861_1677752228_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-002",
		"PU-Name": "ST MICHAEL SCH OMUPO",
		Accredited_Voters: 191,
		Registered_Voters: 1021,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75178/result_68862_1677752295_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-003",
		"PU-Name": "ARABIC  SCH OMUPO",
		Accredited_Voters: 165,
		Registered_Voters: 696,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75179/result_68863_1677752473_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-004",
		"PU-Name": "SHEIK ISLAMIC SCH OMUPO",
		Accredited_Voters: 140,
		Registered_Voters: 647,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75180/result_68864_1677752548_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-005",
		"PU-Name": "ARABIC COLLEGE OMUPO",
		Accredited_Voters: 93,
		Registered_Voters: 501,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75181/result_68865_1677752601_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-006",
		"PU-Name": "COMM SCH AMODU",
		Accredited_Voters: 75,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75182/result_68866_1677752667_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-007",
		"PU-Name": "GOVT TECH  SCH AMODU",
		Accredited_Voters: 40,
		Registered_Voters: 281,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75183/result_68867_1677752771_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-008",
		"PU-Name": "COMM SCH KOKO",
		Accredited_Voters: 99,
		Registered_Voters: 468,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75184/result_68868_1677752835_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-009",
		"PU-Name": "L.G.E.A SCH KOKO",
		Accredited_Voters: 93,
		Registered_Voters: 448,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75185/result_68869_1677752914_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-010",
		"PU-Name": "WESLEY SCH OKANLE",
		Accredited_Voters: 120,
		Registered_Voters: 558,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75186/result_68870_1677752991_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-011",
		"PU-Name": "COMM SCH BASANYIN",
		Accredited_Voters: 172,
		Registered_Voters: 672,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75187/result_68871_1677753101_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-012",
		"PU-Name": "ANSARUL ISLAM SCH IGBOWU",
		Accredited_Voters: 199,
		Registered_Voters: 867,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75188/result_68872_1677753156_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-013",
		"PU-Name": "COMM SCH MALOKO",
		Accredited_Voters: 69,
		Registered_Voters: 621,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75189/result_68873_1677753217_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-015",
		"PU-Name": "COMM SCH  ZULU",
		Accredited_Voters: 70,
		Registered_Voters: 312,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75191/result_68875_1677753379_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-016",
		"PU-Name": "COMM SCH  OBALOYAN",
		Accredited_Voters: 108,
		Registered_Voters: 495,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75192/result_68876_1677753426_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-017",
		"PU-Name": "L.G.E.A SCH ARUGBO",
		Accredited_Voters: 29,
		Registered_Voters: 193,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75193/result_68877_1677753504_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-018",
		"PU-Name": "OPEN SPACE ATANDA NDA ALIYU",
		Accredited_Voters: 33,
		Registered_Voters: 342,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75194/result_68878_1677753586_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-001",
		"PU-Name": "COMM SCH SHARE",
		Accredited_Voters: 201,
		Registered_Voters: 749,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/001/001-1677378951.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-002",
		"PU-Name": "ILE BALE OJABUTU SHARE",
		Accredited_Voters: 170,
		Registered_Voters: 827,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/002/002-1677374646.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-003",
		"PU-Name": "ILE GARBA SOJA SHARE",
		Accredited_Voters: 115,
		Registered_Voters: 570,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/003/003-1677373229.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-004",
		"PU-Name": "SHAYO L.G.E.A SCH SHARE",
		Accredited_Voters: 206,
		Registered_Voters: 827,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/004/004-1677388219.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-005",
		"PU-Name": "AREA COURT SHARE",
		Accredited_Voters: 191,
		Registered_Voters: 733,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/005/005-1677379477.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-006",
		"PU-Name": "ILE ONIBI SHARE",
		Accredited_Voters: 72,
		Registered_Voters: 582,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/006/006-1677370620.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-001",
		"PU-Name": "N.Y.S.C BUS STOP SHARE",
		Accredited_Voters: 238,
		Registered_Voters: 915,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75203/result_68894_1677754108_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-002",
		"PU-Name": "ILE ABOLOGBON SHARE",
		Accredited_Voters: 209,
		Registered_Voters: 736,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75204/result_68895_1677754171_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-003",
		"PU-Name": "ILE OLULOKE SHARE",
		Accredited_Voters: 251,
		Registered_Voters: 765,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75205/result_68896_1677754225_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-004",
		"PU-Name": "ILE OLULOKE SHARE",
		Accredited_Voters: 251,
		Registered_Voters: 765,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75205/result_68896_1677754225_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-005",
		"PU-Name": "ILE AGUN   SHARE",
		Accredited_Voters: 267,
		Registered_Voters: 965,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75207/result_68898_1677754326_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-006",
		"PU-Name": "OPEN SPACE MOTOR PARK SHARE",
		Accredited_Voters: 188,
		Registered_Voters: 849,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/006/006-1677378626.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-007",
		"PU-Name": "ILE OLOWOLAIYEMO SHARE",
		Accredited_Voters: 69,
		Registered_Voters: 532,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/007/007-1677378086.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-008",
		"PU-Name": "TOWN HALL SHARE",
		Accredited_Voters: 157,
		Registered_Voters: 939,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/008/008-1677377657.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-001",
		"PU-Name": "KATALAGBON OPEN SPACE",
		Accredited_Voters: 265,
		Registered_Voters: 897,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/001/001-1677369619.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-002",
		"PU-Name": "OPEN SPACE  TITALAGOLO",
		Accredited_Voters: 86,
		Registered_Voters: 464,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/002/002-1677367792.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-003",
		"PU-Name": "MARKET SQUARE LOMA",
		Accredited_Voters: 212,
		Registered_Voters: 836,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/003/003-1677398206.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-004",
		"PU-Name": "COMM SCH  LOMA",
		Accredited_Voters: 107,
		Registered_Voters: 574,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/004/004-1677376341.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-005",
		"PU-Name": "AGUN AREA LOMA",
		Accredited_Voters: 91,
		Registered_Voters: 476,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/005/005-1677369018.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-006",
		"PU-Name": "OPEN SPACE ARUSA LOMA",
		Accredited_Voters: 68,
		Registered_Voters: 366,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/006/006-1677372282.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-007",
		"PU-Name": "OPEN SPACE OLABALU  LOMA",
		Accredited_Voters: 110,
		Registered_Voters: 582,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/007/007-1677374550.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-008",
		"PU-Name": "OPEN SPACE AWUWO   LOMA",
		Accredited_Voters: 154,
		Registered_Voters: 575,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/008/008-1677370972.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-009",
		"PU-Name": "OPEN SPACE FADEYI   LOMA",
		Accredited_Voters: 54,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/009/009-1677364738.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1V",
		"PU-Code": "23-05-12-001",
		"PU-Name": "OPEN SPACE GBOGILEMU",
		Accredited_Voters: 144,
		Registered_Voters: 522,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/12/pu/001/001-1677382809.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1V",
		"PU-Code": "23-05-12-003",
		"PU-Name": "COUNCIL HALL LOMA",
		Accredited_Voters: 139,
		Registered_Voters: 633,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/12/pu/003/003-1677379988.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1V",
		"PU-Code": "23-05-12-004",
		"PU-Name": "ILE OLUODE LOMA",
		Accredited_Voters: 90,
		Registered_Voters: 467,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/12/pu/004/004-1677373901.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1V",
		"PU-Code": "23-05-12-007",
		"PU-Name": "OPEN SPACE AFARI   AREA LOMA",
		Accredited_Voters: 94,
		Registered_Voters: 621,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/12/pu/007/007-1677383581.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1V",
		"PU-Code": "23-05-12-008",
		"PU-Name": "OPEN SPACE MALETE   AREA LOMA",
		Accredited_Voters: 63,
		Registered_Voters: 377,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/12/pu/008/008-1677383990.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-001",
		"PU-Name": "OPEN SPACE FAJE VILLAGE",
		Accredited_Voters: 155,
		Registered_Voters: 1006,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/001/001-1677372071.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-002",
		"PU-Name": "COMM SCH SHARE JUNCTION",
		Accredited_Voters: 244,
		Registered_Voters: 834,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/002/002-1677375988.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-004",
		"PU-Name": "COMM SCH LAKANLA",
		Accredited_Voters: 231,
		Registered_Voters: 781,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/004/004-1677361826.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-005",
		"PU-Name": "COMM SCH ALEGONGO",
		Accredited_Voters: 136,
		Registered_Voters: 433,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/005/005-1677365030.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-006",
		"PU-Name": "COMM SCH TEMIDIRE",
		Accredited_Voters: 159,
		Registered_Voters: 556,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/006/006-1677372812.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-007",
		"PU-Name": "COMM SCH SANGOTAYO/BUDO UMORU",
		Accredited_Voters: 118,
		Registered_Voters: 460,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/007/007-1677375066.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-008",
		"PU-Name": "ST MARTIN'S SCH ADIO",
		Accredited_Voters: 271,
		Registered_Voters: 1238,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/008/008-1677364155.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-009",
		"PU-Name": "COMM SCH ILUPEJU",
		Accredited_Voters: 88,
		Registered_Voters: 533,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/009/009-1677374321.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-010",
		"PU-Name": "COMM SCH ALERA",
		Accredited_Voters: 216,
		Registered_Voters: 745,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/010/010-1677364377.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-002",
		"PU-Name": "ECWA SCH IGBAJA",
		Accredited_Voters: 203,
		Registered_Voters: 839,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/002/002-1677380623.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-003",
		"PU-Name": "COMM SCH IGBAJA",
		Accredited_Voters: 231,
		Registered_Voters: 803,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/003/003-1677382515.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-004",
		"PU-Name": "JAMAAT SCH IGBAJA",
		Accredited_Voters: 117,
		Registered_Voters: 444,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/004/004-1677375373.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-005",
		"PU-Name": "JAMAAT SCH IGBAJA",
		Accredited_Voters: 73,
		Registered_Voters: 402,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/005/005-1677390109.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-006",
		"PU-Name": "BAPTIST SCH IGBAJA",
		Accredited_Voters: 146,
		Registered_Voters: 653,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/006/006-1677383253.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-007",
		"PU-Name": "OPEN SPACE ISALE IGBAJA",
		Accredited_Voters: 133,
		Registered_Voters: 398,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/007/007-1677379257.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-008",
		"PU-Name": "OPEN SPACE ISALE IGBAJA",
		Accredited_Voters: 192,
		Registered_Voters: 678,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/008/008-1677376807.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-009",
		"PU-Name": "ILE BALOGUN IGBAJA",
		Accredited_Voters: 110,
		Registered_Voters: 339,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/009/009-1677377281.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-010",
		"PU-Name": "ECWA DEM SCH IGBAJA",
		Accredited_Voters: 89,
		Registered_Voters: 349,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/010/010-1677378555.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 1",
		"PU-Code": "23-05-14-013",
		"PU-Name": "MARKET SQUARE IGBAJA",
		Accredited_Voters: 78,
		Registered_Voters: 366,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/14/pu/013/013-1677381294.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-001",
		"PU-Name": "COMM SCH OFFARESE",
		Accredited_Voters: 164,
		Registered_Voters: 467,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75252/result_68950_1677754897_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-002",
		"PU-Name": "COMM SCH ADANLA",
		Accredited_Voters: 199,
		Registered_Voters: 698,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75253/result_68951_1677755019_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-003",
		"PU-Name": "COMM SCH ALAKA",
		Accredited_Voters: 126,
		Registered_Voters: 306,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75254/result_68952_1677755080_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-004",
		"PU-Name": "COMM SCH  ALASORO",
		Accredited_Voters: 45,
		Registered_Voters: 424,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75255/result_68953_1677755136_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-005",
		"PU-Name": "COMM SCH  ATIRAN",
		Accredited_Voters: 189,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75256/result_68954_1677755194_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-006",
		"PU-Name": "COMM SCH  ILUPEJU",
		Accredited_Voters: 163,
		Registered_Voters: 802,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75257/result_68955_1677755247_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-007",
		"PU-Name": "COMM SCH  BALOGUN OJA",
		Accredited_Voters: 240,
		Registered_Voters: 823,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75258/result_68956_1677755296_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-008",
		"PU-Name": "JAMAT SCH IDIAPA",
		Accredited_Voters: 143,
		Registered_Voters: 418,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75259/result_68957_1677755359_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 11",
		"PU-Code": "23-05-15-009",
		"PU-Name": "COMM SCH ONIJO",
		Accredited_Voters: 84,
		Registered_Voters: 256,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75260/result_68958_1677755409_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-001",
		"PU-Name": "COMM SCH YARU",
		Accredited_Voters: 112,
		Registered_Voters: 368,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/16/pu/001/001-1677378538.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-002",
		"PU-Name": "MARKET SQUARE YARU",
		Accredited_Voters: 143,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/16/pu/002/002-1677382265.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-003",
		"PU-Name": "COMM SCH DUROSOTO",
		Accredited_Voters: 218,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/16/pu/003/003-1677377832.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-006",
		"PU-Name": "OPEN SPACE TONGOLO",
		Accredited_Voters: 110,
		Registered_Voters: 291,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/16/pu/006/006-1677379984.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-007",
		"PU-Name": "OPEN SPACE OROKI OJA",
		Accredited_Voters: 80,
		Registered_Voters: 311,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75267/result_68965_1677755620_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-008",
		"PU-Name": "MARKET SQUARE BAYERO",
		Accredited_Voters: 155,
		Registered_Voters: 457,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/16/pu/008/008-1677379251.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-009",
		"PU-Name": "L.G.E.A SCH AJIBOWO",
		Accredited_Voters: 142,
		Registered_Voters: 495,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75269/result_68967_1677756237_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IGBAJA 111",
		"PU-Code": "23-05-16-010",
		"PU-Name": "COMM SCH KUNMI",
		Accredited_Voters: 72,
		Registered_Voters: 303,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23154/pu/75967/75967-1677833856.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-001",
		"PU-Name": "COMM SCH IDOFIAN",
		Accredited_Voters: 171,
		Registered_Voters: 905,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/001/001-1677381340.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-003",
		"PU-Name": "ST JOHN'S SCH  IDOFIAN II",
		Accredited_Voters: 72,
		Registered_Voters: 448,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/003/003-1677380421.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-005",
		"PU-Name": "COMM SCH JIMBA OJA",
		Accredited_Voters: 179,
		Registered_Voters: 848,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/005/005-1677388788.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-006",
		"PU-Name": "ST JAME'S SCH FALOKUN-OJA",
		Accredited_Voters: 150,
		Registered_Voters: 709,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/006/006-1677385437.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-007",
		"PU-Name": "MARKET SQUARE FALOKUN",
		Accredited_Voters: 76,
		Registered_Voters: 466,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/007/007-1677404838.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-008",
		"PU-Name": "COMM SCH ALAKUKO",
		Accredited_Voters: 118,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23155/pu/75975/75975-1677584565.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-009",
		"PU-Name": "OPEN SPACE GATTA",
		Accredited_Voters: 54,
		Registered_Voters: 270,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/009/009-1677387620.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-001",
		"PU-Name": "COMM SCH GANMO",
		Accredited_Voters: 386,
		Registered_Voters: 1700,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75977/75977-1677635209.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-002",
		"PU-Name": "ARABIC SCH GANMO",
		Accredited_Voters: 217,
		Registered_Voters: 941,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75281/result_68983_1677736051_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-003",
		"PU-Name": "WESLEY SCH ELERINJARE I",
		Accredited_Voters: 150,
		Registered_Voters: 710,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75979/75979-1677694513.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-005",
		"PU-Name": "WESLEY SCH ELERINJARE III",
		Accredited_Voters: 106,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/18/pu/005/005-1677381818.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-006",
		"PU-Name": "ECWA SCH  AMAYO",
		Accredited_Voters: 302,
		Registered_Voters: 1272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75982/75982-1677634707.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-007",
		"PU-Name": "OPEN SPACE AMAYO",
		Accredited_Voters: 178,
		Registered_Voters: 1251,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75983/75983-1677634467.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-008",
		"PU-Name": "COMM SCH KABBA/DONGARI",
		Accredited_Voters: 108,
		Registered_Voters: 607,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75984/75984-1677634147.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-009",
		"PU-Name": "OPEN SPACE KABBA/KAJOLA",
		Accredited_Voters: 177,
		Registered_Voters: 1378,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75985/75985-1677633856.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-010",
		"PU-Name": "OPEN SPACE KABBA/OWODE",
		Accredited_Voters: 176,
		Registered_Voters: 644,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/18/pu/010/010-1677382489.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-011",
		"PU-Name": "OPEN SPACE GBAGEDE",
		Accredited_Voters: 157,
		Registered_Voters: 782,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/75987/75987-1677633602.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-003",
		"PU-Name": "GBADAMU LGEA SCH",
		Accredited_Voters: 188,
		Registered_Voters: 613,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75990/75990-1677602454.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-004",
		"PU-Name": "BUDO ODUNBAKU SCH",
		Accredited_Voters: 40,
		Registered_Voters: 135,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75991/75991-1677600784.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-005",
		"PU-Name": "AREGUN LGEA SCH",
		Accredited_Voters: 75,
		Registered_Voters: 229,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75992/75992-1677597900.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-007",
		"PU-Name": "AGBEYANGI LGEA SCH",
		Accredited_Voters: 104,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75994/75994-1677595044.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-008",
		"PU-Name": "ODE BALE ONIKOKO VILLAGE",
		Accredited_Voters: 73,
		Registered_Voters: 393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75995/75995-1677600428.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-009",
		"PU-Name": "ODE MAGAJI OSHIN VILLAGE",
		Accredited_Voters: 109,
		Registered_Voters: 456,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75996/75996-1677596856.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-010",
		"PU-Name": "BADI VILLAGE",
		Accredited_Voters: 89,
		Registered_Voters: 396,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75997/75997-1677603063.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-011",
		"PU-Name": "PANADA LGEA SCH",
		Accredited_Voters: 224,
		Registered_Voters: 657,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75998/75998-1677593481.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-012",
		"PU-Name": "ADELU VILLAGE",
		Accredited_Voters: 75,
		Registered_Voters: 379,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/75999/75999-1677603775.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-014",
		"PU-Name": "ABANGBE/JOLASUN LGEA",
		Accredited_Voters: 125,
		Registered_Voters: 473,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/76001/76001-1677592127.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-015",
		"PU-Name": "ODE-BALE MAPE VILLAGE",
		Accredited_Voters: 17,
		Registered_Voters: 251,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/76002/76002-1677601734.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "AGBEYANGI/GBADAMU/OSIN",
		"PU-Code": "23-06-01-017",
		"PU-Name": "AGBEYANGI LGEA SCH",
		Accredited_Voters: 122,
		Registered_Voters: 392,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23157/pu/76004/76004-1677594209.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-001",
		"PU-Name": "BALOGUN GAMBARI TAX OFFICE I",
		Accredited_Voters: 268,
		Registered_Voters: 1061,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75308/result_69021_1677592253_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-002",
		"PU-Name": "BALOGUN GAMBARI TAX OFFICE II",
		Accredited_Voters: 162,
		Registered_Voters: 780,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76006/76006-1677593359.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-003",
		"PU-Name": "OPPOSITE ITA AJIA",
		Accredited_Voters: 235,
		Registered_Voters: 864,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75310/result_69023_1677592969_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-004",
		"PU-Name": "OPEN SPACE MASANKORE",
		Accredited_Voters: 278,
		Registered_Voters: 727,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/004/004-1677401722.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-005",
		"PU-Name": "ODE KOLAWOLE I",
		Accredited_Voters: 227,
		Registered_Voters: 780,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76009/76009-1677684486.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-006",
		"PU-Name": "ODE KOLAWOLE II",
		Accredited_Voters: 160,
		Registered_Voters: 568,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76010/76010-1677594251.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-007",
		"PU-Name": "ITA MAGAJI",
		Accredited_Voters: 212,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/007/007-1677428053.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-008",
		"PU-Name": "ODE AJIBADE",
		Accredited_Voters: 307,
		Registered_Voters: 912,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/008/008-1677398432.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-009",
		"PU-Name": "ODE JAPA (KORO TAPA)",
		Accredited_Voters: 273,
		Registered_Voters: 735,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/009/009-1677399719.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-010",
		"PU-Name": "ODE ILE NLA AKANLABI",
		Accredited_Voters: 254,
		Registered_Voters: 759,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76014/76014-1677595016.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-011",
		"PU-Name": "AWODI MARKET I",
		Accredited_Voters: 187,
		Registered_Voters: 812,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76015/76015-1677599063.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-012",
		"PU-Name": "AWODI MARKET II",
		Accredited_Voters: 158,
		Registered_Voters: 511,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76016/76016-1677598668.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-013",
		"PU-Name": "ODE ILE ELERAN ITA ADU",
		Accredited_Voters: 343,
		Registered_Voters: 973,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/013/013-1677400413.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-014",
		"PU-Name": "AWODI MARKET III",
		Accredited_Voters: 196,
		Registered_Voters: 738,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76018/76018-1677600494.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-015",
		"PU-Name": "ODE ILE NLA AKANLABI",
		Accredited_Voters: 285,
		Registered_Voters: 779,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76019/76019-1677599639.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-016",
		"PU-Name": "ORI OKO AWODI",
		Accredited_Voters: 265,
		Registered_Voters: 767,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "TRUE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/76020/76020-1677597386.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-001",
		"PU-Name": "ODE WAZIRI GOBIR I",
		Accredited_Voters: 222,
		Registered_Voters: 870,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76021/76021-1677597359.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-002",
		"PU-Name": "ODE WAZIRI",
		Accredited_Voters: 66,
		Registered_Voters: 327,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76022/76022-1677602799.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-003",
		"PU-Name": "INFRONT OF ALABI BARE I",
		Accredited_Voters: 180,
		Registered_Voters: 687,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76023/76023-1677596573.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-004",
		"PU-Name": "INFRONT OF ALABI BARE II",
		Accredited_Voters: 254,
		Registered_Voters: 855,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76024/76024-1677599685.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-005",
		"PU-Name": "KARUMA L.G.E.A SCH I",
		Accredited_Voters: 214,
		Registered_Voters: 809,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76025/76025-1677597931.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-006",
		"PU-Name": "KARUMA L.G.E.A SCH II",
		Accredited_Voters: 265,
		Registered_Voters: 1036,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76026/76026-1677599242.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-007",
		"PU-Name": "ADEDO LANE",
		Accredited_Voters: 289,
		Registered_Voters: 941,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76027/76027-1677596449.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-009",
		"PU-Name": "OJAGBORO MINI MARKET II",
		Accredited_Voters: 223,
		Registered_Voters: 892,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76029/76029-1677599178.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-010",
		"PU-Name": "OJAGBORO L.G.E.A SCH I",
		Accredited_Voters: 279,
		Registered_Voters: 963,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76030/76030-1677599079.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-012",
		"PU-Name": "OJAGBORO L.G.E.A SCH II",
		Accredited_Voters: 287,
		Registered_Voters: 830,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76032/76032-1677599049.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-013",
		"PU-Name": "OPEN SPACE PATAKI",
		Accredited_Voters: 282,
		Registered_Voters: 782,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76033/76033-1677600446.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-014",
		"PU-Name": "ODE WAZIRI GOBIR II",
		Accredited_Voters: 169,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76034/76034-1677597421.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-015",
		"PU-Name": "INFRONT OF ALABI BARE III",
		Accredited_Voters: 260,
		Registered_Voters: 807,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76035/76035-1677757989.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-016",
		"PU-Name": "ODE SHABA PATAKI",
		Accredited_Voters: 252,
		Registered_Voters: 784,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/76036/76036-1677603533.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-001",
		"PU-Name": "GOVT. DAY SEC SCH AMULE I",
		Accredited_Voters: 364,
		Registered_Voters: 1411,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76037/76037-1677840553.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-002",
		"PU-Name": "GOVT. DAY SEC SCH AMULE II",
		Accredited_Voters: 179,
		Registered_Voters: 554,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76038/76038-1677593558.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-004",
		"PU-Name": "ODE ALAWONLA OKELELE II",
		Accredited_Voters: 227,
		Registered_Voters: 526,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76040/76040-1677603440.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-005",
		"PU-Name": "INFRONT OF JAGUN MOSQUE",
		Accredited_Voters: 260,
		Registered_Voters: 781,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76041/76041-1677603519.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-007",
		"PU-Name": "OKELELE L.G.E.A SCH II",
		Accredited_Voters: 216,
		Registered_Voters: 870,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76043/76043-1677660021.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-008",
		"PU-Name": "OKELELE L.G.E.A SCH III",
		Accredited_Voters: 220,
		Registered_Voters: 827,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76044/76044-1677601325.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-009",
		"PU-Name": "KANKATU MINI MARKET I",
		Accredited_Voters: 273,
		Registered_Voters: 935,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76045/76045-1677601209.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-010",
		"PU-Name": "KANKATU MINI MARKET II",
		Accredited_Voters: 372,
		Registered_Voters: 1083,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76046/76046-1677672494.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-011",
		"PU-Name": "ODE SEFURA OKELELE",
		Accredited_Voters: 258,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76047/76047-1677831277.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-012",
		"PU-Name": "SAMSUDEEN L.G.E.A SCH I",
		Accredited_Voters: 139,
		Registered_Voters: 823,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76048/76048-1677757620.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-013",
		"PU-Name": "SAMSUDEEN L.G.E.A SCH II",
		Accredited_Voters: 279,
		Registered_Voters: 1630,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76049/76049-1677659407.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-014",
		"PU-Name": "SAMSUDEEN L.G.E.A SCH III",
		Accredited_Voters: 172,
		Registered_Voters: 786,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76050/76050-1677765447.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-015",
		"PU-Name": "ODE BANIGBE (DADA K)",
		Accredited_Voters: 209,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76051/76051-1677754353.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-017",
		"PU-Name": "ODE ONDUGBE OKELELE",
		Accredited_Voters: 329,
		Registered_Voters: 915,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76053/76053-1677664875.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-018",
		"PU-Name": "ODE ELESIN OKELELE",
		Accredited_Voters: 307,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76054/76054-1677601405.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-019",
		"PU-Name": "ODE ASINLEKE",
		Accredited_Voters: 245,
		Registered_Voters: 894,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76055/76055-1677602599.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-020",
		"PU-Name": "ODE ONITOBI IDI ARO",
		Accredited_Voters: 187,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76056/76056-1677602752.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-021",
		"PU-Name": "INFRONT OF JAGUN MOSQUE",
		Accredited_Voters: 335,
		Registered_Voters: 1403,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76057/76057-1677593889.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-022",
		"PU-Name": "ODE ONITOBI IDIARO AREA",
		Accredited_Voters: 227,
		Registered_Voters: 775,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76058/76058-1677837304.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-023",
		"PU-Name": "GOVT DAY SEC SCH AMULE",
		Accredited_Voters: 218,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76059/76059-1677591523.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-024",
		"PU-Name": "OKELELE L.G.E.A SCH",
		Accredited_Voters: 241,
		Registered_Voters: 980,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/76060/76060-1677835019.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-001",
		"PU-Name": "FAMOLE L.G.E.A SCH",
		Accredited_Voters: 75,
		Registered_Voters: 243,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76061/76061-1677756849.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-002",
		"PU-Name": "WORU L.G.E.A SCH",
		Accredited_Voters: 210,
		Registered_Voters: 544,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/05/pu/002/002-1677408125.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-003",
		"PU-Name": "APADO L.G.E.A SCH",
		Accredited_Voters: 116,
		Registered_Voters: 407,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76063/76063-1677601335.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-004",
		"PU-Name": "AIGORO",
		Accredited_Voters: 214,
		Registered_Voters: 740,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/05/pu/004/004-1677409998.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-005",
		"PU-Name": "ALOKO/AFARA L.G.E.A SCH",
		Accredited_Voters: 169,
		Registered_Voters: 673,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76065/76065-1677601876.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-006",
		"PU-Name": "APADO VILLAGE I",
		Accredited_Voters: 112,
		Registered_Voters: 539,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76066/76066-1677662630.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-007",
		"PU-Name": "APADO L.G.E.A SCH",
		Accredited_Voters: 131,
		Registered_Voters: 524,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76067/76067-1677669064.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "APADO",
		"PU-Code": "23-06-05-008",
		"PU-Name": "APADO VILLAGE II",
		Accredited_Voters: 108,
		Registered_Voters: 419,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23161/pu/76068/76068-1677663788.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-001",
		"PU-Name": "OLORO L.G.E.A SCH",
		Accredited_Voters: 115,
		Registered_Voters: 438,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/001/001-1677406031.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-002",
		"PU-Name": "IPONRIN L.G.E.A SCH",
		Accredited_Voters: 182,
		Registered_Voters: 581,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/002/002-1677406295.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-003",
		"PU-Name": "ODE BALE ISAMU VILLAGE",
		Accredited_Voters: 127,
		Registered_Voters: 450,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/003/003-1677408051.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-005",
		"PU-Name": "ODE BALE BUDO FULANI",
		Accredited_Voters: 90,
		Registered_Voters: 379,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/005/005-1677409838.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-006",
		"PU-Name": "ODE BALE ISAJE OJA IPONRIN",
		Accredited_Voters: 143,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/006/006-1677410409.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-007",
		"PU-Name": "ODE BALE  IPONRIN",
		Accredited_Voters: 138,
		Registered_Voters: 442,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/007/007-1677410750.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IPONRIN",
		"PU-Code": "23-06-06-008",
		"PU-Name": "IPONRIN L.G.E.A SCH",
		Accredited_Voters: 191,
		Registered_Voters: 543,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/06/pu/008/008-1677411479.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-001",
		"PU-Name": "ODE SAUTA ADIFA I",
		Accredited_Voters: 218,
		Registered_Voters: 707,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76077/76077-1677766075.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-002",
		"PU-Name": "ODE SAUTA ADIFA II",
		Accredited_Voters: 172,
		Registered_Voters: 481,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76078/76078-1677753539.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-003",
		"PU-Name": "IDI APE MARKET I",
		Accredited_Voters: 273,
		Registered_Voters: 978,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76079/76079-1677751662.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-004",
		"PU-Name": "IDI APE MARKET II",
		Accredited_Voters: 276,
		Registered_Voters: 964,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76080/76080-1677754785.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-005",
		"PU-Name": "ODE BABA ORO",
		Accredited_Voters: 235,
		Registered_Voters: 887,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76081/76081-1677753339.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-008",
		"PU-Name": "IDI AGBEDE MARKET",
		Accredited_Voters: 211,
		Registered_Voters: 762,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76083/76083-1677753965.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-009",
		"PU-Name": "ODE ILE GANGAN AKODUDU",
		Accredited_Voters: 262,
		Registered_Voters: 761,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76085/76085-1677755689.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-010",
		"PU-Name": "ODE ILE GANGAN",
		Accredited_Voters: 138,
		Registered_Voters: 319,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76086/76086-1677751885.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-011",
		"PU-Name": "OKE OKUTA I",
		Accredited_Voters: 253,
		Registered_Voters: 796,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76087/76087-1677706790.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-012",
		"PU-Name": "OKE OKUTA I",
		Accredited_Voters: 253,
		Registered_Voters: 796,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76087/76087-1677706790.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-013",
		"PU-Name": "ODE DAUDU AMULE",
		Accredited_Voters: 256,
		Registered_Voters: 757,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76089/76089-1677756841.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-014",
		"PU-Name": "ODE OBA ONILU",
		Accredited_Voters: 224,
		Registered_Voters: 712,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76090/76090-1677756625.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-015",
		"PU-Name": "OPEN SPACE ORISANKOKO I",
		Accredited_Voters: 164,
		Registered_Voters: 402,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76091/76091-1677753752.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-016",
		"PU-Name": "OPEN SPACE ORISANKOKO II",
		Accredited_Voters: 167,
		Registered_Voters: 265,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76092/76092-1677755246.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-017",
		"PU-Name": "ODE AGBADAMU I",
		Accredited_Voters: 303,
		Registered_Voters: 797,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76093/76093-1677750690.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-018",
		"PU-Name": "ILE ELETU I",
		Accredited_Voters: 280,
		Registered_Voters: 798,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76094/76094-1677754250.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-019",
		"PU-Name": "ODE ILE ELETU",
		Accredited_Voters: 267,
		Registered_Voters: 746,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76095/76095-1677755486.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-020",
		"PU-Name": "ODE ONILU OKEKURA",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76096/76096-1677751464.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-021",
		"PU-Name": "OKEKURA OPEN SPACE",
		Accredited_Voters: 213,
		Registered_Voters: 832,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76097/76097-1677750463.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-022",
		"PU-Name": "ODE AGBADAMU II",
		Accredited_Voters: 240,
		Registered_Voters: 693,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76098/76098-1677756198.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-023",
		"PU-Name": "IDI APE MARKET III",
		Accredited_Voters: 212,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76099/76099-1677757476.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-024",
		"PU-Name": "ILE ELETU II",
		Accredited_Voters: 227,
		Registered_Voters: 644,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76100/76100-1677768247.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-025",
		"PU-Name": "IDI APE MARKET IV",
		Accredited_Voters: 260,
		Registered_Voters: 824,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/76101/76101-1677766714.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-002",
		"PU-Name": "ALALUBOSA N.MARABA GARAGE II",
		Accredited_Voters: 188,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76103/76103-1677597701.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-003",
		"PU-Name": "ST JOHN'S L.G.E.A I",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/003/003-1677414238.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-004",
		"PU-Name": "ST JOHN'S L.G.E.A II",
		Accredited_Voters: 165,
		Registered_Voters: 1069,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76105/76105-1677599467.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-005",
		"PU-Name": "ST JOHN'S L.G.E.A III",
		Accredited_Voters: 178,
		Registered_Voters: 993,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76106/76106-1677602427.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-007",
		"PU-Name": "GOVT SEC SCH ILORIN I",
		Accredited_Voters: 234,
		Registered_Voters: 1304,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76108/76108-1677595965.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-008",
		"PU-Name": "GOVT SEC SCH ILORIN II",
		Accredited_Voters: 164,
		Registered_Voters: 976,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/008/008-1677406571.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-009",
		"PU-Name": "GOVT SEC SCH ILORIN III",
		Accredited_Voters: 144,
		Registered_Voters: 975,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76110/76110-1677587633.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-010",
		"PU-Name": "OPP COMM OF POLICE",
		Accredited_Voters: 111,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/010/010-1677392245.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-011",
		"PU-Name": "INFRONT OF KWARA HOTEL I",
		Accredited_Voters: 154,
		Registered_Voters: 930,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76112/76112-1677452972.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-012",
		"PU-Name": "INFRONT OF KWARA HOTEL II",
		Accredited_Voters: 110,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/012/012-1677413629.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-013",
		"PU-Name": "INFRONT OF KWARA HOTEL III",
		Accredited_Voters: 129,
		Registered_Voters: 917,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76114/76114-1677593947.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-014",
		"PU-Name": 'INFRONT OF POLICE "A" DIVISION I',
		Accredited_Voters: 179,
		Registered_Voters: 1368,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76115/76115-1677603889.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-015",
		"PU-Name": 'INFRONT OF POLICE "A" DIVISION II',
		Accredited_Voters: 74,
		Registered_Voters: 621,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76116/76116-1677590420.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-016",
		"PU-Name": "OPPOSITE GOVT HOUSE ILORIN I",
		Accredited_Voters: 171,
		Registered_Voters: 1085,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/016/016-1677382426.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-017",
		"PU-Name": "OPPOSITE GOVT HOUSE ILORIN II",
		Accredited_Voters: 65,
		Registered_Voters: 597,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76118/76118-1677475478.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-018",
		"PU-Name": "OPPOSITE GOVT HOUSE ILORIN III",
		Accredited_Voters: 147,
		Registered_Voters: 941,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/018/018-1677396611.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-019",
		"PU-Name": "OPPOSITE GOVT HOUSE ILORIN IV",
		Accredited_Voters: 121,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/019/019-1677364663.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-020",
		"PU-Name": "ST BARNABAS L.G.E.A SCH I",
		Accredited_Voters: 207,
		Registered_Voters: 833,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76121/76121-1677558894.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-021",
		"PU-Name": "ST BARNABAS L.G.E.A SCH II",
		Accredited_Voters: 88,
		Registered_Voters: 572,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/021/021-1677397268.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-022",
		"PU-Name": "ST BARNABAS L.G.E.A SCH III",
		Accredited_Voters: 70,
		Registered_Voters: 383,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/022/022-1677382723.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-024",
		"PU-Name": "ST BARNABAS L.G.E.A SCH V",
		Accredited_Voters: 63,
		Registered_Voters: 413,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/76125/76125-1677603575.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-001",
		"PU-Name": "ELESINMETA L.G.E.A. SCH I",
		Accredited_Voters: 86,
		Registered_Voters: 325,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76126/76126-1677500822.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-002",
		"PU-Name": "ELESINMETA L.G.E.A. SCH II",
		Accredited_Voters: 97,
		Registered_Voters: 291,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76127/76127-1677676703.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-003",
		"PU-Name": "MARAFA L.G.E.A. SCH I",
		Accredited_Voters: 91,
		Registered_Voters: 308,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76128/76128-1677676970.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-004",
		"PU-Name": "MARAFA L.G.E.A. SCH II",
		Accredited_Voters: 82,
		Registered_Voters: 267,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76129/76129-1677677183.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-005",
		"PU-Name": "PEPELE L.G.E.A. SCH",
		Accredited_Voters: 56,
		Registered_Voters: 150,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76130/76130-1677500934.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-006",
		"PU-Name": "BUDO OBA L.G.E.A. SCH",
		Accredited_Voters: 155,
		Registered_Voters: 474,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/09/pu/006/006-1677426134.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-008",
		"PU-Name": "DALEMA L.G.E.A. SCH",
		Accredited_Voters: 80,
		Registered_Voters: 200,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76133/76133-1677677461.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-009",
		"PU-Name": "JABI L.G.E.A. SCH",
		Accredited_Voters: 26,
		Registered_Voters: 90,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76134/76134-1677677611.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-010",
		"PU-Name": "AJELENDE L.G.E.A. SCH",
		Accredited_Voters: 85,
		Registered_Voters: 265,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76135/76135-1677662851.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-011",
		"PU-Name": "AIYETORO ILE L.G.E.A. SCH",
		Accredited_Voters: 86,
		Registered_Voters: 235,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75439/result_69237_1677661574_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-013",
		"PU-Name": "ELESINMETA VILLAGE",
		Accredited_Voters: 66,
		Registered_Voters: 260,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76138/76138-1677677789.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-014",
		"PU-Name": "MARAFA VILLAGE",
		Accredited_Voters: 81,
		Registered_Voters: 262,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76139/76139-1677501563.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-015",
		"PU-Name": "ADANDA VILLAGE",
		Accredited_Voters: 83,
		Registered_Voters: 258,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76140/76140-1677506905.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-016",
		"PU-Name": "KELEBE VILLAGE",
		Accredited_Voters: 20,
		Registered_Voters: 69,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76141/76141-1677669784.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-017",
		"PU-Name": "PEPELE L.G.E.A. SCH",
		Accredited_Voters: 54,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76142/76142-1677501817.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-018",
		"PU-Name": "OYO IDERA OPEN SPACE",
		Accredited_Voters: 136,
		Registered_Voters: 390,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76143/76143-1677669607.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MARAFA/PEPELE",
		"PU-Code": "23-06-09-019",
		"PU-Name": "OLORORO VILLAGE (OPEN SPACE)",
		Accredited_Voters: 72,
		Registered_Voters: 257,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23165/pu/76144/76144-1677673168.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-001",
		"PU-Name": "ARAMONU L.G.E.A. SCH",
		Accredited_Voters: 93,
		Registered_Voters: 337,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/001/001-1677413742.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-002",
		"PU-Name": "ZENTU  L.G.E.A. SCH",
		Accredited_Voters: 112,
		Registered_Voters: 698,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/002/002-1677403830.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-003",
		"PU-Name": "MAYA L.G.E.A. SCH",
		Accredited_Voters: 285,
		Registered_Voters: 870,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75450/result_69248_1677756177_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-004",
		"PU-Name": "BUDO  ALFA",
		Accredited_Voters: 76,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/004/004-1677410694.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-005",
		"PU-Name": "ODE BALE ATIKAN",
		Accredited_Voters: 111,
		Registered_Voters: 434,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/005/005-1677405370.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-006",
		"PU-Name": "BUDO ARE L.G.E.A. SCH",
		Accredited_Voters: 48,
		Registered_Voters: 404,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/006/006-1677404451.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-007",
		"PU-Name": "AKE L.G.E.A. SCH",
		Accredited_Voters: 46,
		Registered_Voters: 272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/007/007-1677409174.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-008",
		"PU-Name": "OHA ISSA",
		Accredited_Voters: 60,
		Registered_Voters: 350,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/008/008-1677413173.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-009",
		"PU-Name": "OHA L.G.E.A. SCH",
		Accredited_Voters: 46,
		Registered_Voters: 296,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/009/009-1677410249.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-010",
		"PU-Name": "LAJIKI L.G.E.A. SCH",
		Accredited_Voters: 81,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/010/010-1677406762.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-011",
		"PU-Name": "ILE ADAN",
		Accredited_Voters: 64,
		Registered_Voters: 821,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/011/011-1677404879.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-012",
		"PU-Name": "ALASE L.G.E.A. SCH",
		Accredited_Voters: 77,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/012/012-1677407168.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-013",
		"PU-Name": "OHA GBAGI",
		Accredited_Voters: 64,
		Registered_Voters: 418,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/013/013-1677412581.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-015",
		"PU-Name": "LAJIKI L.G.E.A. SCH II",
		Accredited_Voters: 56,
		Registered_Voters: 456,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/015/015-1677407122.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-016",
		"PU-Name": "BUDO ARE L.G.E.A. SCH",
		Accredited_Voters: 37,
		Registered_Voters: 189,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/016/016-1677410035.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-017",
		"PU-Name": "OKE-ODO",
		Accredited_Voters: 60,
		Registered_Voters: 205,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/017/017-1677416036.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-019",
		"PU-Name": "OPEN SPACE ATERE VILLAGE",
		Accredited_Voters: 17,
		Registered_Voters: 578,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/019/019-1677406005.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-001",
		"PU-Name": "OKE OYI AREA COUNCIL",
		Accredited_Voters: 251,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75467/result_69267_1677579657_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-002",
		"PU-Name": "ODE BODE OKE OYI",
		Accredited_Voters: 371,
		Registered_Voters: 718,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75468/result_69268_1677580671_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-003",
		"PU-Name": "ODE BALE OKE OYI",
		Accredited_Voters: 199,
		Registered_Voters: 429,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75469/result_69269_1677580767_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-004",
		"PU-Name": "OKE OYI L.G.E.A. SCH",
		Accredited_Voters: 241,
		Registered_Voters: 555,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75470/result_69270_1677580886_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-005",
		"PU-Name": "ODE BALE IDI APA VILLAGE",
		Accredited_Voters: 143,
		Registered_Voters: 338,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75471/result_69271_1677580932_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-006",
		"PU-Name": "ODE BALE IPAKO OBO",
		Accredited_Voters: 97,
		Registered_Voters: 295,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75472/result_69272_1677581029_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-007",
		"PU-Name": "ODE BALE AFEYIN VILLAGE",
		Accredited_Voters: 169,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75473/result_69273_1677581082_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-008",
		"PU-Name": "ODE BALE OTEFON  VILLAGE",
		Accredited_Voters: 188,
		Registered_Voters: 527,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75474/result_69274_1677581146_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-009",
		"PU-Name": "OKE OSE L.G.E.A. SCH",
		Accredited_Voters: 357,
		Registered_Voters: 919,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75475/result_69275_1677581214_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-010",
		"PU-Name": "ODE MAGAJI VILLAGE ALALUBOSA",
		Accredited_Voters: 110,
		Registered_Voters: 500,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75476/result_69276_1677581324_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-011",
		"PU-Name": "ODE MAGAJI VILLAGE GAMBE",
		Accredited_Voters: 193,
		Registered_Voters: 403,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75477/result_69277_1677581743_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-012",
		"PU-Name": "ODE BALE AGBOGE VILLAGE",
		Accredited_Voters: 131,
		Registered_Voters: 334,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23167/pu/76175/76175-1677478621.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-013",
		"PU-Name": "ODE BALE ABATA VILLAGE",
		Accredited_Voters: 140,
		Registered_Voters: 374,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75479/result_69279_1677581935_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-014",
		"PU-Name": "ODE BALE ABATA VILLAGE",
		Accredited_Voters: 140,
		Registered_Voters: 374,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75479/result_69279_1677581935_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-015",
		"PU-Name": "ODE BALE DANGII",
		Accredited_Voters: 77,
		Registered_Voters: 284,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75481/result_69281_1677582234_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-017",
		"PU-Name": "ODE BALE APATA YAKUBA",
		Accredited_Voters: 233,
		Registered_Voters: 954,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75483/result_69283_1677582686_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-018",
		"PU-Name": "L.G.E.A. SCH  BUDO OBA",
		Accredited_Voters: 136,
		Registered_Voters: 391,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75484/result_69284_1677582774_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-019",
		"PU-Name": "LAJOLO VILLAGE",
		Accredited_Voters: 155,
		Registered_Voters: 967,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75485/result_69285_1677582851_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-020",
		"PU-Name": "FAJE TUNTUN VILLAGE",
		Accredited_Voters: 101,
		Registered_Voters: 412,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75486/result_69286_1677583268_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-021",
		"PU-Name": "ALALUBOSA VILLAGE I",
		Accredited_Voters: 64,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75487/result_69287_1677583560_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-022",
		"PU-Name": "ALALUBOSA VILLAGE II",
		Accredited_Voters: 77,
		Registered_Voters: 384,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75488/result_69288_1677587067_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-023",
		"PU-Name": "ODE BALE AIYETORO",
		Accredited_Voters: 162,
		Registered_Voters: 338,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75489/result_69289_1677587757_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-001",
		"PU-Name": "OKESUNA L.G.E.A. SCH I",
		Accredited_Voters: 274,
		Registered_Voters: 938,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75491/result_69293_1677595135_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-002",
		"PU-Name": "OKESUNA L.G.E.A. SCH I",
		Accredited_Voters: 274,
		Registered_Voters: 938,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75491/result_69293_1677595135_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-003",
		"PU-Name": "OPEN SPACE AT BACK OF OKESUNA SCH I",
		Accredited_Voters: 180,
		Registered_Voters: 744,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/76190/76190-1677601796.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-004",
		"PU-Name": "OPEN SPACE AT BACK OF OKESUNA SCH II",
		Accredited_Voters: 240,
		Registered_Voters: 958,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/76191/76191-1677668675.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-005",
		"PU-Name": "PAKE L.G.E.A. SCH I",
		Accredited_Voters: 237,
		Registered_Voters: 1170,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75495/result_69297_1677591084_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-006",
		"PU-Name": "PAKE L.G.E.A. SCH II",
		Accredited_Voters: 230,
		Registered_Voters: 1029,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/76193/76193-1677679872.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-009",
		"PU-Name": "ODE SERIKI GAMBARI II",
		Accredited_Voters: 247,
		Registered_Voters: 881,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/12/pu/009/009-1677424361.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-010",
		"PU-Name": "MAD. ALFA OMO IYA ISALE KANIKE I",
		Accredited_Voters: 284,
		Registered_Voters: 764,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75500/result_69302_1677589152_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-011",
		"PU-Name": "MAD. ALFA OMO IYA ISALE KANIKE II",
		Accredited_Voters: 209,
		Registered_Voters: 537,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75501/result_69303_1677588890_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-012",
		"PU-Name": "ODE SERIKI ZANGO",
		Accredited_Voters: 201,
		Registered_Voters: 843,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/76199/76199-1677684540.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-013",
		"PU-Name": "ODE MAYAKI ILORIN",
		Accredited_Voters: 151,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75503/result_69305_1677680995_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-014",
		"PU-Name": "ODE UBANDAWAKI",
		Accredited_Voters: 198,
		Registered_Voters: 626,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75504/result_69306_1677591428_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-015",
		"PU-Name": "ADUALERE OPEN SPACE",
		Accredited_Voters: 217,
		Registered_Voters: 918,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75505/result_69307_1677589455_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-016",
		"PU-Name": "PAKE L.G.E.A. SCH",
		Accredited_Voters: 147,
		Registered_Voters: 764,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75506/result_69308_1677590395_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-017",
		"PU-Name": "ODE ILE ALATA",
		Accredited_Voters: 266,
		Registered_Voters: 832,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75507/result_69309_1677596801_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-018",
		"PU-Name": "ODE ILE MAYAKI",
		Accredited_Voters: 111,
		Registered_Voters: 488,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75508/result_69310_1677672930_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-002",
		"PU-Name": "OMOLERE L.G.E.A SCH",
		Accredited_Voters: 161,
		Registered_Voters: 420,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/002/002-1677415327.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-003",
		"PU-Name": "OPEN SPACE AJOKO",
		Accredited_Voters: 71,
		Registered_Voters: 370,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/003/003-1677391236.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-005",
		"PU-Name": "OPEN SPACE ILOTA AIYETORO",
		Accredited_Voters: 110,
		Registered_Voters: 450,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/005/005-1677394994.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-006",
		"PU-Name": "OPEN SPACE APAOLA BALE'S HOUSE",
		Accredited_Voters: 94,
		Registered_Voters: 282,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/006/006-1677408886.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-007",
		"PU-Name": "OPEN SPACE ABELU-BADA VILLAGE",
		Accredited_Voters: 85,
		Registered_Voters: 383,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/007/007-1677414842.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-008",
		"PU-Name": "OPEN SPACE AGARA VILLAGE",
		Accredited_Voters: 65,
		Registered_Voters: 320,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/008/008-1677409896.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-009",
		"PU-Name": "OPEN SPACE OLOTA'S PALACE",
		Accredited_Voters: 59,
		Registered_Voters: 325,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/009/009-1677397529.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1",
		"PU-Code": "23-07-01-010",
		"PU-Name": "OPEN SPACE  APAOLA",
		Accredited_Voters: 82,
		Registered_Voters: 258,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/01/pu/010/010-1677404781.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-002",
		"PU-Name": "OMODE L.G.E.A SCH",
		Accredited_Voters: 115,
		Registered_Voters: 425,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76217/76217-1677580628.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-003",
		"PU-Name": "OPEN SPACE MAGAJI VILLAGE",
		Accredited_Voters: 133,
		Registered_Voters: 489,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76218/76218-1677582230.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-004",
		"PU-Name": "JOROMO OSHIN L.G.E.A SCH I",
		Accredited_Voters: 71,
		Registered_Voters: 342,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76219/76219-1677581455.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-005",
		"PU-Name": "OJE L.G.E.A SCH",
		Accredited_Voters: 111,
		Registered_Voters: 511,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76220/76220-1677583012.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-007",
		"PU-Name": "OPEN SPACE ISOKUN VILLAGE",
		Accredited_Voters: 193,
		Registered_Voters: 613,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76222/76222-1677585445.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -11",
		"PU-Code": "23-07-02-008",
		"PU-Name": "JOROMO OSHIN L.G.E.A SCH II",
		Accredited_Voters: 74,
		Registered_Voters: 360,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23170/pu/76223/76223-1677586005.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-001",
		"PU-Name": "OPOLO L.G.E.A SCH",
		Accredited_Voters: 198,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75527/result_69342_1677621058_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-003",
		"PU-Name": "OPEN SPACE GBENLE PRESS",
		Accredited_Voters: 229,
		Registered_Voters: 1116,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75529/result_69344_1677640850_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-004",
		"PU-Name": "OPEN SPACE ADJACENT DEEPER LIFE",
		Accredited_Voters: 147,
		Registered_Voters: 696,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75530/result_69345_1677639787_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-005",
		"PU-Name": "OPEN SPACE EBENEZER NUR/PRY SCH I",
		Accredited_Voters: 211,
		Registered_Voters: 979,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75531/result_69346_1677640651_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-006",
		"PU-Name": "OPEN SPACE EBENEZER NUR/PRY SCH II",
		Accredited_Voters: 111,
		Registered_Voters: 686,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75532/result_69347_1677639715_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-007",
		"PU-Name": "OKE OGUN HEALTH CENTRE",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75533/result_69348_1677640180_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-008",
		"PU-Name": "AGBABIAKA L.G.E.A SCH",
		Accredited_Voters: 232,
		Registered_Voters: 857,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75534/result_69349_1677640090_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-009",
		"PU-Name": "OPEN SPACE PIPELINE JUNCTION GAA AKANBI",
		Accredited_Voters: 296,
		Registered_Voters: 1276,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75535/result_69350_1677639520_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-012",
		"PU-Name": "OPEN SPACE ERO OMO ATIKEKERE",
		Accredited_Voters: 128,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75538/result_69353_1677621200_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-014",
		"PU-Name": "OPEN SPACE BUDO AGBANKA",
		Accredited_Voters: 202,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75540/result_69355_1677639100_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-015",
		"PU-Name": "OPEN SPACE ITA AYISA VILLAGE",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75541/result_69356_1677639374_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-016",
		"PU-Name": "OPEN SPACE BUDO OLU LANDE",
		Accredited_Voters: 219,
		Registered_Voters: 1040,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75542/result_69357_1677640581_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-017",
		"PU-Name": "OPEN SPACE ONIREKE VILLAGE",
		Accredited_Voters: 190,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75543/result_69358_1677621396_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-018",
		"PU-Name": "OPEN SPACE BUDO SALAKO",
		Accredited_Voters: 193,
		Registered_Voters: 765,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75544/result_69359_1677639312_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-019",
		"PU-Name": "DANIALU  L.G.E.A SCH",
		Accredited_Voters: 479,
		Registered_Voters: 1482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75545/result_69360_1677619546_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-020",
		"PU-Name": "OPEN SPACE ERO-OMO GARAGE-OFFA",
		Accredited_Voters: 207,
		Registered_Voters: 1257,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75546/result_69361_1677617167_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-021",
		"PU-Name": "OPEN SPACE ERO-OMO SAW-MILL GARAGE",
		Accredited_Voters: 168,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75547/result_69362_1677621507_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-001",
		"PU-Name": "UNILORIN MAIN CAMPUS I",
		Accredited_Voters: 145,
		Registered_Voters: 1021,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76247/76247-1677574069.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-002",
		"PU-Name": "UNILORIN MAIN CAMPUS II",
		Accredited_Voters: 47,
		Registered_Voters: 639,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76248/76248-1677571527.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-003",
		"PU-Name": "OPEN SPACE UNILORIN STAFF QTRS",
		Accredited_Voters: 98,
		Registered_Voters: 575,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76249/76249-1677588128.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-004",
		"PU-Name": "OPEN SPACE BUDO JALALA",
		Accredited_Voters: 292,
		Registered_Voters: 1771,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/004/004-1677405842.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-005",
		"PU-Name": "OPEN SPACE MIN OF HEALTH FATE I",
		Accredited_Voters: 275,
		Registered_Voters: 1023,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76251/76251-1677589007.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-006",
		"PU-Name": "OPEN SPACE OPP. MIN OF HEALTH FATE II",
		Accredited_Voters: 146,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76252/76252-1677587020.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-007",
		"PU-Name": "TANKE L.G.E.A SCH ALENIBORO I",
		Accredited_Voters: 274,
		Registered_Voters: 952,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76253/76253-1677574312.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-008",
		"PU-Name": "TANKE L.G.E.A SCH ALENIBORO II",
		Accredited_Voters: 269,
		Registered_Voters: 1107,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76254/76254-1677571130.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-009",
		"PU-Name": "TANKE L.G.E.A SCH ALENIBORO III",
		Accredited_Voters: 304,
		Registered_Voters: 1120,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76255/76255-1677590537.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-010",
		"PU-Name": "OPEN SPACE MIN OF HEALTH FATE III",
		Accredited_Voters: 168,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76256/76256-1677584490.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-011",
		"PU-Name": "OPEN SPACE OPP MIN OF HEALTH FATE IV",
		Accredited_Voters: 224,
		Registered_Voters: 1039,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/011/011-1677395862.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-012",
		"PU-Name": "TANKE GOVT DAY SEC SCH I",
		Accredited_Voters: 226,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76258/76258-1677575846.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-013",
		"PU-Name": "TANKE GOVT DAY SEC SCH II",
		Accredited_Voters: 190,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/013/013-1677418827.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-014",
		"PU-Name": "OPEN SPACE BUDO AJANAKU VILLAGE",
		Accredited_Voters: 230,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76260/76260-1677570791.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-015",
		"PU-Name": "OPEN SPACE BUDO LAWANI",
		Accredited_Voters: 60,
		Registered_Voters: 384,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76261/76261-1677580286.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-016",
		"PU-Name": "OPEN SPACE RIVER BASIN I",
		Accredited_Voters: 227,
		Registered_Voters: 937,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76262/76262-1677574797.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-017",
		"PU-Name": "OPEN SPACE RIVER BASIN II",
		Accredited_Voters: 264,
		Registered_Voters: 1149,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76263/76263-1677580996.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-018",
		"PU-Name": "ODOFIN JUNCTION BASIN RD I",
		Accredited_Voters: 162,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/018/018-1677403828.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-019",
		"PU-Name": "ODOFIN JUNCTION BASIN RD II",
		Accredited_Voters: 127,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76265/76265-1677482192.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-020",
		"PU-Name": "FATE L.G.E.A SCH I",
		Accredited_Voters: 180,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76266/76266-1677589243.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-021",
		"PU-Name": "FATE L.G.E.A SCH II",
		Accredited_Voters: 174,
		Registered_Voters: 890,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76267/76267-1677578041.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-022",
		"PU-Name": "OPEN SPACE BUDO MASUDO",
		Accredited_Voters: 182,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/022/022-1677417577.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-023",
		"PU-Name": "OPEN SPACE BUDO BOLORUNDURO",
		Accredited_Voters: 194,
		Registered_Voters: 831,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76269/76269-1677590188.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-024",
		"PU-Name": "OPEN SPACE DE-FASHION INSTITUTE",
		Accredited_Voters: 237,
		Registered_Voters: 1134,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76270/76270-1677586718.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-025",
		"PU-Name": "AGO-AIYEKALE L.G.E.A SCH",
		Accredited_Voters: 231,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/76271/76271-1677587749.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-001",
		"PU-Name": "KANGILE L.G.E.A SCH",
		Accredited_Voters: 159,
		Registered_Voters: 663,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/001/001-1677424712.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-002",
		"PU-Name": "OPEN SPACE BUDO GBAGBA",
		Accredited_Voters: 243,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/002/002-1677427014.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-003",
		"PU-Name": "OPEN SPACE GAA OSIBI",
		Accredited_Voters: 178,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/003/003-1677426365.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-004",
		"PU-Name": "FED TRAINING CENTRE KULENDE I",
		Accredited_Voters: 189,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/004/004-1677428550.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-005",
		"PU-Name": "FED TRAINING CENTRE KULENDE II",
		Accredited_Voters: 242,
		Registered_Voters: 959,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76276/76276-1677470019.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-006",
		"PU-Name": "FED TRAINING CENTRE KULENDE III",
		Accredited_Voters: 212,
		Registered_Voters: 977,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76277/76277-1677470622.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-008",
		"PU-Name": "INFRONT OF SERIKIN HAUSAWA KULENDE",
		Accredited_Voters: 238,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76279/76279-1677471584.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-009",
		"PU-Name": "OPP SERIKIN-HAUSAWA KULENDE I",
		Accredited_Voters: 235,
		Registered_Voters: 981,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76280/76280-1677472030.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-010",
		"PU-Name": "OPP SERIKIN-HAUSAWA KULENDE II",
		Accredited_Voters: 219,
		Registered_Voters: 930,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76281/76281-1677472858.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-012",
		"PU-Name": "OPEN SPACE AJEGUNLE AREA I",
		Accredited_Voters: 173,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76283/76283-1677473619.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-013",
		"PU-Name": "OPEN SPACE AJEGUNLE AREA II",
		Accredited_Voters: 187,
		Registered_Voters: 881,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76284/76284-1677474979.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-014",
		"PU-Name": "OPEN SPACE ALAPARUN",
		Accredited_Voters: 187,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76285/76285-1677475828.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-015",
		"PU-Name": "ANSARUL-ISLAM OGIDI",
		Accredited_Voters: 317,
		Registered_Voters: 1231,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76286/76286-1677476433.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-017",
		"PU-Name": "KULENDE L.G.E.A SCH",
		Accredited_Voters: 188,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76288/76288-1677478233.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-018",
		"PU-Name": "OPEN SPACE SOBI ALAGBADO",
		Accredited_Voters: 180,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76289/76289-1677478723.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-019",
		"PU-Name": "OPEN SPACE LOW COST HOUSING OLOJE",
		Accredited_Voters: 181,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/76290/76290-1677479626.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-001",
		"PU-Name": "AREA COURT CENTRE IGBORO",
		Accredited_Voters: 253,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/001/001-1677406958.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-002",
		"PU-Name": "POST OFFICE CENTRE IGBORO",
		Accredited_Voters: 151,
		Registered_Voters: 818,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/002/002-1677396330.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-003",
		"PU-Name": "DISPENSARY/CLINIC CENTRE IGBORO",
		Accredited_Voters: 180,
		Registered_Voters: 707,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/003/003-1677410467.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-004",
		"PU-Name": "DOMESTIC TRAINING CENTRE IGBORO",
		Accredited_Voters: 123,
		Registered_Voters: 529,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/004/004-1677403760.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-005",
		"PU-Name": "OPEN SPACE ILE OLOWO",
		Accredited_Voters: 226,
		Registered_Voters: 608,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/005/005-1677384240.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-006",
		"PU-Name": "ODE SAADU LAUFE",
		Accredited_Voters: 235,
		Registered_Voters: 706,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/006/006-1677408255.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-007",
		"PU-Name": "INFRONT OF MAKAMA'S MOSQUE",
		Accredited_Voters: 131,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/007/007-1677409190.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-008",
		"PU-Name": "OPEN SPACE IDI-ADAN I",
		Accredited_Voters: 221,
		Registered_Voters: 696,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/008/008-1677405196.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-009",
		"PU-Name": "OPEN SPACE IDI-ADAN II",
		Accredited_Voters: 213,
		Registered_Voters: 605,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/009/009-1677401174.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-011",
		"PU-Name": "OPEN SPACE ERUBU LANE II",
		Accredited_Voters: 195,
		Registered_Voters: 614,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/011/011-1677390621.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-013",
		"PU-Name": "ODE ALFA AMINU",
		Accredited_Voters: 135,
		Registered_Voters: 416,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/013/013-1677412171.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-014",
		"PU-Name": "OPEN SPACE ILE DAGBO",
		Accredited_Voters: 212,
		Registered_Voters: 629,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/014/014-1677411608.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-015",
		"PU-Name": "OPEN SPACE ASUNNARA",
		Accredited_Voters: 161,
		Registered_Voters: 531,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/015/015-1677410347.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-016",
		"PU-Name": "OPEN SPACE ASUNNARA",
		Accredited_Voters: 161,
		Registered_Voters: 531,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/015/015-1677410347.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-017",
		"PU-Name": "OPEN SPACE ITA SEKUN",
		Accredited_Voters: 153,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/017/017-1677387743.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-018",
		"PU-Name": "ODE KPATAKO OPEN SPACE",
		Accredited_Voters: 210,
		Registered_Voters: 683,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/018/018-1677405677.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-001",
		"PU-Name": "OPEN SPACE ODE BALOGUN FULANI I",
		Accredited_Voters: 266,
		Registered_Voters: 918,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/07/pu/001/001-1677392220.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-002",
		"PU-Name": "OPEN SPACE ODE BALOGUN FULANI II",
		Accredited_Voters: 297,
		Registered_Voters: 980,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75613/result_69508_1677649315_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-003",
		"PU-Name": "OPEN SPACE IDI AGBON",
		Accredited_Voters: 279,
		Registered_Voters: 817,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75614/result_69509_1677649367_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-004",
		"PU-Name": "OPEN SPACE ODE ALFA DEMBO",
		Accredited_Voters: 380,
		Registered_Voters: 982,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75615/result_69510_1677649420_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-005",
		"PU-Name": "OPEN SPACE BELLO MOTOR'S HOUSE I",
		Accredited_Voters: 264,
		Registered_Voters: 850,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/07/pu/005/005-1677405571.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-006",
		"PU-Name": "OPEN SPACE BELLO MOTOR'S HOUSE II",
		Accredited_Voters: 202,
		Registered_Voters: 728,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75617/result_69512_1677649472_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-007",
		"PU-Name": "ISALE MALIKI L.G.E.A I",
		Accredited_Voters: 265,
		Registered_Voters: 757,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75618/result_69513_1677649530_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-008",
		"PU-Name": "ISALE MALIKI L.G.E.A II",
		Accredited_Voters: 225,
		Registered_Voters: 590,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75619/result_69514_1677649586_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-009",
		"PU-Name": "ISALE MALIKI L.G.E.A III",
		Accredited_Voters: 98,
		Registered_Voters: 419,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75620/result_69515_1677649656_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-010",
		"PU-Name": "ISALE MALIKI L.G.E.A IV",
		Accredited_Voters: 137,
		Registered_Voters: 669,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75621/result_69516_1677649702_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-001",
		"PU-Name": "OPEN SPACE GBABIABIDUN I",
		Accredited_Voters: 197,
		Registered_Voters: 845,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/001/001-1677395627.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-002",
		"PU-Name": "OPEN SPACE GBABIABIDUN II",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/002/002-1677397709.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-003",
		"PU-Name": "ODE BABAGIWA",
		Accredited_Voters: 230,
		Registered_Voters: 909,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/003/003-1677400053.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-004",
		"PU-Name": "OPEN SPACE ODE OLORIN I",
		Accredited_Voters: 241,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/004/004-1677401692.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-005",
		"PU-Name": "OPEN SPACE ODE OLORIN II",
		Accredited_Voters: 182,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/005/005-1677405671.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-006",
		"PU-Name": "OPEN SPACE ODE ALFA IBEJI",
		Accredited_Voters: 188,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/006/006-1677406101.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-007",
		"PU-Name": "GOVT GIRLS DAY SEC SCH OKESUNA I",
		Accredited_Voters: 188,
		Registered_Voters: 709,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/007/007-1677417417.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-008",
		"PU-Name": "GOVT GIRLS DAY SEC SCH OKESUNA II",
		Accredited_Voters: 250,
		Registered_Voters: 992,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/008/008-1677418624.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-001",
		"PU-Name": "OPEN SPACE ODE OLODO ALUKO I",
		Accredited_Voters: 194,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/001/001-1677419224.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-002",
		"PU-Name": "OPEN SPACE ODE OLODO ALUKO II",
		Accredited_Voters: 187,
		Registered_Voters: 811,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/002/002-1677419632.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-003",
		"PU-Name": "OPEN SPACE ODE A.K SULE I",
		Accredited_Voters: 255,
		Registered_Voters: 868,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75633/result_69541_1677650443_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-004",
		"PU-Name": "OPEN SPACE ODE A.K SULE II",
		Accredited_Voters: 164,
		Registered_Voters: 613,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/004/004-1677420066.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-005",
		"PU-Name": "OPEN SPACE EBU-GADA",
		Accredited_Voters: 256,
		Registered_Voters: 969,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/005/005-1677420784.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-006",
		"PU-Name": "OPEN SPACE ODE AMINU",
		Accredited_Voters: 236,
		Registered_Voters: 905,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/006/006-1677421082.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-007",
		"PU-Name": "OPEN SPACE ODE IKOKORO I",
		Accredited_Voters: 250,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/007/007-1677421495.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-008",
		"PU-Name": "OPEN SPACE ODE IKOKORO II",
		Accredited_Voters: 180,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/008/008-1677421791.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-009",
		"PU-Name": "OPEN SPACE ODE  OPELE",
		Accredited_Voters: 217,
		Registered_Voters: 777,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/009/009-1677422208.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-010",
		"PU-Name": "ODE ADETO HUNWA I",
		Accredited_Voters: 174,
		Registered_Voters: 840,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/010/010-1677422581.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-011",
		"PU-Name": "ODE ADETO HUNWA II",
		Accredited_Voters: 114,
		Registered_Voters: 692,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/011/011-1677422847.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-012",
		"PU-Name": "ST WILLIAMS L.G.E.A",
		Accredited_Voters: 338,
		Registered_Voters: 1286,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/012/012-1677423335.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-001",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH I",
		Accredited_Voters: 263,
		Registered_Voters: 1134,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/001/001-1677406712.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-002",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH II",
		Accredited_Voters: 203,
		Registered_Voters: 920,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/002/002-1677387691.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-003",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH III",
		Accredited_Voters: 207,
		Registered_Voters: 996,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75645/result_69562_1677623124_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-004",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH IV",
		Accredited_Voters: 177,
		Registered_Voters: 735,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/004/004-1677385778.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-005",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH V",
		Accredited_Voters: 145,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/005/005-1677390208.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-006",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH VI",
		Accredited_Voters: 169,
		Registered_Voters: 888,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23178/pu/76345/76345-1677533753.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-007",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH VII",
		Accredited_Voters: 150,
		Registered_Voters: 888,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/007/007-1677423337.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-008",
		"PU-Name": "ST MACHEAL L.G.E.A SCH I",
		Accredited_Voters: 208,
		Registered_Voters: 902,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/008/008-1677386690.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-009",
		"PU-Name": "ST MACHEAL L.G.E.A SCH II",
		Accredited_Voters: 115,
		Registered_Voters: 716,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/009/009-1677390001.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-010",
		"PU-Name": "ST MACHEAL L.G.E.A SCH III",
		Accredited_Voters: 119,
		Registered_Voters: 738,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/010/010-1677387759.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-011",
		"PU-Name": "ST MACHEAL L.G.E.A SCH IV",
		Accredited_Voters: 79,
		Registered_Voters: 690,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/011/011-1677388454.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-002",
		"PU-Name": "ODE ALFA EDUN",
		Accredited_Voters: 335,
		Registered_Voters: 828,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/002/002-1677406453.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-003",
		"PU-Name": "ODE  ILE NMA",
		Accredited_Voters: 175,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75656/result_69582_1677578275_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-005",
		"PU-Name": "ODE MAGAJI OKE-OGUN I",
		Accredited_Voters: 235,
		Registered_Voters: 726,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75658/result_69584_1677599365_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-006",
		"PU-Name": "ODE AYIPO",
		Accredited_Voters: 282,
		Registered_Voters: 843,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75659/result_69585_1677598849_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-007",
		"PU-Name": "ODE ILE OTEFUN",
		Accredited_Voters: 248,
		Registered_Voters: 884,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75660/result_69586_1677597322_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-008",
		"PU-Name": "ODE FALOKUN",
		Accredited_Voters: 271,
		Registered_Voters: 950,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/008/008-1677404201.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-009",
		"PU-Name": "ODE MAIGIDA EDUN",
		Accredited_Voters: 245,
		Registered_Voters: 902,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75662/result_69588_1677596635_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-010",
		"PU-Name": "ODE LABALA",
		Accredited_Voters: 178,
		Registered_Voters: 565,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/010/010-1677427171.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-011",
		"PU-Name": "ODE MAGAJI AJANAKU",
		Accredited_Voters: 276,
		Registered_Voters: 810,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75664/result_69590_1677596201_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-013",
		"PU-Name": "ODE MAGAJI OKE OGUN II",
		Accredited_Voters: 142,
		Registered_Voters: 491,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/013/013-1677404414.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-001",
		"PU-Name": "ODE OLOGBIN",
		Accredited_Voters: 277,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75667/result_69599_1677525285_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-003",
		"PU-Name": "ADETA L.G.E.A SCH",
		Accredited_Voters: 224,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75669/result_69601_1677572542_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-004",
		"PU-Name": "IDI IGBA OPEN SPACE",
		Accredited_Voters: 279,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75670/result_69602_1677598748_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-005",
		"PU-Name": "SAKELE OPEN SPACE",
		Accredited_Voters: 298,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75671/result_69603_1677558495_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-006",
		"PU-Name": "OKE AGODI OPEN SPACE",
		Accredited_Voters: 266,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75672/result_69604_1677577440_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-007",
		"PU-Name": "KUNTU L.G.E.A SCH",
		Accredited_Voters: 212,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75673/result_69605_1677551853_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-008",
		"PU-Name": "GAA AREMU OPEN SPACE",
		Accredited_Voters: 242,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75674/result_69606_1677563239_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-009",
		"PU-Name": "GOVERNMENT HIGH SCH I",
		Accredited_Voters: 293,
		Registered_Voters: 1033,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75675/result_69607_1677570182_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-010",
		"PU-Name": "GOVERNMENT HIGH SCH II",
		Accredited_Voters: 430,
		Registered_Voters: 1274,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75676/result_69608_1677555554_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-011",
		"PU-Name": "FEDERAL STAFF PRY SCH",
		Accredited_Voters: 398,
		Registered_Voters: 1494,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75677/result_69609_1677552160_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-012",
		"PU-Name": "ADEWOLE HEALTH CENTRE",
		Accredited_Voters: 271,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75678/result_69610_1677529103_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-013",
		"PU-Name": "ADETA L.G.E.A SCH",
		Accredited_Voters: 207,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75679/result_69611_1677556681_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-014",
		"PU-Name": "OJUDE ELEFO",
		Accredited_Voters: 329,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75680/result_69612_1677529801_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-016",
		"PU-Name": "GAA AREMU OPEN SPACE",
		Accredited_Voters: 210,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75682/result_69614_1677562869_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-017",
		"PU-Name": "OPEN SPACE OJUDE OLODE OKUTA (KUNTU)",
		Accredited_Voters: 290,
		Registered_Voters: 888,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75683/result_69615_1677529434_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-001",
		"PU-Name": "ODE BALOGUN AJIKOBI I",
		Accredited_Voters: 228,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76381/76381-1677591828.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-003",
		"PU-Name": "ODE ALAGBE",
		Accredited_Voters: 277,
		Registered_Voters: 801,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76383/76383-1677589706.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-006",
		"PU-Name": "ODE OPOBIYI II",
		Accredited_Voters: 317,
		Registered_Voters: 927,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76386/76386-1677577257.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-007",
		"PU-Name": "ODE SAURA (AGBAJI) I",
		Accredited_Voters: 317,
		Registered_Voters: 940,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76387/76387-1677598389.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-008",
		"PU-Name": "ODE SAURA (AGBAJI) II",
		Accredited_Voters: 288,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76388/76388-1677590774.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-009",
		"PU-Name": "ODE AKINLANSO I",
		Accredited_Voters: 261,
		Registered_Voters: 705,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76389/76389-1677595041.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-011",
		"PU-Name": "ODE KOTO (POPO GIWA)",
		Accredited_Voters: 355,
		Registered_Voters: 901,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76391/76391-1677593680.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-012",
		"PU-Name": "ODE ONIGUGURU",
		Accredited_Voters: 338,
		Registered_Voters: 934,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76392/76392-1677572019.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-013",
		"PU-Name": "ODE ALARO (ALORE)",
		Accredited_Voters: 276,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76393/76393-1677589989.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-014",
		"PU-Name": "ODE AROWASI",
		Accredited_Voters: 292,
		Registered_Voters: 823,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76394/76394-1677594580.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-015",
		"PU-Name": "ODE ARIBI/IDI-ISIN",
		Accredited_Voters: 338,
		Registered_Voters: 887,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76395/76395-1677596765.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-016",
		"PU-Name": "ODE OYAN",
		Accredited_Voters: 284,
		Registered_Voters: 537,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76396/76396-1677585147.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-017",
		"PU-Name": "SOLAGBERU L.G.E.A SCH",
		Accredited_Voters: 322,
		Registered_Voters: 807,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76397/76397-1677573084.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-018",
		"PU-Name": "ABATA ASUNKERE",
		Accredited_Voters: 301,
		Registered_Voters: 934,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76398/76398-1677587254.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-019",
		"PU-Name": "ODE OKUBIYI I",
		Accredited_Voters: 321,
		Registered_Voters: 974,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76399/76399-1677599537.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-020",
		"PU-Name": "ODE OKUBIYI II",
		Accredited_Voters: 271,
		Registered_Voters: 796,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76400/76400-1677592551.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-021",
		"PU-Name": "ODE OPOBIYI III",
		Accredited_Voters: 214,
		Registered_Voters: 650,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76401/76401-1677596201.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-022",
		"PU-Name": "ANSARU-ISLAM L.G.E.A SCH I",
		Accredited_Voters: 267,
		Registered_Voters: 940,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76402/76402-1677591783.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-023",
		"PU-Name": "ANSARU-ISLAM L.G.E.A SCH II",
		Accredited_Voters: 192,
		Registered_Voters: 700,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76403/76403-1677592865.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-024",
		"PU-Name": "ODE ABOJUMEJI",
		Accredited_Voters: 277,
		Registered_Voters: 834,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76404/76404-1677592454.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-025",
		"PU-Name": "ODE ALAGBEDE I",
		Accredited_Voters: 322,
		Registered_Voters: 898,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677440505-76405.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-026",
		"PU-Name": "ODE ALAWIYE I",
		Accredited_Voters: 296,
		Registered_Voters: 866,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76406/76406-1677577161.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-027",
		"PU-Name": "ODE ALAWIYE II",
		Accredited_Voters: 227,
		Registered_Voters: 630,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/02/pu/027/027-1677428741.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-029",
		"PU-Name": "ODE ELESIN WERE",
		Accredited_Voters: 280,
		Registered_Voters: 841,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76409/76409-1677580380.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-030",
		"PU-Name": "ODE AJIBAYE",
		Accredited_Voters: 188,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76410/76410-1677574163.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-032",
		"PU-Name": "ODE ABOJUMEJI",
		Accredited_Voters: 249,
		Registered_Voters: 710,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76412/76412-1677572291.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-033",
		"PU-Name": "ODE ALAGBEDE II",
		Accredited_Voters: 282,
		Registered_Voters: 778,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76413/76413-1677591995.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-034",
		"PU-Name": "ODE ELESINLA",
		Accredited_Voters: 235,
		Registered_Voters: 771,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76414/76414-1677579471.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-035",
		"PU-Name": "ODE AROWASI",
		Accredited_Voters: 261,
		Registered_Voters: 789,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76415/76415-1677586266.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-036",
		"PU-Name": "ODE ALAWIYE III",
		Accredited_Voters: 214,
		Registered_Voters: 736,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76416/76416-1677574768.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-037",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH III",
		Accredited_Voters: 301,
		Registered_Voters: 873,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76417/76417-1677575261.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-038",
		"PU-Name": "ODE AJIBAIYE",
		Accredited_Voters: 206,
		Registered_Voters: 830,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76418/76418-1677588245.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-039",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH IV",
		Accredited_Voters: 222,
		Registered_Voters: 699,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76419/76419-1677594214.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-040",
		"PU-Name": "ANSARUL-ISLAM L.G.E.A SCH V",
		Accredited_Voters: 237,
		Registered_Voters: 769,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/76420/76420-1677597519.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-005",
		"PU-Name": "ODE MAGAJI BABOKO",
		Accredited_Voters: 248,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/005/005-1677363228.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-007",
		"PU-Name": "ODE AJIDO",
		Accredited_Voters: 288,
		Registered_Voters: 943,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/007/007-1677371387.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-008",
		"PU-Name": "ODE OJODU",
		Accredited_Voters: 282,
		Registered_Voters: 853,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/008/008-1677364454.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-009",
		"PU-Name": "ODE BAYERO",
		Accredited_Voters: 269,
		Registered_Voters: 796,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23182/pu/76429/76429-1677485621.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-010",
		"PU-Name": "ODE ELEGBEDE",
		Accredited_Voters: 243,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/010/010-1677421183.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-011",
		"PU-Name": "ODE IMAM IJETA (BABOKO)",
		Accredited_Voters: 274,
		Registered_Voters: 923,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23182/pu/76431/76431-1677486134.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-012",
		"PU-Name": "ODE ONITANGANRAN I",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/012/012-1677390937.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-013",
		"PU-Name": "ODE ONITANGANRAN II",
		Accredited_Voters: 286,
		Registered_Voters: 989,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/013/013-1677371380.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-001",
		"PU-Name": "ECWA L.G.E.A SCH I",
		Accredited_Voters: 219,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75737/result_69732_1677574508_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-003",
		"PU-Name": "ODE BILEWU",
		Accredited_Voters: 284,
		Registered_Voters: 976,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75739/result_69734_1677574789_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-004",
		"PU-Name": "ILORIN TEACHER'S COLLEGE I",
		Accredited_Voters: 132,
		Registered_Voters: 891,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75740/result_69735_1677578997_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-008",
		"PU-Name": "UNIVERSITY OF ILORIN I",
		Accredited_Voters: 186,
		Registered_Voters: 1215,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75744/result_69739_1677577891_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-009",
		"PU-Name": "UNIVERSITY OF ILORIN II",
		Accredited_Voters: 130,
		Registered_Voters: 914,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75745/result_69740_1677576182_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-010",
		"PU-Name": "BUNMI NURSERY/PRY SCH",
		Accredited_Voters: 172,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75746/result_69741_1677577619_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-011",
		"PU-Name": "ODE BILEWU",
		Accredited_Voters: 218,
		Registered_Voters: 738,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75747/result_69742_1677577518_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-012",
		"PU-Name": "ODE MAFOLAKU",
		Accredited_Voters: 191,
		Registered_Voters: 716,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75748/result_69743_1677598584_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-013",
		"PU-Name": "AGBO OBA ILORIN III",
		Accredited_Voters: 179,
		Registered_Voters: 798,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75749/result_69744_1677578263_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-015",
		"PU-Name": "ILORIN TEACHER'S COLLEGE II",
		Accredited_Voters: 147,
		Registered_Voters: 830,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75751/result_69746_1677574989_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-016",
		"PU-Name": "UNIVERSITY OF ILORIN III",
		Accredited_Voters: 109,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75752/result_69747_1677577740_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-001",
		"PU-Name": "ODE BALOGUN ALANAMU I",
		Accredited_Voters: 269,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76450/76450-1677501908.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-002",
		"PU-Name": "ODE BALOGUN ALANAMU II",
		Accredited_Voters: 248,
		Registered_Voters: 741,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76451/76451-1677495205.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-003",
		"PU-Name": "ODE OLOYIN (ITA ELEPA)",
		Accredited_Voters: 246,
		Registered_Voters: 784,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76452/76452-1677497145.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-004",
		"PU-Name": "ANIFOWOSE (OKEKURA)",
		Accredited_Voters: 112,
		Registered_Voters: 317,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76453/76453-1677499164.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-005",
		"PU-Name": "ODE ONIJA",
		Accredited_Voters: 229,
		Registered_Voters: 631,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76454/76454-1677503710.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-006",
		"PU-Name": "ODE AJIA",
		Accredited_Voters: 246,
		Registered_Voters: 621,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76455/76455-1677494114.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-007",
		"PU-Name": "ODE ELETA",
		Accredited_Voters: 251,
		Registered_Voters: 709,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76456/76456-1677501074.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-008",
		"PU-Name": "ODE ELELU",
		Accredited_Voters: 249,
		Registered_Voters: 724,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76457/76457-1677496544.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-009",
		"PU-Name": "ODE ONIMAGO",
		Accredited_Voters: 320,
		Registered_Voters: 994,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75761/result_69772_1677506568_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-010",
		"PU-Name": "ODE BABA ORO ABATA",
		Accredited_Voters: 275,
		Registered_Voters: 790,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76459/76459-1677496254.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-011",
		"PU-Name": "ODE ZENI",
		Accredited_Voters: 259,
		Registered_Voters: 632,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76460/76460-1677500892.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-012",
		"PU-Name": "ODE ELESINFUNFUN",
		Accredited_Voters: 228,
		Registered_Voters: 878,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76461/76461-1677517200.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-013",
		"PU-Name": "ODE KARATU",
		Accredited_Voters: 215,
		Registered_Voters: 787,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76462/76462-1677502635.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-014",
		"PU-Name": "ODE KURANGA (OLOMODA)",
		Accredited_Voters: 215,
		Registered_Voters: 888,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76463/76463-1677496968.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-015",
		"PU-Name": "ODE EBO DANIYAN",
		Accredited_Voters: 158,
		Registered_Voters: 719,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76464/76464-1677513184.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-016",
		"PU-Name": "ODE IKOLABA",
		Accredited_Voters: 180,
		Registered_Voters: 667,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76465/76465-1677492234.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-017",
		"PU-Name": "ODE OLODO (KUDIMA)",
		Accredited_Voters: 214,
		Registered_Voters: 570,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76466/76466-1677520824.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-019",
		"PU-Name": "ODE OLOMO II",
		Accredited_Voters: 134,
		Registered_Voters: 543,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76468/76468-1677496431.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-020",
		"PU-Name": "ODE ALFA IWO",
		Accredited_Voters: 230,
		Registered_Voters: 764,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76469/76469-1677511245.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-021",
		"PU-Name": "ODE APABIEKUN",
		Accredited_Voters: 200,
		Registered_Voters: 685,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76470/76470-1677503559.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-022",
		"PU-Name": "HIWANU L.G.E.A SCH I",
		Accredited_Voters: 220,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76471/76471-1677493392.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-023",
		"PU-Name": "ODE AKOTA OKE",
		Accredited_Voters: 321,
		Registered_Voters: 840,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76472/76472-1677514723.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-024",
		"PU-Name": "ODE AIYIBASAN I",
		Accredited_Voters: 244,
		Registered_Voters: 842,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76473/76473-1677499148.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-025",
		"PU-Name": "ODE AIYIBASAN II",
		Accredited_Voters: 231,
		Registered_Voters: 887,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76474/76474-1677500726.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-026",
		"PU-Name": "ODE AKUJI",
		Accredited_Voters: 299,
		Registered_Voters: 935,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76475/76475-1677512807.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-027",
		"PU-Name": "ODE BABA OLORI",
		Accredited_Voters: 239,
		Registered_Voters: 661,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76476/76476-1677501641.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-028",
		"PU-Name": "ODE ELEJA ADABATA",
		Accredited_Voters: 258,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76477/76477-1677512535.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-029",
		"PU-Name": "PAKATA L.G.E.A SCH",
		Accredited_Voters: 300,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76478/76478-1677497951.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-030",
		"PU-Name": "ODE KOBE",
		Accredited_Voters: 312,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76479/76479-1677502076.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-031",
		"PU-Name": "ODE ISOWO",
		Accredited_Voters: 261,
		Registered_Voters: 924,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76480/76480-1677516651.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-032",
		"PU-Name": "ODE GBAGIRIMAJO",
		Accredited_Voters: 257,
		Registered_Voters: 581,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76481/76481-1677512783.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-034",
		"PU-Name": "ODE OLOKOBA POPO-GIWA II",
		Accredited_Voters: 244,
		Registered_Voters: 654,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76483/76483-1677495731.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-035",
		"PU-Name": "ODE EPO",
		Accredited_Voters: 251,
		Registered_Voters: 667,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76484/76484-1677512448.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-036",
		"PU-Name": "ODE ONILA",
		Accredited_Voters: 304,
		Registered_Voters: 803,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75788/result_69799_1677506953_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-037",
		"PU-Name": "IDI ARABA KUDIMA",
		Accredited_Voters: 329,
		Registered_Voters: 999,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76486/76486-1677510245.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-038",
		"PU-Name": "ODE ANIFOWOSHE OKE KUKA",
		Accredited_Voters: 187,
		Registered_Voters: 663,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76487/76487-1677499061.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-039",
		"PU-Name": "ODE OGANIJA",
		Accredited_Voters: 236,
		Registered_Voters: 707,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76488/76488-1677499569.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-040",
		"PU-Name": "ODE AJIA SAKASAKA",
		Accredited_Voters: 265,
		Registered_Voters: 675,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76489/76489-1677491214.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-041",
		"PU-Name": "ODE BABA ORO ADABATA",
		Accredited_Voters: 210,
		Registered_Voters: 816,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76490/76490-1677497287.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-042",
		"PU-Name": "OKE KURANGA POPO OLOMOBA",
		Accredited_Voters: 179,
		Registered_Voters: 937,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76491/76491-1677495734.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-043",
		"PU-Name": "HIWANU L.G.E.A SCH II",
		Accredited_Voters: 221,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76492/76492-1677500838.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-044",
		"PU-Name": "ODE AKUJI",
		Accredited_Voters: 222,
		Registered_Voters: 834,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75796/result_69807_1677507900_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-045",
		"PU-Name": "ODE ELELU",
		Accredited_Voters: 232,
		Registered_Voters: 702,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/76494/76494-1677492416.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-001",
		"PU-Name": "ODE ISIAKA OMOBA",
		Accredited_Voters: 242,
		Registered_Voters: 614,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76495/76495-1677591659.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-002",
		"PU-Name": "ARE OGELE ORIOKOH",
		Accredited_Voters: 294,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76496/76496-1677520577.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-003",
		"PU-Name": "KORO GURUMOH",
		Accredited_Voters: 226,
		Registered_Voters: 627,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76497/76497-1677597305.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-004",
		"PU-Name": "ODE JIMBA I",
		Accredited_Voters: 315,
		Registered_Voters: 839,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76498/76498-1677593084.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-005",
		"PU-Name": "ODE AMUDA OMO-IYA",
		Accredited_Voters: 272,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76499/76499-1677521078.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-006",
		"PU-Name": "ODE ALIKALI SOKOTO",
		Accredited_Voters: 384,
		Registered_Voters: 901,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76500/76500-1677598607.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-007",
		"PU-Name": "ODE KAWU AGAKA",
		Accredited_Voters: 277,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76501/76501-1677599645.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-008",
		"PU-Name": "ODE DONGARI",
		Accredited_Voters: 302,
		Registered_Voters: 775,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76502/76502-1677591076.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-009",
		"PU-Name": "ODE GALADIMA",
		Accredited_Voters: 252,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76503/76503-1677517324.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-010",
		"PU-Name": "INFRONT OF L.G SECRETARIAT I",
		Accredited_Voters: 246,
		Registered_Voters: 889,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76504/76504-1677592176.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-011",
		"PU-Name": "INFRONT OF L.G SECRETARIAT II",
		Accredited_Voters: 234,
		Registered_Voters: 873,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76505/76505-1677518354.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-012",
		"PU-Name": "INFRONT OF L.G SECRETARIAT III",
		Accredited_Voters: 177,
		Registered_Voters: 799,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76506/76506-1677519032.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-013",
		"PU-Name": "BAPTIST L.G.E.A SCH I",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76507/76507-1677521582.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-014",
		"PU-Name": "BAPTIST L.G.E.A SCH II",
		Accredited_Voters: 243,
		Registered_Voters: 919,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76508/76508-1677517881.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-015",
		"PU-Name": "ODE IDOMI AGAKA",
		Accredited_Voters: 223,
		Registered_Voters: 620,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76509/76509-1677518724.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-016",
		"PU-Name": "ODE ISIAKA OMOBA",
		Accredited_Voters: 203,
		Registered_Voters: 591,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/76510/76510-1677521493.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-017",
		"PU-Name": "ODE JIMBA II",
		Accredited_Voters: 221,
		Registered_Voters: 463,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/06/pu/017/017-1677394739.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-001",
		"PU-Name": "MOUNT CARMEL COLLEGE I",
		Accredited_Voters: 203,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75815/result_69858_1677599335_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-002",
		"PU-Name": "MOUNT CARMEL COLLEGE II",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75816/result_69859_1677600061_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-003",
		"PU-Name": "ODE OPELOYERU",
		Accredited_Voters: 283,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75817/result_69860_1677600179_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-004",
		"PU-Name": "GOVT. DAY SEC SCH ALORE I",
		Accredited_Voters: 260,
		Registered_Voters: 937,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75818/result_69861_1677605829_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-005",
		"PU-Name": "AIR FORCE PRY SCH I",
		Accredited_Voters: 190,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75819/result_69862_1677605892_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-006",
		"PU-Name": "ODE ONILE ARO",
		Accredited_Voters: 315,
		Registered_Voters: 896,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75820/result_69863_1677605968_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-007",
		"PU-Name": "ODE ALASEJU",
		Accredited_Voters: 273,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75821/result_69864_1677606044_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-008",
		"PU-Name": "ODE MAGAJI OLOJE",
		Accredited_Voters: 233,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75822/result_69865_1677606147_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-009",
		"PU-Name": "MOUNT CARMEL COLLEGE III",
		Accredited_Voters: 214,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75823/result_69866_1677606311_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-010",
		"PU-Name": "GOVT DAY SEC SCH ALORE II",
		Accredited_Voters: 235,
		Registered_Voters: 908,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75824/result_69867_1677606403_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-011",
		"PU-Name": "AIR FORCE PRY SCH II",
		Accredited_Voters: 131,
		Registered_Voters: 620,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75825/result_69868_1677606488_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-012",
		"PU-Name": "ODE OPELOYERU",
		Accredited_Voters: 218,
		Registered_Voters: 823,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75826/result_69869_1677677155_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-013",
		"PU-Name": "ODE ONILE ARO",
		Accredited_Voters: 157,
		Registered_Voters: 625,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75827/result_69870_1677606658_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-014",
		"PU-Name": "ODE OBA YAHAYA",
		Accredited_Voters: 239,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75828/result_69871_1677606739_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-015",
		"PU-Name": "ODE ONIYAN ELELU",
		Accredited_Voters: 274,
		Registered_Voters: 995,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75829/result_69872_1677606794_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-001",
		"PU-Name": "ODE MOGAJI OGIDI",
		Accredited_Voters: 210,
		Registered_Voters: 772,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76527/76527-1677453851.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-002",
		"PU-Name": "INFRONT OF ALORE MOSQUE",
		Accredited_Voters: 325,
		Registered_Voters: 964,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76528/76528-1677454218.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-003",
		"PU-Name": "ODE ALFA BANNI",
		Accredited_Voters: 314,
		Registered_Voters: 808,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76529/76529-1677454832.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-004",
		"PU-Name": "ODE ILOBU",
		Accredited_Voters: 365,
		Registered_Voters: 789,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76530/76530-1677455031.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-007",
		"PU-Name": "BANNI COM. SEC SCH",
		Accredited_Voters: 366,
		Registered_Voters: 908,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76533/76533-1677456028.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-008",
		"PU-Name": "ODE OLORIEGBE",
		Accredited_Voters: 281,
		Registered_Voters: 900,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76534/76534-1677456220.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-009",
		"PU-Name": "ODE AGORO",
		Accredited_Voters: 325,
		Registered_Voters: 813,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76535/76535-1677456409.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-010",
		"PU-Name": "ODE TAKAN",
		Accredited_Voters: 327,
		Registered_Voters: 921,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76536/76536-1677456671.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-011",
		"PU-Name": "ODE DAUDU BANNI",
		Accredited_Voters: 271,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76537/76537-1677456862.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-013",
		"PU-Name": "ODE ILOBU",
		Accredited_Voters: 243,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/76539/76539-1677477612.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-001",
		"PU-Name": "ODE MOGAJI OJUEKUN I",
		Accredited_Voters: 243,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76540/76540-1677504319.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-002",
		"PU-Name": "ODE MOGAJI OJUEKUN II",
		Accredited_Voters: 299,
		Registered_Voters: 932,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76541/76541-1677602869.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-003",
		"PU-Name": "ODE OKUBI I",
		Accredited_Voters: 246,
		Registered_Voters: 804,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76542/76542-1677603646.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-004",
		"PU-Name": "ODE OKUBI II",
		Accredited_Voters: 235,
		Registered_Voters: 787,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76543/76543-1677600382.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-005",
		"PU-Name": "ODE AGARA",
		Accredited_Voters: 184,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76544/76544-1677599751.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-006",
		"PU-Name": "ODE ADIGBONGBO I",
		Accredited_Voters: 294,
		Registered_Voters: 886,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76545/76545-1677579606.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-007",
		"PU-Name": "ODE ADIGBONGBO II",
		Accredited_Voters: 245,
		Registered_Voters: 510,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76546/76546-1677601111.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-008",
		"PU-Name": "ODE NAGERI I",
		Accredited_Voters: 192,
		Registered_Voters: 592,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76547/76547-1677600541.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-011",
		"PU-Name": "ODE KURE (POPO IGBONA)",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76550/76550-1677603533.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-012",
		"PU-Name": "ODE OLORI",
		Accredited_Voters: 281,
		Registered_Voters: 701,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76551/76551-1677502564.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-013",
		"PU-Name": "ODE TUNTUN (POPO IGBONA)",
		Accredited_Voters: 291,
		Registered_Voters: 871,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76552/76552-1677498722.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-014",
		"PU-Name": "ODE KAREBU",
		Accredited_Voters: 283,
		Registered_Voters: 833,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76553/76553-1677602347.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-015",
		"PU-Name": "ODE KOTO",
		Accredited_Voters: 270,
		Registered_Voters: 564,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76554/76554-1677602790.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-016",
		"PU-Name": "ODE OLOMO MESAN",
		Accredited_Voters: 286,
		Registered_Voters: 881,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76555/76555-1677579185.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-017",
		"PU-Name": "ODE OJIBARA I",
		Accredited_Voters: 319,
		Registered_Voters: 859,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76556/76556-1677600649.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-018",
		"PU-Name": "ODE OJIBARA II",
		Accredited_Voters: 201,
		Registered_Voters: 748,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76557/76557-1677602716.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-019",
		"PU-Name": "ODE BABA ONILA",
		Accredited_Voters: 248,
		Registered_Voters: 736,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76558/76558-1677600951.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-020",
		"PU-Name": "ODE ASILEKE",
		Accredited_Voters: 242,
		Registered_Voters: 680,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76559/76559-1677500777.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-021",
		"PU-Name": "ODE AFASE",
		Accredited_Voters: 232,
		Registered_Voters: 796,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76560/76560-1677580033.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-022",
		"PU-Name": "ODE OGUNTOLU",
		Accredited_Voters: 310,
		Registered_Voters: 900,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76561/76561-1677603868.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-023",
		"PU-Name": "ODE FARA",
		Accredited_Voters: 283,
		Registered_Voters: 654,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76562/76562-1677502015.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-024",
		"PU-Name": "ODE SOFUN",
		Accredited_Voters: 293,
		Registered_Voters: 830,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76563/76563-1677601860.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-026",
		"PU-Name": "ABAYOMI MARKET",
		Accredited_Voters: 279,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76565/76565-1677601478.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-028",
		"PU-Name": "OJUDE BATURE",
		Accredited_Voters: 277,
		Registered_Voters: 607,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76567/76567-1677604011.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-029",
		"PU-Name": "ODE ORA BABA",
		Accredited_Voters: 308,
		Registered_Voters: 976,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76568/76568-1677601740.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-032",
		"PU-Name": "ILE KOTO",
		Accredited_Voters: 184,
		Registered_Voters: 470,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76571/76571-1677499987.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-033",
		"PU-Name": "ODE ELESINLA",
		Accredited_Voters: 235,
		Registered_Voters: 553,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76572/76572-1677493320.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-034",
		"PU-Name": "OJUDE ALFA NLA",
		Accredited_Voters: 213,
		Registered_Voters: 567,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/76573/76573-1677603456.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-001",
		"PU-Name": "OMIDOYIN STADIUM AREA I",
		Accredited_Voters: 200,
		Registered_Voters: 636,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76574/76574-1677594807.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-002",
		"PU-Name": "OMIDOYIN STADIUM AREA II",
		Accredited_Voters: 183,
		Registered_Voters: 667,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76575/76575-1677509039.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-003",
		"PU-Name": "QUEEN SCH ILORIN I",
		Accredited_Voters: 235,
		Registered_Voters: 998,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76576/76576-1677579156.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-004",
		"PU-Name": "ILORIN GRAMMAR SCH I",
		Accredited_Voters: 335,
		Registered_Voters: 1199,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76577/76577-1677580447.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-005",
		"PU-Name": "ILORIN GRAMMAR SCH II",
		Accredited_Voters: 194,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76578/76578-1677576535.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-006",
		"PU-Name": "ILORIN GRAMMAR SCH III",
		Accredited_Voters: 167,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76579/76579-1677576099.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-007",
		"PU-Name": "ILORIN GRAMMAR SCH IV",
		Accredited_Voters: 221,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76580/76580-1677581717.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-008",
		"PU-Name": "OSERE JUNCTION",
		Accredited_Voters: 769,
		Registered_Voters: 2686,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/10/pu/008/008-1677374419.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-009",
		"PU-Name": "UNITED L.G.E.A SCH I",
		Accredited_Voters: 140,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76582/76582-1677582424.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-010",
		"PU-Name": "UNITED L.G.E.A SCH II",
		Accredited_Voters: 97,
		Registered_Voters: 808,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76583/76583-1677509864.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-011",
		"PU-Name": "ANSARUL  L.G.E.A SCH I",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76584/76584-1677583128.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-012",
		"PU-Name": "ODE MAGAJI ODOKUN",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76585/76585-1677583331.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-013",
		"PU-Name": "ODOTA L.G.E.A SCH I",
		Accredited_Voters: 286,
		Registered_Voters: 1019,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76586/76586-1677583703.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-014",
		"PU-Name": "L.G.E.A SCH GAA IMMAN",
		Accredited_Voters: 213,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76587/76587-1677584002.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-015",
		"PU-Name": "JORO VILLAGE",
		Accredited_Voters: 261,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75891/result_69967_1677524627_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-016",
		"PU-Name": "WESLEY L.G.E.A SCH",
		Accredited_Voters: 210,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76589/76589-1677584999.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-017",
		"PU-Name": "INFRONT OF COCA COLA",
		Accredited_Voters: 217,
		Registered_Voters: 872,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76590/76590-1677585218.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-018",
		"PU-Name": "BABA ODE VILLAGE",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76591/76591-1677586453.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-019",
		"PU-Name": "OLORUNSOGO OPEN SPACE",
		Accredited_Voters: 226,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76592/76592-1677587012.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-020",
		"PU-Name": "ILE-ALHAJI IDI-OPOTO OSERE",
		Accredited_Voters: 277,
		Registered_Voters: 942,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76593/76593-1677587304.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-021",
		"PU-Name": "QUENN SCH ILORIN II",
		Accredited_Voters: 122,
		Registered_Voters: 529,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76594/76594-1677587562.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-022",
		"PU-Name": "ANSARUL L.G.E.A SCH II",
		Accredited_Voters: 164,
		Registered_Voters: 872,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76595/76595-1677587952.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-023",
		"PU-Name": "ODOTA L.G.E.A SCH II",
		Accredited_Voters: 168,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76596/76596-1677588241.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-024",
		"PU-Name": "JORO VILLAGE",
		Accredited_Voters: 176,
		Registered_Voters: 679,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/76597/76597-1677588633.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-001",
		"PU-Name": "OJUDE UBANDAWAKI",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/001/001-1677392824.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-002",
		"PU-Name": "OJUDE ALADIRE",
		Accredited_Voters: 244,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/002/002-1677395973.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-003",
		"PU-Name": "GOVT GIRLS' DAY SEC SCH PAKATA",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/003/003-1677383226.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-004",
		"PU-Name": "OKE EBO L.G.E.A SCH",
		Accredited_Voters: 269,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/004/004-1677393454.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-006",
		"PU-Name": "BARAKAT L.G.E.A SCH",
		Accredited_Voters: 197,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/006/006-1677393129.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-007",
		"PU-Name": "MADI VILLAGE",
		Accredited_Voters: 292,
		Registered_Voters: 958,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/007/007-1677394146.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-008",
		"PU-Name": "ANIFOWOSE OPEN SPACE",
		Accredited_Voters: 258,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/008/008-1677385472.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-009",
		"PU-Name": "OJUDE ALADIRE",
		Accredited_Voters: 272,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/009/009-1677396607.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-001",
		"PU-Name": "OGUNDELE L.G.E.A SCH",
		Accredited_Voters: 217,
		Registered_Voters: 639,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76608/76608-1677501184.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-002",
		"PU-Name": "WARRAH L.G.E.A SCH",
		Accredited_Voters: 223,
		Registered_Voters: 839,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76609/76609-1677575339.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-004",
		"PU-Name": "GALADIMA VILLAGE",
		Accredited_Voters: 286,
		Registered_Voters: 977,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76611/76611-1677578927.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-005",
		"PU-Name": "GBA GBA VILLAGE",
		Accredited_Voters: 240,
		Registered_Voters: 752,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76612/76612-1677581642.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-006",
		"PU-Name": "AIRFORCE QTRS",
		Accredited_Voters: 223,
		Registered_Voters: 816,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76613/76613-1677575856.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-007",
		"PU-Name": "EGBEJILA VILLAGE",
		Accredited_Voters: 202,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76614/76614-1677588143.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-008",
		"PU-Name": "OBANISUA L.G.E.A SCH",
		Accredited_Voters: 226,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76615/76615-1677577686.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-009",
		"PU-Name": "ODORE VILLAGE",
		Accredited_Voters: 298,
		Registered_Voters: 846,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76616/76616-1677575634.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-010",
		"PU-Name": "IWANTE VILLAGE",
		Accredited_Voters: 56,
		Registered_Voters: 393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76617/76617-1677577033.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-011",
		"PU-Name": "BUDO NUHU VILLAGE",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76618/76618-1677577498.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-012",
		"PU-Name": "BUDO OLOHUNLADE",
		Accredited_Voters: 193,
		Registered_Voters: 815,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76619/76619-1677586144.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-013",
		"PU-Name": "IDI-EGUN/ALENIBORO I",
		Accredited_Voters: 140,
		Registered_Voters: 624,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76620/76620-1677587737.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-014",
		"PU-Name": "IDI-EGUN/ALENIBORO II",
		Accredited_Voters: 117,
		Registered_Voters: 577,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76621/76621-1677503827.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-015",
		"PU-Name": "OSHIN AREMU L.G.E.A",
		Accredited_Voters: 223,
		Registered_Voters: 755,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76622/76622-1677577280.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-016",
		"PU-Name": "BUDO KAWU",
		Accredited_Voters: 141,
		Registered_Voters: 669,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76623/76623-1677587559.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-017",
		"PU-Name": "APATA-OLU VILLAGE",
		Accredited_Voters: 125,
		Registered_Voters: 547,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76624/76624-1677573686.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-018",
		"PU-Name": "ELEPA VILLAGE",
		Accredited_Voters: 230,
		Registered_Voters: 980,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76625/76625-1677579634.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-019",
		"PU-Name": "ITA-ALAMU",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76626/76626-1677579150.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-020",
		"PU-Name": "BUDO KANGUSU",
		Accredited_Voters: 247,
		Registered_Voters: 795,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76627/76627-1677573123.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-021",
		"PU-Name": "BUDO LATUNJI",
		Accredited_Voters: 178,
		Registered_Voters: 748,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76628/76628-1677583814.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-022",
		"PU-Name": "BUDO NUHU",
		Accredited_Voters: 258,
		Registered_Voters: 1043,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76629/76629-1677572935.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-023",
		"PU-Name": "OPEN SPACE GEREWU",
		Accredited_Voters: 196,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76630/76630-1677501981.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-024",
		"PU-Name": "OPEN SPACE IDIEGUN",
		Accredited_Voters: 115,
		Registered_Voters: 699,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/76631/76631-1677573315.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-001",
		"PU-Name": "OLD POLICE STATION AJASE-IPO",
		Accredited_Voters: 275,
		Registered_Voters: 910,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76632/76632-1677464248.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-003",
		"PU-Name": "MUSLIM PRIMARY SCH AJASE-IPO",
		Accredited_Voters: 267,
		Registered_Voters: 896,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76634/76634-1677465318.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-004",
		"PU-Name": "OLD IGBAJA GARAGE AJASE-IPO",
		Accredited_Voters: 188,
		Registered_Voters: 626,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76635/76635-1677466809.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-005",
		"PU-Name": "BAPTIST PRIMARY SCH AJASE-IPO",
		Accredited_Voters: 231,
		Registered_Voters: 828,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76636/76636-1677467217.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-006",
		"PU-Name": "NEPA OFFICE AJASE-IPO",
		Accredited_Voters: 231,
		Registered_Voters: 713,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76637/76637-1677467522.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-007",
		"PU-Name": "ELEYOKA/FALOKUN",
		Accredited_Voters: 233,
		Registered_Voters: 907,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76638/76638-1677467935.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-008",
		"PU-Name": "TOWN  CENTRE MEMUDU",
		Accredited_Voters: 66,
		Registered_Voters: 195,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76639/76639-1677468298.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-009",
		"PU-Name": "OKO AWO COMP. OKEYA",
		Accredited_Voters: 226,
		Registered_Voters: 747,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76640/76640-1677468668.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-010",
		"PU-Name": "COMM PRY SCH OKEYA",
		Accredited_Voters: 164,
		Registered_Voters: 494,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76641/76641-1677469044.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-011",
		"PU-Name": "MATERNITY CENTRE ILALA",
		Accredited_Voters: 90,
		Registered_Voters: 436,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76642/76642-1677469325.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-012",
		"PU-Name": "NEAR OBA'S PALACE ILALA",
		Accredited_Voters: 124,
		Registered_Voters: 696,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76643/76643-1677469648.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-013",
		"PU-Name": "CENTRAL MARKET ILALA",
		Accredited_Voters: 153,
		Registered_Voters: 476,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76644/76644-1677469962.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-014",
		"PU-Name": "ECWA SCH BUHARI",
		Accredited_Voters: 172,
		Registered_Voters: 766,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76645/76645-1677470200.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-015",
		"PU-Name": "OPEN SPACE AT EGGI",
		Accredited_Voters: 220,
		Registered_Voters: 789,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/76646/76646-1677470519.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-001",
		"PU-Name": "L.G.E.A. SCH AGBONDA",
		Accredited_Voters: 133,
		Registered_Voters: 525,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/001/001-1677375601.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-002",
		"PU-Name": "ILE OBALOKE AGBONDA",
		Accredited_Voters: 254,
		Registered_Voters: 792,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/002/002-1677376452.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-003",
		"PU-Name": "NEAR OBA'S PALACE AGBONDA/ADIGUN",
		Accredited_Voters: 111,
		Registered_Voters: 546,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/003/003-1677376971.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-004",
		"PU-Name": "AJENIPA'S QTRS SANMORA",
		Accredited_Voters: 158,
		Registered_Voters: 575,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/004/004-1677377496.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-005",
		"PU-Name": "L.G.E.A SCH SANMORA",
		Accredited_Voters: 94,
		Registered_Voters: 372,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/005/005-1677378030.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-006",
		"PU-Name": "ST PAUL'S SCH AGBAMU I",
		Accredited_Voters: 268,
		Registered_Voters: 812,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/006/006-1677378591.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-007",
		"PU-Name": "ST PAUL'S SCH AGBAMU II",
		Accredited_Voters: 220,
		Registered_Voters: 850,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/007/007-1677379401.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-008",
		"PU-Name": "HEALTH CENTRE AGBAMU",
		Accredited_Voters: 154,
		Registered_Voters: 379,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/008/008-1677380219.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-009",
		"PU-Name": "ILE BALE IGBONLA",
		Accredited_Voters: 218,
		Registered_Voters: 708,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/009/009-1677380976.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-010",
		"PU-Name": "AGANJU IGBONLA",
		Accredited_Voters: 84,
		Registered_Voters: 367,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/010/010-1677381424.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-012",
		"PU-Name": "CENTRAL MARKET OMIDO",
		Accredited_Voters: 209,
		Registered_Voters: 499,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/012/012-1677382918.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-013",
		"PU-Name": "CENTRAL MARKET OMIDO",
		Accredited_Voters: 209,
		Registered_Voters: 499,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/012/012-1677382918.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-014",
		"PU-Name": "OLOTA'S COMPD ISALE-IJU ILUDUN",
		Accredited_Voters: 138,
		Registered_Voters: 541,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/014/014-1677385451.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 11",
		"PU-Code": "23-09-02-015",
		"PU-Name": "CENTRAL MARKET EGUDU",
		Accredited_Voters: 178,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/02/pu/015/015-1677385922.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-002",
		"PU-Name": "ILE AWURE ARANDUN",
		Accredited_Voters: 113,
		Registered_Voters: 571,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75967/result_70102_1677609626_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-003",
		"PU-Name": "OJU-OJA ARANDUN",
		Accredited_Voters: 121,
		Registered_Voters: 497,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75968/result_70103_1677610267_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-004",
		"PU-Name": "ILE OKI ARANDUN",
		Accredited_Voters: 93,
		Registered_Voters: 324,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75969/result_70104_1677619956_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-006",
		"PU-Name": "ILE OLUPO JUNCTION ARANDUN",
		Accredited_Voters: 129,
		Registered_Voters: 435,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75971/result_70106_1677620410_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-007",
		"PU-Name": "ILE OBA ILUFEMILOYE ARANDUN",
		Accredited_Voters: 111,
		Registered_Voters: 371,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75972/result_70107_1677620663_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-008",
		"PU-Name": "ISALE OLA ARANDUN",
		Accredited_Voters: 41,
		Registered_Voters: 164,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75973/result_70108_1677620885_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-009",
		"PU-Name": "ILE OBA BUOYE ARANDUN",
		Accredited_Voters: 45,
		Registered_Voters: 231,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75974/result_70109_1677621160_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-010",
		"PU-Name": "OKE ARAN VILLAGE",
		Accredited_Voters: 72,
		Registered_Voters: 346,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75975/result_70110_1677621326_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-011",
		"PU-Name": "OWODE VILLAGE",
		Accredited_Voters: 86,
		Registered_Voters: 362,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75976/result_70111_1677621573_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-012",
		"PU-Name": "OMINRINRIN VILLAGE",
		Accredited_Voters: 149,
		Registered_Voters: 460,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75977/result_70112_1677621738_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-013",
		"PU-Name": "AJEBANDELE VILLAGE",
		Accredited_Voters: 118,
		Registered_Voters: 333,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75978/result_70113_1677621909_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ARANDUN",
		"PU-Code": "23-09-03-014",
		"PU-Name": "L.G.E.A SCH ARANDUN",
		Accredited_Voters: 112,
		Registered_Voters: 395,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/75979/result_70114_1677622020_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-002",
		"PU-Name": "ILE OSOLO ESIE",
		Accredited_Voters: 124,
		Registered_Voters: 636,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23195/pu/76678/76678-1677678253.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-003",
		"PU-Name": "ST MICHAEL SCH ESIE",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/003/003-1677381854.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-004",
		"PU-Name": "ILE OJOMU OKEASANLU ESIE",
		Accredited_Voters: 129,
		Registered_Voters: 580,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/004/004-1677382746.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-005",
		"PU-Name": "ILE ARO ESIE",
		Accredited_Voters: 182,
		Registered_Voters: 654,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/005/005-1677383280.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-006",
		"PU-Name": "L.G.E.A SCH IJAN",
		Accredited_Voters: 118,
		Registered_Voters: 600,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/006/006-1677385058.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-007",
		"PU-Name": "OLD PRY SCH IJAN",
		Accredited_Voters: 259,
		Registered_Voters: 906,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/007/007-1677385743.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-008",
		"PU-Name": "L.G.E.A SCH AGBELE",
		Accredited_Voters: 167,
		Registered_Voters: 524,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/008/008-1677386430.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-001",
		"PU-Name": "L.G.E.A SCH IPETU",
		Accredited_Voters: 179,
		Registered_Voters: 693,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76685/76685-1677475699.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-003",
		"PU-Name": "L.G.E.A SCH RORE",
		Accredited_Voters: 128,
		Registered_Voters: 415,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76687/76687-1677475977.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-004",
		"PU-Name": "ILE ARO RORE I",
		Accredited_Voters: 132,
		Registered_Voters: 512,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76688/76688-1677479735.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-005",
		"PU-Name": "ILE EDU RORE II",
		Accredited_Voters: 122,
		Registered_Voters: 369,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76689/76689-1677477259.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-006",
		"PU-Name": "ILE OBA  RORE III",
		Accredited_Voters: 113,
		Registered_Voters: 472,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76690/76690-1677478979.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-007",
		"PU-Name": "RORE JUNCTION ARANORIN",
		Accredited_Voters: 89,
		Registered_Voters: 429,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76691/76691-1677479933.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-008",
		"PU-Name": "UNITED L.G.E.A SCH ARANORIN",
		Accredited_Voters: 209,
		Registered_Voters: 778,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76692/76692-1677477035.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-009",
		"PU-Name": "IGBESI COMP ARAN-ORIN",
		Accredited_Voters: 99,
		Registered_Voters: 449,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76693/76693-1677477482.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-010",
		"PU-Name": "OKE-OJE COMPOUND ARAN-ORIN",
		Accredited_Voters: 114,
		Registered_Voters: 394,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76694/76694-1677475245.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-011",
		"PU-Name": "ILE ASANLU ARAN-ORIN",
		Accredited_Voters: 94,
		Registered_Voters: 399,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76695/76695-1677476832.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-012",
		"PU-Name": "NEW MARKET ARAN-ORIN",
		Accredited_Voters: 83,
		Registered_Voters: 443,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76696/76696-1677479184.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-013",
		"PU-Name": "TOWN HALL ARAN-ORIN",
		Accredited_Voters: 106,
		Registered_Voters: 504,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76697/76697-1677681592.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "IPETU/RORE/ARAN-ORIN",
		"PU-Code": "23-09-05-014",
		"PU-Name": "L.G.E.A SCH OLOMI-OJA",
		Accredited_Voters: 214,
		Registered_Voters: 724,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23196/pu/76698/76698-1677478766.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-001",
		"PU-Name": "ILE OLUPO  OKE OMU-ARAN I",
		Accredited_Voters: 133,
		Registered_Voters: 490,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/06/pu/001/001-1677389867.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-002",
		"PU-Name": "ILE OLUPO  ODO OMU-ARAN II",
		Accredited_Voters: 253,
		Registered_Voters: 826,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76701/76701-1677678857.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-003",
		"PU-Name": "MODE COMPOUND OMU-ARAN",
		Accredited_Voters: 167,
		Registered_Voters: 564,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76702/76702-1677679144.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-004",
		"PU-Name": "ADEKUN COMPOUND OMU-ARAN",
		Accredited_Voters: 212,
		Registered_Voters: 509,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/06/pu/004/004-1677387322.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-005",
		"PU-Name": "OKESAN COMPOUND OMU-ARAN",
		Accredited_Voters: 205,
		Registered_Voters: 612,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76704/76704-1677679421.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-006",
		"PU-Name": "OKE APA COMPOUND OMU-ARAN",
		Accredited_Voters: 219,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76705/76705-1677679632.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-007",
		"PU-Name": "ILE ADE/ODO-OPIN OMU-ARAN",
		Accredited_Voters: 169,
		Registered_Voters: 607,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76706/76706-1677679767.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-008",
		"PU-Name": "OKE AJAH OMU-ARAN",
		Accredited_Voters: 200,
		Registered_Voters: 627,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76707/76707-1677679911.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-009",
		"PU-Name": "ILE OTAN OMU-ARAN",
		Accredited_Voters: 108,
		Registered_Voters: 363,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76708/76708-1677680146.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-010",
		"PU-Name": "ST PAUL'S SCH OMU-ARAN",
		Accredited_Voters: 214,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/76709/76709-1677680299.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-001",
		"PU-Name": "ILE ELEMO AFIN OMU-ARAN",
		Accredited_Voters: 172,
		Registered_Voters: 735,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/07/pu/001/001-1677423059.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-002",
		"PU-Name": "ILE EDEMO OMU-ARAN",
		Accredited_Voters: 190,
		Registered_Voters: 616,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/07/pu/002/002-1677427097.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-003",
		"PU-Name": "RABA COMP. OMU-ARAN",
		Accredited_Voters: 206,
		Registered_Voters: 734,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/07/pu/003/003-1677428646.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-004",
		"PU-Name": "ILE AYOMU IGANGU OMU-ARAN",
		Accredited_Voters: 193,
		Registered_Voters: 760,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76714/76714-1677469784.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-005",
		"PU-Name": "ORA COMP. OMU-ARAN",
		Accredited_Voters: 243,
		Registered_Voters: 785,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76715/76715-1677470255.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-006",
		"PU-Name": "OKE ESA COMP OMU-ARAN",
		Accredited_Voters: 257,
		Registered_Voters: 969,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76716/76716-1677470436.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-007",
		"PU-Name": "IKOJA COMP OMU-ARAN",
		Accredited_Voters: 162,
		Registered_Voters: 403,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76717/76717-1677470712.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-008",
		"PU-Name": "ECWA SCH OROLODO OMU-ARAN",
		Accredited_Voters: 212,
		Registered_Voters: 893,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76718/76718-1677470876.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-009",
		"PU-Name": "ITA BUOYE GBELEJE OMU-ARAN",
		Accredited_Voters: 164,
		Registered_Voters: 553,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76719/76719-1677471153.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-010",
		"PU-Name": "ILARO COMP OMU-ARAN",
		Accredited_Voters: 235,
		Registered_Voters: 965,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76720/76720-1677471430.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-011",
		"PU-Name": "ECWA SCH AGANMO OMU-ARAN",
		Accredited_Voters: 260,
		Registered_Voters: 863,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/76721/76721-1677471745.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-001",
		"PU-Name": "ILE OLASANKALE OMU-ARAN",
		Accredited_Voters: 201,
		Registered_Voters: 725,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/08/pu/001/001-1677425593.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-002",
		"PU-Name": "ILE ORO OMU-ARAN",
		Accredited_Voters: 171,
		Registered_Voters: 591,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76724/76724-1677491064.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-003",
		"PU-Name": "ILE ASANLU OMU-ARAN",
		Accredited_Voters: 185,
		Registered_Voters: 707,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76725/76725-1677492394.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-004",
		"PU-Name": "ILE OBA OMU-ARAN",
		Accredited_Voters: 177,
		Registered_Voters: 655,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76726/76726-1677492068.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-005",
		"PU-Name": "ITA OKORE OMU-ARAN",
		Accredited_Voters: 234,
		Registered_Voters: 492,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76727/76727-1677489797.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-006",
		"PU-Name": "ITA OLOYE IJOKO OMU-ARAN",
		Accredited_Voters: 101,
		Registered_Voters: 467,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76728/76728-1677492538.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-007",
		"PU-Name": "ODO ORO GBAGIDA OMU-ARAN",
		Accredited_Voters: 179,
		Registered_Voters: 541,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76729/76729-1677492827.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-008",
		"PU-Name": "S.D.A IMOLEKERE OMU-ARAN",
		Accredited_Voters: 147,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76730/76730-1677489148.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-009",
		"PU-Name": "NEW MARKET AREA  OMU-ARAN",
		Accredited_Voters: 241,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76731/76731-1677493106.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-010",
		"PU-Name": "AREA COMMANDER OFFICE OMU-ARAN",
		Accredited_Voters: 177,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76732/76732-1677490840.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-011",
		"PU-Name": "L.G.E.A SCH OKEGBALA OMU-ARAN",
		Accredited_Voters: 120,
		Registered_Voters: 273,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76733/76733-1677491573.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-012",
		"PU-Name": "EKAN GARAGE OMU-ARAN",
		Accredited_Voters: 220,
		Registered_Voters: 754,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76734/76734-1677490266.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-013",
		"PU-Name": "ILE NLA ILE OBA OMU-ARAN",
		Accredited_Voters: 232,
		Registered_Voters: 794,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/76735/76735-1677489495.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 1",
		"PU-Code": "23-09-09-001",
		"PU-Name": "AFIN OLORO OKERIMI ORO",
		Accredited_Voters: 165,
		Registered_Voters: 668,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23200/pu/76736/76736-1677594515.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 1",
		"PU-Code": "23-09-09-002",
		"PU-Name": "ST PETER'S SCH OKERIMI ORO",
		Accredited_Voters: 223,
		Registered_Voters: 781,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23200/pu/76737/76737-1677685563.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 1",
		"PU-Code": "23-09-09-004",
		"PU-Name": "ILE BALE IDDO ORO",
		Accredited_Voters: 120,
		Registered_Voters: 427,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23200/pu/76739/76739-1677753702.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 1",
		"PU-Code": "23-09-09-007",
		"PU-Name": "MUSLIM SCH IJOMU ORO",
		Accredited_Voters: 189,
		Registered_Voters: 737,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23200/pu/76742/76742-1677699948.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 1",
		"PU-Code": "23-09-09-009",
		"PU-Name": "ILE BAA IJOMU ORO",
		Accredited_Voters: 113,
		Registered_Voters: 353,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23200/pu/76744/76744-1677600919.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-001",
		"PU-Name": "ILE BALE ORO",
		Accredited_Voters: 160,
		Registered_Voters: 817,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76746/76746-1677767887.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-002",
		"PU-Name": "ILE BALE ORO",
		Accredited_Voters: 209,
		Registered_Voters: 732,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677439370-76747.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-004",
		"PU-Name": "ILE ONIJALA ORO",
		Accredited_Voters: 181,
		Registered_Voters: 784,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76749/76749-1677768130.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-005",
		"PU-Name": "MUSLIM SCH ORO",
		Accredited_Voters: 235,
		Registered_Voters: 927,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/10/pu/005/005-1677426909.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-006",
		"PU-Name": "NEAR GENERAL HOSPITAL ORO",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/10/pu/006/006-1677422288.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-007",
		"PU-Name": "MUSLIM SCH, OKEOLA ORO",
		Accredited_Voters: 195,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677446107-76752.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-008",
		"PU-Name": "ILE BALE OKE OLA ORO",
		Accredited_Voters: 206,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76753/76753-1677675963.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-010",
		"PU-Name": "ILE BALE ILUDUN ORO",
		Accredited_Voters: 147,
		Registered_Voters: 460,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76755/76755-1677766489.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-011",
		"PU-Name": "ILE ALAPE ILUDUN ORO",
		Accredited_Voters: 153,
		Registered_Voters: 360,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76756/76756-1677493386.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-012",
		"PU-Name": "ST JAMES SCH ILUDUN ORO",
		Accredited_Voters: 200,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/10/pu/012/012-1677426010.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-013",
		"PU-Name": "ANSARUL L.G.E.A SCH, ILUDUN ORO",
		Accredited_Voters: 220,
		Registered_Voters: 601,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/76758/76758-1677765953.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-001",
		"PU-Name": "ILE OBA OKO",
		Accredited_Voters: 161,
		Registered_Voters: 570,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/11/pu/001/001-1677389643.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-002",
		"PU-Name": "MARKET CENTRE OKO",
		Accredited_Voters: 330,
		Registered_Voters: 968,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/11/pu/002/002-1677405933.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-003",
		"PU-Name": "ILE PETU OKO",
		Accredited_Voters: 361,
		Registered_Voters: 949,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/11/pu/003/003-1677405371.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-004",
		"PU-Name": "L.G.E.A SCH OKO",
		Accredited_Voters: 167,
		Registered_Voters: 570,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23202/pu/76762/76762-1677689814.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-005",
		"PU-Name": "ADULT L.G.E.A SCH INISHAN OKO",
		Accredited_Voters: 240,
		Registered_Voters: 692,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/11/pu/005/005-1677404873.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OKO",
		"PU-Code": "23-09-11-006",
		"PU-Name": "ITA ODOKO OKO",
		Accredited_Voters: 224,
		Registered_Voters: 659,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/11/pu/006/006-1677403702.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ALLA",
		"PU-Code": "23-10-01-002",
		"PU-Name": "L.G.E.A SCH OPONDA",
		Accredited_Voters: 174,
		Registered_Voters: 639,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76069/result_70222_1677593311_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ALLA",
		"PU-Code": "23-10-01-003",
		"PU-Name": "OWODE KAJOLA OPEN SPACE",
		Accredited_Voters: 104,
		Registered_Voters: 492,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76070/result_70223_1677590310_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "EDIDI",
		"PU-Code": "23-10-02-001",
		"PU-Name": "ST ANDREW L.G.E.A SCH",
		Accredited_Voters: 189,
		Registered_Voters: 732,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76072/result_70226_1677701861_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "EDIDI",
		"PU-Code": "23-10-02-002",
		"PU-Name": "BALE'S AREA OPEN SPACE",
		Accredited_Voters: 274,
		Registered_Voters: 952,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76073/result_70227_1677701921_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "EDIDI",
		"PU-Code": "23-10-02-003",
		"PU-Name": "MARKET CENTRE OPEN SPACE",
		Accredited_Voters: 166,
		Registered_Voters: 708,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76074/result_70228_1677701960_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "EDIDI",
		"PU-Code": "23-10-02-004",
		"PU-Name": "ILE-LOKE OPEN SPACE",
		Accredited_Voters: 108,
		Registered_Voters: 552,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76075/result_70229_1677702016_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-002",
		"PU-Name": "ST JOSEPH'S L.G.E.A SCH",
		Accredited_Voters: 109,
		Registered_Voters: 491,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/76774/76774-1677746668.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-003",
		"PU-Name": "AIYETORO OPEN SPACE",
		Accredited_Voters: 95,
		Registered_Voters: 512,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/76775/76775-1677753049.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-005",
		"PU-Name": "MARKET CENTRE ELEYIN",
		Accredited_Voters: 244,
		Registered_Voters: 886,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/76777/76777-1677748742.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-006",
		"PU-Name": "ODOGBO OPEN SPACE",
		Accredited_Voters: 153,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/76778/76778-1677754334.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-007",
		"PU-Name": "ILE OLOGBA AREA",
		Accredited_Voters: 151,
		Registered_Voters: 713,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/76779/76779-1677751736.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-001",
		"PU-Name": "ILE AGBASIN OPEN SPACE",
		Accredited_Voters: 88,
		Registered_Voters: 593,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76083/result_70239_1677653870_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-002",
		"PU-Name": "MARKET CENTRE OPEN SPACE",
		Accredited_Voters: 131,
		Registered_Voters: 755,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76084/result_70240_1677654046_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-003",
		"PU-Name": "OKE-EPA OPEN SPACE",
		Accredited_Voters: 142,
		Registered_Voters: 603,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76085/result_70241_1677654130_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-004",
		"PU-Name": "MATERNITY CENTRE",
		Accredited_Voters: 161,
		Registered_Voters: 825,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76086/result_70242_1677654212_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-005",
		"PU-Name": "AIYEDE OPEN SPACE",
		Accredited_Voters: 158,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76087/result_70243_1677654348_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-006",
		"PU-Name": "IGBAGBOTEDO OPEN SPACE",
		Accredited_Voters: 115,
		Registered_Voters: 594,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76088/result_70244_1677654486_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-007",
		"PU-Name": "ILE OLOMUJO OPEN SPACE",
		Accredited_Voters: 114,
		Registered_Voters: 572,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76089/result_70245_1677654566_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-001",
		"PU-Name": "OKE IGUNSIN OPEN SPACE",
		Accredited_Voters: 155,
		Registered_Voters: 677,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76090/result_70248_1677571862_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-003",
		"PU-Name": "BAPTIST L.G.E.A SCH",
		Accredited_Voters: 164,
		Registered_Voters: 705,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76092/result_70250_1677570986_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-004",
		"PU-Name": "BALE'S AREA OPEN SPACE",
		Accredited_Voters: 114,
		Registered_Voters: 522,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76093/result_70251_1677571155_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-005",
		"PU-Name": "OLD COURT OPEN SPACE",
		Accredited_Voters: 66,
		Registered_Voters: 349,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76094/result_70252_1677571277_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-006",
		"PU-Name": "ILE OLUSIN OPEN SPACE",
		Accredited_Voters: 168,
		Registered_Voters: 711,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76095/result_70253_1677571382_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-007",
		"PU-Name": "ILE NLA OPEN SPACE",
		Accredited_Voters: 109,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76096/result_70254_1677571490_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-008",
		"PU-Name": "AJEGUNLE OPEN SPACE",
		Accredited_Voters: 110,
		Registered_Voters: 535,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76097/result_70255_1677571614_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IJARA",
		"PU-Code": "23-10-05-009",
		"PU-Name": "OFATEDO OPEN SPACE",
		Accredited_Voters: 82,
		Registered_Voters: 343,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76098/result_70256_1677571707_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-001",
		"PU-Name": "ILE OBA OPEN SPACE",
		Accredited_Voters: 24,
		Registered_Voters: 344,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23208/pu/76796/76796-1677498975.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-002",
		"PU-Name": "COMM LGEA SCHOOL",
		Accredited_Voters: 159,
		Registered_Voters: 581,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/76797-1677865120.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-003",
		"PU-Name": "ILE NLA OPEN SPACE",
		Accredited_Voters: 64,
		Registered_Voters: 465,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/76798-1677866485.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-004",
		"PU-Name": "OKE-OPE OPEN SPACE",
		Accredited_Voters: 167,
		Registered_Voters: 699,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/76799-1677867037.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-005",
		"PU-Name": "MATERNITY CENTRE OPEN SPACE I",
		Accredited_Voters: 83,
		Registered_Voters: 508,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/76800-1677867545.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "IWO",
		"PU-Code": "23-10-06-006",
		"PU-Name": "MATERNITY CENTRE OPEN SPACE II",
		Accredited_Voters: 112,
		Registered_Voters: 430,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/76801-1677868602.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-001",
		"PU-Name": "COURT AREA OPEN SPACE",
		Accredited_Voters: 172,
		Registered_Voters: 851,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76105/result_70263_1677659753_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-002",
		"PU-Name": "ILE OBA OWU OPEN SPACE I",
		Accredited_Voters: 145,
		Registered_Voters: 635,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76106/result_70264_1677663088_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-003",
		"PU-Name": "ILE OBA OWU OPEN SPACE II",
		Accredited_Voters: 41,
		Registered_Voters: 222,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76107/result_70265_1677665338_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-005",
		"PU-Name": "LGEA SCH  IJI-ISIN I",
		Accredited_Voters: 147,
		Registered_Voters: 498,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76109/result_70267_1677682734_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-006",
		"PU-Name": "LGEA SCH  IJI-ISIN II",
		Accredited_Voters: 127,
		Registered_Voters: 488,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76110/result_70268_1677660749_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-007",
		"PU-Name": "MARKET CENTRE KUDU",
		Accredited_Voters: 69,
		Registered_Voters: 283,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76111/result_70269_1677673880_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-008",
		"PU-Name": "MARKET CENTRE OYI",
		Accredited_Voters: 194,
		Registered_Voters: 526,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76112/result_70270_1677678960_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-001",
		"PU-Name": "GARAGE OKE ONIGBIN OPEN SPACE",
		Accredited_Voters: 242,
		Registered_Voters: 921,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/76810/76810-1677574012.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-002",
		"PU-Name": "ALL SAINT, LGEA SCH I",
		Accredited_Voters: 259,
		Registered_Voters: 923,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/76811/76811-1677574734.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-003",
		"PU-Name": "ODO-IGBESI OPEN SPACE",
		Accredited_Voters: 144,
		Registered_Voters: 688,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/76812/76812-1677575173.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-005",
		"PU-Name": "IGBESI LGEA SCH",
		Accredited_Voters: 94,
		Registered_Voters: 336,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/76814/76814-1677575937.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-006",
		"PU-Name": "ADIGUN OPEN SPACE",
		Accredited_Voters: 88,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/76815/76815-1677576315.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "SABAJA/PAMO",
		"PU-Code": "23-10-09-002",
		"PU-Name": "OBA-ISIN LGEA SCH",
		Accredited_Voters: 183,
		Registered_Voters: 946,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23211/pu/76817/76817-1677840960.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "SABAJA/PAMO",
		"PU-Code": "23-10-09-003",
		"PU-Name": "SABAJA OPEN SPACE",
		Accredited_Voters: 94,
		Registered_Voters: 423,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76121/result_70283_1677751998_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-001",
		"PU-Name": "OKE ABA LGEA SCH",
		Accredited_Voters: 62,
		Registered_Voters: 382,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76122/result_70286_1677666408_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-002",
		"PU-Name": "ODO EKU LGEA SCH",
		Accredited_Voters: 123,
		Registered_Voters: 537,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76123/result_70287_1677667602_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-004",
		"PU-Name": "MAGAJI OLOKIN OPEN SPACE",
		Accredited_Voters: 66,
		Registered_Voters: 211,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76125/result_70289_1677667403_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-005",
		"PU-Name": "OKE ABA TOWN HALL",
		Accredited_Voters: 46,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76126/result_70290_1677666601_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-006",
		"PU-Name": "ODO-EKU MARKET CENTRE",
		Accredited_Voters: 171,
		Registered_Voters: 738,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76127/result_70291_1677666707_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ABA",
		"PU-Code": "23-10-10-007",
		"PU-Name": "IDI AGBEDE OKE ABA",
		Accredited_Voters: 78,
		Registered_Voters: 329,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76128/result_70292_1677666915_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OLLA",
		"PU-Code": "23-10-11-002",
		"PU-Name": "OLLA MARKET CENTRE",
		Accredited_Voters: 111,
		Registered_Voters: 560,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76131/result_70295_1677757923_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OLLA",
		"PU-Code": "23-10-11-003",
		"PU-Name": "AGAMO OPEN SPACE",
		Accredited_Voters: 167,
		Registered_Voters: 758,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76132/result_70296_1677758002_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OLLA",
		"PU-Code": "23-10-11-005",
		"PU-Name": "COMM LGEA SCH OLLA",
		Accredited_Voters: 106,
		Registered_Voters: 521,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76134/result_70298_1677529650_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OLLA",
		"PU-Code": "23-10-11-006",
		"PU-Name": "ODOFIN AREA OLLA OPEN SPACE",
		Accredited_Voters: 80,
		Registered_Voters: 369,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76135/result_70299_1677529377_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-001",
		"PU-Name": "KLGEA SCH ADENA",
		Accredited_Voters: 239,
		Registered_Voters: 1744,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/76833/76833-1677522498.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-002",
		"PU-Name": "KLGEA SCH  DADA",
		Accredited_Voters: 171,
		Registered_Voters: 852,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/76834/76834-1677523651.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-003",
		"PU-Name": "KLGEA SCH KOSA",
		Accredited_Voters: 114,
		Registered_Voters: 946,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/76835/76835-1677524023.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-001",
		"PU-Name": "BANI KLGEA SCH",
		Accredited_Voters: 295,
		Registered_Voters: 1710,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76837/76837-1677518792.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-002",
		"PU-Name": "ZANGO MARKET, BANI",
		Accredited_Voters: 241,
		Registered_Voters: 1420,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76838/76838-1677453840.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-003",
		"PU-Name": "OLOKOTINTIN KLGEA SCH",
		Accredited_Voters: 92,
		Registered_Voters: 747,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76839/76839-1677503880.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-004",
		"PU-Name": "FONLO OPEN SPACE",
		Accredited_Voters: 117,
		Registered_Voters: 783,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76840/76840-1677485830.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-005",
		"PU-Name": "BANI-OLORI KLGEA SCH",
		Accredited_Voters: 229,
		Registered_Voters: 1186,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76841/76841-1677501766.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-006",
		"PU-Name": "KAAGBONA KLGEA (NOM. SCH)",
		Accredited_Voters: 189,
		Registered_Voters: 970,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76842/76842-1677482631.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-007",
		"PU-Name": "FAMINI KLGEA SCH",
		Accredited_Voters: 224,
		Registered_Voters: 1216,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76843/76843-1677468269.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-008",
		"PU-Name": "OGUNNIYI OPEN SPACE",
		Accredited_Voters: 139,
		Registered_Voters: 804,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/76844/76844-1677455657.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-001",
		"PU-Name": "KANIKOKO PRY SCH I",
		Accredited_Voters: 259,
		Registered_Voters: 1470,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/03/pu/001/001-1677427331.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-002",
		"PU-Name": "KANIKOKO PRY SCH II",
		Accredited_Voters: 138,
		Registered_Voters: 1259,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/03/pu/002/002-1677418597.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-003",
		"PU-Name": "VENRA KLGEA SCH",
		Accredited_Voters: 306,
		Registered_Voters: 1100,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/76847/76847-1677476173.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-005",
		"PU-Name": "TUNGA MAJE PRY SCH",
		Accredited_Voters: 259,
		Registered_Voters: 923,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/03/pu/005/005-1677425712.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-007",
		"PU-Name": "GOROBANI OPEN SPACE",
		Accredited_Voters: 140,
		Registered_Voters: 849,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/76851/76851-1677474059.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-001",
		"PU-Name": "GWATTEKUTA KLGEA SCH",
		Accredited_Voters: 538,
		Registered_Voters: 1651,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/001/001-1677370421.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-002",
		"PU-Name": "TUNGA-ABOKI KLGEA SCH",
		Accredited_Voters: 346,
		Registered_Voters: 1495,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/002/002-1677364602.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-003",
		"PU-Name": "SOPERE KLGEA SCH",
		Accredited_Voters: 218,
		Registered_Voters: 953,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/003/003-1677378612.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-004",
		"PU-Name": "KOROKUN OPEN SPACE",
		Accredited_Voters: 128,
		Registered_Voters: 524,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/004/004-1677361242.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-005",
		"PU-Name": "TUNGA ATIKU DARUSALAM (NS)",
		Accredited_Voters: 214,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/005/005-1677360844.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-006",
		"PU-Name": "OWODE NOM. SCH",
		Accredited_Voters: 140,
		Registered_Voters: 559,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/006/006-1677372338.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-001",
		"PU-Name": "GWARIA KLGEA SCH",
		Accredited_Voters: 385,
		Registered_Voters: 2320,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/05/pu/001/001-1677392498.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-002",
		"PU-Name": "MOZHI-GADA KLGEA SCH",
		Accredited_Voters: 252,
		Registered_Voters: 1458,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/76859/76859-1677502621.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-003",
		"PU-Name": "GWARIA-WUZI KLGEA SCH",
		Accredited_Voters: 139,
		Registered_Voters: 1362,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/76860/76860-1677502829.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-004",
		"PU-Name": "APATA WELEWELE KLGEA SCH",
		Accredited_Voters: 18,
		Registered_Voters: 412,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/76861/76861-1677503027.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-005",
		"PU-Name": "NOMADIC SCH, GORODEGE",
		Accredited_Voters: 188,
		Registered_Voters: 1097,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/76862/76862-1677503287.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-006",
		"PU-Name": "GATE  KLGEA SCH",
		Accredited_Voters: 120,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/76863/76863-1677503550.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-001",
		"PU-Name": "CENTRAL PRY SCH, KAIAMA",
		Accredited_Voters: 270,
		Registered_Voters: 870,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/06/pu/001/001-1677388038.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-002",
		"PU-Name": "NRC SECRETARIAT, KAIAMA I",
		Accredited_Voters: 285,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23219/pu/76865/76865-1677499408.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-003",
		"PU-Name": "NRC SECRETARIAT, KAIAMA II",
		Accredited_Voters: 247,
		Registered_Voters: 822,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/06/pu/003/003-1677389361.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-004",
		"PU-Name": "KPAKPEN OPEN SPACE",
		Accredited_Voters: 228,
		Registered_Voters: 824,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23219/pu/76867/76867-1677499921.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-002",
		"PU-Name": "NASSARAWA OPEN SPACE",
		Accredited_Voters: 211,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/76869/76869-1677591832.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-003",
		"PU-Name": "KULINGIZIN ISLAMIYA OLD SCH",
		Accredited_Voters: 289,
		Registered_Voters: 937,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/76870/76870-1677588107.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-004",
		"PU-Name": "GBANAGIZI KLGEA SCH",
		Accredited_Voters: 308,
		Registered_Voters: 1260,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/76871/76871-1677589030.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-005",
		"PU-Name": "OSIWERA VIEWING CENTRE, KAIAMA",
		Accredited_Voters: 277,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/76872/76872-1677592117.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-006",
		"PU-Name": "KLGEA SCH, SABON-NGARI",
		Accredited_Voters: 348,
		Registered_Voters: 1393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/76873/76873-1677589525.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-001",
		"PU-Name": "KABARU OPEN SPACE",
		Accredited_Voters: 260,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/001/001-1677395490.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-002",
		"PU-Name": "POST OFFICE, KAIAMA",
		Accredited_Voters: 227,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/002/002-1677392691.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-004",
		"PU-Name": "OGA-SAANI OPEN SPACE",
		Accredited_Voters: 327,
		Registered_Voters: 849,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/004/004-1677390818.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KEMANJI",
		"PU-Code": "23-11-09-002",
		"PU-Name": "KPEDEZIN KLGEA SCH",
		Accredited_Voters: 336,
		Registered_Voters: 973,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23222/pu/76879/76879-1677600278.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KEMANJI",
		"PU-Code": "23-11-09-003",
		"PU-Name": "BABETE NOMADIC SCH",
		Accredited_Voters: 174,
		Registered_Voters: 813,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23222/pu/76880/76880-1677601142.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-001",
		"PU-Name": "SHIRI-GWARIA KLGEA SCH",
		Accredited_Voters: 242,
		Registered_Voters: 760,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/001/001-1677388084.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-002",
		"PU-Name": "KUGIJI KLGEA SCH",
		Accredited_Voters: 353,
		Registered_Voters: 1203,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/002/002-1677388542.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-003",
		"PU-Name": "BANISULA KLGEA SCH",
		Accredited_Voters: 201,
		Registered_Voters: 856,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/003/003-1677388912.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-004",
		"PU-Name": "KARO CAMP, KLGEA SCH",
		Accredited_Voters: 82,
		Registered_Voters: 955,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/004/004-1677389664.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-005",
		"PU-Name": "KARO CAMP MARKET SQUARE",
		Accredited_Voters: 75,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/005/005-1677390088.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-007",
		"PU-Name": "NANU KLGEA SCH",
		Accredited_Voters: 124,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/007/007-1677391084.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-001",
		"PU-Name": "UMCA IDI AGBON JEBBA",
		Accredited_Voters: 268,
		Registered_Voters: 952,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/001/001-1677372031.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-002",
		"PU-Name": "ST THERESA SCH JEBBA",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/002/002-1677366137.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-003",
		"PU-Name": "WAITING ROOM, RAILWAY STATION",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/003/003-1677364605.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-004",
		"PU-Name": "BERGER MARKET",
		Accredited_Voters: 204,
		Registered_Voters: 946,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/004/004-1677365121.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-005",
		"PU-Name": "ANSARUL ISLAM SCH",
		Accredited_Voters: 239,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/005/005-1677370894.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-006",
		"PU-Name": "LABOUR CAMP JEBBA",
		Accredited_Voters: 176,
		Registered_Voters: 763,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/006/006-1677374271.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-007",
		"PU-Name": "LGEA  SCH ONIPAKO",
		Accredited_Voters: 173,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/007/007-1677365122.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-009",
		"PU-Name": "LGEA  SCH  MORAFA",
		Accredited_Voters: 146,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/009/009-1677368024.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-010",
		"PU-Name": "LGEA  SCH  FANGAN",
		Accredited_Voters: 200,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/010/010-1677367309.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-011",
		"PU-Name": "LGEA  SCH  ADEKANBI",
		Accredited_Voters: 208,
		Registered_Voters: 821,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/011/011-1677374780.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-001",
		"PU-Name": "VIEWING CENTRE BODE-SAADU",
		Accredited_Voters: 302,
		Registered_Voters: 1776,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/001/001-1677369842.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-002",
		"PU-Name": "COMM PRY SCH BODE-SAADU",
		Accredited_Voters: 238,
		Registered_Voters: 1199,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23225/pu/76901/76901-1677622070.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-003",
		"PU-Name": "LAKANLA VILLAGE",
		Accredited_Voters: 152,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/003/003-1677382092.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-004",
		"PU-Name": "LGEA  SCH LASAKI FALA",
		Accredited_Voters: 179,
		Registered_Voters: 807,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23225/pu/76903/76903-1677849743.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-005",
		"PU-Name": "GATTA VILLAGE",
		Accredited_Voters: 116,
		Registered_Voters: 838,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/005/005-1677420358.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKEMI",
		"PU-Code": "23-12-03-001",
		"PU-Name": "LGEA  SCH OKEMI",
		Accredited_Voters: 281,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/03/pu/001/001-1677371417.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKEMI",
		"PU-Code": "23-12-03-002",
		"PU-Name": "LGEA  SCH ADIO LANWA",
		Accredited_Voters: 248,
		Registered_Voters: 650,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/03/pu/002/002-1677369405.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-001",
		"PU-Name": "LGEA  SCH LANWA",
		Accredited_Voters: 225,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/001/001-1677369316.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-002",
		"PU-Name": "LGEA  SCH ELEBU",
		Accredited_Voters: 184,
		Registered_Voters: 631,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/002/002-1677397506.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-003",
		"PU-Name": "GBODI VILLAGE",
		Accredited_Voters: 105,
		Registered_Voters: 511,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/003/003-1677395112.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-004",
		"PU-Name": "LGEA  SCH BUDO-ODE",
		Accredited_Voters: 165,
		Registered_Voters: 592,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/004/004-1677398117.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-005",
		"PU-Name": "ELEMOSHO VILLAGE",
		Accredited_Voters: 112,
		Registered_Voters: 502,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/005/005-1677396501.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "EJIDONGARI",
		"PU-Code": "23-12-05-003",
		"PU-Name": "LGEA  SCH  MAGAJI OGUNBO",
		Accredited_Voters: 234,
		Registered_Voters: 781,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/05/pu/003/003-1677365129.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "EJIDONGARI",
		"PU-Code": "23-12-05-004",
		"PU-Name": "LGEA  SCH OLOKITI NLA",
		Accredited_Voters: 157,
		Registered_Voters: 613,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/05/pu/004/004-1677365208.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-001",
		"PU-Name": "LGEA  SCH OKUTALA",
		Accredited_Voters: 304,
		Registered_Voters: 970,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/001/001-1677370045.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-002",
		"PU-Name": "LGEA  SCH BI-ELESIN",
		Accredited_Voters: 256,
		Registered_Voters: 958,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/002/002-1677375524.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-003",
		"PU-Name": "LGEA  SCH AMOO",
		Accredited_Voters: 247,
		Registered_Voters: 741,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/003/003-1677371496.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-004",
		"PU-Name": "LGEA  SCH LADOJO",
		Accredited_Voters: 97,
		Registered_Voters: 523,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/004/004-1677375295.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-005",
		"PU-Name": "LGEA  SCH OLOKO",
		Accredited_Voters: 275,
		Registered_Voters: 1038,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23229/pu/76923/76923-1677763190.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-006",
		"PU-Name": "OPEN SPACE JOWA-IDISIN",
		Accredited_Voters: 128,
		Registered_Voters: 506,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/006/006-1677372357.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-001",
		"PU-Name": "LGEA  SCH OGUNTULU",
		Accredited_Voters: 173,
		Registered_Voters: 415,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/001/001-1677393620.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-002",
		"PU-Name": "LGEA  SCH IGBO-EMU",
		Accredited_Voters: 441,
		Registered_Voters: 813,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/002/002-1677380281.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-003",
		"PU-Name": "LGEA  SCH SHEJI",
		Accredited_Voters: 251,
		Registered_Voters: 623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/003/003-1677375417.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-004",
		"PU-Name": "LGEA  SCH JODOMA",
		Accredited_Voters: 128,
		Registered_Voters: 279,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/004/004-1677372979.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-005",
		"PU-Name": "L.G.E.A. SCH AGBAKU-EJI",
		Accredited_Voters: 208,
		Registered_Voters: 520,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/005/005-1677378551.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BABADUDU",
		"PU-Code": "23-12-07-006",
		"PU-Name": "L.G.E.A. SCH BABADUDU",
		Accredited_Voters: 158,
		Registered_Voters: 455,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/07/pu/006/006-1677372844.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-001",
		"PU-Name": "L.G.E.A. SCH OLORU I",
		Accredited_Voters: 247,
		Registered_Voters: 531,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/001/001-1677365015.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-002",
		"PU-Name": "L.G.E.A. SCH OGUN-EDUN",
		Accredited_Voters: 220,
		Registered_Voters: 582,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/002/002-1677360816.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-004",
		"PU-Name": "OPEN SPACE KANBI",
		Accredited_Voters: 189,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/004/004-1677364786.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-005",
		"PU-Name": "SECONDARY SCH OLORU",
		Accredited_Voters: 261,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/005/005-1677366674.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-001",
		"PU-Name": "MATERNITY DISPENSARY BUDO-OKE",
		Accredited_Voters: 146,
		Registered_Voters: 335,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/001/001-1677359383.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-002",
		"PU-Name": "L.G.E.A. SCH OBADA",
		Accredited_Voters: 212,
		Registered_Voters: 445,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/002/002-1677360294.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-003",
		"PU-Name": "L.G.E.A. SCH PAKUNMO",
		Accredited_Voters: 102,
		Registered_Voters: 389,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/003/003-1677368140.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-004",
		"PU-Name": "APOYA VILLAGE",
		Accredited_Voters: 123,
		Registered_Voters: 799,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/004/004-1677358614.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-005",
		"PU-Name": "MOLEKE VILLAGE",
		Accredited_Voters: 137,
		Registered_Voters: 621,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/005/005-1677361254.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "PAKUNMO",
		"PU-Code": "23-12-09-006",
		"PU-Name": "OPEN SPACE ABAMBA",
		Accredited_Voters: 129,
		Registered_Voters: 342,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/09/pu/006/006-1677359226.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-001",
		"PU-Name": "ZURU VILLAGE",
		Accredited_Voters: 38,
		Registered_Voters: 336,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/001/001-1677368315.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-002",
		"PU-Name": "L.G.E.A. SCH ELEMERE",
		Accredited_Voters: 230,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/002/002-1677369365.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-003",
		"PU-Name": "L.G.E.A. SCH ADIO",
		Accredited_Voters: 298,
		Registered_Voters: 832,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/003/003-1677369068.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-004",
		"PU-Name": "L.G.E.A. SCH APATA OLONI",
		Accredited_Voters: 166,
		Registered_Voters: 424,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/004/004-1677372397.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-006",
		"PU-Name": "L.G.E.A. SCH ANIMAJE",
		Accredited_Voters: 239,
		Registered_Voters: 782,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/006/006-1677369152.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-001",
		"PU-Name": "L.G.E.A SCH TEPATAN",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/001/001-1677371331.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-002",
		"PU-Name": "L.G.E.A SCH ARA",
		Accredited_Voters: 400,
		Registered_Voters: 737,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/002/002-1677376977.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-003",
		"PU-Name": "L.G.E.A SCH BUDO ARE",
		Accredited_Voters: 162,
		Registered_Voters: 427,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/003/003-1677371911.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-004",
		"PU-Name": "L.G.E.A SCH KIRIBI",
		Accredited_Voters: 187,
		Registered_Voters: 647,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/004/004-1677377832.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-005",
		"PU-Name": "L.G.E.A SCH ELEKO-YANGAN",
		Accredited_Voters: 312,
		Registered_Voters: 902,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/005/005-1677379402.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-001",
		"PU-Name": "S.D.A SCH SHAO",
		Accredited_Voters: 309,
		Registered_Voters: 1281,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/001/001-1677376793.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-002",
		"PU-Name": "L.G.E.A SCH SHAO",
		Accredited_Voters: 265,
		Registered_Voters: 836,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/002/002-1677399609.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-003",
		"PU-Name": "OKE SINNIGA SHAO",
		Accredited_Voters: 287,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/003/003-1677389777.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-004",
		"PU-Name": "TOWN HALL SHAO",
		Accredited_Voters: 210,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/004/004-1677371698.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-005",
		"PU-Name": "I.A.D.P SHAO",
		Accredited_Voters: 225,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/005/005-1677390725.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-006",
		"PU-Name": "ODE ALAWON SHAO",
		Accredited_Voters: 145,
		Registered_Voters: 430,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/006/006-1677378527.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-007",
		"PU-Name": "MATERNITY CENTRE SHAO",
		Accredited_Voters: 132,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/007/007-1677379022.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LOGUN/JEHUNKUNNU",
		"PU-Code": "23-12-13-001",
		"PU-Name": "L.G.E.A SCH JEUNKUNNU",
		Accredited_Voters: 405,
		Registered_Voters: 918,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23236/pu/76961/76961-1677763593.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LOGUN/JEHUNKUNNU",
		"PU-Code": "23-12-13-002",
		"PU-Name": "KARIBUJE VILLAGE",
		Accredited_Voters: 144,
		Registered_Voters: 340,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23236/pu/76962/76962-1677763650.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LOGUN/JEHUNKUNNU",
		"PU-Code": "23-12-13-003",
		"PU-Name": "BUDO-ABO VILLAGE",
		Accredited_Voters: 102,
		Registered_Voters: 326,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23236/pu/76963/76963-1677764338.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MALETE/GBUGUDU",
		"PU-Code": "23-12-14-001",
		"PU-Name": "L.G.E.A SCH MALETE",
		Accredited_Voters: 235,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/14/pu/001/001-1677367728.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MALETE/GBUGUDU",
		"PU-Code": "23-12-14-002",
		"PU-Name": "L.G.E.A SCH BUSAMU-ADU",
		Accredited_Voters: 165,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/14/pu/002/002-1677369008.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MALETE/GBUGUDU",
		"PU-Code": "23-12-14-003",
		"PU-Name": "L.G.E.A SCH GBUGUDU",
		Accredited_Voters: 227,
		Registered_Voters: 534,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/14/pu/003/003-1677368406.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MALETE/GBUGUDU",
		"PU-Code": "23-12-14-004",
		"PU-Name": "L.G.E.A SCH OKETE-JAGODO",
		Accredited_Voters: 277,
		Registered_Voters: 525,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/14/pu/004/004-1677362510.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AJANAKU",
		"PU-Code": "23-12-15-001",
		"PU-Name": "L.G.E.A SCH BUDO ARE",
		Accredited_Voters: 277,
		Registered_Voters: 921,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23238/pu/76969/76969-1677765093.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AJANAKU",
		"PU-Code": "23-12-15-002",
		"PU-Name": "L.G.E.A SCH AGBAKU",
		Accredited_Voters: 181,
		Registered_Voters: 622,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23238/pu/76970/76970-1677765397.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AJANAKU",
		"PU-Code": "23-12-15-003",
		"PU-Name": "L.G.E.A SCH PAKU",
		Accredited_Voters: 282,
		Registered_Voters: 808,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23238/pu/76971/76971-1677765619.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AJANAKU",
		"PU-Code": "23-12-15-004",
		"PU-Name": "L.G.E.A SCH AGAR",
		Accredited_Voters: 150,
		Registered_Voters: 606,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23238/pu/76972/76972-1677765662.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-001",
		"PU-Name": "L.G.E.A SCH IPAIYE",
		Accredited_Voters: 296,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/001/001-1677402875.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-002",
		"PU-Name": "L.G.E.A SCH BABALOKE",
		Accredited_Voters: 215,
		Registered_Voters: 923,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/002/002-1677403677.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-003",
		"PU-Name": "L.G.E.A SCH OLOWORU",
		Accredited_Voters: 251,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/003/003-1677377053.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-004",
		"PU-Name": "L.G.E.A SCH ALAGBO",
		Accredited_Voters: 281,
		Registered_Voters: 900,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/004/004-1677400575.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-005",
		"PU-Name": "L.G.E.A SCH ABEREJO",
		Accredited_Voters: 107,
		Registered_Voters: 444,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/005/005-1677393303.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-006",
		"PU-Name": "L.G.E.A SCH AGBAKU",
		Accredited_Voters: 150,
		Registered_Voters: 603,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/006/006-1677392436.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-001",
		"PU-Name": "L.G.E.A SCH AROBADI",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/001/001-1677383817.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-002",
		"PU-Name": "L.G.E.A SCH GUDU",
		Accredited_Voters: 137,
		Registered_Voters: 412,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/002/002-1677372548.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-003",
		"PU-Name": "L.G.E.A SCH ADARA",
		Accredited_Voters: 249,
		Registered_Voters: 625,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/003/003-1677369706.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-004",
		"PU-Name": "L.G.E.A. SCHOOL PRIMARY ODONIGI",
		Accredited_Voters: 120,
		Registered_Voters: 513,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/004/004-1677369391.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-005",
		"PU-Name": "L.G.E.A SCH AWUYAN",
		Accredited_Voters: 252,
		Registered_Voters: 772,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/005/005-1677368055.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-001",
		"PU-Name": "OPEN SPACE TIDI BOGEDE L.G.E.A",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/001/001-1677372832.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-004",
		"PU-Name": "OPEN SPACE IDI-ISIN AREA",
		Accredited_Voters: 249,
		Registered_Voters: 811,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/004/004-1677378747.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-007",
		"PU-Name": "OPEN SPACE  IYERU-OKIN L.G.E.A I",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/007/007-1677399211.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-008",
		"PU-Name": "OPEN SPACE  IYERU-OKIN L.G.E.A II",
		Accredited_Voters: 125,
		Registered_Voters: 409,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/008/008-1677376886.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-009",
		"PU-Name": "OPEN SPACE AKINGBESA AREA I",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/009/009-1677394429.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-010",
		"PU-Name": "OPEN SPACE  AMOKO COMP",
		Accredited_Voters: 218,
		Registered_Voters: 802,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/010/010-1677392575.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-001",
		"PU-Name": "OPEN SPACE  ADEOLA JUNCTION",
		Accredited_Voters: 223,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76297/result_70585_1677709612_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-002",
		"PU-Name": "OPEN SPACE  NEAR IGBONNA MOSQUE AREA",
		Accredited_Voters: 188,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76298/result_70586_1677600208_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-003",
		"PU-Name": "OPEN SPACE FREEDOM HOTEL AREA I",
		Accredited_Voters: 161,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 52,
		Lp: "",
		PDP: 93,
		SDP: 5,
		NNPP: 3,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76299/result_70587_1677600946_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-004",
		"PU-Name": "OPEN SPACE  OMO-OWO AREA",
		Accredited_Voters: 287,
		Registered_Voters: 1279,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76300/result_70588_1677709702_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-005",
		"PU-Name": "OPEN SPACE, ST CYPRIAN SCH I",
		Accredited_Voters: 284,
		Registered_Voters: 847,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76301/result_70589_1677600490.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-006",
		"PU-Name": "OPEN SPACE, ST CYPRIAN SCH II",
		Accredited_Voters: 211,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76302/result_70590_1677683597_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-007",
		"PU-Name": "OPEN SPACE, AFOLARIN AREA",
		Accredited_Voters: 387,
		Registered_Voters: 1522,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76303/result_70591_1677683275_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-008",
		"PU-Name": "OPEN SPACE, KANMONU ALAYIN",
		Accredited_Voters: 154,
		Registered_Voters: 752,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 73,
		Lp: 3,
		PDP: 57,
		SDP: 3,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76304/result_70592_1677756543_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-001",
		"PU-Name": "OPEN SPACE, BOLUDE AREA",
		Accredited_Voters: 227,
		Registered_Voters: 710,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76305/result_70607_1677535694_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-002",
		"PU-Name": "OPEN SPACE, OGANLA AREA I",
		Accredited_Voters: 199,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76306/result_70608_1677536117_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-003",
		"PU-Name": "OPEN SPACE, AMBE AREA I",
		Accredited_Voters: 293,
		Registered_Voters: 875,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76307/result_70609_1677536292_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-004",
		"PU-Name": "OPEN SPACE, AKOSIN AREA I",
		Accredited_Voters: 252,
		Registered_Voters: 833,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76308/result_70610_1677536418_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-005",
		"PU-Name": "OPEN SPACE, ALUBATA AREA",
		Accredited_Voters: 206,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76309/result_70611_1677573533_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-006",
		"PU-Name": "OPEN SPACE, POPO MARKET I",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76310/result_70612_1677538545_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-007",
		"PU-Name": "OPEN SPACE, AJIA AREA",
		Accredited_Voters: 213,
		Registered_Voters: 638,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76311/result_70613_1677538646_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-008",
		"PU-Name": "OPEN SPACE, IKOLABA AREA I",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76312/result_70614_1677538722_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-008",
		"PU-Name": "OPEN SPACE, IKOLABA AREA II",
		Accredited_Voters: 97,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 58,
		Lp: "",
		PDP: 30,
		SDP: 4,
		NNPP: 1,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76312/result_70614_1677538722_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-001",
		"PU-Name": "OPEN SPACE, ARE ONILU AREA",
		Accredited_Voters: 364,
		Registered_Voters: 1097,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/001/001-1677398300.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-003",
		"PU-Name": "OPEN SPACE, ELEPA AREA I",
		Accredited_Voters: 255,
		Registered_Voters: 967,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/003/003-1677373541.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-004",
		"PU-Name": "OPEN SPACE, IDI OGUN AREA I",
		Accredited_Voters: 194,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/004/004-1677374818.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-005",
		"PU-Name": "OPEN SPACE, BELEORE AREA I",
		Accredited_Voters: 271,
		Registered_Voters: 932,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/005/005-1677375785.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-006",
		"PU-Name": "OPEN SPACE, OKIN CINEMA AREA I",
		Accredited_Voters: 218,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/006/006-1677367291.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-007",
		"PU-Name": "OPEN SPACE, SAKOSI JUNCTION",
		Accredited_Voters: 252,
		Registered_Voters: 739,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/007/007-1677376583.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-002",
		"PU-Name": "OPEN SPACE, OBADA BOYE AREA I",
		Accredited_Voters: 194,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/002/002-1677368526.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-004",
		"PU-Name": "OPEN SPACE,OPPOSITE OLOFA'S GATE",
		Accredited_Voters: 303,
		Registered_Voters: 755,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/004/004-1677397024.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-006",
		"PU-Name": "OPEN SPACE IGBORO HEALTH CENTRE I",
		Accredited_Voters: 296,
		Registered_Voters: 1012,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/006/006-1677370945.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-001",
		"PU-Name": "OPEN SPACE ONA-ARA BAKERY",
		Accredited_Voters: 210,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 114,
		Lp: "",
		PDP: 89,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76326/result_70645_1677703239_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-002",
		"PU-Name": "DE-CROWN RESTRAURANT OLOYA AREA",
		Accredited_Voters: 232,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76327/result_70646_1677703522_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-003",
		"PU-Name": "OPEN SPACE OLOYABANLEKU AREA I",
		Accredited_Voters: 247,
		Registered_Voters: 889,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 135,
		Lp: 1,
		PDP: 94,
		SDP: 7,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76328/result_70647_1677703754_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-004",
		"PU-Name": "OPEN SPACE SAJIKU AREA I",
		Accredited_Voters: 195,
		Registered_Voters: 859,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 99,
		Lp: "",
		PDP: 57,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76329/result_70648_1677704636_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-005",
		"PU-Name": "OPEN SPACE ESSA SQUARE I",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 86,
		Lp: "",
		PDP: 83,
		SDP: 8,
		NNPP: 2,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76330/result_70649_1677704805_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-002",
		"PU-Name": "OPEN SPACE OLUAWO AREA",
		Accredited_Voters: 241,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76332/result_70657_1677664174_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-003",
		"PU-Name": "IDI-OGUN SAWMILL AREA",
		Accredited_Voters: 228,
		Registered_Voters: 999,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76333/result_70658_1677660262_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-003",
		"PU-Name": "IDI-OGUN SAWMILL AREA",
		Accredited_Voters: 228,
		Registered_Voters: 999,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76333/result_70658_1677660262_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-005",
		"PU-Name": "BAPTIST LGEA ITAFA I",
		Accredited_Voters: 258,
		Registered_Voters: 1623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 160,
		Lp: "",
		PDP: 62,
		SDP: 5,
		NNPP: 2,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76335/result_70660_1677660071_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-006",
		"PU-Name": "OPEN SPACE O.D.U SECRETARIAT I",
		Accredited_Voters: 168,
		Registered_Voters: 808,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 85,
		Lp: 2,
		PDP: 56,
		SDP: 13,
		NNPP: 2,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76336/result_70661_1677660438_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-007",
		"PU-Name": "OPEN SPACE O.D.U SECRETARIAT II",
		Accredited_Voters: 115,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 56,
		Lp: "",
		PDP: 46,
		SDP: 6,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76337/result_70662_1677657374_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-001",
		"PU-Name": "OPEN SPACE IST BAPTIST L.G.E.A",
		Accredited_Voters: 242,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76338/result_70673_1677532273_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-002",
		"PU-Name": "OPEN SPACE AGUN BAPTIST L.G.E.A",
		Accredited_Voters: 259,
		Registered_Voters: 944,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76339/result_70674_1677532116_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-003",
		"PU-Name": "OPEN SPACE ADELEKE ROAD",
		Accredited_Voters: 224,
		Registered_Voters: 933,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76340/result_70675_1677532818_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-004",
		"PU-Name": "OPEN SPACE MUU ROAD",
		Accredited_Voters: 242,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76341/result_70676_1677533024_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-005",
		"PU-Name": "OPEN SPACE O.G.S",
		Accredited_Voters: 220,
		Registered_Voters: 1014,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76342/result_70677_1677533212_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-006",
		"PU-Name": "OPEN SPACE OLUOLO",
		Accredited_Voters: 236,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76343/result_70678_1677533566_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-007",
		"PU-Name": "OPEN SPACE PRINCE MOTEL",
		Accredited_Voters: 309,
		Registered_Voters: 1000,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76344/result_70679_1677533692_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-008",
		"PU-Name": "OPEN SPACE POST OFFICE",
		Accredited_Voters: 244,
		Registered_Voters: 1016,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76345/result_70680_1677533807_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-009",
		"PU-Name": "OPEN SPACE OGAKUNRIN AREA",
		Accredited_Voters: 144,
		Registered_Voters: 632,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76346/result_70681_1677534501_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-001",
		"PU-Name": "OPEN SPACE ESO BABA ALATA",
		Accredited_Voters: 211,
		Registered_Voters: 938,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/001/001-1677367793.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-002",
		"PU-Name": "OPEN SPACE EJISUN AREA I",
		Accredited_Voters: 231,
		Registered_Voters: 917,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/002/002-1677364874.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-003",
		"PU-Name": "OPEN SPACE CHILDREN WELFARE",
		Accredited_Voters: 164,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/003/003-1677362353.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-004",
		"PU-Name": "OPEN SPACE ANADOWO AREA",
		Accredited_Voters: 248,
		Registered_Voters: 875,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/004/004-1677367457.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-005",
		"PU-Name": "OPEN SPACE ALAGURE AREA I",
		Accredited_Voters: 215,
		Registered_Voters: 817,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/005/005-1677361817.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-006",
		"PU-Name": "OPEN SPACE OLA ISALE AREA I",
		Accredited_Voters: 246,
		Registered_Voters: 952,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/006/006-1677365405.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-001",
		"PU-Name": "OPEN SPACE OBATIWAJUOYE AREA I",
		Accredited_Voters: 345,
		Registered_Voters: 1255,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76353/result_70706_1677579112_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-002",
		"PU-Name": "OPEN SPACE ASALOFA AREA",
		Accredited_Voters: 217,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76354/result_70707_1677579692_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-003",
		"PU-Name": "OPEN SPACE OLADODO AREA I",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76355/result_70708_1677579829_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-004",
		"PU-Name": "OPEN SPACE ESO PATAKI AREA I",
		Accredited_Voters: 271,
		Registered_Voters: 911,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76356/result_70709_1677579990_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-005",
		"PU-Name": "OPEN SPACE ST THOMAS L.G.E.A I",
		Accredited_Voters: 227,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76357/result_70710_1677580215_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-001",
		"PU-Name": "L.G.E.A WESLEY SCH",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/77055/77055-1677485897.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-003",
		"PU-Name": "ITA APONBI BUS STOP",
		Accredited_Voters: 183,
		Registered_Voters: 440,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/77057/77057-1677478947.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-004",
		"PU-Name": "OPEN SPACE ITA ERIN AREA I",
		Accredited_Voters: 202,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/004/004-1677409818.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-005",
		"PU-Name": "OPEN SPACE ESINKIN AREA",
		Accredited_Voters: 217,
		Registered_Voters: 759,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/005/005-1677363420.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-006",
		"PU-Name": "OPEN SPACE GEDEGBE AREA",
		Accredited_Voters: 271,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/006/006-1677379070.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-007",
		"PU-Name": "OPEN SPACE OGANRAN AREA I",
		Accredited_Voters: 302,
		Registered_Voters: 862,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/77061/77061-1677487452.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-008",
		"PU-Name": "OPEN SPACE AROJOJOYE  AREA",
		Accredited_Voters: 254,
		Registered_Voters: 776,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/77062/77062-1677486973.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-009",
		"PU-Name": "OPEN SPACE OPELOYERU  AREA I",
		Accredited_Voters: 270,
		Registered_Voters: 985,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/009/009-1677393566.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-010",
		"PU-Name": "OPEN SPACE OPELOYERU  AREA II",
		Accredited_Voters: 254,
		Registered_Voters: 880,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/010/010-1677406234.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "IGBOIDUN",
		"PU-Code": "23-13-12-002",
		"PU-Name": "IGBAWERE  L.G.E.A",
		Accredited_Voters: 158,
		Registered_Voters: 705,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/12/pu/002/002-1677369538.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "IGBOIDUN",
		"PU-Code": "23-13-12-003",
		"PU-Name": "OPEN SPACE GBOSUN OGBONDOROKO",
		Accredited_Voters: 231,
		Registered_Voters: 864,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 106,
		Lp: "",
		PDP: 102,
		SDP: 12,
		NNPP: 1,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/12/pu/003/003-1677370818.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "IGBOIDUN",
		"PU-Code": "23-13-12-005",
		"PU-Name": "OPEN SPACE AJEGUNLE",
		Accredited_Voters: 128,
		Registered_Voters: 391,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 43,
		Lp: "",
		PDP: 75,
		SDP: 9,
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/12/pu/005/005-1677372611.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-002",
		"PU-Name": "MARKET CENTRE II",
		Accredited_Voters: 87,
		Registered_Voters: 524,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 55,
		Lp: "",
		PDP: 83,
		SDP: 2,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76374/result_70741_1677755450_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-003",
		"PU-Name": "IJELU CENTRE I",
		Accredited_Voters: 183,
		Registered_Voters: 558,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76375/result_70742_1677772001_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-004",
		"PU-Name": "IJELU CENTRE II",
		Accredited_Voters: 124,
		Registered_Voters: 325,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76376/result_70743_1677771845_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-005",
		"PU-Name": "ILE ALA",
		Accredited_Voters: 195,
		Registered_Voters: 643,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76377/result_70744_1677853712_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-006",
		"PU-Name": "ADODO",
		Accredited_Voters: 235,
		Registered_Voters: 831,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76378/result_70745_1677772114_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-007",
		"PU-Name": "ODE EDE",
		Accredited_Voters: 187,
		Registered_Voters: 723,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76379/result_70746_1677772271_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-001",
		"PU-Name": "ERI EGUN",
		Accredited_Voters: 17,
		Registered_Voters: 432,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77077/77077-1677767535.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-002",
		"PU-Name": "OPEN SPACE AFIN",
		Accredited_Voters: 113,
		Registered_Voters: 420,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77078/77078-1677767926.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-003",
		"PU-Name": "IDERA ROAD",
		Accredited_Voters: 126,
		Registered_Voters: 547,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77079/77079-1677768681.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-004",
		"PU-Name": "OKE ILEGUN",
		Accredited_Voters: 132,
		Registered_Voters: 599,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77080/77080-1677768861.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-005",
		"PU-Name": "ILE TARA",
		Accredited_Voters: 156,
		Registered_Voters: 473,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77081/77081-1677769017.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-006",
		"PU-Name": "ODO-OWA",
		Accredited_Voters: 140,
		Registered_Voters: 517,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77082/77082-1677769175.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-007",
		"PU-Name": "ILE-AGBEDU",
		Accredited_Voters: 128,
		Registered_Voters: 449,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77083/77083-1677769311.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-008",
		"PU-Name": "OKE-OKIN",
		Accredited_Voters: 106,
		Registered_Voters: 450,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77084/77084-1677769448.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "EKAN",
		"PU-Code": "23-14-02-009",
		"PU-Name": "AJURE",
		Accredited_Voters: 139,
		Registered_Voters: 537,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23254/pu/77085/77085-1677769665.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMOJI/ILALE/ERINMOPE",
		"PU-Code": "23-14-03-001",
		"PU-Name": "COMM L.G.E.A SCH IMOJI",
		Accredited_Voters: 235,
		Registered_Voters: 912,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76389/result_70757_1677687288_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMOJI/ILALE/ERINMOPE",
		"PU-Code": "23-14-03-002",
		"PU-Name": "COMM L.G.E.A SCH ILALE",
		Accredited_Voters: 161,
		Registered_Voters: 715,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76390/result_70758_1677687057_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMOJI/ILALE/ERINMOPE",
		"PU-Code": "23-14-03-004",
		"PU-Name": "ODO OYE ILALE",
		Accredited_Voters: 157,
		Registered_Voters: 687,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76392/result_70760_1677686828_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-002",
		"PU-Name": "OLD MARKET",
		Accredited_Voters: 174,
		Registered_Voters: 760,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76394/result_70763_1677754641_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-003",
		"PU-Name": "IREPE COMPOUND",
		Accredited_Voters: 188,
		Registered_Voters: 758,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76395/result_70764_1677754875_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-004",
		"PU-Name": "OKE IPO I",
		Accredited_Voters: 157,
		Registered_Voters: 606,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76396/result_70765_1677738436_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-005",
		"PU-Name": "OKE IPO II",
		Accredited_Voters: 130,
		Registered_Voters: 551,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76397/result_70766_1677754998_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-006",
		"PU-Name": "ST JOHN C.A.C SCH I",
		Accredited_Voters: 137,
		Registered_Voters: 618,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76398/result_70767_1677755225_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-007",
		"PU-Name": "ST JOHN C.A.C SCH II",
		Accredited_Voters: 96,
		Registered_Voters: 429,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76399/result_70768_1677755530_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-001",
		"PU-Name": "EGOSI TOWN HALL",
		Accredited_Voters: 118,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76400/result_70772_1677704852_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-002",
		"PU-Name": "IDI-EKITI",
		Accredited_Voters: 211,
		Registered_Voters: 896,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76401/result_70773_1677705046_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-003",
		"PU-Name": "OKE-OWA/OKO-ORU",
		Accredited_Voters: 169,
		Registered_Voters: 1036,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76402/result_70774_1677705315_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-004",
		"PU-Name": "OKE-ARO COMPOUND",
		Accredited_Voters: 201,
		Registered_Voters: 818,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76403/result_70775_1677705511_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-005",
		"PU-Name": "BOLORUNDURO",
		Accredited_Voters: 123,
		Registered_Voters: 580,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76404/result_70776_1677705673_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 1",
		"PU-Code": "23-14-06-001",
		"PU-Name": "ADULT L.G.E.A SCH",
		Accredited_Voters: 98,
		Registered_Voters: 502,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76405/result_70781_1677747423_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 1",
		"PU-Code": "23-14-06-002",
		"PU-Name": "COURT PREMISES",
		Accredited_Voters: 109,
		Registered_Voters: 500,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76406/result_70782_1677747792_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 1",
		"PU-Code": "23-14-06-004",
		"PU-Name": "ST PAUL L.G.E.A SCH",
		Accredited_Voters: 167,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76408/result_70784_1677748093_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 1",
		"PU-Code": "23-14-06-005",
		"PU-Name": "ODOLOKE COMPOUND",
		Accredited_Voters: 120,
		Registered_Voters: 485,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76409/result_70785_1677748203_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 1",
		"PU-Code": "23-14-06-006",
		"PU-Name": "ODO-AGBEDE COMPOUND",
		Accredited_Voters: 159,
		Registered_Voters: 627,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76410/result_70786_1677748298_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 11",
		"PU-Code": "23-14-07-001",
		"PU-Name": "MOTOR PARK",
		Accredited_Voters: 135,
		Registered_Voters: 604,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76411/result_70787_1677681434_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 11",
		"PU-Code": "23-14-07-002",
		"PU-Name": "AREA OFFICE",
		Accredited_Voters: 130,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76412/result_70788_1677681706_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 11",
		"PU-Code": "23-14-07-003",
		"PU-Name": "ODO-OSE COMPOUND",
		Accredited_Voters: 68,
		Registered_Voters: 419,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76413/result_70789_1677681880_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 11",
		"PU-Code": "23-14-07-004",
		"PU-Name": "KOBA",
		Accredited_Voters: 226,
		Registered_Voters: 790,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76414/result_70790_1677682035_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN IGBANA 11",
		"PU-Code": "23-14-07-005",
		"PU-Name": "KADE",
		Accredited_Voters: 73,
		Registered_Voters: 449,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76415/result_70791_1677682160_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-001",
		"PU-Name": "L.G.E.A SCH AYEKALE",
		Accredited_Voters: 206,
		Registered_Voters: 631,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76416/result_70792_1677748516_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-002",
		"PU-Name": "MARKET CENTRE EHINAFO",
		Accredited_Voters: 164,
		Registered_Voters: 676,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76417/result_70793_1677748700_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-003",
		"PU-Name": "COMM L.G.E.A SCH EHINAFO",
		Accredited_Voters: 159,
		Registered_Voters: 598,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76418/result_70794_1677748843_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-004",
		"PU-Name": "ILE OLUKOSE AYEKALE",
		Accredited_Voters: 159,
		Registered_Voters: 544,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76419/result_70795_1677748962_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-005",
		"PU-Name": "ILE ALAYE ODO AGA",
		Accredited_Voters: 115,
		Registered_Voters: 483,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76420/result_70796_1677749091_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IDOFIN /ODO-ASHE",
		"PU-Code": "23-14-08-008",
		"PU-Name": "POLICE STATION",
		Accredited_Voters: 152,
		Registered_Voters: 588,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76423/result_70799_1677749638_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-001",
		"PU-Name": "AFIN COMPOUND",
		Accredited_Voters: 192,
		Registered_Voters: 880,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76424/result_70800_1677859357_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-002",
		"PU-Name": "ARINRIN COMPOUND",
		Accredited_Voters: 190,
		Registered_Voters: 740,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76425/result_70801_1677859457_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-003",
		"PU-Name": "IKOTUN COMPOUND",
		Accredited_Voters: 171,
		Registered_Voters: 780,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76426/result_70802_1677859575_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-004",
		"PU-Name": "C.A.C L.G.E.A SCH",
		Accredited_Voters: 197,
		Registered_Voters: 708,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76427/result_70803_1677859666_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-006",
		"PU-Name": "ST THOMAS PRY SCH",
		Accredited_Voters: 123,
		Registered_Voters: 462,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76429/result_70805_1677847133_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-007",
		"PU-Name": "IGBEDE COMPOUND",
		Accredited_Voters: 234,
		Registered_Voters: 807,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76430/result_70806_1677846735_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-001",
		"PU-Name": "IPEKUN COMPOUND",
		Accredited_Voters: 233,
		Registered_Voters: 851,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76431/result_70809_1677713141_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-002",
		"PU-Name": "IGBINLO  COMPOUND",
		Accredited_Voters: 184,
		Registered_Voters: 774,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76432/result_70810_1677713554_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-003",
		"PU-Name": "IGBIRA  COMPOUND",
		Accredited_Voters: 122,
		Registered_Voters: 596,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76433/result_70811_1677714214_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-004",
		"PU-Name": "ST JOSEPH PRY SCH",
		Accredited_Voters: 157,
		Registered_Voters: 699,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76434/result_70812_1677714343_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-005",
		"PU-Name": "TEMIDIRE (YASOLA)",
		Accredited_Voters: 214,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76435/result_70813_1677714467_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-001",
		"PU-Name": "BAPTIST LGEA SCH, ERIN-ILE",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/001/001-1677398306.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-002",
		"PU-Name": "ERIN-ILE GARAGE",
		Accredited_Voters: 195,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/002/002-1677396615.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-003",
		"PU-Name": "OPPOSITE POLICE STATION, ERIN-ILE",
		Accredited_Voters: 266,
		Registered_Voters: 964,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/003/003-1677396354.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-004",
		"PU-Name": "MAGISTRATE COURT, ERIN-ILE",
		Accredited_Voters: 224,
		Registered_Voters: 947,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/004/004-1677395945.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-005",
		"PU-Name": "MUSLIM SCH, ERIN-ILE",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/005/005-1677395389.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-006",
		"PU-Name": "AGO  IWOYE",
		Accredited_Voters: 217,
		Registered_Voters: 706,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/006/006-1677397704.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-001",
		"PU-Name": "LGEA SCH, ILEMONA",
		Accredited_Voters: 200,
		Registered_Voters: 1123,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/001/001-1677391724.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-002",
		"PU-Name": "LGEA SCH, ADINIMODO",
		Accredited_Voters: 224,
		Registered_Voters: 859,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/002/002-1677399832.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-003",
		"PU-Name": "ISAOYE",
		Accredited_Voters: 28,
		Registered_Voters: 273,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/003/003-1677393951.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-004",
		"PU-Name": "LGEA SCH REKE",
		Accredited_Voters: 51,
		Registered_Voters: 132,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/004/004-1677394896.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-005",
		"PU-Name": "AJOKO",
		Accredited_Voters: 233,
		Registered_Voters: 559,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/005/005-1677395163.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-006",
		"PU-Name": "COURT AREA, ILEMONA",
		Accredited_Voters: 112,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/006/006-1677395862.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-001",
		"PU-Name": "TOWN HAL, IGBONA",
		Accredited_Voters: 210,
		Registered_Voters: 855,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/001/001-1677392597.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-002",
		"PU-Name": "LGEA SCH, IGBONA",
		Accredited_Voters: 183,
		Registered_Voters: 655,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/002/002-1677393154.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-003",
		"PU-Name": "ELEKU",
		Accredited_Voters: 178,
		Registered_Voters: 729,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/003/003-1677389356.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-004",
		"PU-Name": "KERE-AJE LGEA SCH",
		Accredited_Voters: 165,
		Registered_Voters: 482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/004/004-1677394499.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-005",
		"PU-Name": "BOLORUNDURO LGEA SCH",
		Accredited_Voters: 163,
		Registered_Voters: 585,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/005/005-1677423953.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-006",
		"PU-Name": "AGBARA LGEA SCH",
		Accredited_Voters: 192,
		Registered_Voters: 462,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/006/006-1677391688.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-001",
		"PU-Name": "ST PETER'S LGEA SCH , IRRA",
		Accredited_Voters: 183,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/77152/77152-1677593115.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-002",
		"PU-Name": "INFRONT OF OJOMU'S COMPOUND, IRRA",
		Accredited_Voters: 157,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/77153/77153-1677593241.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-003",
		"PU-Name": "IRRA GRAMMAR SCH, IRRA",
		Accredited_Voters: 162,
		Registered_Voters: 827,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/77154/77154-1677593356.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-004",
		"PU-Name": "INFRONT OF ARO'S COMPOUND, IRRA",
		Accredited_Voters: 214,
		Registered_Voters: 850,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/77155/77155-1677593524.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-005",
		"PU-Name": "MUSLIM LGEA SCH, IRRA",
		Accredited_Voters: 93,
		Registered_Voters: 487,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/77156/77156-1677601148.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-001",
		"PU-Name": "LGEA SCH , INAJA MALIKI",
		Accredited_Voters: 189,
		Registered_Voters: 539,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/001/001-1677424333.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-002",
		"PU-Name": "LGEA SCH , INAJA ALARO",
		Accredited_Voters: 330,
		Registered_Voters: 837,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/002/002-1677422437.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-003",
		"PU-Name": "ILOBU - KAJOLA",
		Accredited_Voters: 104,
		Registered_Voters: 284,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/003/003-1677421197.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-004",
		"PU-Name": "LGEA SCH, AHOGBADA",
		Accredited_Voters: 120,
		Registered_Voters: 399,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/004/004-1677402359.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-005",
		"PU-Name": "LGEA SCH, SANNI ODE",
		Accredited_Voters: 213,
		Registered_Voters: 554,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/005/005-1677404096.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "INAJA/AHOGBADA",
		"PU-Code": "23-15-05-006",
		"PU-Name": "LGEA SCH, AFIJAGBA",
		Accredited_Voters: 131,
		Registered_Voters: 398,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/05/pu/006/006-1677399117.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-001",
		"PU-Name": "IKOTUN COURT FRONTAGE",
		Accredited_Voters: 188,
		Registered_Voters: 675,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/001/001-1677392696.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-002",
		"PU-Name": "ANSARUL-ISLAM LGEA SCH, IKOTUN",
		Accredited_Voters: 215,
		Registered_Voters: 807,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23268/pu/77164/77164-1677527875.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-003",
		"PU-Name": "LGEA SCH FALOKUN/FADE",
		Accredited_Voters: 159,
		Registered_Voters: 483,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/003/003-1677392587.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-004",
		"PU-Name": "GUDUGBA/OKE-OYE",
		Accredited_Voters: 187,
		Registered_Voters: 479,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/004/004-1677392140.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-006",
		"PU-Name": "AGBAMU",
		Accredited_Voters: 111,
		Registered_Voters: 378,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/006/006-1677391853.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-007",
		"PU-Name": "ANSARUL-ISLAM LGEA SCH, IKOTUN",
		Accredited_Voters: 170,
		Registered_Voters: 809,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/007/007-1677391027.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: 17,
		"PU-Code": "23-15-07-001",
		"PU-Name": "MUSLIM LGEA SCH, OJOKU",
		Accredited_Voters: 137,
		Registered_Voters: 695,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 62,
		Lp: "",
		PDP: 46,
		SDP: 2,
		NNPP: 18,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/07/pu/001/001-1677427021.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-003",
		"PU-Name": "INFRONT OF GBOYE'S COMP, OJOKU",
		Accredited_Voters: 89,
		Registered_Voters: 704,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 47,
		Lp: 1,
		PDP: 30,
		SDP: "",
		NNPP: 8,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/77172/77172-1677476334.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-004",
		"PU-Name": "OPPOSITE COUNCIL HALL, OJOKU",
		Accredited_Voters: 154,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 59,
		Lp: 1,
		PDP: 52,
		SDP: 5,
		NNPP: 33,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/77173/77173-1677476640.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-005",
		"PU-Name": "WESLEY LGEA SCH, OJOKU",
		Accredited_Voters: 105,
		Registered_Voters: 675,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 46,
		Lp: "",
		PDP: 43,
		SDP: 1,
		NNPP: 2,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/77174/77174-1677477271.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-006",
		"PU-Name": "LGEA SCH, AWONIYI",
		Accredited_Voters: 124,
		Registered_Voters: 681,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 54,
		Lp: "",
		PDP: 33,
		SDP: 5,
		NNPP: 2,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/77175/77175-1677477614.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-007",
		"PU-Name": "MUSLIM SCH, ISALE IDERA",
		Accredited_Voters: 181,
		Registered_Voters: 964,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 98,
		Lp: "",
		PDP: 48,
		SDP: 7,
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/77176/77176-1677477892.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-001",
		"PU-Name": "BAPTIST LGEA SCH, IJAGBO I",
		Accredited_Voters: 190,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 64,
		Lp: 1,
		PDP: 59,
		SDP: 3,
		NNPP: 6,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/001/001-1677395161.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-002",
		"PU-Name": "BAPTIST LGEA SCH, IJAGBO II",
		Accredited_Voters: 169,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 54,
		Lp: "",
		PDP: 53,
		SDP: 3,
		NNPP: 6,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/002/002-1677394164.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-003",
		"PU-Name": "POST OFFICE, IJAGBO",
		Accredited_Voters: 207,
		Registered_Voters: 869,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 89,
		Lp: 2,
		PDP: 65,
		SDP: 2,
		NNPP: 1,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/003/003-1677393408.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-004",
		"PU-Name": "A.U.D LGEA SCH, IJAGBO",
		Accredited_Voters: 200,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 76,
		Lp: 6,
		PDP: 61,
		SDP: 5,
		NNPP: 10,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/004/004-1677393000.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-005",
		"PU-Name": "INFRONT OF ONILU'S COMP, IGOSUN",
		Accredited_Voters: 140,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 58,
		Lp: 2,
		PDP: 52,
		SDP: 1,
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/005/005-1677392615.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGOSUN",
		"PU-Code": "23-15-09-001",
		"PU-Name": "INFRONT OF ONILU'S COMP, IGOSUN",
		Accredited_Voters: 318,
		Registered_Voters: 896,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/09/pu/001/001-1677393059.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGOSUN",
		"PU-Code": "23-15-09-002",
		"PU-Name": "OLD MARKET IGOSUN",
		Accredited_Voters: 259,
		Registered_Voters: 926,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 88,
		Lp: 4,
		PDP: 57,
		SDP: 90,
		NNPP: 2,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/09/pu/002/002-1677394706.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGOSUN",
		"PU-Code": "23-15-09-003",
		"PU-Name": "BESIDE NEPA OFFICE, IGOSUN",
		Accredited_Voters: 222,
		Registered_Voters: 703,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/09/pu/003/003-1677399528.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGOSUN",
		"PU-Code": "23-15-09-004",
		"PU-Name": "MUSLIM LGEA SCH, IGOSUN",
		Accredited_Voters: 275,
		Registered_Voters: 902,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/09/pu/004/004-1677396842.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGOSUN",
		"PU-Code": "23-15-09-005",
		"PU-Name": "AGO IDERA",
		Accredited_Voters: 196,
		Registered_Voters: 619,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/09/pu/005/005-1677401568.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-001",
		"PU-Name": "MUSLIM LGEA SCH, IPEE",
		Accredited_Voters: 193,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 82,
		Lp: "",
		PDP: 103,
		SDP: 2,
		NNPP: 5,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/001/001-1677397554.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-002",
		"PU-Name": "BAPTIST LGEA SCH, IPEE",
		Accredited_Voters: 230,
		Registered_Voters: 790,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 79,
		Lp: "",
		PDP: 121,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/002/002-1677396830.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-003",
		"PU-Name": "central mosque,epe",
		Accredited_Voters: 261,
		Registered_Voters: 1000,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 115,
		Lp: 1,
		PDP: 132,
		SDP: 2,
		NNPP: 4,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/003/003-1677396221.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-004",
		"PU-Name": "BUDO AIYEKALE",
		Accredited_Voters: 155,
		Registered_Voters: 390,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 68,
		Lp: "",
		PDP: 70,
		SDP: "",
		NNPP: 1,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/004/004-1677396991.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-005",
		"PU-Name": "LGEA SCH, AJOKO",
		Accredited_Voters: 98,
		Registered_Voters: 264,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 75,
		Lp: "",
		PDP: 17,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/005/005-1677394801.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-006",
		"PU-Name": "BUDO-ALFA",
		Accredited_Voters: 189,
		Registered_Voters: 891,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/006/006-1677393161.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-007",
		"PU-Name": "IBGS JUNCTION, ORIWO",
		Accredited_Voters: 125,
		Registered_Voters: 728,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 42,
		Lp: 1,
		PDP: 64,
		SDP: "",
		NNPP: 3,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/007/007-1677394600.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-001",
		"PU-Name": "OPEN SPACE OLOWE",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/11/pu/001/001-1677428663.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-002",
		"PU-Name": "ST MATHIAS LGEA SCH, ERIN-ILE I",
		Accredited_Voters: 266,
		Registered_Voters: 1027,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77196/77196-1677457928.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-003",
		"PU-Name": "ST MATHIAS LGEA SCH, ERIN-ILE II",
		Accredited_Voters: 254,
		Registered_Voters: 985,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77197/77197-1677458182.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-004",
		"PU-Name": "EBENEZER LGEA SCH, ERIN-ILE",
		Accredited_Voters: 203,
		Registered_Voters: 714,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77198/77198-1677458390.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-005",
		"PU-Name": "INFRONT OF OLOBA'S COMP, ERIN-ILE",
		Accredited_Voters: 231,
		Registered_Voters: 739,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77199/77199-1677458784.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-006",
		"PU-Name": "INFRONT OF OKIKI'S COMP, ERIN-ILE",
		Accredited_Voters: 217,
		Registered_Voters: 853,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77200/77200-1677458997.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-007",
		"PU-Name": "SURAJUDEEN LGEA SCH, ERIN-ILE",
		Accredited_Voters: 238,
		Registered_Voters: 930,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/77201/77201-1677491749.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-001",
		"PU-Name": "BASIC HEALTH CENTRE",
		Accredited_Voters: 261,
		Registered_Voters: 949,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/001/001-1677374738.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-002",
		"PU-Name": "CENTRAL OFFICE",
		Accredited_Voters: 186,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/002/002-1677379270.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-003",
		"PU-Name": "CENTRAL SCHOOL",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/003/003-1677379709.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-004",
		"PU-Name": "REST HOUSE",
		Accredited_Voters: 164,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/004/004-1677387429.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-005",
		"PU-Name": "S.I.M  SCHOOL",
		Accredited_Voters: 283,
		Registered_Voters: 893,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/005/005-1677397024.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-001",
		"PU-Name": "EFUNGUNZHI OPEN SPACE",
		Accredited_Voters: 257,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/77207/77207-1677461563.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-002",
		"PU-Name": "GBOKE LGEA SCH I",
		Accredited_Voters: 273,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/77208/77208-1677459600.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-003",
		"PU-Name": "GBOKE LGEA SCH II",
		Accredited_Voters: 222,
		Registered_Voters: 764,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/77209/77209-1677462233.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 111",
		"PU-Code": "23-16-03-001",
		"PU-Name": "DISPENSARY CENTRE",
		Accredited_Voters: 209,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76513/result_70941_1677527101_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 111",
		"PU-Code": "23-16-03-004",
		"PU-Name": "MAMANNAWO'S GATE",
		Accredited_Voters: 238,
		Registered_Voters: 891,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23276/pu/77213/77213-1677455064.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-001",
		"PU-Name": "EDOGI LGEA SCH",
		Accredited_Voters: 247,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76517/result_70949_1677811817_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-002",
		"PU-Name": "ELLA LGEA SCH",
		Accredited_Voters: 293,
		Registered_Voters: 751,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76518/result_70950_1677799284_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-003",
		"PU-Name": "GBADOKIN LGEA SCH",
		Accredited_Voters: 115,
		Registered_Voters: 690,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76519/result_70951_1677812544_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-004",
		"PU-Name": "GBARADOGI LGEA SCH",
		Accredited_Voters: 338,
		Registered_Voters: 793,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76520/result_70952_1677811519_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-005",
		"PU-Name": "GODIWAGI LGEA SCH",
		Accredited_Voters: 241,
		Registered_Voters: 1262,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76521/result_70953_1677812399_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-006",
		"PU-Name": "MAWOGI OPEN SPACE",
		Accredited_Voters: 195,
		Registered_Voters: 601,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76522/result_70954_1677812259_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-007",
		"PU-Name": "TSWATAGI LGEA SCH",
		Accredited_Voters: 125,
		Registered_Voters: 478,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76523/result_70955_1677811641_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-001",
		"PU-Name": "BASIC HEALTH CENTRE",
		Accredited_Voters: 246,
		Registered_Voters: 727,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76524/result_70959_1677798418_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-002",
		"PU-Name": "DURO LGEA SCH",
		Accredited_Voters: 150,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76525/result_70960_1677793723_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-003",
		"PU-Name": "EMIWOROGI LGEA SCH",
		Accredited_Voters: 277,
		Registered_Voters: 852,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76526/result_70961_1677794055_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-006",
		"PU-Name": "KAJITA LGEA SCH",
		Accredited_Voters: 118,
		Registered_Voters: 389,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76529/result_70964_1677795005_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-007",
		"PU-Name": "KPADA MARKET SQUARE",
		Accredited_Voters: 271,
		Registered_Voters: 971,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76530/result_70965_1677795350_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-008",
		"PU-Name": "KPADA  S.I.M SCH",
		Accredited_Voters: 206,
		Registered_Voters: 564,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76531/result_70966_1677795702_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-010",
		"PU-Name": "WAKO LGEA SCH",
		Accredited_Voters: 130,
		Registered_Voters: 439,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76533/result_70968_1677796272_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 11",
		"PU-Code": "23-16-06-001",
		"PU-Name": "ECHIWADA LGEA SCH",
		Accredited_Voters: 207,
		Registered_Voters: 597,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23279/pu/77231/77231-1677605797.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 11",
		"PU-Code": "23-16-06-004",
		"PU-Name": "FEY LGEA SCH",
		Accredited_Voters: 223,
		Registered_Voters: 828,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23279/pu/77234/77234-1677601015.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 111",
		"PU-Code": "23-16-07-001",
		"PU-Name": "AGBORO LGEA SCH",
		Accredited_Voters: 110,
		Registered_Voters: 700,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/07/pu/001/001-1677371907.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 111",
		"PU-Code": "23-16-07-004",
		"PU-Name": "MATOKUN LGEA SCH",
		Accredited_Voters: 187,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/07/pu/004/004-1677375920.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-001",
		"PU-Name": "BONGI LGEA SCH",
		Accredited_Voters: 168,
		Registered_Voters: 834,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23281/pu/77243/77243-1677518742.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-002",
		"PU-Name": "CHITTA LGEA SCH",
		Accredited_Voters: 200,
		Registered_Voters: 688,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/08/pu/002/002-1677389073.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-003",
		"PU-Name": "GBADASHABA LGEA SCH",
		Accredited_Voters: 197,
		Registered_Voters: 1200,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23281/pu/77245/77245-1677519597.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-004",
		"PU-Name": "MAGYA LGEA SCH",
		Accredited_Voters: 113,
		Registered_Voters: 608,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23281/pu/77246/77246-1677520757.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-005",
		"PU-Name": "SUNKUSO LGEA SCH",
		Accredited_Voters: 315,
		Registered_Voters: 890,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23281/pu/77247/77247-1677524072.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-006",
		"PU-Name": "SANCHITA OPEN SPACE",
		Accredited_Voters: 281,
		Registered_Voters: 846,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/08/pu/006/006-1677393606.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-002",
		"PU-Name": "DINA LGEA SCH",
		Accredited_Voters: 228,
		Registered_Voters: 896,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76553/result_71004_1677869812_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-003",
		"PU-Name": "DISTRICT OFFICE LADE",
		Accredited_Voters: 200,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76554/result_71005_1677783624_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-004",
		"PU-Name": "RANI-NDAKO LGEA SCH",
		Accredited_Voters: 264,
		Registered_Voters: 873,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76555/result_71006_1677575473_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-005",
		"PU-Name": "TSUBA LGEA SCH",
		Accredited_Voters: 269,
		Registered_Voters: 966,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76556/result_71007_1677783080_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-006",
		"PU-Name": "COTTAGE HOSPITAL",
		Accredited_Voters: 227,
		Registered_Voters: 867,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76557/result_71008_1677781769_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-001",
		"PU-Name": "EDOGI-CHAPPA LGEA SCH",
		Accredited_Voters: 340,
		Registered_Voters: 930,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76558/result_71016_1677488031_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-002",
		"PU-Name": "DZAKO LGEA SCH",
		Accredited_Voters: 288,
		Registered_Voters: 713,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76559/result_71017_1677488920_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-003",
		"PU-Name": "LALAGI LGEA SCH",
		Accredited_Voters: 450,
		Registered_Voters: 959,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76560/result_71018_1677491465_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-004",
		"PU-Name": "LATA LGEA SCH",
		Accredited_Voters: 224,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76561/result_71019_1677491785_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-005",
		"PU-Name": "SAKPEFU LGEA SCH",
		Accredited_Voters: 300,
		Registered_Voters: 1200,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76562/result_71020_1677492097_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-006",
		"PU-Name": "WODATA LGEA SCH",
		Accredited_Voters: 325,
		Registered_Voters: 934,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/76563/result_71021_1677494257_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-007",
		"PU-Name": "ABOTO LGEA SCH III",
		Accredited_Voters: 56,
		Registered_Voters: 128,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23107/pu/155387/155387-1677601286.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-008",
		"PU-Name": "ABOTO LGEA SCH IV",
		Accredited_Voters: 56,
		Registered_Voters: 129,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/17/pu/008/008-1677396199.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ODO-ODE/ABOTO",
		"PU-Code": "23-01-17-009",
		"PU-Name": "ODO-ODE LGEA SCH II",
		Accredited_Voters: 44,
		Registered_Voters: 89,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23107/pu/155389/155389-1677601688.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-008",
		"PU-Name": "BUDO TUNTUN LGEA SCHOOL",
		Accredited_Voters: 220,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/008/008-1677392462.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ELEBUE/AGBONA/FATA",
		"PU-Code": "23-01-03-009",
		"PU-Name": "AGBOOLU LGEA SCHOOL",
		Accredited_Voters: 154,
		Registered_Voters: 227,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/03/pu/009/009-1677387339.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-005",
		"PU-Name": "IDI-NAARI ERE",
		Accredited_Voters: 143,
		Registered_Voters: 516,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/005/005-1677408709.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-006",
		"PU-Name": "OGBONDOROKO LGEA SCH II",
		Accredited_Voters: 240,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/006/006-1677410118.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-007",
		"PU-Name": "ILE-ILA JUNCTION OGBONDOROKO OPPOSITE OLAM",
		Accredited_Voters: 229,
		Registered_Voters: 401,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/007/007-1677411706.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGBONDOROKO/REKE",
		"PU-Code": "23-01-10-008",
		"PU-Name": "ORI-ERU LGEA SCH",
		Accredited_Voters: 162,
		Registered_Voters: 317,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/10/pu/008/008-1677406729.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-005",
		"PU-Name": "APATA LGEA SCH APATA",
		Accredited_Voters: 237,
		Registered_Voters: 575,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23104/pu/155376/155376-1677774935.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-006",
		"PU-Name": "OGELE SEC. SCH.",
		Accredited_Voters: 255,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23104/pu/155377/155377-1677775056.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-007",
		"PU-Name": "HEALTH CENTRE EXTENSION OGELE",
		Accredited_Voters: 211,
		Registered_Voters: 745,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/14/pu/007/007-1677419625.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-008",
		"PU-Name": "OGELE ANSARUL ISLAM LGEA SCH.",
		Accredited_Voters: 236,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23104/pu/155379/155379-1677775452.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-009",
		"PU-Name": "PAMPO LGEA SCH II",
		Accredited_Voters: 90,
		Registered_Voters: 157,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/14/pu/009/009-1677399794.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OGELE",
		"PU-Code": "23-01-14-011",
		"PU-Name": "ALADERE - ODE LGEA SCH",
		Accredited_Voters: 43,
		Registered_Voters: 56,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23104/pu/155382/155382-1677599860.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-008",
		"PU-Name": "OJUDE COURT ALAPA",
		Accredited_Voters: 364,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/008/008-1677395394.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-009",
		"PU-Name": "ODEGIWA LGEA SCH",
		Accredited_Voters: 186,
		Registered_Voters: 691,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/009/009-1677386206.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-010",
		"PU-Name": "ONIPAKO LGEA SCH",
		Accredited_Voters: 86,
		Registered_Voters: 111,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/010/010-1677402368.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ONIRE/ODEGIWA/ALAPA",
		"PU-Code": "23-01-04-011",
		"PU-Name": "LGEA SCHOOL LAMBA",
		Accredited_Voters: 185,
		Registered_Voters: 231,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/04/pu/011/011-1677391029.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE 11/OKEWERU",
		"PU-Code": "23-01-05-006",
		"PU-Name": "OGUNLOMA/GAA GBURUKU COMMUNITY HALL",
		Accredited_Voters: 237,
		Registered_Voters: 385,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/05/pu/006/006-1677380806.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AFON",
		"PU-Code": "23-01-12-007",
		"PU-Name": "REDE/AFON OPPOSITE POLICE STATION",
		Accredited_Voters: 52,
		Registered_Voters: 99,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/12/pu/007/007-1677378142.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AFON",
		"PU-Code": "23-01-12-008",
		"PU-Name": "AFON AREA COURT ASA LGEA SHOPPING COMPLEX",
		Accredited_Voters: 150,
		Registered_Voters: 407,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/12/pu/008/008-1677379308.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AFON",
		"PU-Code": "23-01-12-009",
		"PU-Name": "APA - ONIMALU LGEA SCH",
		Accredited_Voters: 185,
		Registered_Voters: 245,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/12/pu/009/009-1677379879.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-009",
		"PU-Name": "LADUBA LGEA SCH II",
		Accredited_Voters: 104,
		Registered_Voters: 186,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/009/009-1677400626.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-010",
		"PU-Name": "SAPATI-ILE LGEA SCH II",
		Accredited_Voters: 188,
		Registered_Voters: 483,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/010/010-1677398992.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-011",
		"PU-Name": "SAPATI COMMUNITY SEC SCHOOL",
		Accredited_Voters: 182,
		Registered_Voters: 502,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/11/pu/011/011-1677392126.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "AGO-OJA/OSHIN/SAPATI/LADUBA",
		"PU-Code": "23-01-11-012",
		"PU-Name": "BUDO AGUN LGEA SCHOOL",
		Accredited_Voters: 42,
		Registered_Voters: 70,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23101/pu/155368/155368-1677766990.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-012",
		"PU-Name": "OTTE LGEA SCHOOL II",
		Accredited_Voters: 152,
		Registered_Voters: 382,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/012/012-1677395031.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-013",
		"PU-Name": "BALLAH LGEA SCH II",
		Accredited_Voters: 115,
		Registered_Voters: 160,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/013/013-1677390339.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-015",
		"PU-Name": "EYENKORIN LGEA SCH II",
		Accredited_Voters: 286,
		Registered_Voters: 618,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/015/015-1677389449.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-016",
		"PU-Name": "KAM-ABIOYE HOUSING POWER-LINE EYENKORIN",
		Accredited_Voters: 264,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/016/016-1677378758.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-018",
		"PU-Name": "HEALTH CENTRE AKOPARI",
		Accredited_Voters: 183,
		Registered_Voters: 318,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23099/pu/155359/155359-1677494575.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-019",
		"PU-Name": "LASOJU LGEA SCH",
		Accredited_Voters: 207,
		Registered_Voters: 437,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/019/019-1677379407.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-008",
		"PU-Name": "COTTAGE HOSPITAL BUDO-EGBA",
		Accredited_Voters: 316,
		Registered_Voters: 727,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/008/008-1677377033.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BUDO-EGBA",
		"PU-Code": "23-01-15-009",
		"PU-Name": "FRONT OF ASA LOCAL GOVERNMENT  SHOPPING COMPLEX BUDO-EGBA",
		Accredited_Voters: 309,
		Registered_Voters: 592,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/15/pu/009/009-1677380279.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "EFUE/BERIKODO",
		"PU-Code": "23-01-07-004",
		"PU-Name": "EFUE LGEA SCH II",
		Accredited_Voters: 262,
		Registered_Voters: 618,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/07/pu/004/004-1677375838.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "GAMBARI/AIYEKALE",
		"PU-Code": "23-01-06-003",
		"PU-Name": "DONGARI LGEA SCH II",
		Accredited_Voters: 83,
		Registered_Voters: 202,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/06/pu/003/003-1677391712.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-010",
		"PU-Name": "AJAGUSI LGEA SCHOOL",
		Accredited_Voters: 187,
		Registered_Voters: 267,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/010/010-1677383091.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-011",
		"PU-Name": "OLOMODA LGEA",
		Accredited_Voters: 98,
		Registered_Voters: 197,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/011/011-1677382226.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "ILA-OJA",
		"PU-Code": "23-01-13-012",
		"PU-Name": "IGBO-ARAN LGEA SCHOOL",
		Accredited_Voters: 155,
		Registered_Voters: 313,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/13/pu/012/012-1677381582.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OKESHO",
		"PU-Code": "23-01-16-003",
		"PU-Name": "OKESO LGEA SCHOOL II",
		Accredited_Voters: 129,
		Registered_Voters: 222,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23106/pu/155385/155385-1677773342.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OKESHO",
		"PU-Code": "23-01-16-004",
		"PU-Name": "AFEYIN LGEA SCH II",
		Accredited_Voters: 37,
		Registered_Voters: 64,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3592/ward/23106/pu/155386/155386-1677773902.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "OWODE/GBOGUN",
		"PU-Code": "23-01-08-006",
		"PU-Name": "AJUWON LGEA SCHOOL II",
		Accredited_Voters: 69,
		Registered_Voters: 127,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/08/pu/006/006-1677381604.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "YOWERE/SOSOKI",
		"PU-Code": "23-01-01-006",
		"PU-Name": "ONIYEYE LGEA SCHOOL",
		Accredited_Voters: 175,
		Registered_Voters: 466,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/01/pu/006/006-1677386862.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-014",
		"PU-Name": "MARKET SQUARE BORIYA",
		Accredited_Voters: 207,
		Registered_Voters: 692,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/014/014-1677406011.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-015",
		"PU-Name": "BENIN GARAGE BORIYA OPEN SPACE",
		Accredited_Voters: 134,
		Registered_Voters: 320,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/015/015-1677423937.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-016",
		"PU-Name": "MANGO SOKII",
		Accredited_Voters: 58,
		Registered_Voters: 99,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/016/016-1677407549.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-017",
		"PU-Name": "BORIYA GARAGE",
		Accredited_Voters: 143,
		Registered_Voters: 515,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/017/017-1677428285.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-018",
		"PU-Name": "ARAFAT OPEN SPACE",
		Accredited_Voters: 164,
		Registered_Voters: 282,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/018/018-1677421858.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-020",
		"PU-Name": "LOKORGOBI OPEN SPACE",
		Accredited_Voters: 49,
		Registered_Voters: 116,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/020/020-1677423001.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-021",
		"PU-Name": "KOROBANI KPALURU",
		Accredited_Voters: 125,
		Registered_Voters: 272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/021/021-1677419980.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-022",
		"PU-Name": "YARU-GADO OPEN SPACE",
		Accredited_Voters: 237,
		Registered_Voters: 619,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/022/022-1677408133.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-023",
		"PU-Name": "SAKISAN SUKURU OPEN SPACE",
		Accredited_Voters: 170,
		Registered_Voters: 404,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/023/023-1677422440.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-024",
		"PU-Name": "KASANE LGEA SCHOOL",
		Accredited_Voters: 219,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/024/024-1677374262.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "BORIYA/SHIYA",
		"PU-Code": "23-02-01-025",
		"PU-Name": "FEREKERU SHIYA OPEN SPACE",
		Accredited_Voters: 149,
		Registered_Voters: 352,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/01/pu/025/025-1677427545.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-017",
		"PU-Name": "MOSHIKPEKU MOORE II",
		Accredited_Voters: 128,
		Registered_Voters: 675,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155402/155402-1677499485.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-018",
		"PU-Name": "MOSHI GBOFA CENT. MARKET",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155403/155403-1677499940.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-019",
		"PU-Name": "BWEREGURU II OPP.MTN MAST",
		Accredited_Voters: 202,
		Registered_Voters: 386,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155404/155404-1677500243.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-020",
		"PU-Name": "DADIN KOWA KURABARU",
		Accredited_Voters: 59,
		Registered_Voters: 455,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155405/155405-1677500510.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-021",
		"PU-Name": "OKADA GARAGE TUKA",
		Accredited_Voters: 157,
		Registered_Voters: 304,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155406/155406-1677500781.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-022",
		"PU-Name": "BLGA DISPENSARY GWANE RD",
		Accredited_Voters: 286,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155407/155407-1677501048.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-023",
		"PU-Name": "CAMP BESIDE POL. STATION",
		Accredited_Voters: 266,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155408/155408-1677501284.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-024",
		"PU-Name": "GURU BOREHOLE GWANE",
		Accredited_Voters: 184,
		Registered_Voters: 604,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155409/155409-1677501492.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-025",
		"PU-Name": "TONNA TANGE LGEA SCH.",
		Accredited_Voters: 65,
		Registered_Voters: 550,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155410/155410-1677501868.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-026",
		"PU-Name": "SERESEKIRI LGEA SCHOOL",
		Accredited_Voters: 82,
		Registered_Voters: 380,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155411/155411-1677502065.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-027",
		"PU-Name": "SABO SARE II",
		Accredited_Voters: 62,
		Registered_Voters: 169,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155412/155412-1677502264.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-028",
		"PU-Name": "TAKISARIRU YANRI OPEN SPACE",
		Accredited_Voters: 247,
		Registered_Voters: 555,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155413/155413-1677502464.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-029",
		"PU-Name": "GRA GURE OPEN SPACE",
		Accredited_Voters: 191,
		Registered_Voters: 697,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155414/155414-1677502798.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-030",
		"PU-Name": "KPAWULU GURE OPEN SPACE",
		Accredited_Voters: 204,
		Registered_Voters: 665,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155415/155415-1677502972.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-031",
		"PU-Name": "OKADA GARAGE YONGUREGI GURE",
		Accredited_Voters: 160,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155416/155416-1677503406.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-032",
		"PU-Name": "ALLAH YA BADA SA'A GURE",
		Accredited_Voters: 192,
		Registered_Voters: 500,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155417/155417-1677503846.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-033",
		"PU-Name": "DAAGURU GURE OPEN SPACE",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155418/155418-1677506753.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-035",
		"PU-Name": "NASARAWA AREA KOSUBOSU",
		Accredited_Voters: 192,
		Registered_Voters: 635,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155420/155420-1677507407.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-036",
		"PU-Name": "KIRUKUNKPARU KOSUBOSU",
		Accredited_Voters: 166,
		Registered_Voters: 578,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155421/155421-1677507913.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GURE/GWASORO",
		"PU-Code": "23-02-02-037",
		"PU-Name": "NURTW GARAGE KOSUBOSU",
		Accredited_Voters: 273,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23109/pu/155422/155422-1677508118.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-016",
		"PU-Name": "DOKONU OPEN SPACE",
		Accredited_Voters: 190,
		Registered_Voters: 301,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/016/016-1677374799.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-017",
		"PU-Name": "OPP. KOKIGBABI PALACE OPEN SPACE",
		Accredited_Voters: 40,
		Registered_Voters: 75,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/017/017-1677370613.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-018",
		"PU-Name": "OPP. KIYAYERU PALACE OPEN SPACE",
		Accredited_Voters: 63,
		Registered_Voters: 154,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/018/018-1677391365.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-019",
		"PU-Name": "WERA OPEN SPACE",
		Accredited_Voters: 132,
		Registered_Voters: 420,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/019/019-1677373300.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "GWANARA",
		"PU-Code": "23-02-04-020",
		"PU-Name": "NEW MARKET OPEN SPACE",
		Accredited_Voters: 228,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/04/pu/020/020-1677376517.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-012",
		"PU-Name": "OJORA PRIMARY SCHOOL",
		Accredited_Voters: 232,
		Registered_Voters: 428,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/012/012-1677363563.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-013",
		"PU-Name": "OGUNKPA AREA",
		Accredited_Voters: 126,
		Registered_Voters: 302,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/013/013-1677377000.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-014",
		"PU-Name": "TUTUNKUGURU AREA",
		Accredited_Voters: 67,
		Registered_Voters: 151,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/014/014-1677362429.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-015",
		"PU-Name": "BUYONFITILA AREA",
		Accredited_Voters: 231,
		Registered_Voters: 738,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/015/015-1677382693.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-016",
		"PU-Name": "BWINKPKI AREA",
		Accredited_Voters: 201,
		Registered_Voters: 685,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/016/016-1677378790.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-017",
		"PU-Name": "NEW YIDI PRAYER GROUND",
		Accredited_Voters: 197,
		Registered_Voters: 641,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/017/017-1677377692.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "ILESHA",
		"PU-Code": "23-02-05-018",
		"PU-Name": "WENRAKOKOU OPEN SPACE",
		Accredited_Voters: 110,
		Registered_Voters: 193,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/05/pu/018/018-1677378415.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-016",
		"PU-Name": "KORO OLD MARKET",
		Accredited_Voters: 38,
		Registered_Voters: 93,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155455/155455-1677473248.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-018",
		"PU-Name": "OLD KIYIRU LGEA SCHOOL",
		Accredited_Voters: 179,
		Registered_Voters: 602,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155457/155457-1677468359.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-019",
		"PU-Name": "TABARU OPEN SPACE",
		Accredited_Voters: 153,
		Registered_Voters: 555,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155458/155458-1677469487.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-020",
		"PU-Name": "BWEN MARKET",
		Accredited_Voters: 194,
		Registered_Voters: 536,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155459/155459-1677467572.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-021",
		"PU-Name": "BUKURO CENTRAL MARKET",
		Accredited_Voters: 204,
		Registered_Voters: 710,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155460/155460-1677474527.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-022",
		"PU-Name": "ZANGO  OPEN SPACE",
		Accredited_Voters: 246,
		Registered_Voters: 897,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155461/155461-1677468944.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KIYORU/BWEN",
		"PU-Code": "23-02-08-023",
		"PU-Name": "DAMERA DISPENSARY",
		Accredited_Voters: 119,
		Registered_Voters: 331,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23115/pu/155462/155462-1677474931.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-012",
		"PU-Name": "YEKORU LGEA SCHOOL",
		Accredited_Voters: 341,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/155450/155450-1677709550.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-013",
		"PU-Name": "YAKIRU NEW MARKET",
		Accredited_Voters: 212,
		Registered_Voters: 552,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/155451/155451-1677709191.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "KPAURA/YAKIRU",
		"PU-Code": "23-02-07-014",
		"PU-Name": "KOROBORI LGEA SCHOOL",
		Accredited_Voters: 230,
		Registered_Voters: 553,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23114/pu/155452/155452-1677708195.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-017",
		"PU-Name": "BOORIPARU BANIKANI",
		Accredited_Voters: 113,
		Registered_Voters: 551,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650750/result_68470_1677753296_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-018",
		"PU-Name": "SIKORONE OPEN SPACE",
		Accredited_Voters: 40,
		Registered_Voters: 108,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650751/result_68471_1677753690_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-019",
		"PU-Name": "GIDAKPANO LGEA SCHOOL",
		Accredited_Voters: 171,
		Registered_Voters: 620,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650752/result_68472_1677753806_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-020",
		"PU-Name": "BANIKANI AREA OPEN SPACE",
		Accredited_Voters: 107,
		Registered_Voters: 225,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650753/result_68473_1677753892_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-021",
		"PU-Name": "KIPARUBARUTEN  LGEA SCH.",
		Accredited_Voters: 26,
		Registered_Voters: 615,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650754/result_68474_1677754256_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-023",
		"PU-Name": "GURUMANKASARU OPEN SPACE",
		Accredited_Voters: 164,
		Registered_Voters: 458,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650756/result_68476_1677754456_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-024",
		"PU-Name": "TAKAREROCK OPEN SPACE",
		Accredited_Voters: 120,
		Registered_Voters: 466,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650757/result_68477_1677754532_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-025",
		"PU-Name": "KENU WORU OPEN SPACE",
		Accredited_Voters: 99,
		Registered_Voters: 366,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650758/result_68478_1677754613_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-026",
		"PU-Name": "SABO OPEN SPACE",
		Accredited_Voters: 127,
		Registered_Voters: 312,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650759/result_68479_1677754964_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-028",
		"PU-Name": "CENTRAL OFFICE OPEN SPACE",
		Accredited_Voters: 154,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650761/result_68481_1677755111_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "OKUTA",
		"PU-Code": "23-02-09-029",
		"PU-Name": "SIYANONKPARU OPEN SPACE",
		Accredited_Voters: 47,
		Registered_Voters: 126,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650762/result_68482_1677755180_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-008",
		"PU-Name": "ZANGO OPEN SPACE",
		Accredited_Voters: 305,
		Registered_Voters: 728,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/008/008-1677368587.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-009",
		"PU-Name": "WONKORU OPEN SPACE",
		Accredited_Voters: 406,
		Registered_Voters: 730,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/009/009-1677373626.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-010",
		"PU-Name": "TUNBUYAN NEW SETTLEMENT",
		Accredited_Voters: 184,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/010/010-1677370748.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "SHINAWU/TUNBUYAN",
		"PU-Code": "23-02-10-012",
		"PU-Name": "AGBANKA OPEN SPACE",
		Accredited_Voters: 218,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/02/ward/10/pu/012/012-1677369660.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-016",
		"PU-Name": "KEY PARISONE LGEA SCH.",
		Accredited_Voters: 54,
		Registered_Voters: 473,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155481/155481-1677758513.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-018",
		"PU-Name": "KUBURUFU OLD MARKET",
		Accredited_Voters: 164,
		Registered_Voters: 464,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155483/155483-1677759425.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-019",
		"PU-Name": "JENNERI LGEA SCHOOL",
		Accredited_Voters: 114,
		Registered_Voters: 595,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155484/155484-1677760306.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-020",
		"PU-Name": "BANI/WEERI OPEN SPACE",
		Accredited_Voters: 173,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155485/155485-1677760871.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-021",
		"PU-Name": "YENSEMME LGEA SCHOOL",
		Accredited_Voters: 17,
		Registered_Voters: 47,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155486/155486-1677761389.pdf",
	},
	{
		State: "KWARA",
		LGA: "BARUTEN",
		Ward: "YASHIKIRA",
		"PU-Code": "23-02-11-022",
		"PU-Name": "KARA MARKET OPEN SPACE",
		Accredited_Voters: 139,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3593/ward/23118/pu/155487/155487-1677763749.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-012",
		"PU-Name": "OPEN SPACE EGBAN KANGA",
		Accredited_Voters: 158,
		Registered_Voters: 448,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155488/155488-1677478523.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-013",
		"PU-Name": "OPEN SPACE EGBAN CHECHE",
		Accredited_Voters: 58,
		Registered_Voters: 91,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155489/155489-1677675251.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-014",
		"PU-Name": "OPEN SPACE EGBAN BANA",
		Accredited_Voters: 118,
		Registered_Voters: 170,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155490/155490-1677675476.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-015",
		"PU-Name": "OPEN SPACE EGBAN NAGUN",
		Accredited_Voters: 203,
		Registered_Voters: 460,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155491/155491-1677479575.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-016",
		"PU-Name": "OPEN SPACE EGBAN NDA DARI",
		Accredited_Voters: 331,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155492/155492-1677481014.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-017",
		"PU-Name": "OPEN SPACE BOKUN BAZUMA",
		Accredited_Voters: 212,
		Registered_Voters: 477,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155493/155493-1677478036.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-018",
		"PU-Name": "OPEN SPACE EGBAN NDABA TAKO",
		Accredited_Voters: 120,
		Registered_Voters: 179,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155494/155494-1677675608.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-019",
		"PU-Name": "OPEN SPACE EGBAN LADAN KAFINTA",
		Accredited_Voters: 186,
		Registered_Voters: 662,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155495/155495-1677476729.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1",
		"PU-Code": "23-03-01-020",
		"PU-Name": "OPEN SPACE EMI LIMAN MOSQUE",
		Accredited_Voters: 52,
		Registered_Voters: 93,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3594/ward/23119/pu/155496/155496-1677675866.pdf",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-012",
		"PU-Name": "OPEN SPACE EMI- ABAGYAMA",
		Accredited_Voters: 134,
		Registered_Voters: 200,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650784/result_68548_1677611032_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-013",
		"PU-Name": "OPEN SPACE EGBAN MAYAKI",
		Accredited_Voters: 146,
		Registered_Voters: 205,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650785/result_68549_1677611113_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-014",
		"PU-Name": "OPEN SPACE EMI -WOROGI",
		Accredited_Voters: 136,
		Registered_Voters: 423,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650786/result_68550_1677611191_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-015",
		"PU-Name": "OPEN SPACE EGBAN RAFI",
		Accredited_Voters: 198,
		Registered_Voters: 483,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650787/result_68551_1677611289_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-016",
		"PU-Name": "OPEN SPACE DZUKOGI",
		Accredited_Voters: 118,
		Registered_Voters: 178,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650788/result_68552_1677611439_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-017",
		"PU-Name": "OPEN SPACE EGBAN GBAZHI",
		Accredited_Voters: 198,
		Registered_Voters: 571,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650789/result_68553_1677611542_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-018",
		"PU-Name": "OPEN SPACE EGBAN GANAZA BAZUMA",
		Accredited_Voters: 218,
		Registered_Voters: 540,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650790/result_68554_1677611650_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-019",
		"PU-Name": "OPEN SPACE EGBAN CHATTA",
		Accredited_Voters: 201,
		Registered_Voters: 465,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650791/result_68555_1677611729_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-020",
		"PU-Name": "L.G.E.A NOMADIC SCH.",
		Accredited_Voters: 157,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650792/result_68556_1677611842_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-021",
		"PU-Name": "OPEN SPACE KUSONINGUBA",
		Accredited_Voters: 253,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650793/result_68557_1677611934_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 11",
		"PU-Code": "23-03-02-022",
		"PU-Name": "OPEN SPACE SAKIWA",
		Accredited_Voters: 196,
		Registered_Voters: 552,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650794/result_68558_1677612004_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-013",
		"PU-Name": "GADA ZAMBUFU",
		Accredited_Voters: 130,
		Registered_Voters: 494,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650795/result_68571_1677572764_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-014",
		"PU-Name": "L.G.E.A SCH. GAMALEGI",
		Accredited_Voters: 355,
		Registered_Voters: 505,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650796/result_68572_1677572982_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-015",
		"PU-Name": "L.G.E.A SCH. MANCHA",
		Accredited_Voters: 356,
		Registered_Voters: 720,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650797/result_68573_1677573054_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-016",
		"PU-Name": "OPEN SPACE EMI-WORO GBUGBU",
		Accredited_Voters: 188,
		Registered_Voters: 623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650798/result_68574_1677573143_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-017",
		"PU-Name": "L.G.E.A .PRY SCH FADA",
		Accredited_Voters: 186,
		Registered_Voters: 213,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650799/result_68575_1677573311_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-018",
		"PU-Name": "L.G.E.A BUSSA",
		Accredited_Voters: 280,
		Registered_Voters: 418,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650800/result_68576_1677573372_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 111",
		"PU-Code": "23-03-03-019",
		"PU-Name": "L.G.E.A SCH LEMA",
		Accredited_Voters: 262,
		Registered_Voters: 702,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650801/result_68577_1677573423_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-014",
		"PU-Name": "OPEN SPACE LIKPATA BESIDE CENTRAL MOSQUE",
		Accredited_Voters: 205,
		Registered_Voters: 257,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650802/result_68591_1677664282_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-015",
		"PU-Name": "L.G.E.A SCH. EFFAGI",
		Accredited_Voters: 206,
		Registered_Voters: 697,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650803/result_68592_1677664623_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-016",
		"PU-Name": "OPEN SPACE  OLD CENTRAL MOSQUE",
		Accredited_Voters: 171,
		Registered_Voters: 370,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650804/result_68593_1677664760_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "LAFIAGI 1V",
		"PU-Code": "23-03-04-017",
		"PU-Name": "L.G.E.A SCH. CHEWURU",
		Accredited_Voters: 86,
		Registered_Voters: 362,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650805/result_68594_1677664833_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-011",
		"PU-Name": "L.G.E.A PRY SCH.ANKORO",
		Accredited_Voters: 162,
		Registered_Voters: 227,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650806/result_68605_1677578003_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-012",
		"PU-Name": "OPEN SPACE KARATI",
		Accredited_Voters: 221,
		Registered_Voters: 327,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650807/result_68606_1677578090_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-013",
		"PU-Name": "L.G.E.A PRY.SCH GBADAGUN",
		Accredited_Voters: 236,
		Registered_Voters: 441,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650808/result_68607_1677578180_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 1",
		"PU-Code": "23-03-05-016",
		"PU-Name": "L.G.E.A PRY SCH. PATIDATI",
		Accredited_Voters: 297,
		Registered_Voters: 512,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650811/result_68610_1677578537_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-013",
		"PU-Name": "L.G.E.A PRY SCH. GULUFU",
		Accredited_Voters: 171,
		Registered_Voters: 277,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650812/result_68623_1677580390_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-014",
		"PU-Name": "OPEN SPACE MOKWAGI KEREMI",
		Accredited_Voters: 222,
		Registered_Voters: 317,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650813/result_68624_1677577870_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-015",
		"PU-Name": "L.G.E.A SCH. CENTRAL SCHOOL BACITA",
		Accredited_Voters: 97,
		Registered_Voters: 138,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650814/result_68625_1677576156_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-016",
		"PU-Name": "L.G.E.A SCH. GONDAN",
		Accredited_Voters: 220,
		Registered_Voters: 261,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650815/result_68626_1677579961_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-019",
		"PU-Name": "OPEN SPACE SHISHITA",
		Accredited_Voters: 30,
		Registered_Voters: 38,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650818/result_68629_1677576502_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 11",
		"PU-Code": "23-03-06-020",
		"PU-Name": "L.G.E.A PRY SCH. ANGLICAN",
		Accredited_Voters: 285,
		Registered_Voters: 449,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650819/result_68630_1677587324.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-014",
		"PU-Name": "OPEN SPACE EMI MANSIDI ABDULLAHI",
		Accredited_Voters: 170,
		Registered_Voters: 210,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650820/result_68644_1677597816_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-015",
		"PU-Name": "L.G.E.A SCH. FEDUNDANGI",
		Accredited_Voters: 390,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650821/result_68645_1677598621_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-016",
		"PU-Name": "L.G.E.A SCH GBADUWA",
		Accredited_Voters: 358,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650822/result_68646_1677580883_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-017",
		"PU-Name": "L.G.E.A.PRY SCH GINDA",
		Accredited_Voters: 435,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650823/result_68647_1677585077_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-018",
		"PU-Name": "L.G.E.A.SCH SOKUNKPAN",
		Accredited_Voters: 290,
		Registered_Voters: 357,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650824/result_68648_1677581541_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-019",
		"PU-Name": "OPEN SPACE ETSU SULEIMAN",
		Accredited_Voters: 215,
		Registered_Voters: 283,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650825/result_68649_1677588438_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSARAGI 111",
		"PU-Code": "23-03-07-020",
		"PU-Name": "NDADZOKO OPEN SPACE",
		Accredited_Voters: 215,
		Registered_Voters: 301,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650826/result_68650_1677589735_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-011",
		"PU-Name": "OPEN SPACE EMI-ESTSU ABUBAKAR",
		Accredited_Voters: 92,
		Registered_Voters: 179,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650827/result_68661_1677575454_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-012",
		"PU-Name": "L.G.E.A CENTRAL SCH.TSONGA",
		Accredited_Voters: 46,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650828/result_68662_1677575572_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-013",
		"PU-Name": "OPEN SPACE MASALACHI BOLOGI",
		Accredited_Voters: 158,
		Registered_Voters: 232,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650829/result_68663_1677575908_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 1",
		"PU-Code": "23-03-08-014",
		"PU-Name": "OPEN SPACE ALH.MAMMAN EFU NDAYAGI",
		Accredited_Voters: 157,
		Registered_Voters: 229,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650830/result_68664_1677576129_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-010",
		"PU-Name": "OPEN SPACE DUMANGI",
		Accredited_Voters: 287,
		Registered_Voters: 423,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650833/result_68676_1677572785_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-011",
		"PU-Name": "COMMUNITY HEALTH CENTER GBORO",
		Accredited_Voters: 230,
		Registered_Voters: 558,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650834/result_68677_1677573317_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 11",
		"PU-Code": "23-03-09-012",
		"PU-Name": "COMMNITY SCH.KANKOFU",
		Accredited_Voters: 314,
		Registered_Voters: 668,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650835/result_68678_1677573589_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-011",
		"PU-Name": "L.G.E.A.SCH. CHIKANGI-WORO",
		Accredited_Voters: 195,
		Registered_Voters: 218,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650836/result_68689_1677669689_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-012",
		"PU-Name": "L.G.E.A.SCH. TSADUKO",
		Accredited_Voters: 298,
		Registered_Voters: 348,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650837/result_68690_1677669766_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EDU",
		Ward: "TSONGA 111",
		"PU-Code": "23-03-10-013",
		"PU-Name": "L.G.E.A.SCH.CHIJI",
		Accredited_Voters: 175,
		Registered_Voters: 307,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650838/result_68691_1677669846_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "ISAPA",
		"PU-Code": "23-04-02-007",
		"PU-Name": "TOWN HALL, OKE ODO-ORO",
		Accredited_Voters: 189,
		Registered_Voters: 495,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650839/result_68705_1677576626_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "KORO",
		"PU-Code": "23-04-03-004",
		"PU-Name": "COMMUNITY PRIMARY SCHOOL, EGURE",
		Accredited_Voters: 129,
		Registered_Voters: 272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650841/result_68710_1677626992_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "KORO",
		"PU-Code": "23-04-03-005",
		"PU-Name": "HEALTH CENTRE, BOLORUNDURO",
		Accredited_Voters: 204,
		Registered_Voters: 376,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650842/result_68711_1677627124_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-AIYEGGUNLE 11",
		"PU-Code": "23-04-05-006",
		"PU-Name": "ST LUKE'S PRIMARY SCHOOL, ILEMO",
		Accredited_Voters: 59,
		Registered_Voters: 156,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3595/ward/23133/pu/155557/155557-1677586609.pdf",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-006",
		"PU-Name": "ST. JOSEPH'S PRY SCH. ORA AIYETORO",
		Accredited_Voters: 162,
		Registered_Voters: 299,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650845/result_68729_1677669514_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OBBO-ILE",
		"PU-Code": "23-04-06-007",
		"PU-Name": "COMMUNITY PRIMARY SCHOOL, EJIU - ILE",
		Accredited_Voters: 119,
		Registered_Voters: 305,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650846/result_68730_1677669766_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 1",
		"PU-Code": "23-04-07-009",
		"PU-Name": "OPEN SPACE NEAR, PROVIDENCE COLLEGE",
		Accredited_Voters: 114,
		Registered_Voters: 256,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650847/result_68739_1677626292_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "EKITI",
		Ward: "OSI 11",
		"PU-Code": "23-04-08-007",
		"PU-Name": "OLD MARKET, OSI",
		Accredited_Voters: 89,
		Registered_Voters: 260,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650848/result_68746_1677599343_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-010",
		"PU-Name": "POST OFFICE IDOFIAN",
		Accredited_Voters: 71,
		Registered_Voters: 147,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/010/010-1677382641.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-012",
		"PU-Name": "SUCCESS NUR&PRY SCH. IDOFIAN",
		Accredited_Voters: 45,
		Registered_Voters: 71,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/012/012-1677379259.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 1",
		"PU-Code": "23-05-17-013",
		"PU-Name": "JIMBA OJA MARKET OPEN SPACE",
		Accredited_Voters: 82,
		Registered_Voters: 165,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/17/pu/013/013-1677378333.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-012",
		"PU-Name": "ATH-THABAAT INT.SCH.N.T.A AREA",
		Accredited_Voters: 122,
		Registered_Voters: 286,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155590/155590-1677633329.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-013",
		"PU-Name": "CITIZENS MODEL SCH. ALOMILAYA",
		Accredited_Voters: 96,
		Registered_Voters: 178,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/18/pu/013/013-1677378280.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-014",
		"PU-Name": "OPELOYERU MODEL PRY SCH. GANMO",
		Accredited_Voters: 228,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155592/155592-1677632983.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-016",
		"PU-Name": "ANSARUL ISLAM AKATA, GANMO",
		Accredited_Voters: 129,
		Registered_Voters: 294,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155594/155594-1677632297.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-017",
		"PU-Name": "JUNIOR SECONDARY SCHOOL AMAYO",
		Accredited_Voters: 242,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155595/155595-1677632000.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-018",
		"PU-Name": "ANSARUL ISLAM PRIMARY SCH.AMAYO",
		Accredited_Voters: 133,
		Registered_Voters: 209,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/18/pu/018/018-1677369312.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-019",
		"PU-Name": "AKEWUSHOLA COLLEGE, AMAYO",
		Accredited_Voters: 134,
		Registered_Voters: 235,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155597/155597-1677630002.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-021",
		"PU-Name": "GBAGEDE BASIC HEALTH CENTRE",
		Accredited_Voters: 235,
		Registered_Voters: 433,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/18/pu/021/021-1677382986.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "IDOFIAN 11",
		"PU-Code": "23-05-18-022",
		"PU-Name": "OPEN SPACE NOTREDAM AMAYO",
		Accredited_Voters: 107,
		Registered_Voters: 189,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23156/pu/155600/155600-1677631555.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-020",
		"PU-Name": "BABASANGO OPEN SPACE AREA",
		Accredited_Voters: 87,
		Registered_Voters: 257,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/020/020-1677383153.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-021",
		"PU-Name": "OKE OYAN SENIOR SECONDARY SCHOOL",
		Accredited_Voters: 100,
		Registered_Voters: 332,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650865/result_68830_1677738592_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ILE-IRE",
		"PU-Code": "23-05-05-022",
		"PU-Name": "BASIC HEALTH CENTER OREKE",
		Accredited_Voters: 313,
		Registered_Voters: 1056,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/05/pu/022/022-1677382657.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-019",
		"PU-Name": "MUSLIM COLLEGE, OMUPO",
		Accredited_Voters: 75,
		Registered_Voters: 196,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650867/result_68879_1677753639_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "OMUPO",
		"PU-Code": "23-05-08-020",
		"PU-Name": "BAYANGAN ILE COMMUNITY SCH.",
		Accredited_Voters: 133,
		Registered_Voters: 253,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650868/result_68880_1677753732_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORA",
		"PU-Code": "23-05-04-011",
		"PU-Name": "JAMAT NASIR ISLAM LGEA SCHOOL,ORA",
		Accredited_Voters: 66,
		Registered_Voters: 171,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/04/pu/011/011-1677363248.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-016",
		"PU-Name": "OPEN SPACE OKEWA OYATEDO ROAD",
		Accredited_Voters: 51,
		Registered_Voters: 86,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/016/016-1677385098.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-017",
		"PU-Name": "OKE-MURE MARKET SQURE, OPEN SPACE",
		Accredited_Voters: 74,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/017/017-1677385598.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-018",
		"PU-Name": "OJUDE OGAYIN (MEETING PLACE)",
		Accredited_Voters: 105,
		Registered_Voters: 219,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/018/018-1677386033.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-019",
		"PU-Name": "OMO-OLOMI COMPREHENSIVE HIGH SCH.AHUN",
		Accredited_Voters: 69,
		Registered_Voters: 152,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3596/ward/23145/pu/155569/155569-1677507684.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-020",
		"PU-Name": "OPEN SPACE BESIDE NSCDC'S OFFICE, OMUGO",
		Accredited_Voters: 139,
		Registered_Voters: 257,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/020/020-1677386453.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "ORO-AGO",
		"PU-Code": "23-05-07-021",
		"PU-Name": "AGBADA OPEN SPACE",
		Accredited_Voters: 45,
		Registered_Voters: 86,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/07/pu/021/021-1677386524.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-009",
		"PU-Name": "OPEN SPACE BOJI BAALE, SHARE",
		Accredited_Voters: 54,
		Registered_Voters: 132,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/009/009-1677370447.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-011",
		"PU-Name": "COMMUNITY PRIMARY SCH.APATA AJE",
		Accredited_Voters: 228,
		Registered_Voters: 598,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/011/011-1677382637.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-012",
		"PU-Name": "GENERAL HOSPITAL OPEN SPACE SHARE",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/012/012-1677376905.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 1",
		"PU-Code": "23-05-09-013",
		"PU-Name": "CAC PRIMARY & SECONDARY SCH. SHARE",
		Accredited_Voters: 53,
		Registered_Voters: 145,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/09/pu/013/013-1677376321.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-010",
		"PU-Name": "OLOJO BUS STOP, SHARE",
		Accredited_Voters: 142,
		Registered_Voters: 294,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/010/010-1677376544.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-011",
		"PU-Name": "SHARIAH COURT OF APPEAL, SHARE",
		Accredited_Voters: 186,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/011/011-1677373211.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-012",
		"PU-Name": "POLICE BARACK OPEN SPACE",
		Accredited_Voters: 108,
		Registered_Voters: 286,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/012/012-1677374512.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 11",
		"PU-Code": "23-05-10-013",
		"PU-Name": "MAGISTRATE COURT, SHARE",
		Accredited_Voters: 113,
		Registered_Voters: 340,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/10/pu/013/013-1677375389.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE 111",
		"PU-Code": "23-05-11-010",
		"PU-Name": "BUS STOP LOMA",
		Accredited_Voters: 64,
		Registered_Voters: 515,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/11/pu/010/010-1677367534.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-011",
		"PU-Name": "GIDANBURU OPEN SPACE",
		Accredited_Voters: 100,
		Registered_Voters: 208,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/011/011-1677371903.pdf",
	},
	{
		State: "KWARA",
		LGA: "IFELODUN",
		Ward: "SHARE V",
		"PU-Code": "23-05-13-012",
		"PU-Name": "COMMUNITY SCH. KPIANGBIA",
		Accredited_Voters: 195,
		Registered_Voters: 337,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/05/ward/13/pu/012/012-1677372718.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-017",
		"PU-Name": "OPEN  SPACE BABA OLOKOLE",
		Accredited_Voters: 67,
		Registered_Voters: 95,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/155601/155601-1677599902.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-018",
		"PU-Name": "OPEN  SPACE OPPOSITE BOLANTA JUNCTION",
		Accredited_Voters: 36,
		Registered_Voters: 90,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/018/018-1677401108.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-020",
		"PU-Name": "OPEN SPACE NEAR KORO AGIDI MOSQUE",
		Accredited_Voters: 74,
		Registered_Voters: 96,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/02/pu/020/020-1677427048.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-021",
		"PU-Name": "OPEN SPACE IN FRONT OF IMMAM BARUBA",
		Accredited_Voters: 88,
		Registered_Voters: 121,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/155605/155605-1677596545.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-022",
		"PU-Name": "BALOGUN GAMBARI PRIMARY HEALTH CARE",
		Accredited_Voters: 65,
		Registered_Voters: 101,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/155606/155606-1677595816.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "GAMBARI 1",
		"PU-Code": "23-06-02-023",
		"PU-Name": "ODE ILE ELERAN II",
		Accredited_Voters: 52,
		Registered_Voters: 87,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23158/pu/155607/155607-1677596427.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-017",
		"PU-Name": "ODE WAZIRI GOBIR  II",
		Accredited_Voters: 30,
		Registered_Voters: 55,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155608/155608-1677598919.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-018",
		"PU-Name": "OPEN  SPACE KORO AFOJU",
		Accredited_Voters: 136,
		Registered_Voters: 389,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155609/155609-1677605701.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-019",
		"PU-Name": "OPEN SPACE ABATA KARUMA BESIDE L.G.E.A SCH",
		Accredited_Voters: 251,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155610/155610-1677623989.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-020",
		"PU-Name": "OPEN  SPACE LADUBA JUNCTION",
		Accredited_Voters: 88,
		Registered_Voters: 135,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155611/155611-1677606315.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-021",
		"PU-Name": "OPEN  SPACE ODE SERIKI KARUMA",
		Accredited_Voters: 49,
		Registered_Voters: 83,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155612/155612-1677598980.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-022",
		"PU-Name": "OPEN  SPACE ILE LABE",
		Accredited_Voters: 192,
		Registered_Voters: 393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155613/155613-1677602295.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-023",
		"PU-Name": "OPEN  SPACE MAIMASA COMPOUND",
		Accredited_Voters: 67,
		Registered_Voters: 86,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155614/155614-1677596037.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-024",
		"PU-Name": "OPEN SPACE INFRONT OF ILE OLOKO",
		Accredited_Voters: 73,
		Registered_Voters: 124,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155615/155615-1677601676.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-025",
		"PU-Name": "OJAGBORO SECONDARY SCHOOL",
		Accredited_Voters: 156,
		Registered_Voters: 247,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155616/155616-1677604880.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-026",
		"PU-Name": "OPEN SPACE IDI OSE KARUMA",
		Accredited_Voters: 89,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155617/155617-1677596662.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-027",
		"PU-Name": "OPEN SPACE CAMPUS ISALE KOKO",
		Accredited_Voters: 126,
		Registered_Voters: 201,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155618/155618-1677624303.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "BALOGUN GAMBARI 11",
		"PU-Code": "23-06-03-028",
		"PU-Name": "ITA KANO GOBIR",
		Accredited_Voters: 74,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23159/pu/155619/155619-1677596196.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-025",
		"PU-Name": "GOV'T DAY JUNIOR SEC SCHOOL",
		Accredited_Voters: 35,
		Registered_Voters: 66,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155621/155621-1677676606.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-026",
		"PU-Name": "OKELELE PRIMARY HEALTH CARE CENTRE",
		Accredited_Voters: 58,
		Registered_Voters: 116,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155622/155622-1677603920.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-027",
		"PU-Name": "OPEN SPACE INFRONT OF ILE ELESIN META OKELELE",
		Accredited_Voters: 97,
		Registered_Voters: 188,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155623/155623-1677601599.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-028",
		"PU-Name": "OPEN SPACE AMUYANKAN JAGUN",
		Accredited_Voters: 47,
		Registered_Voters: 75,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155624/155624-1677832449.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-029",
		"PU-Name": "OPEN SPACE BEHIND JAGUN MOSQUE",
		Accredited_Voters: 306,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155625/155625-1677666532.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-030",
		"PU-Name": "OPEN SPACE DADA AIYEGBAMI MOSQUE",
		Accredited_Voters: 150,
		Registered_Voters: 225,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155626/155626-1677834108.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-031",
		"PU-Name": "OPEN SPACE BALE DADA AIYEGBAMI JUNCTION",
		Accredited_Voters: 101,
		Registered_Voters: 193,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155627/155627-1677601450.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-032",
		"PU-Name": "DADA HEALTH CARE CENTRE",
		Accredited_Voters: 125,
		Registered_Voters: 232,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155628/155628-1677601281.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-033",
		"PU-Name": "OPEN SPACE IDI EGUN OPEN SPACE",
		Accredited_Voters: 286,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155629/155629-1677601335.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-034",
		"PU-Name": "ODE YITTA KANKATU",
		Accredited_Voters: 194,
		Registered_Voters: 711,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155630/155630-1677601274.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-036",
		"PU-Name": "OPEN SPACE ODE ILE ILESHA",
		Accredited_Voters: 211,
		Registered_Voters: 457,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155632/155632-1677759932.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-037",
		"PU-Name": "ALI MAIYAKI L.G.E.A SCHOOL AKEREBIATA",
		Accredited_Voters: 170,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155633/155633-1677840042.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-038",
		"PU-Name": "OPEN SPACE BESIDE SOHIBUL BAYAN MOSQUE BABA SOJA",
		Accredited_Voters: 221,
		Registered_Voters: 375,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155634/155634-1677761723.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-039",
		"PU-Name": "AKEREBIATA JUNIOR SEC SCH L.G.E.A",
		Accredited_Voters: 27,
		Registered_Voters: 84,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155635/155635-1677662668.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-040",
		"PU-Name": "AKEREBIATA   L.G.E.A SCH",
		Accredited_Voters: 12,
		Registered_Voters: 38,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155636/155636-1677682423.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-041",
		"PU-Name": "IDIGBA WERE, JUNCTION 1 HARMONY AKEREBIATA",
		Accredited_Voters: 111,
		Registered_Voters: 188,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155637/155637-1677601285.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-042",
		"PU-Name": "OPEN SPACE ODE ADALAN KANKATU",
		Accredited_Voters: 78,
		Registered_Voters: 124,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155638/155638-1677667482.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-043",
		"PU-Name": "OPEN SPACE INFRONT OF BABA TAPA TINU STREET",
		Accredited_Voters: 185,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155639/155639-1677832652.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-044",
		"PU-Name": "INFRONT OF ABATIOR AKEREBIATA SOBI ROAD",
		Accredited_Voters: 116,
		Registered_Voters: 324,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155640/155640-1677663598.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-045",
		"PU-Name": "ITESIWAJU COMMUNITY IDIGBA WERE JUNCTION 2 HARMONY AKEREBIATA",
		Accredited_Voters: 45,
		Registered_Voters: 85,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155641/155641-1677757618.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-046",
		"PU-Name": "OPEN SPACE NEW SHAO GARAGE AKEREBIATA",
		Accredited_Voters: 126,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155642/155642-1677835427.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-047",
		"PU-Name": "KARUMA SECONDARY SCHOOL AKEREBIATA",
		Accredited_Voters: 177,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155643/155643-1677835277.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-048",
		"PU-Name": "OPEN SPACE ILE KOKORO OLESHIN AREA",
		Accredited_Voters: 230,
		Registered_Voters: 473,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155644/155644-1677844221.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-049",
		"PU-Name": "OPEN SPACE ODE BABA OKANKAN",
		Accredited_Voters: 91,
		Registered_Voters: 125,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155645/155645-1677602566.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-050",
		"PU-Name": "ODE ASINLEKE 1",
		Accredited_Voters: 245,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155646/155646-1677670863.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-051",
		"PU-Name": "OPEN SPACE ODE AMODE",
		Accredited_Voters: 269,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155647/155647-1677841040.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-052",
		"PU-Name": "OPEN SPACE OKE ONITIKU BY TRANSFORMER",
		Accredited_Voters: 78,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155648/155648-1677841662.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-053",
		"PU-Name": "OPEN SPACE INFRONT OF ONDOKO MRT JAGUN",
		Accredited_Voters: 215,
		Registered_Voters: 631,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155649/155649-1677602954.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-054",
		"PU-Name": "OPEN SPACE INFRONT OF ILE SEFURA ABATA ISALE JAGUN",
		Accredited_Voters: 128,
		Registered_Voters: 212,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155650/155650-1677748936.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-055",
		"PU-Name": "OPEN SPACE BARAJE ONITOBE",
		Accredited_Voters: 29,
		Registered_Voters: 49,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155651/155651-1677755635.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-056",
		"PU-Name": "OPEN SPACE INFRONT OF OLAOPARUN MOSQUE",
		Accredited_Voters: 82,
		Registered_Voters: 103,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155652/155652-1677758085.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-057",
		"PU-Name": "OPEN SPACE BEHIND GOV'T DAY SEC SCH AMULE",
		Accredited_Voters: 244,
		Registered_Voters: 668,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155653/155653-1677757642.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "IBAGUN",
		"PU-Code": "23-06-04-058",
		"PU-Name": "JUNCTION NIMANNIMULA DADA OPEN SPACE",
		Accredited_Voters: 132,
		Registered_Voters: 198,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23160/pu/155654/155654-1677831335.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-026",
		"PU-Name": "OPEN SPACE INFRONT OF BABA ISALE COMP IDI-APE",
		Accredited_Voters: 108,
		Registered_Voters: 185,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155655/155655-1677687702.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-028",
		"PU-Name": "OPEN SPACE INFRONT OF OLONI DAN BAWA",
		Accredited_Voters: 65,
		Registered_Voters: 95,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155657/155657-1677752999.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-029",
		"PU-Name": "OPEN SPACE OPPOSITE DAUDU YEKELUS COMP BOLANTA",
		Accredited_Voters: 27,
		Registered_Voters: 47,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155658/155658-1677754483.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-030",
		"PU-Name": "OPEN SPACE ILE-AGO BARUBA",
		Accredited_Voters: 112,
		Registered_Voters: 139,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155659/155659-1677752816.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-031",
		"PU-Name": "OPEN SPACE ILE-BELLO IDI-ARO",
		Accredited_Voters: 40,
		Registered_Voters: 87,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155660/155660-1677750160.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-032",
		"PU-Name": "OPEN SPACE ODE DAUDU ISALE-OJA",
		Accredited_Voters: 63,
		Registered_Voters: 114,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155661/155661-1677756407.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-033",
		"PU-Name": "OPEN SPACE OLANREWAJU ISALE OJA",
		Accredited_Voters: 75,
		Registered_Voters: 97,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155662/155662-1677767996.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-034",
		"PU-Name": "DAUDU AMULE OLOKO-OBI OPEN SPACE",
		Accredited_Voters: 79,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155663/155663-1677756001.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 1",
		"PU-Code": "23-06-07-035",
		"PU-Name": "OPEN SPACE AGBARERE MOSQUE",
		Accredited_Voters: 97,
		Registered_Voters: 157,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23163/pu/155664/155664-1677687875.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-025",
		"PU-Name": "OPEN SPACE BESIDE SABO-OKE MEDICAL CENTRE ALALUBOSA",
		Accredited_Voters: 136,
		Registered_Voters: 217,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/025/025-1677402000.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-026",
		"PU-Name": "ALALUBOSA L.G.E.A SCHOOL",
		Accredited_Voters: 211,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155669/155669-1677588462.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-027",
		"PU-Name": "OPEN SPACE MUBO PHASE  I",
		Accredited_Voters: 57,
		Registered_Voters: 97,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155670/155670-1677592230.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-028",
		"PU-Name": "ORISUNMIBARE COMMUNITY JUNCTION MUBO PHASE 2",
		Accredited_Voters: 86,
		Registered_Voters: 136,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155671/155671-1677456725.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-030",
		"PU-Name": "OPEN SPACE OPPOSITE FEDERAL SECRETARIAT FATE ROAD",
		Accredited_Voters: 26,
		Registered_Voters: 61,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/030/030-1677419237.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-031",
		"PU-Name": "BODUNDE STREET JUNCTION OFF ADELODUN ROAD FLOWER GARDEN GRA",
		Accredited_Voters: 26,
		Registered_Voters: 47,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/031/031-1677402387.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-033",
		"PU-Name": "OPEN SPACE INFRONT OF VETERINBARY TEACHING HOSPITAL  II",
		Accredited_Voters: 41,
		Registered_Voters: 58,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155676/155676-1677592674.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-034",
		"PU-Name": "LAJORIN JUNCTION BESIDE TOWN PLANNING OFFICE",
		Accredited_Voters: 10,
		Registered_Voters: 20,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155677/155677-1677496101.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-035",
		"PU-Name": "OPEN SPACE INFRONT OF WATER CORPORATION AGBA DAM",
		Accredited_Voters: 27,
		Registered_Voters: 57,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155678/155678-1677483997.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-036",
		"PU-Name": "INFRONT OF RADIO KWARA MIDLAND F.M",
		Accredited_Voters: 42,
		Registered_Voters: 60,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155679/155679-1677587239.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-037",
		"PU-Name": "KWARA STATE ENVIRONMENTAL PROTECTION AGENCY",
		Accredited_Voters: 22,
		Registered_Voters: 37,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/037/037-1677408028.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-038",
		"PU-Name": "SIMEON OKIDE STREET BEHIND ADISA HOUSE GRA",
		Accredited_Voters: 5,
		Registered_Voters: 10,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155681/155681-1677592848.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-039",
		"PU-Name": "MINISTRY OF WORK ROUND ABOUT I",
		Accredited_Voters: 36,
		Registered_Voters: 57,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155682/155682-1677589863.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-040",
		"PU-Name": "MINISTRY OF WORK ROUND ABOUT II",
		Accredited_Voters: 28,
		Registered_Voters: 53,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/08/pu/040/040-1677427980.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAGAJI ARE 11",
		"PU-Code": "23-06-08-041",
		"PU-Name": "OPEN SPACE ILE ISANA BESIDE SULU GAMBARI JUMMAT MOSQUE",
		Accredited_Voters: 29,
		Registered_Voters: 45,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23164/pu/155684/155684-1677753943.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-020",
		"PU-Name": "OPEN SPACE AGA ILE APA",
		Accredited_Voters: 60,
		Registered_Voters: 87,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/020/020-1677405199.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-025",
		"PU-Name": "JUNIOR SECONDARY SCOOL APATA YAKUBA",
		Accredited_Voters: 117,
		Registered_Voters: 251,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650974/result_69291_1677589240_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "OKE OYI/OKE OSE/ALALUBOSA",
		"PU-Code": "23-06-11-026",
		"PU-Name": "OPEN SPACE BARIGUDU SULU IDI ORI",
		Accredited_Voters: 140,
		Registered_Voters: 251,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650975/result_69292_1677590156_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-019",
		"PU-Name": "OPEN SPACE ELOKO YANGAN ISALE GAMBARI",
		Accredited_Voters: 54,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650977/result_69311_1677596406_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-020",
		"PU-Name": "OPEN SPACE MASALASI ILE ONILEKE ALONG BOLANTA",
		Accredited_Voters: 145,
		Registered_Voters: 194,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155691/155691-1677600653.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-021",
		"PU-Name": "OPEN SPACE ILE KARATU",
		Accredited_Voters: 69,
		Registered_Voters: 109,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155692/155692-1677671442.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-022",
		"PU-Name": "OPEN SPACE ODE WOKILI OKESUNA",
		Accredited_Voters: 69,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155693/155693-1677672083.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-023",
		"PU-Name": "IPATA LGEA SCH I",
		Accredited_Voters: 44,
		Registered_Voters: 108,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155694/155694-1677675384.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-024",
		"PU-Name": "IPATA LGEA  SCHOOL II",
		Accredited_Voters: 21,
		Registered_Voters: 42,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650982/result_69316_1677596403_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-025",
		"PU-Name": "OPEN SPACE ODE ILE EMU",
		Accredited_Voters: 180,
		Registered_Voters: 291,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650983/result_69317_1677598977_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-026",
		"PU-Name": "ODE MAGAJI YABBA COMPOUND",
		Accredited_Voters: 69,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650984/result_69318_1677590503_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-027",
		"PU-Name": "OPEN SPACE SANNI MAI TEA BALOGUN FULANI ROAD",
		Accredited_Voters: 61,
		Registered_Voters: 82,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650985/result_69319_1677589966_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-028",
		"PU-Name": "OPEN  SPACE OMOLABI MORUFI",
		Accredited_Voters: 49,
		Registered_Voters: 80,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155699/155699-1677675426.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-029",
		"PU-Name": "OPEN SPACE ILE BABA BADADUMA PHASE II",
		Accredited_Voters: 56,
		Registered_Voters: 80,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155700/155700-1677602902.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-030",
		"PU-Name": "OPEN SPACE BESIDE TEMIDAYO CENTRAL MOSQUE ADUALERE",
		Accredited_Voters: 70,
		Registered_Voters: 106,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155701/155701-1677600477.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "ZANGO",
		"PU-Code": "23-06-12-031",
		"PU-Name": "OPEN SPACE DUMO AMUNILAKA ADURAGBA STREET",
		Accredited_Voters: 128,
		Registered_Voters: 202,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3597/ward/23168/pu/155702/155702-1677591622.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-024",
		"PU-Name": "OPEN SPACE BATA (OPOLO)",
		Accredited_Voters: 185,
		Registered_Voters: 488,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650990/result_69365_1677621634_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-025",
		"PU-Name": "OPEN SPACE , OPP. EBENEZER HIGH SCHOOL",
		Accredited_Voters: 67,
		Registered_Voters: 154,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650991/result_69366_1677621703_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-026",
		"PU-Name": "OPEN SPACE ERIN-ILE ROAD, ODO-OWA JUNCTION, GAA-AKANBI",
		Accredited_Voters: 52,
		Registered_Voters: 139,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650992/result_69367_1677621755_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-027",
		"PU-Name": "OPEN SPACE, INFRONT OF OMOSHEBI HOSPITAL GAA-AKANBI",
		Accredited_Voters: 136,
		Registered_Voters: 584,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650993/result_69368_1677621814_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-028",
		"PU-Name": "OKE OGUN LGEA PRY SCHOOL",
		Accredited_Voters: 56,
		Registered_Voters: 104,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650994/result_69369_1677621873_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-029",
		"PU-Name": "OPEN SPACE, OKE OGUN PRIMARY SCHOOL ROAD",
		Accredited_Voters: 205,
		Registered_Voters: 648,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650995/result_69370_1677621942_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-030",
		"PU-Name": "ONIKANGA PRIMARY HEALTH CENTER ILORIN SOUTH",
		Accredited_Voters: 227,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650996/result_69371_1677617519_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-032",
		"PU-Name":
			"OPEN SPACE YASHIRIKA RD JUNCTION, OPP. UNION BAPTIST GRAMMAR SCH",
		Accredited_Voters: 222,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650998/result_69373_1677590872_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-033",
		"PU-Name":
			"OPEN SPACE, OTITO-LOJU MULTIPURPOSE COOPERATIVE SOCIETY JUNCTION",
		Accredited_Voters: 1,
		Registered_Voters: 4,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/650999/result_69374_1677618464_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-034",
		"PU-Name": "OPEN SPACE, DE-CHARMP PHARMACY, PIPE LINE ROAD",
		Accredited_Voters: 89,
		Registered_Voters: 359,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651000/result_69375_1677622169_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-035",
		"PU-Name": "OPEN SPACE, OPP. GAA AKANBI CENTRAL MOSQUE",
		Accredited_Voters: 10,
		Registered_Voters: 31,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651001/result_69376_1677610207_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-036",
		"PU-Name": "OPEN SPACE, LUMEX INTERNATIONAL COLLEGE JUNCTION",
		Accredited_Voters: 205,
		Registered_Voters: 596,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651002/result_69377_1677622238_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-037",
		"PU-Name": "JUNIOR SECODNARY SCHOOL ITA-AYISA",
		Accredited_Voters: 150,
		Registered_Voters: 589,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651003/result_69378_1677590002_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-038",
		"PU-Name": "OLULADE LGEA PRIMARY SCHOOL",
		Accredited_Voters: 275,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651004/result_69379_1677622327_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-039",
		"PU-Name": "OPEN SPACE, CAC ALABUKUN JUNCTION ITA-ALAMU",
		Accredited_Voters: 240,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651005/result_69380_1677622407_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-040",
		"PU-Name": "OPEN SPACE, IFE SOWAPO COMMUNITY JUNCTION, BUDO-EFO",
		Accredited_Voters: 174,
		Registered_Voters: 598,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651006/result_69381_1677622526_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-041",
		"PU-Name": "OPEN SPACE, OPP KHABETA NUR/PRY SCHOOL, DANIALU",
		Accredited_Voters: 25,
		Registered_Voters: 38,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651007/result_69382_1677622609_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-042",
		"PU-Name": "OPEN SPACE, OPP. BIADA MOSQUE",
		Accredited_Voters: 124,
		Registered_Voters: 193,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651008/result_69383_1677610544_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-044",
		"PU-Name": "OPEN SPACE, OPPOSITE INISHA STREET, ITA OLODAN",
		Accredited_Voters: 250,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651010/result_69385_1677637918_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-045",
		"PU-Name": "ERO OMO HEALTH CENTRE, ERO OMO, GARAGE OFFA",
		Accredited_Voters: 142,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651011/result_69386_1677622720_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-046",
		"PU-Name": "OPEN SPACE, SANMARA STRET JUNCTION, ERO OMO",
		Accredited_Voters: 65,
		Registered_Voters: 419,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651012/result_69387_1677617795_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-047",
		"PU-Name": "ERO OMO LGEA PRY SCH GARAGE OFFA",
		Accredited_Voters: 45,
		Registered_Voters: 110,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651013/result_69388_1677639035_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-048",
		"PU-Name": "ALUMIJIRI MARIKAZ UBE PRY SCHOOL ERO OMO",
		Accredited_Voters: 21,
		Registered_Voters: 34,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651014/result_69389_1677619975_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-049",
		"PU-Name": "OPEN SPACE AJAGUSI KILANKO ROAD",
		Accredited_Voters: 186,
		Registered_Voters: 582,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651015/result_69390_1677616679_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-050",
		"PU-Name": "ALAGBEDE LGEA PRY SCH.",
		Accredited_Voters: 123,
		Registered_Voters: 662,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651016/result_69391_1677637132_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -111",
		"PU-Code": "23-07-03-051",
		"PU-Name": "BOLORUNDURO COMM. INFRONT OF IROYIN AYO BLOCK INDUSTRY",
		Accredited_Voters: 32,
		Registered_Voters: 58,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651017/result_69392_1677638729_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-026",
		"PU-Name":
			"UNILORIN JUNIOR STAFF QUARTERS JALALA VILLAGE, OPP. WATER RESERVIOR",
		Accredited_Voters: 32,
		Registered_Voters: 47,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155731/155731-1677577337.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-027",
		"PU-Name":
			"UNILORIN JUNIOR STAFF QUARTERS JALALA VILLAGE, OPP. WATER RESERVIOR",
		Accredited_Voters: 32,
		Registered_Voters: 47,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155731/155731-1677577337.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-028",
		"PU-Name": "JALALA VILLAGE, PRIMARY HEALT CENTRE, TANKE OKE ODO",
		Accredited_Voters: 166,
		Registered_Voters: 339,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155733/155733-1677581795.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-029",
		"PU-Name":
			"OPEN SPACE BERACHA INT. NUR/PRY SCH. JUNCTION TANKE OKE ODO AREA",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155734/155734-1677580625.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-030",
		"PU-Name": "OPEN SPACE TEMITOPE SCHOL JUNCTION TANKE ALENIBORO VILLAGE",
		Accredited_Voters: 18,
		Registered_Voters: 49,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155735/155735-1677586258.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-031",
		"PU-Name": "KWARA STATE , STAFF DEVELOPMENT COLLEGE, FATE",
		Accredited_Voters: 19,
		Registered_Voters: 50,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155736/155736-1677587314.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-032",
		"PU-Name": "OPEN SPACE MAYOWA STREET, OPP. MOSQUE FATE AREA",
		Accredited_Voters: 78,
		Registered_Voters: 150,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155737/155737-1677579287.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-033",
		"PU-Name": "OPEN SPACE OPP. OLD SAW-MILL TANKE",
		Accredited_Voters: 207,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155738/155738-1677589504.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-034",
		"PU-Name": "OPEN SPACE ADIFA STREET JUNCTION, TANKE",
		Accredited_Voters: 235,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155739/155739-1677571853.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-035",
		"PU-Name": "OPEN SPACE, TIPPER GARAGE ROUNDABOUT TANKE",
		Accredited_Voters: 254,
		Registered_Voters: 521,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155740/155740-1677575512.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-036",
		"PU-Name": "OPEN SPACE OPP. RENDEZ EVENT CENTRE, 'F' DIVISION TANKE",
		Accredited_Voters: 304,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/036/036-1677416822.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-037",
		"PU-Name": "OPEN SPACE, JUDGES QUARTERS JUNCTION, TANKE",
		Accredited_Voters: 68,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155742/155742-1677579008.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-039",
		"PU-Name":
			"OPEN SPACE, INFRONT OF WATER WORKS RESERVIOR, OFF PIPE LINE ROAD, TANKE",
		Accredited_Voters: 126,
		Registered_Voters: 522,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/039/039-1677414567.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-040",
		"PU-Name": "OPEN SPACE, FATAI AFOLABI JUNCTION PIPE-LINE ROAD, TANKE",
		Accredited_Voters: 133,
		Registered_Voters: 458,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155745/155745-1677588574.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-041",
		"PU-Name": "BUBU LGEA SCH, TANKE",
		Accredited_Voters: 247,
		Registered_Voters: 687,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/041/041-1677419924.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-042",
		"PU-Name": "OPEN SPACE ALIKALI BEGORE YUSUF ROAD JUNCTION, BASIN",
		Accredited_Voters: 80,
		Registered_Voters: 437,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155747/155747-1677578326.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-043",
		"PU-Name": "OPEN SPACE ANUOLUWA ASALA VILLA RIVER BASIN",
		Accredited_Voters: 14,
		Registered_Voters: 22,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/043/043-1677415831.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-044",
		"PU-Name": "OPEN SPACE UMCA CHURCH JUNCTION, OFF TAOHEED ROAD, BASIN",
		Accredited_Voters: 120,
		Registered_Voters: 246,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155749/155749-1677589378.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-045",
		"PU-Name": "OPEN SPACE, OPP. EVERGREEN COMMUNITY HOUSING ESTATE, TANKE",
		Accredited_Voters: 35,
		Registered_Voters: 55,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155750/155750-1677576192.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-046",
		"PU-Name": "OPEN SPACE, AYO AWONIYI JUNCTION, ODOFIN LANE BASIN",
		Accredited_Voters: 115,
		Registered_Voters: 502,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155751/155751-1677578659.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-047",
		"PU-Name": "OPEN SPACE SULYMAN ADEWUYI STREET JUNCTION, FATE AREA",
		Accredited_Voters: 163,
		Registered_Voters: 610,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155752/155752-1677585847.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-048",
		"PU-Name":
			"OPEN SPACE CENTRE FOR ALTERNATIVE AND DISPUTE RESOLUTION JUNCTION, FATE",
		Accredited_Voters: 78,
		Registered_Voters: 404,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/048/048-1677404849.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-049",
		"PU-Name":
			"OPEN SPACE AYOBAMI CLINIC AND MATERNITY JUNCTION, OKO OBA ROAD, TANKE",
		Accredited_Voters: 50,
		Registered_Voters: 72,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155754/155754-1677585053.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-050",
		"PU-Name": "OPEN SPACE, SURULERE PLANK MARKET JUNCTION, BOLORUNDURO AREA",
		Accredited_Voters: 42,
		Registered_Voters: 82,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155755/155755-1677579761.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-051",
		"PU-Name":
			"OPEN SPACE, PA DAVID AWOLOLA JUNCTION, BESIDE EMMANUEL BAPTIST COLLEGE ROAD, TANKE",
		Accredited_Voters: 171,
		Registered_Voters: 293,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155756/155756-1677573662.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-052",
		"PU-Name": "OPEN SPACE, TANKE AKATA JUNCTION, TANKE",
		Accredited_Voters: 159,
		Registered_Voters: 272,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155757/155757-1677591250.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-053",
		"PU-Name": "OPEN SPACE, DR. DELE GEGE STREET JUNCTION, AWOLOWO RD, TANKE",
		Accredited_Voters: 55,
		Registered_Voters: 107,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23172/pu/155758/155758-1677575179.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -1V",
		"PU-Code": "23-07-04-054",
		"PU-Name": "PRY HEALTH CENTRE AGO-IFEDAPO-AIYEKALE",
		Accredited_Voters: 71,
		Registered_Voters: 126,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/04/pu/054/054-1677402637.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-020",
		"PU-Name":
			"OPEN SPACE, OPP. ALIMI ISLAMIYAT ACADEMY BEHIND ROYAL VALLEY ESTATE",
		Accredited_Voters: 150,
		Registered_Voters: 520,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155760/155760-1677480527.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-021",
		"PU-Name": "OPEN SPACE, HEALTH CENTRE, MEDINA",
		Accredited_Voters: 206,
		Registered_Voters: 590,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155761/155761-1677481479.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-022",
		"PU-Name": "OPEN SPACE, MAGAJI NKEBBI, SANGO AREA",
		Accredited_Voters: 52,
		Registered_Voters: 89,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/022/022-1677401579.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-024",
		"PU-Name": "OPEN SPACE, OPP. OUR LADIES SECODNARY SCHOOL",
		Accredited_Voters: 88,
		Registered_Voters: 163,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155764/155764-1677483166.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-025",
		"PU-Name": "OPEN SPACE, OPP. J & A HOTEL KULENDE AREA",
		Accredited_Voters: 128,
		Registered_Voters: 546,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/05/pu/025/025-1677406024.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-026",
		"PU-Name": "OPEN SPACE, OPEN LEGACY ENERGY FILLING STATION, SANGO AREA",
		Accredited_Voters: 206,
		Registered_Voters: 536,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155766/155766-1677486070.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-027",
		"PU-Name": "AJEGUNLE LGEA SCHOOL, KULENDE AREA",
		Accredited_Voters: 39,
		Registered_Voters: 78,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155767/155767-1677486291.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-028",
		"PU-Name": "OPEN SPACE, OPP. KULENDE NEW MARKET",
		Accredited_Voters: 118,
		Registered_Voters: 231,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155768/155768-1677487895.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-029",
		"PU-Name": "OPEN SPACE ARAROMI COMM. OKE ANDI",
		Accredited_Voters: 98,
		Registered_Voters: 187,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155769/155769-1677488209.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-030",
		"PU-Name": "SAHABA LGEA SCH. OKE ANDI",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155770/155770-1677489449.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-031",
		"PU-Name": "OPEN, SPACE MUIDEEN IDI-IGBA",
		Accredited_Voters: 117,
		Registered_Voters: 192,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155771/155771-1677490251.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-032",
		"PU-Name": "OPEN SPACE, ORILOWO JUNCTION, OPP. APOSTOLIC CHURCH SANGO AREA",
		Accredited_Voters: 112,
		Registered_Voters: 368,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155772/155772-1677490547.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-033",
		"PU-Name": "GOVT DAY SEC. SCH. KULENDE",
		Accredited_Voters: 139,
		Registered_Voters: 418,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155773/155773-1677491508.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-034",
		"PU-Name": "GAA OKE IDI EMI COMM. LGEA SCH.",
		Accredited_Voters: 241,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155774/155774-1677491802.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-035",
		"PU-Name": "GOVT. DAY SEC. SCH, OKEKERE",
		Accredited_Voters: 296,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155775/155775-1677492675.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-036",
		"PU-Name": "OPEN SPACE, ARAROMI COMMUNITY, OKO-OLOWO AREA",
		Accredited_Voters: 280,
		Registered_Voters: 655,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155776/155776-1677493368.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-037",
		"PU-Name": "AJIBESIN COMMUNITY L.G.E.A SCH. OGIDI AREA",
		Accredited_Voters: 273,
		Registered_Voters: 560,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155777/155777-1677494194.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-038",
		"PU-Name": "OPEN SPACE, OPP. MOUNT OLIVE NIG. LTD, FARMER CENTRE",
		Accredited_Voters: 39,
		Registered_Voters: 87,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155778/155778-1677494419.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-039",
		"PU-Name": "OPEN SPACE MOUNTAIN VIEW ESTATE JUNCTION ALAGBADO AREA",
		Accredited_Voters: 266,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155779/155779-1677495005.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "AKANBI -V",
		"PU-Code": "23-07-05-040",
		"PU-Name": "OPEN SPACE, IDI-APE VILLAGE",
		Accredited_Voters: 202,
		Registered_Voters: 589,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23173/pu/155780/155780-1677495213.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-019",
		"PU-Name": "OPEN SPACE, BAWA HOUSE, CENTRE IGBORO",
		Accredited_Voters: 129,
		Registered_Voters: 365,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/019/019-1677398681.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI I",
		"PU-Code": "23-07-06-020",
		"PU-Name": "OPEN SPACE, ITA GOMA",
		Accredited_Voters: 191,
		Registered_Voters: 237,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/06/pu/020/020-1677411840.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-011",
		"PU-Name": "OPEN SPACE, OPPOSITE IDRIS ALAYA & SON LTD",
		Accredited_Voters: 141,
		Registered_Voters: 186,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651070/result_69517_1677649750_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-012",
		"PU-Name": "OPEN SPACE, ILE OLOYIN, SABO-LINE AREA",
		Accredited_Voters: 149,
		Registered_Voters: 201,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651071/result_69518_1677649799_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-013",
		"PU-Name": "OPEN SPACE, ILE ALAYA EMIRS ROAD",
		Accredited_Voters: 156,
		Registered_Voters: 229,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651072/result_69519_1677650006_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-014",
		"PU-Name": "OPEN SPACE, ITA KOLO GBODOFU",
		Accredited_Voters: 118,
		Registered_Voters: 181,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651073/result_69520_1677650083_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 11",
		"PU-Code": "23-07-07-015",
		"PU-Name": "OPEN SPACE ELERE COMPOUND, SABO-LINE",
		Accredited_Voters: 108,
		Registered_Voters: 139,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651074/result_69521_1677650145_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-012",
		"PU-Name": "OPEN SPACE, ILE OLOGEDE, OKE ALUKO",
		Accredited_Voters: 49,
		Registered_Voters: 85,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/012/012-1677388025.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-013",
		"PU-Name": "OPEN SPACE, ODE ILE ELERAN, SAKAMA STREET, NIGER",
		Accredited_Voters: 43,
		Registered_Voters: 56,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/013/013-1677390501.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-014",
		"PU-Name": "OPEN SPACE, ALABIAMO COMPOUND, SAKAMA STREET, OFF NIGER ROAD",
		Accredited_Voters: 113,
		Registered_Voters: 146,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/014/014-1677420683.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-015",
		"PU-Name": "OPEN SPACE ODE SAKAMA OFF NIGER ROAD",
		Accredited_Voters: 43,
		Registered_Voters: 62,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23178/pu/155808/155808-1677579025.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-016",
		"PU-Name": "OPEN SPACE ODE-KASANDUBU NIGER ROAD",
		Accredited_Voters: 40,
		Registered_Voters: 65,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/016/016-1677384141.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-017",
		"PU-Name": "OPEN SPACE, ODE-DAODU SUNNARA NIGER ROAD",
		Accredited_Voters: 64,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/017/017-1677396812.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-018",
		"PU-Name": "OKE-ALUKO LGEA PRY SCH (A) OFF NIGER ROAD",
		Accredited_Voters: 42,
		Registered_Voters: 71,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/018/018-1677396705.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 11",
		"PU-Code": "23-07-10-019",
		"PU-Name": "OPEN SPACE ODE NASAMU ITA AMODU AREA",
		Accredited_Voters: 123,
		Registered_Voters: 366,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/10/pu/019/019-1677387079.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-014",
		"PU-Name": "OPEN SPACE ILE OLORO ISALE KOTO AREA",
		Accredited_Voters: 58,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/014/014-1677405493.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-015",
		"PU-Name": "OPEN SPACE, ILE OMUN ISALE KOTO",
		Accredited_Voters: 18,
		Registered_Voters: 23,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3598/ward/23179/pu/155815/155815-1677560327.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-016",
		"PU-Name":
			"OPEN SPACE, ASSOCIATION OF MOTORCYCLE RIDER, SECRETARIATE EDUN AREA",
		Accredited_Voters: 44,
		Registered_Voters: 52,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651086/result_69595_1677578461_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-017",
		"PU-Name": "OPEN SPACE, ODE DASUKI, ISALE KOTO",
		Accredited_Voters: 93,
		Registered_Voters: 137,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/11/pu/017/017-1677405594.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-018",
		"PU-Name": "OPEN SPACE, IDI MANGORO, EMIR'S ROAD",
		Accredited_Voters: 120,
		Registered_Voters: 159,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651088/result_69597_1677594457_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKE-OGUN",
		"PU-Code": "23-07-11-019",
		"PU-Name": "OPEN SPACE, OPP. RASCO PHARMACY EDUN JUNCTION, OFF EMIRS ROAD",
		Accredited_Voters: 106,
		Registered_Voters: 159,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651089/result_69598_1677577984_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-013",
		"PU-Name": "OPEN SPACE, OKOSHO NIGER ROAD",
		Accredited_Voters: 57,
		Registered_Voters: 100,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/013/013-1677423838.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-015",
		"PU-Name": "OPEN SPACE, ODE ALADI WOKILI",
		Accredited_Voters: 52,
		Registered_Voters: 80,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651092/result_69553_1677623024_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-016",
		"PU-Name": "OPEN SPACE, SON & LOVERS BOOKSHOP, EMIRS ROAD",
		Accredited_Voters: 41,
		Registered_Voters: 72,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/016/016-1677424229.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-017",
		"PU-Name": "OPEN SPACE, INFRONT OF ELERE COMPOUND,",
		Accredited_Voters: 34,
		Registered_Voters: 49,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/017/017-1677424586.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-018",
		"PU-Name": "OPNE SPACE, OBA DADA JUNCTION",
		Accredited_Voters: 225,
		Registered_Voters: 662,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/018/018-1677424941.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-019",
		"PU-Name": "OPNE SPACE, ILE AYUBA AKANBI IKORORO AREA",
		Accredited_Voters: 130,
		Registered_Voters: 395,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/019/019-1677425208.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "OKAKA 1",
		"PU-Code": "23-07-09-021",
		"PU-Name": "OPEN SPACE BESIDE TOTAL RESTAURANT EXTENSION OBBO ROAD",
		Accredited_Voters: 63,
		Registered_Voters: 101,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/09/pu/021/021-1677425855.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-019",
		"PU-Name": "OPEN SPACE ALAPO/BABA IBADAN",
		Accredited_Voters: 322,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651099/result_69617_1677529680_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-021",
		"PU-Name": "OPEN SPACE ODE AJIARAN",
		Accredited_Voters: 282,
		Registered_Voters: 562,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651101/result_69619_1677584811_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-022",
		"PU-Name": "IDI IGBA HEALTH CENTER",
		Accredited_Voters: 200,
		Registered_Voters: 578,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651102/result_69620_1677572459_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-024",
		"PU-Name": "BARAKA COMMUNITY SECONDARY SCH.",
		Accredited_Voters: 199,
		Registered_Voters: 593,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651103/result_69622_1677557692_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-025",
		"PU-Name": "OPEN SPACE SAKELE OLORI COMPOUND",
		Accredited_Voters: 246,
		Registered_Voters: 448,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651104/result_69623_1677567652_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-027",
		"PU-Name": "OPEN SPACE DAROSA",
		Accredited_Voters: 203,
		Registered_Voters: 568,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651106/result_69625_1677572835_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-028",
		"PU-Name": "OPEN SPACE ONIMANSA",
		Accredited_Voters: 281,
		Registered_Voters: 685,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651107/result_69626_1677566616_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-029",
		"PU-Name": "OPEN SPACE KANGU ALASINRIN AREA",
		Accredited_Voters: 313,
		Registered_Voters: 646,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651108/result_69627_1677556519_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-030",
		"PU-Name": "FIRST MANDATE L.G.E.A PRY SCH",
		Accredited_Voters: 290,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651109/result_69628_1677568913_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-031",
		"PU-Name": "COLLEGE OF LEGAL STUDIES",
		Accredited_Voters: 243,
		Registered_Voters: 524,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651110/result_69629_1677555935_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-032",
		"PU-Name": "OPEN SPACE FRONT OF COTTAGE HOSPITAL",
		Accredited_Voters: 256,
		Registered_Voters: 564,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23180/pu/155834/155834-1677551309.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-038",
		"PU-Name": "OPEN SPACE AKONI KORO",
		Accredited_Voters: 109,
		Registered_Voters: 170,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651113/result_69636_1677556167_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-042",
		"PU-Name": "OPEN SPACE ILE OLOYIN",
		Accredited_Voters: 56,
		Registered_Voters: 67,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677442307-155842.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-045",
		"PU-Name": "OPEN SPACE ILE OLOYIN",
		Accredited_Voters: 56,
		Registered_Voters: 67,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677442307-155842.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-046",
		"PU-Name": "OPEN SPACE IN FRONT OF KEJEBU",
		Accredited_Voters: 70,
		Registered_Voters: 95,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155846/155846-1677595104.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-048",
		"PU-Name": "ODE ILE KABA",
		Accredited_Voters: 150,
		Registered_Voters: 333,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155848/155848-1677589123.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-049",
		"PU-Name": "ODE-ILE ALARO (POPO GIWA)",
		Accredited_Voters: 68,
		Registered_Voters: 88,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155849/155849-1677588432.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-051",
		"PU-Name": "ODE ELEFO",
		Accredited_Voters: 214,
		Registered_Voters: 492,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155851/155851-1677593670.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-052",
		"PU-Name": "ODE-SEBULOKU",
		Accredited_Voters: 52,
		Registered_Voters: 73,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/02/pu/052/052-1677426280.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-053",
		"PU-Name": "OPEN SPACE ODE ONIGBA",
		Accredited_Voters: 64,
		Registered_Voters: 86,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155853/155853-1677592588.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-054",
		"PU-Name": "OPEN SPACE ODE ALFA IYA KEWU",
		Accredited_Voters: 61,
		Registered_Voters: 94,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155854/155854-1677592315.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-055",
		"PU-Name": "OPEN SPACE ODE-ILE LABINTAN",
		Accredited_Voters: 58,
		Registered_Voters: 101,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155855/155855-1677582318.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-056",
		"PU-Name": "ODE-ILE APO",
		Accredited_Voters: 74,
		Registered_Voters: 105,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155856/155856-1677576193.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-057",
		"PU-Name": "ODE ONILU OKE KERE",
		Accredited_Voters: 40,
		Registered_Voters: 58,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155857/155857-1677593687.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-059",
		"PU-Name": "ODE-SADO",
		Accredited_Voters: 47,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155859/155859-1677591810.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-062",
		"PU-Name": "OPEN SPACE ILE OLOBI",
		Accredited_Voters: 37,
		Registered_Voters: 64,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155862/155862-1677589476.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-064",
		"PU-Name": "ODE BAALE",
		Accredited_Voters: 77,
		Registered_Voters: 114,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155864/155864-1677586133.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-067",
		"PU-Name": "ODE ILE JITUN MASINGBA",
		Accredited_Voters: 52,
		Registered_Voters: 66,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155867/155867-1677576724.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-069",
		"PU-Name": "ODE ILE ILA MASINGBA",
		Accredited_Voters: 113,
		Registered_Voters: 179,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155869/155869-1677579690.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-015",
		"PU-Name": "ODE MAGAJI ODUNLAMI",
		Accredited_Voters: 99,
		Registered_Voters: 141,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/015/015-1677362635.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-016",
		"PU-Name": "ERUDA L.G.E.A PRY SCH",
		Accredited_Voters: 190,
		Registered_Voters: 596,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/016/016-1677362442.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-018",
		"PU-Name": "OPEN SPACE ODE BABAOLOBI",
		Accredited_Voters: 234,
		Registered_Voters: 590,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/018/018-1677367998.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-026",
		"PU-Name": "OPEN SPACE TEMIDERE",
		Accredited_Voters: 88,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/026/026-1677364307.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-020",
		"PU-Name": "OPEN SPACE ODE SEGI ITA AMODU",
		Accredited_Voters: 135,
		Registered_Voters: 168,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651137/result_69751_1677598230_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-022",
		"PU-Name": "JAMAITAL PRY SCH OPEN SPACE",
		Accredited_Voters: 143,
		Registered_Voters: 428,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651138/result_69753_1677578125_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-027",
		"PU-Name": "OPEN SPACE ODE LASAKI",
		Accredited_Voters: 185,
		Registered_Voters: 518,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651139/result_69758_1677576078_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-031",
		"PU-Name": "OPEN SPACE ODE OLOWO COOLER",
		Accredited_Voters: 28,
		Registered_Voters: 36,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651141/result_69762_1677577103_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-025",
		"PU-Name": "ODE ILE ALATA",
		Accredited_Voters: 32,
		Registered_Voters: 48,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651142/result_69756_1677579219_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-046",
		"PU-Name": "ODE AFUN KU",
		Accredited_Voters: 157,
		Registered_Voters: 384,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155899/155899-1677504137.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-049",
		"PU-Name": "ODE KARATU II",
		Accredited_Voters: 39,
		Registered_Voters: 66,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651145/result_69812_1677506853_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-051",
		"PU-Name": "ODE KAJOLA",
		Accredited_Voters: 81,
		Registered_Voters: 182,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155904/155904-1677503037.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-058",
		"PU-Name": "ODE ONILA ADABATA",
		Accredited_Voters: 261,
		Registered_Voters: 518,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155911/155911-1677503011.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-060",
		"PU-Name": "ODE ONIROFI OKE KURA",
		Accredited_Voters: 152,
		Registered_Voters: 347,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651148/result_69823_1677506446_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-061",
		"PU-Name": "ODE ONIKUMO AREA",
		Accredited_Voters: 75,
		Registered_Voters: 97,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155914/155914-1677503413.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-063",
		"PU-Name": "IDI OSE ADABATA",
		Accredited_Voters: 23,
		Registered_Voters: 35,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651150/result_69826_1677505593_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-064",
		"PU-Name": "ODE ALAGE",
		Accredited_Voters: 31,
		Registered_Voters: 79,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155917/155917-1677495212.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-019",
		"PU-Name": "OPEN SPACE ISALE OLOKUN ALAPATA",
		Accredited_Voters: 228,
		Registered_Voters: 442,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155922/155922-1677592446.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-021",
		"PU-Name": "IDI AGBEDI AGAKA",
		Accredited_Voters: 172,
		Registered_Voters: 368,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155924/155924-1677597666.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-022",
		"PU-Name": "ODE KUBA GEGELE",
		Accredited_Voters: 41,
		Registered_Voters: 75,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155925/155925-1677596478.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-023",
		"PU-Name": "ODE DAUDU FAGBA",
		Accredited_Voters: 44,
		Registered_Voters: 75,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155926/155926-1677598051.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-024",
		"PU-Name": "ODE ALFA FOLORUNSHO FAGBA",
		Accredited_Voters: 35,
		Registered_Voters: 60,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155927/155927-1677593473.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-026",
		"PU-Name": "BAPTIST LGEA SCHOOL III",
		Accredited_Voters: 218,
		Registered_Voters: 548,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "\\",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155929/155929-1677599174.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-027",
		"PU-Name": "BAPTIST LGEA SCHOOL IV",
		Accredited_Voters: 61,
		Registered_Voters: 109,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155930/155930-1677598347.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-015",
		"PU-Name": "ALD YAUDEEN LGEA SCH",
		Accredited_Voters: 204,
		Registered_Voters: 314,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155946/155946-1677478513.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-016",
		"PU-Name": "OPEN SPACE AKALAMBA GUNNIYAN",
		Accredited_Voters: 186,
		Registered_Voters: 252,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155947/155947-1677478770.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-017",
		"PU-Name": "OPEN SPACE ODE ELEPO",
		Accredited_Voters: 125,
		Registered_Voters: 162,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155948/155948-1677479073.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-018",
		"PU-Name": "PRIMARY HEALTH CENTER BANNI KUNNI",
		Accredited_Voters: 273,
		Registered_Voters: 581,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155949/155949-1677479428.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-019",
		"PU-Name": "ODE OLORI",
		Accredited_Voters: 117,
		Registered_Voters: 150,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155950/155950-1677479800.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-035",
		"PU-Name": "ODE MAKANU",
		Accredited_Voters: 148,
		Registered_Voters: 358,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155951/155951-1677602029.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-036",
		"PU-Name": "OPEN SPACE ODE ONIWE",
		Accredited_Voters: 45,
		Registered_Voters: 55,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155952/155952-1677493633.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-038",
		"PU-Name": "ODE OKANJUAGBA",
		Accredited_Voters: 72,
		Registered_Voters: 94,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155954/155954-1677585835.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-039",
		"PU-Name": "ODE ALAWUYAN",
		Accredited_Voters: 36,
		Registered_Voters: 56,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155955/155955-1677501450.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-041",
		"PU-Name": "ODE BABA ITA",
		Accredited_Voters: 180,
		Registered_Voters: 228,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155957/155957-1677599132.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-043",
		"PU-Name": "OPEN SPACE AJEGUNLE",
		Accredited_Voters: 59,
		Registered_Voters: 76,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155959/155959-1677600042.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-044",
		"PU-Name": "SARUNMI HEALTH CENTER",
		Accredited_Voters: 143,
		Registered_Voters: 182,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155960/155960-1677593622.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-045",
		"PU-Name": "OPEN SPACE ODE OGANIJA",
		Accredited_Voters: 94,
		Registered_Voters: 136,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155961/155961-1677602527.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-046",
		"PU-Name": "ALADABIYA JSS SCHOOL",
		Accredited_Voters: 215,
		Registered_Voters: 547,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155962/155962-1677580367.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-026",
		"PU-Name": "OPEN SPACE BESIDE IFEOMO TEXTILE HUB",
		Accredited_Voters: 92,
		Registered_Voters: 169,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155964/155964-1677588985.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-027",
		"PU-Name": "OPEN SPACE AYILARA CRESCENT",
		Accredited_Voters: 230,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155965/155965-1677589126.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-028",
		"PU-Name": "OPEN SPACE NUT SHOPPING COMPLEX",
		Accredited_Voters: 191,
		Registered_Voters: 586,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155966/155966-1677589350.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-033",
		"PU-Name": "OPEN SPACE OPP C.A.C TAIWO ROAD",
		Accredited_Voters: 7,
		Registered_Voters: 28,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155971/155971-1677590265.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-035",
		"PU-Name": "OPEN SPACE BESIDE AJOJE SCHOOL OFF TAIWO ROAD",
		Accredited_Voters: 88,
		Registered_Voters: 312,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/10/pu/035/035-1677381864.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-036",
		"PU-Name": "OPEN SPACE OPP ESO TYRE ADJACENT OLD MOTOR PACK SAW MILL",
		Accredited_Voters: 145,
		Registered_Voters: 446,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/10/pu/036/036-1677382822.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-039",
		"PU-Name": "JUNIOR SEC SCH JORO",
		Accredited_Voters: 230,
		Registered_Voters: 603,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155977/155977-1677591170.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-040",
		"PU-Name": "OPEN SPACE ILUDUN ADJACENT CUSTOMS",
		Accredited_Voters: 226,
		Registered_Voters: 674,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155978/155978-1677591355.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-042",
		"PU-Name": "OPEN SPACE ADJACENT IRETI CLINIC",
		Accredited_Voters: 56,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155980/155980-1677591750.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-043",
		"PU-Name": "ODE SALAKO OPPOSITE AMINA AWERO MEMORIAL ACADEMY",
		Accredited_Voters: 185,
		Registered_Voters: 614,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155981/155981-1677592083.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-049",
		"PU-Name": "OPEN SPACE INFRONT OF ALH. ISSA AGBEYANGI HOUSE",
		Accredited_Voters: 135,
		Registered_Voters: 383,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155987/155987-1677593489.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-019",
		"PU-Name": "GOVT DAT SEC SCH ALORE III",
		Accredited_Voters: 59,
		Registered_Voters: 88,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651185/result_69876_1677607025_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-022",
		"PU-Name": "ODE OMUNILOJA",
		Accredited_Voters: 59,
		Registered_Voters: 106,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651186/result_69879_1677607379_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-024",
		"PU-Name": "ODE ONIGUGURU",
		Accredited_Voters: 207,
		Registered_Voters: 472,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651187/result_69881_1677608174_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-027",
		"PU-Name": "ODE AKONIKORO",
		Accredited_Voters: 85,
		Registered_Voters: 130,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651188/result_69884_1677608500_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-021",
		"PU-Name": "AIRFORCE PRY SCHOOL IV",
		Accredited_Voters: 98,
		Registered_Voters: 380,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651189/result_69878_1677607268_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-028",
		"PU-Name": "ODE ILE OLA",
		Accredited_Voters: 190,
		Registered_Voters: 425,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651190/result_69885_1677608617_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-010",
		"PU-Name": "OJUDE ELESHINLAGBA",
		Accredited_Voters: 264,
		Registered_Voters: 673,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/010/010-1677379754.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-012",
		"PU-Name": "OPEN SPACE ODE ASILEKE",
		Accredited_Voters: 187,
		Registered_Voters: 599,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/012/012-1677381445.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-013",
		"PU-Name": "OPEN SPACE ODE ALAHANPE",
		Accredited_Voters: 173,
		Registered_Voters: 495,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/013/013-1677383830.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-015",
		"PU-Name": "OPEN SPACE ODE BABA PUPA",
		Accredited_Voters: 178,
		Registered_Voters: 577,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23190/pu/155993/155993-1677601692.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-017",
		"PU-Name": "OPEN SPACE ODE OTTU",
		Accredited_Voters: 216,
		Registered_Voters: 508,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/017/017-1677380783.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-020",
		"PU-Name": "GAA SAKA NOMADIC PRY SCH",
		Accredited_Voters: 123,
		Registered_Voters: 224,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/020/020-1677400256.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-021",
		"PU-Name": "OPEN SPACE AHUNSOJEUN ANIFOWOSE",
		Accredited_Voters: 286,
		Registered_Voters: 555,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/021/021-1677391800.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-028",
		"PU-Name": "OPEN SPACE ALFA MAKANJUDURO",
		Accredited_Voters: 261,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156004/156004-1677502852.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-034",
		"PU-Name": "ILORIN WEST L.G.E.A SCHOOL OSHIN AREMU",
		Accredited_Voters: 222,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156010/156010-1677589524.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-035",
		"PU-Name": "OPEN SPACE OME-ASEWA BLOCK INDUSTRY",
		Accredited_Voters: 107,
		Registered_Voters: 209,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156011/156011-1677584463.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-036",
		"PU-Name":
			"ITA ALAMU II OPPOSITE YEBMOT OIL (IN FRONT OF SHOPPING COMPLEX)",
		Accredited_Voters: 115,
		Registered_Voters: 346,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156012/156012-1677500383.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-025",
		"PU-Name": "LGEA SCH OLOKONLA",
		Accredited_Voters: 191,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156001/156001-1677517468.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-039",
		"PU-Name": "OPEN SPACE OKUTAGIDI ISLAMIC VILLAGE",
		Accredited_Voters: 290,
		Registered_Voters: 623,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156015/156015-1677585825.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-018",
		"PU-Name": "OPEN SPACE OLOGBIN/OGELE",
		Accredited_Voters: 197,
		Registered_Voters: 595,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651206/result_69616_1677555700_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-034",
		"PU-Name": "OPEN SPACE AGBO OBAMU",
		Accredited_Voters: 251,
		Registered_Voters: 638,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651207/result_69632_1677557394_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-043",
		"PU-Name": "ODE BABA KINI",
		Accredited_Voters: 173,
		Registered_Voters: 243,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155843/155843-1677578018.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-044",
		"PU-Name": "ODE ILE BABA ELESIN",
		Accredited_Voters: 40,
		Registered_Voters: 68,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155844/155844-1677594505.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-047",
		"PU-Name": "OPEN SPACE BEHIND EJA-OKO COMPOUND",
		Accredited_Voters: 89,
		Registered_Voters: 118,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/02/pu/047/047-1677425085.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-050",
		"PU-Name": "ODE ONIGUGURU II",
		Accredited_Voters: 112,
		Registered_Voters: 147,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155850/155850-1677571811.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-060",
		"PU-Name": "LGEA PRY SCH ABATA BABA OYO I",
		Accredited_Voters: 45,
		Registered_Voters: 84,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155860/155860-1677593160.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-061",
		"PU-Name": "ODE-ONISONA",
		Accredited_Voters: 72,
		Registered_Voters: 132,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155861/155861-1677579131.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-063",
		"PU-Name": "ODE-ELEJA",
		Accredited_Voters: 171,
		Registered_Voters: 489,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155863/155863-1677596012.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-058",
		"PU-Name": "OPEN SPACE ODE ONIKAUN",
		Accredited_Voters: 58,
		Registered_Voters: 83,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/02/pu/058/058-1677422438.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-014",
		"PU-Name": "ODE AGOYI (YIDI ROAD)",
		Accredited_Voters: 53,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/014/014-1677410728.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-017",
		"PU-Name": "ECWA L.G.E.A IV",
		Accredited_Voters: 148,
		Registered_Voters: 432,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651218/result_69748_1677575862_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-019",
		"PU-Name": "ORI ITA OJA IYA OPEN SPACE",
		Accredited_Voters: 198,
		Registered_Voters: 532,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651219/result_69750_1677576396_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-021",
		"PU-Name": "ODE ILE ALAGBON",
		Accredited_Voters: 26,
		Registered_Voters: 46,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651221/result_69752_1677577001_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-052",
		"PU-Name": "ODE OGELE",
		Accredited_Voters: 112,
		Registered_Voters: 180,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155905/155905-1677514836.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-050",
		"PU-Name": "ALANAMU BASIC HEALTH CENTER",
		Accredited_Voters: 23,
		Registered_Voters: 45,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155903/155903-1677495447.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-053",
		"PU-Name": "SHUBAN JUNIOR SECH SCH I",
		Accredited_Voters: 158,
		Registered_Voters: 482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155906/155906-1677514824.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-018",
		"PU-Name": "ODE ALASALUTA JIMBA GEGELE",
		Accredited_Voters: 61,
		Registered_Voters: 88,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155921/155921-1677516849.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-020",
		"PU-Name": "ODE BALOGUN SANI OKIN",
		Accredited_Voters: 78,
		Registered_Voters: 114,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155923/155923-1677520256.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OGIDI",
		"PU-Code": "23-08-08-014",
		"PU-Name": "OPEN SPACE ODE ALAAYA",
		Accredited_Voters: 138,
		Registered_Voters: 185,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23187/pu/155945/155945-1677478035.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-037",
		"PU-Name": "OPEN SPACE OLUGBIN",
		Accredited_Voters: 56,
		Registered_Voters: 79,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155953/155953-1677492944.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-040",
		"PU-Name": "OPEN SPACE AYILARA PLAY GROUND",
		Accredited_Voters: 63,
		Registered_Voters: 105,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677438779-155956.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-042",
		"PU-Name": "ODE AKUJI",
		Accredited_Voters: 70,
		Registered_Voters: 91,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155958/155958-1677603277.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OJUEKUN/ZARUMI",
		"PU-Code": "23-08-09-047",
		"PU-Name": "OPEN SPACE GBON GBON",
		Accredited_Voters: 61,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23188/pu/155963/155963-1677581044.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-029",
		"PU-Name": "OPEN SPACE BESIDE TIPPER GARAGE",
		Accredited_Voters: 138,
		Registered_Voters: 464,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155967/155967-1677589506.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-048",
		"PU-Name": "GAA ODOTA LGEA PRY SCHOOL",
		Accredited_Voters: 293,
		Registered_Voters: 712,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155986/155986-1677593286.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-046",
		"PU-Name": "OPEN SPACE OYE BLOCKS AIYEGBAMI",
		Accredited_Voters: 88,
		Registered_Voters: 146,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155984/155984-1677592844.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-016",
		"PU-Name": "MOUNT CAMEL COLLEGE IV",
		Accredited_Voters: 173,
		Registered_Voters: 606,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651237/result_69873_1677606847_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-017",
		"PU-Name": "MOUNT CAMEL COLLEGE V",
		Accredited_Voters: 124,
		Registered_Voters: 393,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651238/result_69874_1677606898_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-018",
		"PU-Name": "ODE POPOOLA",
		Accredited_Voters: 192,
		Registered_Voters: 428,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651239/result_69875_1677606957_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-011",
		"PU-Name": "OPEN SPACE ALUBARIKA ZONE G",
		Accredited_Voters: 22,
		Registered_Voters: 38,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/011/011-1677374177.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-018",
		"PU-Name": "JAMAT IBADUR RAHMAN PRY SCH",
		Accredited_Voters: 230,
		Registered_Voters: 655,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/018/018-1677378211.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-026",
		"PU-Name": "OPEN SPACE ILE MOGAJI GALADIMA",
		Accredited_Voters: 71,
		Registered_Voters: 124,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156002/156002-1677583503.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-033",
		"PU-Name": "OPEN SPACE IDI OGEDE",
		Accredited_Voters: 87,
		Registered_Voters: 163,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156009/156009-1677502458.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-038",
		"PU-Name": "OPEN SPACE ILE IDI-AGBON",
		Accredited_Voters: 195,
		Registered_Voters: 350,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156014/156014-1677504267.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-017",
		"PU-Name": "NEAR BARIKE WATER TANK, OPEN SPACE",
		Accredited_Voters: 78,
		Registered_Voters: 145,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156016/156016-1677470809.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-018",
		"PU-Name": "BODOJO, NEAR IDOFIN BUS STOP",
		Accredited_Voters: 83,
		Registered_Voters: 149,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156017/156017-1677471173.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-019",
		"PU-Name": "BODOJO, NEAR IDOFIN BUS STOP",
		Accredited_Voters: 83,
		Registered_Voters: 149,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156017/156017-1677471173.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-020",
		"PU-Name": "KARA MKT OPEN SPACE, AJASE IPO",
		Accredited_Voters: 65,
		Registered_Voters: 119,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156019/156019-1677471979.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-021",
		"PU-Name": "COMPREHENSIVE HIGH SCH, AJASE IPO",
		Accredited_Voters: 189,
		Registered_Voters: 307,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156020/156020-1677472307.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-022",
		"PU-Name": "AMBERI OBATE MKT OPEN SPACE",
		Accredited_Voters: 289,
		Registered_Voters: 461,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156021/156021-1677472646.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "AJASE IPO 1",
		"PU-Code": "23-09-01-023",
		"PU-Name": "IGBORO MKT, BUHARI",
		Accredited_Voters: 81,
		Registered_Voters: 155,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23192/pu/156022/156022-1677472993.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ESIE/IJAN",
		"PU-Code": "23-09-04-009",
		"PU-Name": "OKE-ILEGUN, NEAR BOREHOLE, OPEN SPACE",
		Accredited_Voters: 265,
		Registered_Voters: 724,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/09/ward/04/pu/009/009-1677387332.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 1 (ARAN)",
		"PU-Code": "23-09-06-012",
		"PU-Name": "ST. PAUL SCH. II",
		Accredited_Voters: 210,
		Registered_Voters: 523,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23197/pu/156024/156024-1677680412.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-014",
		"PU-Name": "S.D.A. IMULEKERE II",
		Accredited_Voters: 41,
		Registered_Voters: 106,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/156030/156030-1677491459.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-015",
		"PU-Name": "S.D.A. IMULEKERE III",
		Accredited_Voters: 148,
		Registered_Voters: 585,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/156031/156031-1677490056.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-016",
		"PU-Name": "APERAN COMPREHENSIVE COLLEGE OMU-ARAN",
		Accredited_Voters: 241,
		Registered_Voters: 558,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/156032/156032-1677741694.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 111 (IFAJA)",
		"PU-Code": "23-09-08-017",
		"PU-Name": "ANSARUL ISLAM SCH. OMU-ARAN",
		Accredited_Voters: 157,
		Registered_Voters: 471,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23199/pu/156033/156033-1677490644.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-014",
		"PU-Name": "OKE-IROKO, OPEN SPACE, ORO",
		Accredited_Voters: 17,
		Registered_Voters: 28,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/156035/156035-1677765644.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-016",
		"PU-Name": "LAKELE SQUARE, ORO",
		Accredited_Voters: 84,
		Registered_Voters: 128,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/156037/156037-1677765106.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-017",
		"PU-Name": "BINUKUNO MULTIPURPOSE HOUSE, ORO",
		Accredited_Voters: 12,
		Registered_Voters: 26,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/156038/156038-1677674700.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-018",
		"PU-Name": "JAMA'AT NASRIL ISLAM SCH. OKEOLA, ORO",
		Accredited_Voters: 191,
		Registered_Voters: 535,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/156039/156039-1677766881.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "ORO 11",
		"PU-Code": "23-09-10-019",
		"PU-Name": "NUT MULTI-PURPOSE HOUSE OKEOLA, ORO",
		Accredited_Voters: 198,
		Registered_Voters: 505,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23201/pu/156040/156040-1677764759.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ALLA",
		"PU-Code": "23-10-01-005",
		"PU-Name": "PRIMARY HEALTH CENTRE ALLA",
		Accredited_Voters: 97,
		Registered_Voters: 220,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651265/result_70225_1677523647_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "EDIDI",
		"PU-Code": "23-10-02-005",
		"PU-Name": "MUSLIM COMMUNITY LGEA SCHOOL",
		Accredited_Voters: 57,
		Registered_Voters: 155,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651266/result_70230_1677702061_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 1",
		"PU-Code": "23-10-03-008",
		"PU-Name": "LGEA SCH KAJOLA",
		Accredited_Voters: 28,
		Registered_Voters: 37,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23205/pu/156043/156043-1677750492.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "ISANLU 11",
		"PU-Code": "23-10-04-009",
		"PU-Name": "POST OFFICE ISANLU-ISIN",
		Accredited_Voters: 41,
		Registered_Voters: 68,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651269/result_70247_1677654838_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-008",
		"PU-Name": "ALL SAINTS LGEA SCH II",
		Accredited_Voters: 57,
		Registered_Voters: 128,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/156048/156048-1677577258.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-009",
		"PU-Name": "MUSLIM COMMUNITY LGEA SCHOOL",
		Accredited_Voters: 206,
		Registered_Voters: 503,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/156049/156049-1677577676.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OWU ISIN",
		"PU-Code": "23-10-07-009",
		"PU-Name": "MODEL PRIMARY HEALTH CENTRE OWU-ISIN",
		Accredited_Voters: 130,
		Registered_Voters: 259,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651274/result_70271_1677659799_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "SABAJA/PAMO",
		"PU-Code": "23-10-09-004",
		"PU-Name": "HEALTH CENTRE PAMO",
		Accredited_Voters: 131,
		Registered_Voters: 600,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651275/result_70284_1677753220_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "SABAJA/PAMO",
		"PU-Code": "23-10-09-005",
		"PU-Name": "TOWN HALL OBA-ISIN",
		Accredited_Voters: 53,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651276/result_70285_1677752841_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-005",
		"PU-Name": "ADOGWU KLGEA",
		Accredited_Voters: 115,
		Registered_Voters: 171,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156053/156053-1677524516.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-007",
		"PU-Name": "KARA MARKET",
		Accredited_Voters: 216,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156055/156055-1677524978.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-008",
		"PU-Name": "DAWANGA OPEN SPACE",
		Accredited_Voters: 42,
		Registered_Voters: 49,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156056/156056-1677525265.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-009",
		"PU-Name": "MASAMA KLGEA",
		Accredited_Voters: 203,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156057/156057-1677525477.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-010",
		"PU-Name": "MAJE MARKET CENTRE",
		Accredited_Voters: 212,
		Registered_Voters: 385,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156058/156058-1677525731.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-011",
		"PU-Name": "GIRL CHANGI OPEN SPACE",
		Accredited_Voters: 78,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156059/156059-1677525936.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-012",
		"PU-Name": "TUNGAN RICHI",
		Accredited_Voters: 110,
		Registered_Voters: 182,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156060/156060-1677526151.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "ADENA",
		"PU-Code": "23-11-01-013",
		"PU-Name": "LOKO MOSHE KLGEA",
		Accredited_Voters: 167,
		Registered_Voters: 302,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23214/pu/156061/156061-1677526338.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-009",
		"PU-Name": "SHEIKH BABA KLGEA",
		Accredited_Voters: 58,
		Registered_Voters: 129,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156062/156062-1677504660.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-010",
		"PU-Name": "AGERI KLGEA",
		Accredited_Voters: 78,
		Registered_Voters: 101,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156063/156063-1677477737.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-011",
		"PU-Name": "BANI GOVT SEC SCH",
		Accredited_Voters: 212,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156064/156064-1677455254.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-012",
		"PU-Name": "BADDE OPEN SPACE",
		Accredited_Voters: 209,
		Registered_Voters: 450,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156065/156065-1677502574.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-013",
		"PU-Name": "ZANGO NEW MARKET",
		Accredited_Voters: 141,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156066/156066-1677483747.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-014",
		"PU-Name": "TOHLABICHI OPEN SPACE",
		Accredited_Voters: 100,
		Registered_Voters: 201,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156067/156067-1677452219.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-015",
		"PU-Name": "BABA ILORI OPEN SPACE",
		Accredited_Voters: 80,
		Registered_Voters: 127,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156068/156068-1677513908.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-016",
		"PU-Name": "TUNGA JULLI KLGEA",
		Accredited_Voters: 202,
		Registered_Voters: 361,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156069/156069-1677499708.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-017",
		"PU-Name": "KANGO OWEDE KLGEA",
		Accredited_Voters: 102,
		Registered_Voters: 202,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156070/156070-1677499096.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-018",
		"PU-Name": "ALAGI OPEN SPACE",
		Accredited_Voters: 74,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156071/156071-1677500893.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-019",
		"PU-Name": "RIGI OYI OPEN SPACE",
		Accredited_Voters: 113,
		Registered_Voters: 181,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156072/156072-1677481924.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "BANI",
		"PU-Code": "23-11-02-020",
		"PU-Name": "LABELABE KLGEA",
		Accredited_Voters: 129,
		Registered_Voters: 190,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23215/pu/156073/156073-1677500962.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-008",
		"PU-Name": "NOMADIC SCH FUDUNGA",
		Accredited_Voters: 200,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156074/156074-1677473626.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-009",
		"PU-Name": "DEGZI KLGEA",
		Accredited_Voters: 159,
		Registered_Voters: 373,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156075/156075-1677473225.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-010",
		"PU-Name": "KORO FONNI OPEN SPACE",
		Accredited_Voters: 251,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156076/156076-1677472378.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-011",
		"PU-Name": "TUNGA ALH OKE OPEN SPACE",
		Accredited_Voters: 221,
		Registered_Voters: 515,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156077/156077-1677476642.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-012",
		"PU-Name": "VENRA CENTRAL MARKET",
		Accredited_Voters: 319,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156078/156078-1677477061.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-013",
		"PU-Name": "GBENKUWA OPEN SPACE",
		Accredited_Voters: 67,
		Registered_Voters: 106,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156079/156079-1677477478.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-014",
		"PU-Name": "DONGON RUWA OPEN SPACE",
		Accredited_Voters: 115,
		Registered_Voters: 516,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156080/156080-1677478044.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-015",
		"PU-Name": "WORO MARKET CENTER",
		Accredited_Voters: 228,
		Registered_Voters: 534,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156081/156081-1677478369.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 1",
		"PU-Code": "23-11-03-016",
		"PU-Name": "WORUMA KOTO KLGEA",
		Accredited_Voters: 214,
		Registered_Voters: 343,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23216/pu/156082/156082-1677478847.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-007",
		"PU-Name": "ZEKANA LGEA",
		Accredited_Voters: 74,
		Registered_Voters: 266,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/007/007-1677360958.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-008",
		"PU-Name": "ZEKANA OPEN SPACE",
		Accredited_Voters: 95,
		Registered_Voters: 264,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/008/008-1677362921.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-009",
		"PU-Name": "TUNGA ABOKI MARKET",
		Accredited_Voters: 245,
		Registered_Voters: 569,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/009/009-1677361566.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-010",
		"PU-Name": "SABO OPEN SPACE",
		Accredited_Voters: 184,
		Registered_Voters: 428,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/010/010-1677360159.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-011",
		"PU-Name": "LONDON KLGEA",
		Accredited_Voters: 272,
		Registered_Voters: 482,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/011/011-1677366277.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWANABE 11",
		"PU-Code": "23-11-04-012",
		"PU-Name": "GURE PANJI OPEN SPACE",
		Accredited_Voters: 228,
		Registered_Voters: 663,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/04/pu/012/012-1677368891.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-007",
		"PU-Name": "GWARIA CENTRAL MARKET",
		Accredited_Voters: 261,
		Registered_Voters: 951,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156089/156089-1677506841.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-008",
		"PU-Name": "GANDA WAGU OPEN SPACE",
		Accredited_Voters: 34,
		Registered_Voters: 204,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156090/156090-1677507564.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-009",
		"PU-Name": "NASARAWA KLGEA",
		Accredited_Voters: 200,
		Registered_Voters: 409,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156091/156091-1677510726.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-010",
		"PU-Name": "TESSI AGEDA OPEN SPACE",
		Accredited_Voters: 0,
		Registered_Voters: 68,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156092/156092-1677511255.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-011",
		"PU-Name": "TESE GADA KLGEA",
		Accredited_Voters: 262,
		Registered_Voters: 560,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156093/156093-1677511629.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-012",
		"PU-Name": "GAAGA OPEN SPACE",
		Accredited_Voters: 50,
		Registered_Voters: 206,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156094/156094-1677511982.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-013",
		"PU-Name": "VOBERA KLGEA",
		Accredited_Voters: 319,
		Registered_Voters: 660,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156095/156095-1677512391.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-014",
		"PU-Name": "TESSI AGBEDE KLGEA",
		Accredited_Voters: 50,
		Registered_Voters: 658,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156096/156096-1677512895.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "GWARI A (GWARIA)",
		"PU-Code": "23-11-05-015",
		"PU-Name": "SOLADE KLGEA",
		Accredited_Voters: 124,
		Registered_Voters: 306,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23218/pu/156097/156097-1677513146.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-005",
		"PU-Name": "GBABASAWA OPEN SPACE",
		Accredited_Voters: 142,
		Registered_Voters: 268,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23219/pu/156098/156098-1677497749.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-006",
		"PU-Name": "MORA TASUDE SEC SCH",
		Accredited_Voters: 235,
		Registered_Voters: 525,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23219/pu/156099/156099-1677498915.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 1",
		"PU-Code": "23-11-06-007",
		"PU-Name": "SERIKIN NOMA OPEN SPACE",
		Accredited_Voters: 310,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/06/pu/007/007-1677390289.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-007",
		"PU-Name": "BACHA OPEN SPACE",
		Accredited_Voters: 243,
		Registered_Voters: 566,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156101/156101-1677591067.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-008",
		"PU-Name": "TUNDA WADA OPEN SPACE",
		Accredited_Voters: 257,
		Registered_Voters: 694,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156102/156102-1677591262.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-009",
		"PU-Name": "ISLAMIYYAH KLGEA",
		Accredited_Voters: 82,
		Registered_Voters: 133,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156103/156103-1677590617.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-010",
		"PU-Name": "MEGIRO SUPREME SCPEC SCH",
		Accredited_Voters: 257,
		Registered_Voters: 630,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156104/156104-1677590857.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-011",
		"PU-Name": "SABO EEC V0CATIONAL I",
		Accredited_Voters: 241,
		Registered_Voters: 560,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156105/156105-1677589984.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-012",
		"PU-Name": "ALIMAJIRI KLGEA",
		Accredited_Voters: 243,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156106/156106-1677591606.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 11",
		"PU-Code": "23-11-07-013",
		"PU-Name": "SABO EEC V0CATIONAL II",
		Accredited_Voters: 52,
		Registered_Voters: 102,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23220/pu/156107/156107-1677575762.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-005",
		"PU-Name": "WALI OPEN SPACE",
		Accredited_Voters: 183,
		Registered_Voters: 429,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/005/005-1677390293.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-006",
		"PU-Name": "BAASIA OPEN SPACE",
		Accredited_Voters: 262,
		Registered_Voters: 703,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/006/006-1677389539.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-007",
		"PU-Name": "SERIKI SAMARI OPEN SPACE",
		Accredited_Voters: 145,
		Registered_Voters: 427,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/007/007-1677394603.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KAIAMA 111",
		"PU-Code": "23-11-08-008",
		"PU-Name": "YARELEA OPEN SPACE",
		Accredited_Voters: 147,
		Registered_Voters: 289,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/08/pu/008/008-1677398483.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KEMANJI",
		"PU-Code": "23-11-09-005",
		"PU-Name": "TUNGA SABARUMA OPEN SPACE",
		Accredited_Voters: 278,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23222/pu/156112/156112-1677602811.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "KEMANJI",
		"PU-Code": "23-11-09-006",
		"PU-Name": "TUNGA GARUWA CENTRAL MRKT",
		Accredited_Voters: 276,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3602/ward/23222/pu/156113/156113-1677602986.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-008",
		"PU-Name": "SHIRI GWARIA MARKET CENTER",
		Accredited_Voters: 252,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/008/008-1677391524.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-009",
		"PU-Name": "WUZIBE OPEN SPACE",
		Accredited_Voters: 255,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/009/009-1677391936.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-010",
		"PU-Name": "DAZI OPEN SPACE",
		Accredited_Voters: 100,
		Registered_Voters: 297,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/010/010-1677392540.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-011",
		"PU-Name": "MAKE WIZII OPEN SPACE",
		Accredited_Voters: 120,
		Registered_Voters: 193,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/011/011-1677387505.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-012",
		"PU-Name": "KARO KLGEA",
		Accredited_Voters: 180,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/012/012-1677393069.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-013",
		"PU-Name": "SABONGARI OPEN SPACE",
		Accredited_Voters: 35,
		Registered_Voters: 481,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/013/013-1677393594.pdf",
	},
	{
		State: "KWARA",
		LGA: "KAIAMA",
		Ward: "WAJIBE",
		"PU-Code": "23-11-10-014",
		"PU-Name": "NANU OPEN SPACE",
		Accredited_Voters: 84,
		Registered_Voters: 481,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/11/ward/10/pu/014/014-1677394392.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-006",
		"PU-Name": "SENIOR SECONDARY SCHOOL ABATI /TEPATAN",
		Accredited_Voters: 60,
		Registered_Voters: 126,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/006/006-1677374546.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-007",
		"PU-Name": "OPEN SPACE AMADI",
		Accredited_Voters: 86,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/007/007-1677373232.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-008",
		"PU-Name": "OPEN SPACE OYUN",
		Accredited_Voters: 160,
		Registered_Voters: 644,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/008/008-1677373889.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "ABATI/ALARA",
		"PU-Code": "23-12-11-009",
		"PU-Name": "HEALTH CENTER ELEKOYANGAN",
		Accredited_Voters: 181,
		Registered_Voters: 715,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/11/pu/009/009-1677393124.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "AROBADI",
		"PU-Code": "23-12-17-006",
		"PU-Name": "OPEN SPACE ALATEKO",
		Accredited_Voters: 209,
		Registered_Voters: 525,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/17/pu/006/006-1677370890.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-006",
		"PU-Name": "OPEN SPACE AL-AMEEN",
		Accredited_Voters: 39,
		Registered_Voters: 137,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/006/006-1677367644.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-007",
		"PU-Name": "OPEN SPACE MARKET CENTRE",
		Accredited_Voters: 24,
		Registered_Voters: 61,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/156131-1677856085.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-008",
		"PU-Name": "LGEA SCHOOL JIHAD",
		Accredited_Voters: 198,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/008/008-1677368315.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-009",
		"PU-Name": "DIVINE FAVOUR OPEN SPACE",
		Accredited_Voters: 177,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/009/009-1677369142.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-010",
		"PU-Name": "OPEN SPACE OLORUNSHOGO",
		Accredited_Voters: 12,
		Registered_Voters: 72,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/010/010-1677380610.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-011",
		"PU-Name": "LGEA SCH. OGUNBO",
		Accredited_Voters: 93,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/011/011-1677394768.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-012",
		"PU-Name": "OPEN SPACE FALLAH OJA",
		Accredited_Voters: 63,
		Registered_Voters: 593,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23225/pu/156136/156136-1677620043.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "BODE-SAADU",
		"PU-Code": "23-12-02-013",
		"PU-Name": "OPEN SPACE BUKA/TAPA OLOGORO",
		Accredited_Voters: 39,
		Registered_Voters: 91,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/02/pu/013/013-1677368725.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "EJIDONGARI",
		"PU-Code": "23-12-05-005",
		"PU-Name": "OPEN SPACE KANGODABE",
		Accredited_Voters: 85,
		Registered_Voters: 117,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/05/pu/005/005-1677365032.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-012",
		"PU-Name": "OPEN SPACE AHO",
		Accredited_Voters: 158,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/012/012-1677369777.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-013",
		"PU-Name": "OPEN SPACE OKE YARO",
		Accredited_Voters: 216,
		Registered_Voters: 619,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/013/013-1677368764.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-014",
		"PU-Name": "OPEN SPACE IPATA",
		Accredited_Voters: 248,
		Registered_Voters: 673,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/014/014-1677367997.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-015",
		"PU-Name": "OPEN SPACE COLONY MODEL SCHOOL",
		Accredited_Voters: 40,
		Registered_Voters: 67,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/015/015-1677376220.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-016",
		"PU-Name": "OPEN SPACE ILE PUPA",
		Accredited_Voters: 56,
		Registered_Voters: 84,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/016/016-1677366980.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-017",
		"PU-Name": "OPEN SPACE SURULERE",
		Accredited_Voters: 217,
		Registered_Voters: 596,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/017/017-1677376339.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-018",
		"PU-Name": "OPEN SPACE EGBERIOMO",
		Accredited_Voters: 118,
		Registered_Voters: 529,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/018/018-1677372121.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-019",
		"PU-Name": "OPEN SPACE OWOLABI",
		Accredited_Voters: 96,
		Registered_Voters: 345,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/019/019-1677369916.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "JEBBA",
		"PU-Code": "23-12-01-020",
		"PU-Name": "OPEN SPACE OLOHUNLANA",
		Accredited_Voters: 43,
		Registered_Voters: 61,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/01/pu/020/020-1677371055.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-007",
		"PU-Name": "LGEA SCHOOL BUDO AYAN",
		Accredited_Voters: 189,
		Registered_Voters: 518,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/007/007-1677392084.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "LANWA",
		"PU-Code": "23-12-04-008",
		"PU-Name": "LGEA SCHOOL ELEJA ZULU",
		Accredited_Voters: 124,
		Registered_Voters: 182,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/04/pu/008/008-1677371073.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MALETE/GBUGUDU",
		"PU-Code": "23-12-14-005",
		"PU-Name": "OPEN SPACE MALETE",
		Accredited_Voters: 206,
		Registered_Voters: 544,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/14/pu/005/005-1677369865.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-007",
		"PU-Name": "LGEA SCHOOL GBOROKO",
		Accredited_Voters: 72,
		Registered_Voters: 91,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/007/007-1677392323.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-008",
		"PU-Name": "LGEA SCHOOL GIWA OLOWO",
		Accredited_Voters: 52,
		Registered_Voters: 96,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3603/ward/23239/pu/156164/156164-1677766318.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "MEGIDA",
		"PU-Code": "23-12-16-009",
		"PU-Name": "HEALTH CENTRE DAGI",
		Accredited_Voters: 14,
		Registered_Voters: 22,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/16/pu/009/009-1677403549.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-007",
		"PU-Name": "OPEN SPACE GBANGBALAKO/BUDO OBA",
		Accredited_Voters: 164,
		Registered_Voters: 214,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/007/007-1677372818.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-008",
		"PU-Name": "LGEA JOKOLU",
		Accredited_Voters: 199,
		Registered_Voters: 253,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/008/008-1677376536.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OKUTALA",
		"PU-Code": "23-12-06-009",
		"PU-Name": "OPEN SPACE OGUNBO",
		Accredited_Voters: 87,
		Registered_Voters: 159,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/06/pu/009/009-1677374969.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-006",
		"PU-Name": "LGEA SCHOOL ADAMA",
		Accredited_Voters: 231,
		Registered_Voters: 583,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/006/006-1677366068.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "OLORU",
		"PU-Code": "23-12-08-007",
		"PU-Name": "L.G.E.A. SCH OLORU II",
		Accredited_Voters: 177,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/08/pu/007/007-1677365941.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-008",
		"PU-Name": "OPEN SPACE DOGO AVENUE",
		Accredited_Voters: 31,
		Registered_Voters: 43,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/008/008-1677379363.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-009",
		"PU-Name": "OPEN SPACE OGIDIRI",
		Accredited_Voters: 181,
		Registered_Voters: 585,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/009/009-1677377430.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-010",
		"PU-Name": "OPEN SPACE ALAPATA",
		Accredited_Voters: 32,
		Registered_Voters: 51,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/010/010-1677370353.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-012",
		"PU-Name": "OPEN SPACE OBARISA",
		Accredited_Voters: 39,
		Registered_Voters: 78,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/012/012-1677376245.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-013",
		"PU-Name": "OPEN SPACE SININGA",
		Accredited_Voters: 155,
		Registered_Voters: 382,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/013/013-1677391421.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-014",
		"PU-Name": "OPEN SPACE ISALE ARE",
		Accredited_Voters: 192,
		Registered_Voters: 689,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/014/014-1677388445.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-015",
		"PU-Name": "OPEN SPACE YELU AREA",
		Accredited_Voters: 232,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/015/015-1677389183.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "SHAO",
		"PU-Code": "23-12-12-016",
		"PU-Name": "OPEN SPACE NEF AREA",
		Accredited_Voters: 39,
		Registered_Voters: 74,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/12/pu/016/016-1677379265.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-007",
		"PU-Name": "OPEN SPACE OGUN-IKAN",
		Accredited_Voters: 49,
		Registered_Voters: 62,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/007/007-1677367504.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-008",
		"PU-Name": "OPEN SPACE IKUSANU",
		Accredited_Voters: 239,
		Registered_Voters: 722,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/008/008-1677370128.pdf",
	},
	{
		State: "KWARA",
		LGA: "MORO",
		Ward: "WOMI/AYAKI",
		"PU-Code": "23-12-10-009",
		"PU-Name": "OPEN SPACE ORE",
		Accredited_Voters: 105,
		Registered_Voters: 136,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/12/ward/10/pu/009/009-1677369183.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-011",
		"PU-Name": "ST. JAMES LGEA SCHOOL",
		Accredited_Voters: 106,
		Registered_Voters: 304,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/011/011-1677371931.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-013",
		"PU-Name": "OPEN SPACE AROMASODUN",
		Accredited_Voters: 8,
		Registered_Voters: 17,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23241/pu/156170/156170-1677513374.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-015",
		"PU-Name": "OPEN SPACE A.U.D II",
		Accredited_Voters: 16,
		Registered_Voters: 36,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/015/015-1677376141.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-016",
		"PU-Name": "IYERU-OKIN LGEA SCHOOL 1B",
		Accredited_Voters: 70,
		Registered_Voters: 378,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/016/016-1677396052.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-017",
		"PU-Name": "IYERU-OKIN LGEA SCHOOL 1C",
		Accredited_Voters: 85,
		Registered_Voters: 352,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/017/017-1677395084.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "BALOGUN",
		"PU-Code": "23-13-01-018",
		"PU-Name": "OPEN SPACE AKINGBESA AREA II",
		Accredited_Voters: 132,
		Registered_Voters: 443,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/01/pu/018/018-1677373789.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-007",
		"PU-Name": "OPEN SPACE OBADA BOYE AREA II",
		Accredited_Voters: 139,
		Registered_Voters: 365,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/007/007-1677361828.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-008",
		"PU-Name": "OPEN SPACE AKINLOFI AREA II",
		Accredited_Voters: 12,
		Registered_Voters: 25,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/008/008-1677401477.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - A",
		"PU-Code": "23-13-05-010",
		"PU-Name": "OPEN SPACE IGBORO HEALTH CENTRE II",
		Accredited_Voters: 49,
		Registered_Voters: 88,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/05/pu/010/010-1677398103.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-006",
		"PU-Name": "OGIDIRI PRIMARY SCHOOL",
		Accredited_Voters: 193,
		Registered_Voters: 512,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 97,
		Lp: "",
		PDP: 53,
		SDP: 3,
		NNPP: 1,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651404/result_70650_1677704913_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-007",
		"PU-Name": "OPEN SPACE DE-CROWN",
		Accredited_Voters: 149,
		Registered_Voters: 447,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 61,
		Lp: 1,
		PDP: 74,
		SDP: 8,
		NNPP: 1,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651405/result_70651_1677706226_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-008",
		"PU-Name": "OPEN SPACE OLOYA-BANLEKU AREA II",
		Accredited_Voters: 14,
		Registered_Voters: 20,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 5,
		Lp: "",
		PDP: 9,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651406/result_70652_1677705431_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-009",
		"PU-Name": "OPEN SPACE SAJIKU AREA II",
		Accredited_Voters: 11,
		Registered_Voters: 21,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651407/result_70653_1677705672_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - B",
		"PU-Code": "23-13-06-010",
		"PU-Name": "OPEN SPACE ESSA SQUARE II",
		Accredited_Voters: 114,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 68,
		Lp: "",
		PDP: 40,
		SDP: 1,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651408/result_70654_1677705816_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-008",
		"PU-Name": "OPEN SPACE ODIWO AREA II",
		Accredited_Voters: 24,
		Registered_Voters: 57,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 12,
		Lp: "",
		PDP: 10,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651410/result_70663_1677660594_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-009",
		"PU-Name": "OPEN SPACE IDI-OGUN SAW MILL II",
		Accredited_Voters: 6,
		Registered_Voters: 22,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 2,
		Lp: 1,
		PDP: 3,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651411/result_70664_1677657181_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-011",
		"PU-Name": "BAPTIST LGEA ITAFA II",
		Accredited_Voters: 155,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 88,
		Lp: "",
		PDP: 38,
		SDP: 10,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651413/result_70666_1677659212_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-012",
		"PU-Name": "OPEN SPACE EBO EKU IKALE",
		Accredited_Voters: 40,
		Registered_Voters: 81,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 18,
		Lp: "",
		PDP: 18,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651414/result_70667_1677656053_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-013",
		"PU-Name": "NAWARU-DEEN COLLEGE",
		Accredited_Voters: 28,
		Registered_Voters: 81,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 13,
		Lp: "",
		PDP: 8,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651415/result_70668_1677658904_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-014",
		"PU-Name": "OFFA DESCENDANT MULTIPURPOSE HALL",
		Accredited_Voters: 169,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 81,
		Lp: 2,
		PDP: 60,
		SDP: 9,
		NNPP: 1,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651416/result_70669_1677661141_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-015",
		"PU-Name": "OPEN SPACE ALONG DESCENDANT MULTIPURPOSE HALL",
		Accredited_Voters: 77,
		Registered_Voters: 400,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 46,
		Lp: "",
		PDP: 16,
		SDP: 2,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651417/result_70670_1677656718_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-016",
		"PU-Name": "VIEWING CENTRE",
		Accredited_Voters: 58,
		Registered_Voters: 359,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 28,
		Lp: 1,
		PDP: 15,
		SDP: 3,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651418/result_70671_1677678413_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "ESSA - C",
		"PU-Code": "23-13-07-017",
		"PU-Name": "G.D.S.S. OFFA",
		Accredited_Voters: 128,
		Registered_Voters: 288,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 74,
		Lp: "",
		PDP: 35,
		SDP: 6,
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651419/result_70672_1677657058_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-007",
		"PU-Name": "OPEN SPACE BABA ALATA II",
		Accredited_Voters: 24,
		Registered_Voters: 30,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/007/007-1677360953.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-008",
		"PU-Name": "OPEN SPACE EJISUN AREA II",
		Accredited_Voters: 28,
		Registered_Voters: 42,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/008/008-1677360637.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-009",
		"PU-Name": "ST. MARK'S LGEA SCHOOL",
		Accredited_Voters: 166,
		Registered_Voters: 526,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/009/009-1677363336.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-010",
		"PU-Name": "OPEN SPACE ANADOWO II",
		Accredited_Voters: 26,
		Registered_Voters: 38,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/010/010-1677363358.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-011",
		"PU-Name": "OPEN SPACE ALAGURE AREA II",
		Accredited_Voters: 19,
		Registered_Voters: 28,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/011/011-1677364352.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 1",
		"PU-Code": "23-13-09-012",
		"PU-Name": "OPEN SPACE OLA ISALE AREA II",
		Accredited_Voters: 17,
		Registered_Voters: 45,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/09/pu/012/012-1677366158.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-007",
		"PU-Name": "BISHOP SMITH PRIMARY SCHOOL",
		Accredited_Voters: 131,
		Registered_Voters: 437,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651428/result_70712_1677580710_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-008",
		"PU-Name": "OPEN SPACE OLADODO AREA II",
		Accredited_Voters: 84,
		Registered_Voters: 267,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651429/result_70713_1677580849_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-009",
		"PU-Name": "OPEN SPACE ESO PATAKI AREA II",
		Accredited_Voters: 28,
		Registered_Voters: 48,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651430/result_70714_1677581134_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-010",
		"PU-Name": "OPEN SPACE ST. THOMAS LGEA SCHOOL II",
		Accredited_Voters: 125,
		Registered_Voters: 336,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651431/result_70715_1677581302_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  CENTRAL 11",
		"PU-Code": "23-13-10-011",
		"PU-Name": "ST. THOMAS LGEA SCHOOL III",
		Accredited_Voters: 95,
		Registered_Voters: 343,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651432/result_70716_1677581450_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-010",
		"PU-Name": "OPEN SPACE DEEPER LIFE JUNCTION",
		Accredited_Voters: 194,
		Registered_Voters: 634,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651433/result_70682_1677534641_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-011",
		"PU-Name": "OPEN SPACE GRA OFFA IPEE JUNCTION",
		Accredited_Voters: 194,
		Registered_Voters: 616,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651434/result_70683_1677534780_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-012",
		"PU-Name": "OPEN SPACE YIDI JUNCTION OFFA",
		Accredited_Voters: 46,
		Registered_Voters: 100,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651435/result_70684_1677535032_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-013",
		"PU-Name": "AGUN BAPTIST SCHOOL",
		Accredited_Voters: 198,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651436/result_70685_1677535147_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-014",
		"PU-Name": "OPEN SPACE ADELEKE AREA II",
		Accredited_Voters: 238,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651437/result_70686_1677535546_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-016",
		"PU-Name": "GOODNESS COLLEGE",
		Accredited_Voters: 175,
		Registered_Voters: 369,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651438/result_70688_1677535918_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-017",
		"PU-Name": "IYERU-OKIN SECONDARY SCHOOL",
		Accredited_Voters: 116,
		Registered_Voters: 344,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651439/result_70689_1677536081_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-018",
		"PU-Name": "G.S.S, OFFA",
		Accredited_Voters: 20,
		Registered_Voters: 48,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651440/result_70690_1677563724_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-019",
		"PU-Name": "OPEN SPACE OJOKU GARAGE OFFA",
		Accredited_Voters: 219,
		Registered_Voters: 646,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651441/result_70691_1677563999_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-020",
		"PU-Name": "OKIN HIGH SCHOOL OFFA",
		Accredited_Voters: 57,
		Registered_Voters: 120,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651442/result_70692_1677564237_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-021",
		"PU-Name": "OPEN SPACE OWODE MARKET",
		Accredited_Voters: 26,
		Registered_Voters: 56,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651443/result_70693_1677564379_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-011",
		"PU-Name": "WESLEY SCHOOL II",
		Accredited_Voters: 113,
		Registered_Voters: 412,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/011/011-1677413450.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-013",
		"PU-Name": "OPEN SPACE ITA-ERIN AREA II",
		Accredited_Voters: 98,
		Registered_Voters: 336,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/013/013-1677408847.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-014",
		"PU-Name": "OPENSPACE ANIFOWOSHE",
		Accredited_Voters: 148,
		Registered_Voters: 423,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/156250/156250-1677483282.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-015",
		"PU-Name": "OPEN SPACE OGANRAN AREA II",
		Accredited_Voters: 16,
		Registered_Voters: 25,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3604/ward/23251/pu/156251/156251-1677483683.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU  SOUTH EAST",
		"PU-Code": "23-13-11-016",
		"PU-Name": "OPEN SPACE OPELOYERU AREA III",
		Accredited_Voters: 11,
		Registered_Voters: 18,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/11/pu/016/016-1677362220.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-009",
		"PU-Name": "OPEN SPACE OGANLA AREA II",
		Accredited_Voters: 99,
		Registered_Voters: 308,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651452/result_70615_1677538792_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-010",
		"PU-Name": "OPEN SPACE AMBE AREA II",
		Accredited_Voters: 28,
		Registered_Voters: 48,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651453/result_70616_1677575176_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-011",
		"PU-Name": "OPEN SPACE AKOSIN II",
		Accredited_Voters: 17,
		Registered_Voters: 35,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651454/result_70617_1677539161_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-012",
		"PU-Name": "OPEN SPACE OYANISUNWA II",
		Accredited_Voters: 171,
		Registered_Voters: 573,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651455/result_70618_1677539276_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-013",
		"PU-Name": "OPEN SPACE POPO MARKET II",
		Accredited_Voters: 119,
		Registered_Voters: 350,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651456/result_70619_1677539368_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO CENTRAL",
		"PU-Code": "23-13-03-014",
		"PU-Name": "OPEN SPACE IKOLABA II",
		Accredited_Voters: 117,
		Registered_Voters: 328,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651457/result_70620_1677539457_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-008",
		"PU-Name": "OLUGBENSE LGEA SCHOOL",
		Accredited_Voters: 96,
		Registered_Voters: 213,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/008/008-1677393942.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-009",
		"PU-Name": "OPEN SPACE OLUWE II",
		Accredited_Voters: 61,
		Registered_Voters: 98,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/009/009-1677368228.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-010",
		"PU-Name": "OPEN SPACE ILE ELEPA II",
		Accredited_Voters: 29,
		Registered_Voters: 46,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/010/010-1677365722.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-011",
		"PU-Name": "OPEN SPACE IDI-OGUN AREA II",
		Accredited_Voters: 86,
		Registered_Voters: 349,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/011/011-1677398760.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH EAST",
		"PU-Code": "23-13-04-014",
		"PU-Name": "OPEN SPACE OKIN CINEMA II",
		Accredited_Voters: 157,
		Registered_Voters: 508,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/13/ward/04/pu/014/014-1677393488.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-009",
		"PU-Name": "OPEN SPACE ZULIKHATU ISLAMIC CENTRE",
		Accredited_Voters: 111,
		Registered_Voters: 425,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651465/result_70593_1677774205_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-010",
		"PU-Name": "OPEN SPACE COL.TOKI",
		Accredited_Voters: 122,
		Registered_Voters: 427,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651466/result_70594_1677656347_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-011",
		"PU-Name": "OPEN SPACE FIRE SERVICE OFFA",
		Accredited_Voters: 256,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651467/result_70595_1677757438_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-012",
		"PU-Name": "OPEN SPACE NAWARU-DEEN SCHOOL I",
		Accredited_Voters: 220,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651468/result_70596_1677601536_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-013",
		"PU-Name": "OPEN SPACE NAWARU-DEEN SCHOOL II",
		Accredited_Voters: 123,
		Registered_Voters: 657,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 75,
		Lp: 4,
		PDP: 29,
		SDP: 5,
		NNPP: 3,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651469/result_70597_1677774099_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-014",
		"PU-Name": "OPEN SPACE ALESINLOYE",
		Accredited_Voters: 84,
		Registered_Voters: 266,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651470/result_70598_1677709873_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-016",
		"PU-Name": "OPEN SPACE GAA OLOMI FUNFUN",
		Accredited_Voters: 192,
		Registered_Voters: 415,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651472/result_70600_1677656452_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-018",
		"PU-Name": "A.U.D COLLEGE OPEN SPACE",
		Accredited_Voters: 190,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 110,
		Lp: "",
		PDP: 61,
		SDP: 9,
		NNPP: 1,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651474/result_70602_1677709456_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-020",
		"PU-Name": "OPEN SPACE OBANIMOMO",
		Accredited_Voters: 195,
		Registered_Voters: 369,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651476/result_70604_1677683731_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-021",
		"PU-Name": "OPEN SPACE ARO ELEPO AREA",
		Accredited_Voters: 70,
		Registered_Voters: 126,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651477/result_70605_1677678711_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "SHAWO SOUTH WEST",
		"PU-Code": "23-13-02-022",
		"PU-Name": "HEALTH CENTRE KANMONU ALAYIN",
		Accredited_Voters: 11,
		Registered_Voters: 18,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: 9,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651478/result_70606_1677742917_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "AIYEDUN",
		"PU-Code": "23-14-01-008",
		"PU-Name": "PASERE OPEN SPACE",
		Accredited_Voters: 101,
		Registered_Voters: 209,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651479/result_70747_1677772573_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-008",
		"PU-Name": "ILOFFA GRAMMAR SCHOOL",
		Accredited_Voters: 80,
		Registered_Voters: 199,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651480/result_70769_1677755667_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-009",
		"PU-Name": "COTTAGE HOSPITAL ILOFFA",
		Accredited_Voters: 135,
		Registered_Voters: 296,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651481/result_70770_1677755826_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ILOFFA",
		"PU-Code": "23-14-04-010",
		"PU-Name": "MAGISTRATE COURT",
		Accredited_Voters: 148,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651482/result_70771_1677755931_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-006",
		"PU-Name": "COMMUNITY PRY SCHOOL EGOSI ILE",
		Accredited_Voters: 119,
		Registered_Voters: 253,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651483/result_70777_1677705842_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-007",
		"PU-Name": "ABE OBI OPEN SPACE",
		Accredited_Voters: 137,
		Registered_Voters: 256,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651484/result_70778_1677706023_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-008",
		"PU-Name": "JUNIOR SECONDARY SCHOOL EGOSI ILE",
		Accredited_Voters: 119,
		Registered_Voters: 279,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651485/result_70779_1677706190_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMODE/EGOSI",
		"PU-Code": "23-14-05-009",
		"PU-Name": "COMMUNITY PRY SCHOOL IMODE",
		Accredited_Voters: 151,
		Registered_Voters: 296,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651486/result_70780_1677706335_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "IMOJI/ILALE/ERINMOPE",
		"PU-Code": "23-14-03-005",
		"PU-Name": "ILALE COMMUNITY MARKET",
		Accredited_Voters: 214,
		Registered_Voters: 371,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651487/result_70761_1677687447_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-008",
		"PU-Name": "OROTA COMMUNITY HIGH SCHOOL",
		Accredited_Voters: 77,
		Registered_Voters: 167,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651488/result_70807_1677846909_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 1",
		"PU-Code": "23-14-09-009",
		"PU-Name": "IKOTUN ILE OPEN SPACE",
		Accredited_Voters: 51,
		Registered_Voters: 104,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3605/ward/23261/pu/156265/156265-1677691795.pdf",
	},
	{
		State: "KWARA",
		LGA: "OKE - ERO",
		Ward: "ODO-OWA 11",
		"PU-Code": "23-14-10-007",
		"PU-Name": "KAJOLA MARKET",
		Accredited_Voters: 246,
		Registered_Voters: 700,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651491/result_70815_1677714767_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-008",
		"PU-Name": "NOMADIC PRIMARY SCHOOL IYALOJA AREA ERIN-ILE",
		Accredited_Voters: 112,
		Registered_Voters: 207,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/156301/156301-1677459350.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-009",
		"PU-Name": "GENERAL HOSPITAL OPEN SPACE ERIN-ILE",
		Accredited_Voters: 225,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/156302/156302-1677459547.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-010",
		"PU-Name": "ERIN-ILE TOWN HALL",
		Accredited_Voters: 159,
		Registered_Voters: 457,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/156303/156303-1677459810.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-011",
		"PU-Name": "E.S.A LIBRARY ERIN-ILE OPEN SPACE",
		Accredited_Voters: 41,
		Registered_Voters: 89,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/156304/156304-1677460075.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-012",
		"PU-Name": "OHEE/OGINSADO JUNCTION",
		Accredited_Voters: 34,
		Registered_Voters: 82,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23273/pu/156305/156305-1677460290.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE NORTH",
		"PU-Code": "23-15-11-013",
		"PU-Name": "OJOMU KAWU/ASIKAN JUNCTION",
		Accredited_Voters: 31,
		Registered_Voters: 68,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections/1292/1677447165-156306.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-007",
		"PU-Name": "CHRIST COMPREHENSIVE HIGH SCHOOL ERIN-ILE",
		Accredited_Voters: 212,
		Registered_Voters: 675,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23263/pu/156268/156268-1677755572.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-008",
		"PU-Name": "OPEN SPACE SABULA",
		Accredited_Voters: 213,
		Registered_Voters: 711,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/008/008-1677392132.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-009",
		"PU-Name": "DAUDU/ATERE OPEN SPACE",
		Accredited_Voters: 104,
		Registered_Voters: 214,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/009/009-1677392925.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-010",
		"PU-Name": "POPOOLA COLLEGE OKE PATA ERIN-ILE",
		Accredited_Voters: 162,
		Registered_Voters: 331,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/010/010-1677390923.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-011",
		"PU-Name": "ANSARUL-ISLAM PRIMARY SCHOOL ERIN-ILE",
		Accredited_Voters: 84,
		Registered_Voters: 154,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/011/011-1677390971.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ERIN-ILE SOUTH",
		"PU-Code": "23-15-01-012",
		"PU-Name": "ESHA OPEN SPACE",
		Accredited_Voters: 159,
		Registered_Voters: 602,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/01/pu/012/012-1677389320.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IGBONA",
		"PU-Code": "23-15-03-008",
		"PU-Name": "IDI-APA SURULERE OPEN SPACE",
		Accredited_Voters: 80,
		Registered_Voters: 124,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/03/pu/008/008-1677390087.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-007",
		"PU-Name": "OPEN SPACE BUKOYE",
		Accredited_Voters: 176,
		Registered_Voters: 715,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 62,
		Lp: 2,
		PDP: 65,
		SDP: 6,
		NNPP: 8,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651506/result_70885_1677649237_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-008",
		"PU-Name": "BEHIND TADE-FILLING STATION IJAGBO",
		Accredited_Voters: 214,
		Registered_Voters: 701,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/008/008-1677391208.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-009",
		"PU-Name": "OPEN SPACE AJOBIEWE IJAGBO",
		Accredited_Voters: 227,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 82,
		Lp: 2,
		PDP: 99,
		SDP: 1,
		NNPP: 4,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/009/009-1677390946.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-010",
		"PU-Name": "OPEN SPACE ALAYIN",
		Accredited_Voters: 21,
		Registered_Voters: 51,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 10,
		Lp: 1,
		PDP: 5,
		SDP: 1,
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/010/010-1677390457.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-011",
		"PU-Name": "IN FRONT OF COTTAGE HOSPITAL IJAGBO",
		Accredited_Voters: 62,
		Registered_Voters: 132,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 24,
		Lp: "",
		PDP: 14,
		SDP: 4,
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/011/011-1677396028.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-012",
		"PU-Name": "OPEN SPACE ODO-ATAN",
		Accredited_Voters: 152,
		Registered_Voters: 670,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 68,
		Lp: 4,
		PDP: 36,
		SDP: 6,
		NNPP: 6,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/012/012-1677389998.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-013",
		"PU-Name": "ANSARU-DEEN COLLEGE ODO-IFA IJAGBO",
		Accredited_Voters: 50,
		Registered_Voters: 130,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 20,
		Lp: "",
		PDP: 24,
		SDP: 2,
		NNPP: 1,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/013/013-1677389510.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-014",
		"PU-Name": "OPEN SPACE BEHIND TNT RADIO STATION IJAGBO",
		Accredited_Voters: 77,
		Registered_Voters: 334,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 33,
		Lp: 2,
		PDP: 22,
		SDP: 1,
		NNPP: 10,
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651513/result_70892_1677649406_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IKOTUN",
		"PU-Code": "23-15-06-009",
		"PU-Name": "ST MATHEW LGEA SCHOOL IKOTUN",
		Accredited_Voters: 77,
		Registered_Voters: 164,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 47,
		Lp: "",
		PDP: 11,
		SDP: 2,
		NNPP: 10,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/06/pu/009/009-1677389874.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-007",
		"PU-Name": "VOCATIONAL CENTRE OPEN SPACE ILEMONA",
		Accredited_Voters: 165,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/007/007-1677396770.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-008",
		"PU-Name": "COTTAGE HOSPITAL ILEMONA",
		Accredited_Voters: 75,
		Registered_Voters: 129,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/008/008-1677396339.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-009",
		"PU-Name": "OPEN SPACE OLUODE AREA ILEMONA",
		Accredited_Voters: 90,
		Registered_Voters: 271,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/009/009-1677397112.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-010",
		"PU-Name": "BAALE OPEN SPACE BUDO GBADA",
		Accredited_Voters: 152,
		Registered_Voters: 187,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/010/010-1677397495.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "ILEMONA",
		"PU-Code": "23-15-02-011",
		"PU-Name": "OPEN SPACE ALAAYA",
		Accredited_Voters: 147,
		Registered_Voters: 603,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/02/pu/011/011-1677397798.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-008",
		"PU-Name": "OPEN SPACE OKE-AYO",
		Accredited_Voters: 257,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 97,
		Lp: 1,
		PDP: 144,
		SDP: 1,
		NNPP: 9,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/008/008-1677391985.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-009",
		"PU-Name": "OPEN SPACE IMALUMA",
		Accredited_Voters: 196,
		Registered_Voters: 504,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 87,
		Lp: "",
		PDP: 90,
		SDP: 2,
		NNPP: 9,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/009/009-1677391267.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-010",
		"PU-Name": "ANSARUDEEN COLLEGE IPEE",
		Accredited_Voters: 167,
		Registered_Voters: 250,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 88,
		Lp: 1,
		PDP: 68,
		SDP: "",
		NNPP: 2,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/010/010-1677390187.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-011",
		"PU-Name": "IREWOLEDE MARKET IPEE",
		Accredited_Voters: 115,
		Registered_Voters: 160,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 53,
		Lp: "",
		PDP: 51,
		SDP: "",
		NNPP: 4,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/011/011-1677389558.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IPEE",
		"PU-Code": "23-15-10-012",
		"PU-Name": "OPEN SPACE ORIWO-IPEE",
		Accredited_Voters: 27,
		Registered_Voters: 69,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 7,
		Lp: 1,
		PDP: 19,
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/10/pu/012/012-1677390840.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-006",
		"PU-Name": "LGEA SCHOOL IRRA FERE",
		Accredited_Voters: 94,
		Registered_Voters: 149,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/156280/156280-1677601478.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-007",
		"PU-Name": "LGEA SCHOOL GAA OLOMOBA",
		Accredited_Voters: 30,
		Registered_Voters: 56,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/156281/156281-1677594032.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IRRA",
		"PU-Code": "23-15-04-008",
		"PU-Name": "OPEN SPACE IRRA MARKET",
		Accredited_Voters: 217,
		Registered_Voters: 527,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23266/pu/156282/156282-1677594179.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-008",
		"PU-Name": "OPEN SPACE GAA KADUNA",
		Accredited_Voters: 39,
		Registered_Voters: 110,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 22,
		Lp: "",
		PDP: 8,
		SDP: 1,
		NNPP: 4,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/156285/156285-1677478275.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "OJOKU",
		"PU-Code": "23-15-07-009",
		"PU-Name": "OPEN SPACE ALERE OJOKU",
		Accredited_Voters: 155,
		Registered_Voters: 552,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 66,
		Lp: "",
		PDP: 39,
		SDP: 1,
		NNPP: 37,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3606/ward/23269/pu/156286/156286-1677478578.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-011",
		"PU-Name": "EBU L.G.E.A. SCHOOL",
		Accredited_Voters: 129,
		Registered_Voters: 180,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651531/result_70969_1677796568_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-013",
		"PU-Name": "BABOGI L.G.E.A. PRIMARY SCHOOL",
		Accredited_Voters: 154,
		Registered_Voters: 476,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651533/result_70971_1677797211_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 1",
		"PU-Code": "23-16-05-014",
		"PU-Name": "MA'AGI LGEA PRI SCH",
		Accredited_Voters: 342,
		Registered_Voters: 775,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651534/result_70972_1677797766_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 11",
		"PU-Code": "23-16-06-009",
		"PU-Name": "GBAFU LGEA SCHOOL",
		Accredited_Voters: 261,
		Registered_Voters: 715,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23279/pu/156328/156328-1677586454.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 11",
		"PU-Code": "23-16-06-011",
		"PU-Name": "SUKU LGEA SCHOOL",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23279/pu/156330/156330-1677750594.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 111",
		"PU-Code": "23-16-07-006",
		"PU-Name": "TANKPAFU COMMINUTY SECONDARY SCHOOL",
		Accredited_Voters: 255,
		Registered_Voters: 573,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/07/pu/006/006-1677376548.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "KPADA 111",
		"PU-Code": "23-16-07-007",
		"PU-Name": "OPOTA/OKOLUSHE OPEN SPACE",
		Accredited_Voters: 62,
		Registered_Voters: 637,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/07/pu/007/007-1677376760.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-007",
		"PU-Name": "LILE L.G.E.A. SCHOOL",
		Accredited_Voters: 253,
		Registered_Voters: 321,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/08/pu/007/007-1677401166.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-008",
		"PU-Name": "GADAWORO L.G.E.A PRY SCHOOL",
		Accredited_Voters: 216,
		Registered_Voters: 550,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23281/pu/156336/156336-1677529908.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-009",
		"PU-Name": "EKATI L.G.E.A. SCHOOL",
		Accredited_Voters: 255,
		Registered_Voters: 333,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/08/pu/009/009-1677402152.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 1",
		"PU-Code": "23-16-08-010",
		"PU-Name": "DAKANI L.G.E.A PRY SCHOOL",
		Accredited_Voters: 332,
		Registered_Voters: 545,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/08/pu/010/010-1677400165.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-007",
		"PU-Name": "KOCHITAGI OPEN SPACE",
		Accredited_Voters: 356,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651547/result_71009_1677790251_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-008",
		"PU-Name": "NDANAKU COMMUNITY II",
		Accredited_Voters: 174,
		Registered_Voters: 315,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651548/result_71010_1677790481_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-009",
		"PU-Name": "EMI ADAM CARPENTER OPEN SPACE",
		Accredited_Voters: 141,
		Registered_Voters: 190,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651549/result_71011_1677783415_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-010",
		"PU-Name": "GUNUBATA OPEN SPACE",
		Accredited_Voters: 274,
		Registered_Voters: 676,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651550/result_71012_1677784679_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-011",
		"PU-Name": "UBANDAWAKI OPEN SPACE",
		Accredited_Voters: 310,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651551/result_71013_1677870167_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-012",
		"PU-Name": "NDANAKU COMMUNITY I",
		Accredited_Voters: 200,
		Registered_Voters: 436,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651552/result_71014_1677782300_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 11",
		"PU-Code": "23-16-09-013",
		"PU-Name": "GBANGEDE LGEA SCHOOL",
		Accredited_Voters: 300,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651553/result_71015_1677782136_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-007",
		"PU-Name": "EDOGI CHAPPA MARKET SQUARE",
		Accredited_Voters: 164,
		Registered_Voters: 227,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651554/result_71022_1677520543_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-008",
		"PU-Name": "ESUNDARI L.G.E.A PRY SCHOOL",
		Accredited_Voters: 294,
		Registered_Voters: 353,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651555/result_71023_1677527326_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-009",
		"PU-Name": "LALAGI MARKET SQUARE",
		Accredited_Voters: 163,
		Registered_Voters: 195,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651556/result_71024_1677531748_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-010",
		"PU-Name": "LATA ARABIC PRIMARY SCHOOL",
		Accredited_Voters: 219,
		Registered_Voters: 517,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651557/result_71025_1677532097_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-011",
		"PU-Name": "ARABIC PRIMARY SCHOOL SAKPEFU",
		Accredited_Voters: 288,
		Registered_Voters: 639,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651558/result_71026_1677532569_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-012",
		"PU-Name": "CHANENGI L.G.E.A. PRIMARY SCHOOL",
		Accredited_Voters: 206,
		Registered_Voters: 353,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651559/result_71027_1677533113_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "LADE 111",
		"PU-Code": "23-16-10-013",
		"PU-Name": "KANWORO L.G.E.A. PRIMARY SCHOOL",
		Accredited_Voters: 259,
		Registered_Voters: 326,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651560/result_71028_1677533345_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-006",
		"PU-Name": "TSADO GATE",
		Accredited_Voters: 23,
		Registered_Voters: 41,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/006/006-1677399586.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-008",
		"PU-Name": "KPONTUN GANA GATE",
		Accredited_Voters: 160,
		Registered_Voters: 498,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/008/008-1677400886.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-009",
		"PU-Name": "KPANMANGI LGA SCHOOL",
		Accredited_Voters: 118,
		Registered_Voters: 405,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/009/009-1677401431.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1",
		"PU-Code": "23-16-01-010",
		"PU-Name": "SIM SCHOOL II",
		Accredited_Voters: 235,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/16/ward/01/pu/010/010-1677402085.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-004",
		"PU-Name": "NAKODI JIMADA OPEN SPACE",
		Accredited_Voters: 152,
		Registered_Voters: 381,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/156313/156313-1677459100.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-005",
		"PU-Name": "MAKUN OPEN SPACE",
		Accredited_Voters: 206,
		Registered_Voters: 568,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/156314/156314-1677460783.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 11",
		"PU-Code": "23-16-02-006",
		"PU-Name": "NDAWODI TSAWATSWAN OPEN SPACE",
		Accredited_Voters: 56,
		Registered_Voters: 99,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3607/ward/23275/pu/156315/156315-1677460211.pdf",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 111",
		"PU-Code": "23-16-03-008",
		"PU-Name": "SHESHI SHAABA OPEN SPACE",
		Accredited_Voters: 55,
		Registered_Voters: 119,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651573/result_70948_1677526148_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-008",
		"PU-Name": "LIKPOFU PRIMARY SCHOOL",
		Accredited_Voters: 204,
		Registered_Voters: 727,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651574/result_70956_1677811932_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-009",
		"PU-Name": "KUSOGI GANA TSWALU",
		Accredited_Voters: 214,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651575/result_70957_1677812665_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "PATIGI",
		Ward: "PATIGI 1V",
		"PU-Code": "23-16-04-010",
		"PU-Name": "GUDUGI LGEA PRIMARY SCHOOL",
		Accredited_Voters: 108,
		Registered_Voters: 142,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651576/result_70958_1677812114_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-010",
		"PU-Name": "OPEN SPACE, ILE ALERI GBABIABIDUN AREA",
		Accredited_Voters: 88,
		Registered_Voters: 158,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/010/010-1677419724.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-011",
		"PU-Name": "OPEN SPACE, ILE KETEKETE GBABIABIDUN",
		Accredited_Voters: 97,
		Registered_Voters: 370,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/011/011-1677418084.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-012",
		"PU-Name": "OPEN SPACE, INFRONT OF SAHIBAT PRINTING PRESS OPO MALU AREA",
		Accredited_Voters: 163,
		Registered_Voters: 522,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/012/012-1677420135.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-013",
		"PU-Name": "OPEN SPACE, BESIDE AJEYE FOOD CARTEEN OPOMALU AREA",
		Accredited_Voters: 198,
		Registered_Voters: 510,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/013/013-1677421142.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-014",
		"PU-Name": "OPEN SPACE, OPO MALU JUNCTION",
		Accredited_Voters: 79,
		Registered_Voters: 127,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/014/014-1677420535.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-015",
		"PU-Name": "PRIMARY HEALTHCARE CENTRE, ISALE -ASA OPOMALU",
		Accredited_Voters: 227,
		Registered_Voters: 678,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/015/015-1677421744.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-016",
		"PU-Name": "OPEN SPACE, ILE JEKODOLA ISALE ASA",
		Accredited_Voters: 75,
		Registered_Voters: 101,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/016/016-1677422411.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-SOUTH",
		Ward: "BALOGUN-FULANI 111",
		"PU-Code": "23-07-08-017",
		"PU-Name": "OPEN SPACE, OPEYEMI EYE CLINIC CENTRE, SABO-LINE ISALE",
		Accredited_Voters: 104,
		Registered_Voters: 183,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/07/ward/08/pu/017/017-1677422860.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-023",
		"PU-Name": "ODE BOSERO COMPOUND",
		Accredited_Voters: 281,
		Registered_Voters: 516,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651585/result_69621_1677551731_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-036",
		"PU-Name": "OPEN SPACE ONI-NAHU",
		Accredited_Voters: 208,
		Registered_Voters: 429,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651586/result_69634_1677556305_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-037",
		"PU-Name": "OPEN SPACE ABATA SAKOFI",
		Accredited_Voters: 242,
		Registered_Voters: 562,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651587/result_69635_1677572934_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "ADEWOLE",
		"PU-Code": "23-08-01-033",
		"PU-Name": "GOVERNMENT DAY JUNIOR SEC SCH ADEWOLE",
		Accredited_Voters: 256,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651588/result_69631_1677557269_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-065",
		"PU-Name": "ODE ALAGBO",
		Accredited_Voters: 100,
		Registered_Voters: 134,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155865/155865-1677574480.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "AJIKOBI",
		"PU-Code": "23-08-02-068",
		"PU-Name": "OPEN SPACE ODE ARAOJE",
		Accredited_Voters: 98,
		Registered_Voters: 147,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23181/pu/155868/155868-1677595021.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-019",
		"PU-Name": "ISALE APATA ODE OMO ADUDU",
		Accredited_Voters: 237,
		Registered_Voters: 465,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/019/019-1677394362.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-023",
		"PU-Name": "OPEN SPACE ODE OLOWOYI COMP",
		Accredited_Voters: 174,
		Registered_Voters: 432,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23182/pu/155879/155879-1677488269.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-025",
		"PU-Name": "BEHIND ILORIN WEST COMPLEX",
		Accredited_Voters: 236,
		Registered_Voters: 590,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/025/025-1677393276.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-018",
		"PU-Name": "ODE MAGAJI IYA OBA",
		Accredited_Voters: 165,
		Registered_Voters: 438,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651595/result_69749_1677576876_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-029",
		"PU-Name": "OPEN SPACE IN FRONT OF AWOLADE HOUSE",
		Accredited_Voters: 54,
		Registered_Voters: 79,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651596/result_69760_1677579969_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-030",
		"PU-Name": "ODE ZULU MAJIDADI OJA IYA",
		Accredited_Voters: 141,
		Registered_Voters: 430,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651597/result_69761_1677577199_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-026",
		"PU-Name": "OPEN SPACE BEHIND OKE SUNA UNIVERSITY OF ILORIN",
		Accredited_Voters: 74,
		Registered_Voters: 121,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651598/result_69757_1677579454_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-054",
		"PU-Name": "ODE OLOJO",
		Accredited_Voters: 10,
		Registered_Voters: 19,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155907/155907-1677501445.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-055",
		"PU-Name": "ODE ILE EGBA",
		Accredited_Voters: 33,
		Registered_Voters: 44,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155908/155908-1677495071.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-056",
		"PU-Name": "OPEN SPACE ILE AKUJI ISALE",
		Accredited_Voters: 23,
		Registered_Voters: 33,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155909/155909-1677514749.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-059",
		"PU-Name": "PAKATA JUNIOR SEC SCHOOL",
		Accredited_Voters: 251,
		Registered_Voters: 496,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155912/155912-1677518966.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-066",
		"PU-Name": "OPEN SPACE ILE ONIRE",
		Accredited_Voters: 37,
		Registered_Voters: 53,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651603/result_69829_1677505985_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "MAGAJI NGERI",
		"PU-Code": "23-08-06-025",
		"PU-Name": "ODE MOGAJI NDA",
		Accredited_Voters: 55,
		Registered_Voters: 77,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23185/pu/155928/155928-1677593916.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-032",
		"PU-Name": "OPEN SPACE OPPOSITE POLICE STATION IFEFOLAPO COMMUNITY",
		Accredited_Voters: 84,
		Registered_Voters: 254,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155970/155970-1677590013.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-034",
		"PU-Name": "OPEN SPACE BESIDE STANBIC BANK/GOMOLA GIFT SHOP",
		Accredited_Voters: 28,
		Registered_Voters: 46,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155972/155972-1677590470.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-041",
		"PU-Name": "OPEN SPACE BESIDE HERITAGE WATER",
		Accredited_Voters: 278,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155979/155979-1677591474.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-045",
		"PU-Name": "OPEN SPACE BESIDE ELEJIGBO STREET",
		Accredited_Voters: 154,
		Registered_Voters: 469,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155983/155983-1677592600.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-047",
		"PU-Name": "OPEN SPACE OPP DHIKROD ACADEMY STADIUM ROAD",
		Accredited_Voters: 26,
		Registered_Voters: 48,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155985/155985-1677578399.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-023",
		"PU-Name": "ODE BOMU",
		Accredited_Voters: 189,
		Registered_Voters: 415,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651612/result_69880_1677608075_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-025",
		"PU-Name": "MOUNT CAMEL COLLEGE VI",
		Accredited_Voters: 109,
		Registered_Voters: 342,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651613/result_69882_1677608268_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-026",
		"PU-Name": "GOVT DAY SEC SCH ALORE IV",
		Accredited_Voters: 20,
		Registered_Voters: 39,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651614/result_69883_1677608339_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-014",
		"PU-Name": "OPEN SPACE ILERO ANNEX IDERADE ZONE 2 MADI VILLAGE",
		Accredited_Voters: 168,
		Registered_Voters: 521,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/014/014-1677392540.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-019",
		"PU-Name": "IDERA DE COMMUNITY HALL OPEN SPACE ZONE I",
		Accredited_Voters: 235,
		Registered_Voters: 636,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/019/019-1677376804.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "UBANDAWAKI",
		"PU-Code": "23-08-11-016",
		"PU-Name": "OPEN SPACE ODE-MALU",
		Accredited_Voters: 280,
		Registered_Voters: 724,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/11/pu/016/016-1677380731.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-032",
		"PU-Name": "OPEN SPACE OPPOSITE OPAKUNLE",
		Accredited_Voters: 228,
		Registered_Voters: 575,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156008/156008-1677578048.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-029",
		"PU-Name": "L.G.E.A PRY SCH EGBEJILA",
		Accredited_Voters: 236,
		Registered_Voters: 660,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156005/156005-1677590020.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-020",
		"PU-Name": "ODE AJIDO II",
		Accredited_Voters: 66,
		Registered_Voters: 97,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/020/020-1677387312.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-021",
		"PU-Name": "OPEN SPACE ILE SEBUJU",
		Accredited_Voters: 53,
		Registered_Voters: 73,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "TRUE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/08/ward/03/pu/021/021-1677389792.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BABOKO",
		"PU-Code": "23-08-03-022",
		"PU-Name": "ODE JIDA",
		Accredited_Voters: 68,
		Registered_Voters: 96,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23182/pu/155878/155878-1677487759.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-023",
		"PU-Name": "OPEN SPACE ODE AKANBI",
		Accredited_Voters: 78,
		Registered_Voters: 436,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651623/result_69754_1677577998_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BADARI",
		"PU-Code": "23-08-04-024",
		"PU-Name": "ODE ILE CUSTOM",
		Accredited_Voters: 43,
		Registered_Voters: 68,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651624/result_69755_1677575134_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-057",
		"PU-Name": "OPEN SPACE ODE AKUJI",
		Accredited_Voters: 19,
		Registered_Voters: 29,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155910/155910-1677500236.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-062",
		"PU-Name": "ODE-MAI KABARA",
		Accredited_Voters: 7,
		Registered_Voters: 10,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23184/pu/155915/155915-1677493039.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "BALOGUN ALANAMU CENTRAL",
		"PU-Code": "23-08-05-067",
		"PU-Name": "OPEN SPACE ILE JAWONDO",
		Accredited_Voters: 51,
		Registered_Voters: 71,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651627/result_69830_1677506126_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-037",
		"PU-Name": "OPEN SPACE EXACT PETROLEUM ODOTA",
		Accredited_Voters: 249,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651628/result_69989_1677523930_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OKO-ERIN",
		"PU-Code": "23-08-10-044",
		"PU-Name": "OPEN SPACE OPPOSITE ATINUKE BUKOYE",
		Accredited_Voters: 130,
		Registered_Voters: 488,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23189/pu/155982/155982-1677592354.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-020",
		"PU-Name": "AIRFORCE PRY SCHOOL III",
		Accredited_Voters: 105,
		Registered_Voters: 467,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651630/result_69877_1677607109_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "OLOJE",
		"PU-Code": "23-08-07-029",
		"PU-Name": "ODE BABA ELESHIN",
		Accredited_Voters: 77,
		Registered_Voters: 142,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/651631/result_69886_1677608679_thumb.jpg",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-027",
		"PU-Name": "GBAGBA COMMUNITY SCHOOL",
		Accredited_Voters: 296,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156003/156003-1677515838.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-030",
		"PU-Name": "OPEN SPACE OBANISUA",
		Accredited_Voters: 249,
		Registered_Voters: 656,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "TRUE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156006/156006-1677573514.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN-WEST",
		Ward: "WARRAH/EGBE JILA/OSHIN",
		"PU-Code": "23-08-12-031",
		"PU-Name":
			"OPEN SPACE IN FRONT OF ARIYO SHOPPING COMPLEX (OPPOSITE AVIATION COLLOEGE)",
		Accredited_Voters: 286,
		Registered_Voters: 722,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3599/ward/23191/pu/156007/156007-1677579364.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-013",
		"PU-Name": "FURTUNATE SCH. OKO ROAD, OMU-ARAN",
		Accredited_Voters: 174,
		Registered_Voters: 339,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/156025/156025-1677472291.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-014",
		"PU-Name": "NUT HOUSE, OMU-ARAN",
		Accredited_Voters: 64,
		Registered_Voters: 120,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/156026/156026-1677472555.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-015",
		"PU-Name": "OGBO GRAMMAR SCH. OMU-ARAN",
		Accredited_Voters: 215,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/156027/156027-1677472672.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-016",
		"PU-Name": "L.G. SECRETATRIAT, OMU-ARAN",
		Accredited_Voters: 218,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/156028/156028-1677474025.pdf",
	},
	{
		State: "KWARA",
		LGA: "IREPODUN",
		Ward: "OMU-ARAN 11 (IHAYE)",
		"PU-Code": "23-09-07-017",
		"PU-Name": "MANDATE, NEAR ADEWUMI SCH. OMU-ARAN",
		Accredited_Voters: 98,
		Registered_Voters: 195,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3600/ward/23198/pu/156029/156029-1677474268.pdf",
	},
	{
		State: "KWARA",
		LGA: "ILORIN EAST",
		Ward: "MAYA/ILE-APA",
		"PU-Code": "23-06-10-021",
		"PU-Name": "ALASE HEALTH CENTRE",
		Accredited_Voters: 128,
		Registered_Voters: 423,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/06/ward/10/pu/021/021-1677407761.pdf",
	},
	{
		State: "KWARA",
		LGA: "ASA",
		Ward: "BALLAH/OTTE",
		"PU-Code": "23-01-09-014",
		"PU-Name": "HEALTH CENTER ARAROMI",
		Accredited_Voters: 208,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/01/ward/09/pu/014/014-1677380016.pdf",
	},
	{
		State: "KWARA",
		LGA: "OYUN",
		Ward: "IJAGBO",
		"PU-Code": "23-15-08-006",
		"PU-Name": "OPEN SPACE AGUN",
		Accredited_Voters: 58,
		Registered_Voters: 100,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: 18,
		Lp: "",
		PDP: 26,
		SDP: 3,
		NNPP: 4,
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/01/lga/15/ward/08/pu/006/006-1677392311.pdf",
	},
	{
		State: "KWARA",
		LGA: "ISIN",
		Ward: "OKE ONIGBIN",
		"PU-Code": "23-10-08-007",
		"PU-Name": "COMPREHENSIVE HEALTH CENTRE",
		Accredited_Voters: 111,
		Registered_Voters: 255,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "FALSE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://docs.inecelectionresults.net/elections_prod/1292/state/1/lga/3601/ward/23210/pu/156047/156047-1677576836.pdf",
	},
	{
		State: "KWARA",
		LGA: "OFFA",
		Ward: "OJOMU NORTH/NORTH WEST",
		"PU-Code": "23-13-08-015",
		"PU-Name": "COMMUNITY SECONDARY SCHOOL OFFA",
		Accredited_Voters: 196,
		Registered_Voters: 750,
		Results_Found: "TRUE",
		Transcription_Count: -1,
		Result_Sheet_Stamped: "FALSE",
		Result_Sheet_Corrected: "TRUE",
		Result_Sheet_Invalid: "FALSE",
		Result_Sheet_Unclear: "FALSE",
		Result_Sheet_Unsigned: "UNKNOWN",
		APC: "",
		Lp: "",
		PDP: "",
		SDP: "",
		NNPP: "",
		Results_File:
			"https://inec-cvr-cache.s3.eu-west-1.amazonaws.com/cached/results/675518/result_70687_1677535708_thumb.jpg",
	},
];
export default Data;
